(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { WidgetContextProvider as WF, makeExecuteQuery as GF, makeUseLazyQuery as YF, makeUseQuery as JF, makeUseMutation as QF, validateApiHostName as qN, useTracking as bn, useWidgetContext as pn, hasDownstreamApiForbiddenError as Pv, hasDownstreamApiAuthorizationError as Av, DisplayErrors as Fn, useCopyWithDelay as ri, defaultDateFormat as vt, displayAttributeValue as HN, OAuthSettings as vu, useData as Lv, KlaviyoSubscribeSetting as XF, isDownstreamApiAuthorizationError as ZF, isDownstreamApiPermissionError as eI, capitalizeFirstCharacter as Vv, hasDownstreamApiTooManyRequestsError as nI, hasDownstreamApiPermissionError as KN, hasDownstreamApiNotFoundError as Zo } from "@dixa/partner-widget-integration-support";
export * from "@dixa/partner-widget-integration-support";
import we, { useMemo as At, useState as me, useEffect as Ge, useRef as pa, useCallback as ut, useReducer as tI, useLayoutEffect as rI, isValidElement as iI, createElement as aI, Fragment as oI } from "react";
import { Modal as Ht, ModalHead as Kt, ModalBody as Wt, ModalFoot as rr, Text as q, FlexBox as _, Spinner as fn, Icon as ye, Tooltip as nn, List as Je, Badge as Jn, Button as Qn, IconButton as qr, Tag as Dn, NavigationButton as Ct, Select as Fr, CollapseCard as lr, Box as Wn, FormGrid as Ir, FormField as ln, FieldWrapper as Vn, InputText as Cr, Textarea as Tp, TagsInput as WN, Banner as hu, Divider as zv, InputSelectionList as ni, SelectionList as Bt, FieldText as ur, FieldTextarea as sI, CopyToClipboardButton as lI, Avatar as Mv, Timestamp as uI, Attachment as cI, FieldLabel as dI, Switch as Op, Image as GN, ErrorBoundaryContext as YN, FieldSwitch as JN } from "@dixa/lib-shared-habla";
import { ApolloLink as QN, Observable as mI, ApolloClient as fI, InMemoryCache as pI, createHttpLink as vI, ApolloProvider as hI, ApolloConsumer as yI, gql as es, NetworkStatus as cr, isApolloError as XN, ApolloError as gI, useQuery as kI, useMutation as Oy } from "@apollo/client";
import bI from "cross-fetch";
import { config as Ll } from "lib-shared-backend-config";
import { __extends as _I, __assign as ei, __rest as ZN } from "tslib";
import ct from "classnames";
import An from "moment";
import "moment-timezone";
import { useLocation as xI } from "react-router-dom";
function Uv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Cs = { exports: {} }, Wa = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ry;
function SI() {
  if (Ry) return Wa;
  Ry = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return Wa.Fragment = t, Wa.jsx = s, Wa.jsxs = s, Wa;
}
var Ga = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dy;
function NI() {
  return Dy || (Dy = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u, R));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    Ga.Fragment = i, Ga.jsx = Mn, Ga.jsxs = Un;
  }()), Ga;
}
var Py;
function wI() {
  return Py || (Py = 1, process.env.NODE_ENV === "production" ? Cs.exports = SI() : Cs.exports = NI()), Cs.exports;
}
var qe = wI();
function ew(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: jI } = Object.prototype, { getPrototypeOf: Bv } = Object, yu = /* @__PURE__ */ ((e) => (n) => {
  const t = jI.call(n);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), $r = (e) => (e = e.toLowerCase(), (n) => yu(n) === e), gu = (e) => (n) => typeof n === e, { isArray: Ia } = Array, Ko = gu("undefined");
function CI(e) {
  return e !== null && !Ko(e) && e.constructor !== null && !Ko(e.constructor) && nr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const nw = $r("ArrayBuffer");
function FI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && nw(e.buffer), n;
}
const II = gu("string"), nr = gu("function"), tw = gu("number"), ku = (e) => e !== null && typeof e == "object", $I = (e) => e === !0 || e === !1, kl = (e) => {
  if (yu(e) !== "object")
    return !1;
  const n = Bv(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, EI = $r("Date"), TI = $r("File"), OI = $r("Blob"), RI = $r("FileList"), DI = (e) => ku(e) && nr(e.pipe), PI = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || nr(e.append) && ((n = yu(e)) === "formdata" || // detect form-data instance
  n === "object" && nr(e.toString) && e.toString() === "[object FormData]"));
}, AI = $r("URLSearchParams"), [LI, VI, zI, MI] = ["ReadableStream", "Request", "Response", "Headers"].map($r), UI = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ns(e, n, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Ia(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    const o = t ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function rw(e, n) {
  n = n.toLowerCase();
  const t = Object.keys(e);
  let i = t.length, a;
  for (; i-- > 0; )
    if (a = t[i], n === a.toLowerCase())
      return a;
  return null;
}
const Oi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, iw = (e) => !Ko(e) && e !== Oi;
function Rp() {
  const { caseless: e } = iw(this) && this || {}, n = {}, t = (i, a) => {
    const o = e && rw(n, a) || a;
    kl(n[o]) && kl(i) ? n[o] = Rp(n[o], i) : kl(i) ? n[o] = Rp({}, i) : Ia(i) ? n[o] = i.slice() : n[o] = i;
  };
  for (let i = 0, a = arguments.length; i < a; i++)
    arguments[i] && ns(arguments[i], t);
  return n;
}
const BI = (e, n, t, { allOwnKeys: i } = {}) => (ns(n, (a, o) => {
  t && nr(a) ? e[o] = ew(a, t) : e[o] = a;
}, { allOwnKeys: i }), e), qI = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), HI = (e, n, t, i) => {
  e.prototype = Object.create(n.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), t && Object.assign(e.prototype, t);
}, KI = (e, n, t, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = t !== !1 && Bv(e);
  } while (e && (!t || t(e, n)) && e !== Object.prototype);
  return n;
}, WI = (e, n, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= n.length;
  const i = e.indexOf(n, t);
  return i !== -1 && i === t;
}, GI = (e) => {
  if (!e) return null;
  if (Ia(e)) return e;
  let n = e.length;
  if (!tw(n)) return null;
  const t = new Array(n);
  for (; n-- > 0; )
    t[n] = e[n];
  return t;
}, YI = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Bv(Uint8Array)), JI = (e, n) => {
  const i = (e && e[Symbol.iterator]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, QI = (e, n) => {
  let t;
  const i = [];
  for (; (t = e.exec(n)) !== null; )
    i.push(t);
  return i;
}, XI = $r("HTMLFormElement"), ZI = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, i, a) {
    return i.toUpperCase() + a;
  }
), Ay = (({ hasOwnProperty: e }) => (n, t) => e.call(n, t))(Object.prototype), e$ = $r("RegExp"), aw = (e, n) => {
  const t = Object.getOwnPropertyDescriptors(e), i = {};
  ns(t, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, n$ = (e) => {
  aw(e, (n, t) => {
    if (nr(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const i = e[t];
    if (nr(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, t$ = (e, n) => {
  const t = {}, i = (a) => {
    a.forEach((o) => {
      t[o] = !0;
    });
  };
  return Ia(e) ? i(e) : i(String(e).split(n)), t;
}, r$ = () => {
}, i$ = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function a$(e) {
  return !!(e && nr(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const o$ = (e) => {
  const n = new Array(10), t = (i, a) => {
    if (ku(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Ia(i) ? [] : {};
        return ns(i, (s, l) => {
          const c = t(s, a + 1);
          !Ko(c) && (o[l] = c);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return t(e, 0);
}, s$ = $r("AsyncFunction"), l$ = (e) => e && (ku(e) || nr(e)) && nr(e.then) && nr(e.catch), ow = ((e, n) => e ? setImmediate : n ? ((t, i) => (Oi.addEventListener("message", ({ source: a, data: o }) => {
  a === Oi && o === t && i.length && i.shift()();
}, !1), (a) => {
  i.push(a), Oi.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  nr(Oi.postMessage)
), u$ = typeof queueMicrotask < "u" ? queueMicrotask.bind(Oi) : typeof process < "u" && process.nextTick || ow, ke = {
  isArray: Ia,
  isArrayBuffer: nw,
  isBuffer: CI,
  isFormData: PI,
  isArrayBufferView: FI,
  isString: II,
  isNumber: tw,
  isBoolean: $I,
  isObject: ku,
  isPlainObject: kl,
  isReadableStream: LI,
  isRequest: VI,
  isResponse: zI,
  isHeaders: MI,
  isUndefined: Ko,
  isDate: EI,
  isFile: TI,
  isBlob: OI,
  isRegExp: e$,
  isFunction: nr,
  isStream: DI,
  isURLSearchParams: AI,
  isTypedArray: YI,
  isFileList: RI,
  forEach: ns,
  merge: Rp,
  extend: BI,
  trim: UI,
  stripBOM: qI,
  inherits: HI,
  toFlatObject: KI,
  kindOf: yu,
  kindOfTest: $r,
  endsWith: WI,
  toArray: GI,
  forEachEntry: JI,
  matchAll: QI,
  isHTMLForm: XI,
  hasOwnProperty: Ay,
  hasOwnProp: Ay,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: aw,
  freezeMethods: n$,
  toObjectSet: t$,
  toCamelCase: ZI,
  noop: r$,
  toFiniteNumber: i$,
  findKey: rw,
  global: Oi,
  isContextDefined: iw,
  isSpecCompliantForm: a$,
  toJSONObject: o$,
  isAsyncFn: s$,
  isThenable: l$,
  setImmediate: ow,
  asap: u$
};
function kn(e, n, t, i, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), t && (this.config = t), i && (this.request = i), a && (this.response = a, this.status = a.status ? a.status : null);
}
ke.inherits(kn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ke.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const sw = kn.prototype, lw = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  lw[e] = { value: e };
});
Object.defineProperties(kn, lw);
Object.defineProperty(sw, "isAxiosError", { value: !0 });
kn.from = (e, n, t, i, a, o) => {
  const s = Object.create(sw);
  return ke.toFlatObject(e, s, function(c) {
    return c !== Error.prototype;
  }, (l) => l !== "isAxiosError"), kn.call(s, e.message, n, t, i, a), s.cause = e, s.name = e.name, o && Object.assign(s, o), s;
};
const c$ = null;
function Dp(e) {
  return ke.isPlainObject(e) || ke.isArray(e);
}
function uw(e) {
  return ke.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ly(e, n, t) {
  return e ? e.concat(n).map(function(a, o) {
    return a = uw(a), !t && o ? "[" + a + "]" : a;
  }).join(t ? "." : "") : n;
}
function d$(e) {
  return ke.isArray(e) && !e.some(Dp);
}
const m$ = ke.toFlatObject(ke, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function bu(e, n, t) {
  if (!ke.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), t = ke.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(b, j) {
    return !ke.isUndefined(j[b]);
  });
  const i = t.metaTokens, a = t.visitor || d, o = t.dots, s = t.indexes, c = (t.Blob || typeof Blob < "u" && Blob) && ke.isSpecCompliantForm(n);
  if (!ke.isFunction(a))
    throw new TypeError("visitor must be a function");
  function m(S) {
    if (S === null) return "";
    if (ke.isDate(S))
      return S.toISOString();
    if (!c && ke.isBlob(S))
      throw new kn("Blob is not supported. Use a Buffer instead.");
    return ke.isArrayBuffer(S) || ke.isTypedArray(S) ? c && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  function d(S, b, j) {
    let x = S;
    if (S && !j && typeof S == "object") {
      if (ke.endsWith(b, "{}"))
        b = i ? b : b.slice(0, -2), S = JSON.stringify(S);
      else if (ke.isArray(S) && d$(S) || (ke.isFileList(S) || ke.endsWith(b, "[]")) && (x = ke.toArray(S)))
        return b = uw(b), x.forEach(function(P, N) {
          !(ke.isUndefined(P) || P === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Ly([b], N, o) : s === null ? b : b + "[]",
            m(P)
          );
        }), !1;
    }
    return Dp(S) ? !0 : (n.append(Ly(j, b, o), m(S)), !1);
  }
  const p = [], v = Object.assign(m$, {
    defaultVisitor: d,
    convertValue: m,
    isVisitable: Dp
  });
  function y(S, b) {
    if (!ke.isUndefined(S)) {
      if (p.indexOf(S) !== -1)
        throw Error("Circular reference detected in " + b.join("."));
      p.push(S), ke.forEach(S, function(x, h) {
        (!(ke.isUndefined(x) || x === null) && a.call(
          n,
          x,
          ke.isString(h) ? h.trim() : h,
          b,
          v
        )) === !0 && y(x, b ? b.concat(h) : [h]);
      }), p.pop();
    }
  }
  if (!ke.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), n;
}
function Vy(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return n[i];
  });
}
function qv(e, n) {
  this._pairs = [], e && bu(e, this, n);
}
const cw = qv.prototype;
cw.append = function(n, t) {
  this._pairs.push([n, t]);
};
cw.toString = function(n) {
  const t = n ? function(i) {
    return n.call(this, i, Vy);
  } : Vy;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function f$(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function dw(e, n, t) {
  if (!n)
    return e;
  const i = t && t.encode || f$;
  ke.isFunction(t) && (t = {
    serialize: t
  });
  const a = t && t.serialize;
  let o;
  if (a ? o = a(n, t) : o = ke.isURLSearchParams(n) ? n.toString() : new qv(n, t).toString(i), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class zy {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, t, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: t,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ke.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const mw = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, p$ = typeof URLSearchParams < "u" ? URLSearchParams : qv, v$ = typeof FormData < "u" ? FormData : null, h$ = typeof Blob < "u" ? Blob : null, y$ = {
  isBrowser: !0,
  classes: {
    URLSearchParams: p$,
    FormData: v$,
    Blob: h$
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Hv = typeof window < "u" && typeof document < "u", Pp = typeof navigator == "object" && navigator || void 0, g$ = Hv && (!Pp || ["ReactNative", "NativeScript", "NS"].indexOf(Pp.product) < 0), k$ = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", b$ = Hv && window.location.href || "http://localhost", _$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Hv,
  hasStandardBrowserEnv: g$,
  hasStandardBrowserWebWorkerEnv: k$,
  navigator: Pp,
  origin: b$
}, Symbol.toStringTag, { value: "Module" })), jt = {
  ..._$,
  ...y$
};
function x$(e, n) {
  return bu(e, new jt.classes.URLSearchParams(), Object.assign({
    visitor: function(t, i, a, o) {
      return jt.isNode && ke.isBuffer(t) ? (this.append(i, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function S$(e) {
  return ke.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function N$(e) {
  const n = {}, t = Object.keys(e);
  let i;
  const a = t.length;
  let o;
  for (i = 0; i < a; i++)
    o = t[i], n[o] = e[o];
  return n;
}
function fw(e) {
  function n(t, i, a, o) {
    let s = t[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), c = o >= t.length;
    return s = !s && ke.isArray(a) ? a.length : s, c ? (ke.hasOwnProp(a, s) ? a[s] = [a[s], i] : a[s] = i, !l) : ((!a[s] || !ke.isObject(a[s])) && (a[s] = []), n(t, i, a[s], o) && ke.isArray(a[s]) && (a[s] = N$(a[s])), !l);
  }
  if (ke.isFormData(e) && ke.isFunction(e.entries)) {
    const t = {};
    return ke.forEachEntry(e, (i, a) => {
      n(S$(i), a, t, 0);
    }), t;
  }
  return null;
}
function w$(e, n, t) {
  if (ke.isString(e))
    try {
      return (n || JSON.parse)(e), ke.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (t || JSON.stringify)(e);
}
const ts = {
  transitional: mw,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, t) {
    const i = t.getContentType() || "", a = i.indexOf("application/json") > -1, o = ke.isObject(n);
    if (o && ke.isHTMLForm(n) && (n = new FormData(n)), ke.isFormData(n))
      return a ? JSON.stringify(fw(n)) : n;
    if (ke.isArrayBuffer(n) || ke.isBuffer(n) || ke.isStream(n) || ke.isFile(n) || ke.isBlob(n) || ke.isReadableStream(n))
      return n;
    if (ke.isArrayBufferView(n))
      return n.buffer;
    if (ke.isURLSearchParams(n))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let l;
    if (o) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return x$(n, this.formSerializer).toString();
      if ((l = ke.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return bu(
          l ? { "files[]": n } : n,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return o || a ? (t.setContentType("application/json", !1), w$(n)) : n;
  }],
  transformResponse: [function(n) {
    const t = this.transitional || ts.transitional, i = t && t.forcedJSONParsing, a = this.responseType === "json";
    if (ke.isResponse(n) || ke.isReadableStream(n))
      return n;
    if (n && ke.isString(n) && (i && !this.responseType || a)) {
      const s = !(t && t.silentJSONParsing) && a;
      try {
        return JSON.parse(n);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? kn.from(l, kn.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: jt.classes.FormData,
    Blob: jt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ke.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ts.headers[e] = {};
});
const j$ = ke.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), C$ = (e) => {
  const n = {};
  let t, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), t = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!t || n[t] && j$[t]) && (t === "set-cookie" ? n[t] ? n[t].push(i) : n[t] = [i] : n[t] = n[t] ? n[t] + ", " + i : i);
  }), n;
}, My = Symbol("internals");
function Ya(e) {
  return e && String(e).trim().toLowerCase();
}
function bl(e) {
  return e === !1 || e == null ? e : ke.isArray(e) ? e.map(bl) : String(e);
}
function F$(e) {
  const n = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = t.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const I$ = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function rc(e, n, t, i, a) {
  if (ke.isFunction(i))
    return i.call(this, n, t);
  if (a && (n = t), !!ke.isString(n)) {
    if (ke.isString(i))
      return n.indexOf(i) !== -1;
    if (ke.isRegExp(i))
      return i.test(n);
  }
}
function $$(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, t, i) => t.toUpperCase() + i);
}
function E$(e, n) {
  const t = ke.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + t, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let qt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, t, i) {
    const a = this;
    function o(l, c, m) {
      const d = Ya(c);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const p = ke.findKey(a, d);
      (!p || a[p] === void 0 || m === !0 || m === void 0 && a[p] !== !1) && (a[p || c] = bl(l));
    }
    const s = (l, c) => ke.forEach(l, (m, d) => o(m, d, c));
    if (ke.isPlainObject(n) || n instanceof this.constructor)
      s(n, t);
    else if (ke.isString(n) && (n = n.trim()) && !I$(n))
      s(C$(n), t);
    else if (ke.isHeaders(n))
      for (const [l, c] of n.entries())
        o(c, l, i);
    else
      n != null && o(t, n, i);
    return this;
  }
  get(n, t) {
    if (n = Ya(n), n) {
      const i = ke.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!t)
          return a;
        if (t === !0)
          return F$(a);
        if (ke.isFunction(t))
          return t.call(this, a, i);
        if (ke.isRegExp(t))
          return t.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, t) {
    if (n = Ya(n), n) {
      const i = ke.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!t || rc(this, this[i], i, t)));
    }
    return !1;
  }
  delete(n, t) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Ya(s), s) {
        const l = ke.findKey(i, s);
        l && (!t || rc(i, i[l], l, t)) && (delete i[l], a = !0);
      }
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const t = Object.keys(this);
    let i = t.length, a = !1;
    for (; i--; ) {
      const o = t[i];
      (!n || rc(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const t = this, i = {};
    return ke.forEach(this, (a, o) => {
      const s = ke.findKey(i, o);
      if (s) {
        t[s] = bl(a), delete t[o];
        return;
      }
      const l = n ? $$(o) : String(o).trim();
      l !== o && delete t[o], t[l] = bl(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const t = /* @__PURE__ */ Object.create(null);
    return ke.forEach(this, (i, a) => {
      i != null && i !== !1 && (t[a] = n && ke.isArray(i) ? i.join(", ") : i);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, t]) => n + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...t) {
    const i = new this(n);
    return t.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[My] = this[My] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Ya(s);
      i[l] || (E$(a, s), i[l] = !0);
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
qt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ke.reduceDescriptors(qt.prototype, ({ value: e }, n) => {
  let t = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[t] = i;
    }
  };
});
ke.freezeMethods(qt);
function ic(e, n) {
  const t = this || ts, i = n || t, a = qt.from(i.headers);
  let o = i.data;
  return ke.forEach(e, function(l) {
    o = l.call(t, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function pw(e) {
  return !!(e && e.__CANCEL__);
}
function $a(e, n, t) {
  kn.call(this, e ?? "canceled", kn.ERR_CANCELED, n, t), this.name = "CanceledError";
}
ke.inherits($a, kn, {
  __CANCEL__: !0
});
function vw(e, n, t) {
  const i = t.config.validateStatus;
  !t.status || !i || i(t.status) ? e(t) : n(new kn(
    "Request failed with status code " + t.status,
    [kn.ERR_BAD_REQUEST, kn.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function T$(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function O$(e, n) {
  e = e || 10;
  const t = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(c) {
    const m = Date.now(), d = i[o];
    s || (s = m), t[a] = c, i[a] = m;
    let p = o, v = 0;
    for (; p !== a; )
      v += t[p++], p = p % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const y = d && m - d;
    return y ? Math.round(v * 1e3 / y) : void 0;
  };
}
function R$(e, n) {
  let t = 0, i = 1e3 / n, a, o;
  const s = (m, d = Date.now()) => {
    t = d, a = null, o && (clearTimeout(o), o = null), e.apply(null, m);
  };
  return [(...m) => {
    const d = Date.now(), p = d - t;
    p >= i ? s(m, d) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - p)));
  }, () => a && s(a)];
}
const Vl = (e, n, t = 3) => {
  let i = 0;
  const a = O$(50, 250);
  return R$((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, c = s - i, m = a(c), d = s <= l;
    i = s;
    const p = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: c,
      rate: m || void 0,
      estimated: m && l && d ? (l - s) / m : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(p);
  }, t);
}, Uy = (e, n) => {
  const t = e != null;
  return [(i) => n[0]({
    lengthComputable: t,
    total: e,
    loaded: i
  }), n[1]];
}, By = (e) => (...n) => ke.asap(() => e(...n)), D$ = jt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (t) => (t = new URL(t, jt.origin), e.protocol === t.protocol && e.host === t.host && (n || e.port === t.port)))(
  new URL(jt.origin),
  jt.navigator && /(msie|trident)/i.test(jt.navigator.userAgent)
) : () => !0, P$ = jt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, t, i, a, o) {
      const s = [e + "=" + encodeURIComponent(n)];
      ke.isNumber(t) && s.push("expires=" + new Date(t).toGMTString()), ke.isString(i) && s.push("path=" + i), ke.isString(a) && s.push("domain=" + a), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function A$(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function L$(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function hw(e, n, t) {
  let i = !A$(n);
  return e && (i || t == !1) ? L$(e, n) : n;
}
const qy = (e) => e instanceof qt ? { ...e } : e;
function Mi(e, n) {
  n = n || {};
  const t = {};
  function i(m, d, p, v) {
    return ke.isPlainObject(m) && ke.isPlainObject(d) ? ke.merge.call({ caseless: v }, m, d) : ke.isPlainObject(d) ? ke.merge({}, d) : ke.isArray(d) ? d.slice() : d;
  }
  function a(m, d, p, v) {
    if (ke.isUndefined(d)) {
      if (!ke.isUndefined(m))
        return i(void 0, m, p, v);
    } else return i(m, d, p, v);
  }
  function o(m, d) {
    if (!ke.isUndefined(d))
      return i(void 0, d);
  }
  function s(m, d) {
    if (ke.isUndefined(d)) {
      if (!ke.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, d);
  }
  function l(m, d, p) {
    if (p in n)
      return i(m, d);
    if (p in e)
      return i(void 0, m);
  }
  const c = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, d, p) => a(qy(m), qy(d), p, !0)
  };
  return ke.forEach(Object.keys(Object.assign({}, e, n)), function(d) {
    const p = c[d] || a, v = p(e[d], n[d], d);
    ke.isUndefined(v) && p !== l || (t[d] = v);
  }), t;
}
const yw = (e) => {
  const n = Mi({}, e);
  let { data: t, withXSRFToken: i, xsrfHeaderName: a, xsrfCookieName: o, headers: s, auth: l } = n;
  n.headers = s = qt.from(s), n.url = dw(hw(n.baseURL, n.url, n.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  );
  let c;
  if (ke.isFormData(t)) {
    if (jt.hasStandardBrowserEnv || jt.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((c = s.getContentType()) !== !1) {
      const [m, ...d] = c ? c.split(";").map((p) => p.trim()).filter(Boolean) : [];
      s.setContentType([m || "multipart/form-data", ...d].join("; "));
    }
  }
  if (jt.hasStandardBrowserEnv && (i && ke.isFunction(i) && (i = i(n)), i || i !== !1 && D$(n.url))) {
    const m = a && o && P$.read(o);
    m && s.set(a, m);
  }
  return n;
}, V$ = typeof XMLHttpRequest < "u", z$ = V$ && function(e) {
  return new Promise(function(t, i) {
    const a = yw(e);
    let o = a.data;
    const s = qt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: c, onDownloadProgress: m } = a, d, p, v, y, S;
    function b() {
      y && y(), S && S(), a.cancelToken && a.cancelToken.unsubscribe(d), a.signal && a.signal.removeEventListener("abort", d);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function x() {
      if (!j)
        return;
      const P = qt.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), $ = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: P,
        config: e,
        request: j
      };
      vw(function(B) {
        t(B), b();
      }, function(B) {
        i(B), b();
      }, $), j = null;
    }
    "onloadend" in j ? j.onloadend = x : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.indexOf("file:") === 0) || setTimeout(x);
    }, j.onabort = function() {
      j && (i(new kn("Request aborted", kn.ECONNABORTED, e, j)), j = null);
    }, j.onerror = function() {
      i(new kn("Network Error", kn.ERR_NETWORK, e, j)), j = null;
    }, j.ontimeout = function() {
      let N = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const $ = a.transitional || mw;
      a.timeoutErrorMessage && (N = a.timeoutErrorMessage), i(new kn(
        N,
        $.clarifyTimeoutError ? kn.ETIMEDOUT : kn.ECONNABORTED,
        e,
        j
      )), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && ke.forEach(s.toJSON(), function(N, $) {
      j.setRequestHeader($, N);
    }), ke.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), m && ([v, S] = Vl(m, !0), j.addEventListener("progress", v)), c && j.upload && ([p, y] = Vl(c), j.upload.addEventListener("progress", p), j.upload.addEventListener("loadend", y)), (a.cancelToken || a.signal) && (d = (P) => {
      j && (i(!P || P.type ? new $a(null, e, j) : P), j.abort(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(d), a.signal && (a.signal.aborted ? d() : a.signal.addEventListener("abort", d)));
    const h = T$(a.url);
    if (h && jt.protocols.indexOf(h) === -1) {
      i(new kn("Unsupported protocol " + h + ":", kn.ERR_BAD_REQUEST, e));
      return;
    }
    j.send(o || null);
  });
}, M$ = (e, n) => {
  const { length: t } = e = e ? e.filter(Boolean) : [];
  if (n || t) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const d = m instanceof Error ? m : this.reason;
        i.abort(d instanceof kn ? d : new $a(d instanceof Error ? d.message : d));
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new kn(`timeout ${n} of ms exceeded`, kn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: c } = i;
    return c.unsubscribe = () => ke.asap(l), c;
  }
}, U$ = function* (e, n) {
  let t = e.byteLength;
  if (t < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < t; )
    a = i + n, yield e.slice(i, a), i = a;
}, B$ = async function* (e, n) {
  for await (const t of q$(e))
    yield* U$(t, n);
}, q$ = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: t, value: i } = await n.read();
      if (t)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Hy = (e, n, t, i) => {
  const a = B$(e, n);
  let o = 0, s, l = (c) => {
    s || (s = !0, i && i(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: m, value: d } = await a.next();
        if (m) {
          l(), c.close();
          return;
        }
        let p = d.byteLength;
        if (t) {
          let v = o += p;
          t(v);
        }
        c.enqueue(new Uint8Array(d));
      } catch (m) {
        throw l(m), m;
      }
    },
    cancel(c) {
      return l(c), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, _u = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", gw = _u && typeof ReadableStream == "function", H$ = _u && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (n) => e.encode(n))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), kw = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, K$ = gw && kw(() => {
  let e = !1;
  const n = new Request(jt.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !n;
}), Ky = 64 * 1024, Ap = gw && kw(() => ke.isReadableStream(new Response("").body)), zl = {
  stream: Ap && ((e) => e.body)
};
_u && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((n) => {
    !zl[n] && (zl[n] = ke.isFunction(e[n]) ? (t) => t[n]() : (t, i) => {
      throw new kn(`Response type '${n}' is not supported`, kn.ERR_NOT_SUPPORT, i);
    });
  });
})(new Response());
const W$ = async (e) => {
  if (e == null)
    return 0;
  if (ke.isBlob(e))
    return e.size;
  if (ke.isSpecCompliantForm(e))
    return (await new Request(jt.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (ke.isArrayBufferView(e) || ke.isArrayBuffer(e))
    return e.byteLength;
  if (ke.isURLSearchParams(e) && (e = e + ""), ke.isString(e))
    return (await H$(e)).byteLength;
}, G$ = async (e, n) => {
  const t = ke.toFiniteNumber(e.getContentLength());
  return t ?? W$(n);
}, Y$ = _u && (async (e) => {
  let {
    url: n,
    method: t,
    data: i,
    signal: a,
    cancelToken: o,
    timeout: s,
    onDownloadProgress: l,
    onUploadProgress: c,
    responseType: m,
    headers: d,
    withCredentials: p = "same-origin",
    fetchOptions: v
  } = yw(e);
  m = m ? (m + "").toLowerCase() : "text";
  let y = M$([a, o && o.toAbortSignal()], s), S;
  const b = y && y.unsubscribe && (() => {
    y.unsubscribe();
  });
  let j;
  try {
    if (c && K$ && t !== "get" && t !== "head" && (j = await G$(d, i)) !== 0) {
      let $ = new Request(n, {
        method: "POST",
        body: i,
        duplex: "half"
      }), O;
      if (ke.isFormData(i) && (O = $.headers.get("content-type")) && d.setContentType(O), $.body) {
        const [B, Z] = Uy(
          j,
          Vl(By(c))
        );
        i = Hy($.body, Ky, B, Z);
      }
    }
    ke.isString(p) || (p = p ? "include" : "omit");
    const x = "credentials" in Request.prototype;
    S = new Request(n, {
      ...v,
      signal: y,
      method: t.toUpperCase(),
      headers: d.normalize().toJSON(),
      body: i,
      duplex: "half",
      credentials: x ? p : void 0
    });
    let h = await fetch(S);
    const P = Ap && (m === "stream" || m === "response");
    if (Ap && (l || P && b)) {
      const $ = {};
      ["status", "statusText", "headers"].forEach((Y) => {
        $[Y] = h[Y];
      });
      const O = ke.toFiniteNumber(h.headers.get("content-length")), [B, Z] = l && Uy(
        O,
        Vl(By(l), !0)
      ) || [];
      h = new Response(
        Hy(h.body, Ky, B, () => {
          Z && Z(), b && b();
        }),
        $
      );
    }
    m = m || "text";
    let N = await zl[ke.findKey(zl, m) || "text"](h, e);
    return !P && b && b(), await new Promise(($, O) => {
      vw($, O, {
        data: N,
        headers: qt.from(h.headers),
        status: h.status,
        statusText: h.statusText,
        config: e,
        request: S
      });
    });
  } catch (x) {
    throw b && b(), x && x.name === "TypeError" && /fetch/i.test(x.message) ? Object.assign(
      new kn("Network Error", kn.ERR_NETWORK, e, S),
      {
        cause: x.cause || x
      }
    ) : kn.from(x, x && x.code, e, S);
  }
}), Lp = {
  http: c$,
  xhr: z$,
  fetch: Y$
};
ke.forEach(Lp, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const Wy = (e) => `- ${e}`, J$ = (e) => ke.isFunction(e) || e === null || e === !1, bw = {
  getAdapter: (e) => {
    e = ke.isArray(e) ? e : [e];
    const { length: n } = e;
    let t, i;
    const a = {};
    for (let o = 0; o < n; o++) {
      t = e[o];
      let s;
      if (i = t, !J$(t) && (i = Lp[(s = String(t)).toLowerCase()], i === void 0))
        throw new kn(`Unknown adapter '${s}'`);
      if (i)
        break;
      a[s || "#" + o] = i;
    }
    if (!i) {
      const o = Object.entries(a).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = n ? o.length > 1 ? `since :
` + o.map(Wy).join(`
`) : " " + Wy(o[0]) : "as no adapter specified";
      throw new kn(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return i;
  },
  adapters: Lp
};
function ac(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new $a(null, e);
}
function Gy(e) {
  return ac(e), e.headers = qt.from(e.headers), e.data = ic.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), bw.getAdapter(e.adapter || ts.adapter)(e).then(function(i) {
    return ac(e), i.data = ic.call(
      e,
      e.transformResponse,
      i
    ), i.headers = qt.from(i.headers), i;
  }, function(i) {
    return pw(i) || (ac(e), i && i.response && (i.response.data = ic.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = qt.from(i.response.headers))), Promise.reject(i);
  });
}
const _w = "1.8.4", xu = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  xu[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Yy = {};
xu.transitional = function(n, t, i) {
  function a(o, s) {
    return "[Axios v" + _w + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new kn(
        a(s, " has been removed" + (t ? " in " + t : "")),
        kn.ERR_DEPRECATED
      );
    return t && !Yy[s] && (Yy[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
xu.spelling = function(n) {
  return (t, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function Q$(e, n, t) {
  if (typeof e != "object")
    throw new kn("options must be an object", kn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = n[o];
    if (s) {
      const l = e[o], c = l === void 0 || s(l, o, e);
      if (c !== !0)
        throw new kn("option " + o + " must be " + c, kn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new kn("Unknown option " + o, kn.ERR_BAD_OPTION);
  }
}
const _l = {
  assertOptions: Q$,
  validators: xu
}, Or = _l.validators;
let Ai = class {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new zy(),
      response: new zy()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, t) {
    try {
      return await this._request(n, t);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? o && !String(i.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + o) : i.stack = o;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, t) {
    typeof n == "string" ? (t = t || {}, t.url = n) : t = n || {}, t = Mi(this.defaults, t);
    const { transitional: i, paramsSerializer: a, headers: o } = t;
    i !== void 0 && _l.assertOptions(i, {
      silentJSONParsing: Or.transitional(Or.boolean),
      forcedJSONParsing: Or.transitional(Or.boolean),
      clarifyTimeoutError: Or.transitional(Or.boolean)
    }, !1), a != null && (ke.isFunction(a) ? t.paramsSerializer = {
      serialize: a
    } : _l.assertOptions(a, {
      encode: Or.function,
      serialize: Or.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), _l.assertOptions(t, {
      baseUrl: Or.spelling("baseURL"),
      withXsrfToken: Or.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let s = o && ke.merge(
      o.common,
      o[t.method]
    );
    o && ke.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (S) => {
        delete o[S];
      }
    ), t.headers = qt.concat(s, o);
    const l = [];
    let c = !0;
    this.interceptors.request.forEach(function(b) {
      typeof b.runWhen == "function" && b.runWhen(t) === !1 || (c = c && b.synchronous, l.unshift(b.fulfilled, b.rejected));
    });
    const m = [];
    this.interceptors.response.forEach(function(b) {
      m.push(b.fulfilled, b.rejected);
    });
    let d, p = 0, v;
    if (!c) {
      const S = [Gy.bind(this), void 0];
      for (S.unshift.apply(S, l), S.push.apply(S, m), v = S.length, d = Promise.resolve(t); p < v; )
        d = d.then(S[p++], S[p++]);
      return d;
    }
    v = l.length;
    let y = t;
    for (p = 0; p < v; ) {
      const S = l[p++], b = l[p++];
      try {
        y = S(y);
      } catch (j) {
        b.call(this, j);
        break;
      }
    }
    try {
      d = Gy.call(this, y);
    } catch (S) {
      return Promise.reject(S);
    }
    for (p = 0, v = m.length; p < v; )
      d = d.then(m[p++], m[p++]);
    return d;
  }
  getUri(n) {
    n = Mi(this.defaults, n);
    const t = hw(n.baseURL, n.url, n.allowAbsoluteUrls);
    return dw(t, n.params, n.paramsSerializer);
  }
};
ke.forEach(["delete", "get", "head", "options"], function(n) {
  Ai.prototype[n] = function(t, i) {
    return this.request(Mi(i || {}, {
      method: n,
      url: t,
      data: (i || {}).data
    }));
  };
});
ke.forEach(["post", "put", "patch"], function(n) {
  function t(i) {
    return function(o, s, l) {
      return this.request(Mi(l || {}, {
        method: n,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  Ai.prototype[n] = t(), Ai.prototype[n + "Form"] = t(!0);
});
let X$ = class xw {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new $a(o, s, l), t(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(n);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), t = (i) => {
      n.abort(i);
    };
    return this.subscribe(t), n.signal.unsubscribe = () => this.unsubscribe(t), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new xw(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function Z$(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function eE(e) {
  return ke.isObject(e) && e.isAxiosError === !0;
}
const Vp = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Vp).forEach(([e, n]) => {
  Vp[n] = e;
});
function Sw(e) {
  const n = new Ai(e), t = ew(Ai.prototype.request, n);
  return ke.extend(t, Ai.prototype, n, { allOwnKeys: !0 }), ke.extend(t, n, null, { allOwnKeys: !0 }), t.create = function(a) {
    return Sw(Mi(e, a));
  }, t;
}
const at = Sw(ts);
at.Axios = Ai;
at.CanceledError = $a;
at.CancelToken = X$;
at.isCancel = pw;
at.VERSION = _w;
at.toFormData = bu;
at.AxiosError = kn;
at.Cancel = at.CanceledError;
at.all = function(n) {
  return Promise.all(n);
};
at.spread = Z$;
at.isAxiosError = eE;
at.mergeConfig = Mi;
at.AxiosHeaders = qt;
at.formToJSON = (e) => fw(ke.isHTMLForm(e) ? new FormData(e) : e);
at.getAdapter = bw.getAdapter;
at.HttpStatusCode = Vp;
at.default = at;
const {
  Axios: One,
  AxiosError: Rne,
  CanceledError: Dne,
  isCancel: Pne,
  CancelToken: Ane,
  VERSION: Lne,
  all: Vne,
  Cancel: zne,
  isAxiosError: nE,
  spread: Mne,
  toFormData: Une,
  AxiosHeaders: Bne,
  HttpStatusCode: qne,
  formToJSON: Hne,
  getAdapter: Kne,
  mergeConfig: Wne
} = at;
var oc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function tE(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Fs = function(e) {
  return e && e.Math === Math && e;
}, ht = (
  // eslint-disable-next-line es/no-global-this -- safe
  Fs(typeof globalThis == "object" && globalThis) || Fs(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Fs(typeof self == "object" && self) || Fs(typeof oc == "object" && oc) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || oc || Function("return this")()
), ot = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, rE = ot, Su = !rE(function() {
  var e = (function() {
  }).bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), iE = Su, Nw = Function.prototype, Jy = Nw.apply, Qy = Nw.call, Kv = typeof Reflect == "object" && Reflect.apply || (iE ? Qy.bind(Jy) : function() {
  return Qy.apply(Jy, arguments);
}), ww = Su, jw = Function.prototype, zp = jw.call, aE = ww && jw.bind.bind(zp, zp), yt = ww ? aE : function(e) {
  return function() {
    return zp.apply(e, arguments);
  };
}, Cw = yt, oE = Cw({}.toString), sE = Cw("".slice), Bi = function(e) {
  return sE(oE(e), 8, -1);
}, lE = Bi, uE = yt, Wv = function(e) {
  if (lE(e) === "Function") return uE(e);
}, Mp = typeof document == "object" && document.all, cE = typeof Mp > "u" && Mp !== void 0, Fw = {
  all: Mp,
  IS_HTMLDDA: cE
}, Iw = Fw, dE = Iw.all, dt = Iw.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === dE;
} : function(e) {
  return typeof e == "function";
}, Ea = {}, mE = ot, ir = !mE(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), fE = Su, Is = Function.prototype.call, Nt = fE ? Is.bind(Is) : function() {
  return Is.apply(Is, arguments);
}, Nu = {}, $w = {}.propertyIsEnumerable, Ew = Object.getOwnPropertyDescriptor, pE = Ew && !$w.call({ 1: 2 }, 1);
Nu.f = pE ? function(n) {
  var t = Ew(this, n);
  return !!t && t.enumerable;
} : $w;
var qi = function(e, n) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: n
  };
}, vE = yt, hE = ot, yE = Bi, sc = Object, gE = vE("".split), Gv = hE(function() {
  return !sc("z").propertyIsEnumerable(0);
}) ? function(e) {
  return yE(e) === "String" ? gE(e, "") : sc(e);
} : sc, wu = function(e) {
  return e == null;
}, kE = wu, bE = TypeError, Yv = function(e) {
  if (kE(e)) throw bE("Can't call method on " + e);
  return e;
}, _E = Gv, xE = Yv, si = function(e) {
  return _E(xE(e));
}, Xy = dt, Tw = Fw, SE = Tw.all, mr = Tw.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : Xy(e) || e === SE;
} : function(e) {
  return typeof e == "object" ? e !== null : Xy(e);
}, fr = {}, lc = fr, uc = ht, NE = dt, Zy = function(e) {
  return NE(e) ? e : void 0;
}, pr = function(e, n) {
  return arguments.length < 2 ? Zy(lc[e]) || Zy(uc[e]) : lc[e] && lc[e][n] || uc[e] && uc[e][n];
}, wE = yt, rs = wE({}.isPrototypeOf), ju = typeof navigator < "u" && String(navigator.userAgent) || "", Ow = ht, cc = ju, eg = Ow.process, ng = Ow.Deno, tg = eg && eg.versions || ng && ng.version, rg = tg && tg.v8, gr, Ml;
rg && (gr = rg.split("."), Ml = gr[0] > 0 && gr[0] < 4 ? 1 : +(gr[0] + gr[1]));
!Ml && cc && (gr = cc.match(/Edge\/(\d+)/), (!gr || gr[1] >= 74) && (gr = cc.match(/Chrome\/(\d+)/), gr && (Ml = +gr[1])));
var Cu = Ml, ig = Cu, jE = ot, CE = ht, FE = CE.String, Ta = !!Object.getOwnPropertySymbols && !jE(function() {
  var e = Symbol("symbol detection");
  return !FE(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && ig && ig < 41;
}), IE = Ta, Rw = IE && !Symbol.sham && typeof Symbol.iterator == "symbol", $E = pr, EE = dt, TE = rs, OE = Rw, RE = Object, Fu = OE ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var n = $E("Symbol");
  return EE(n) && TE(n.prototype, RE(e));
}, DE = String, is = function(e) {
  try {
    return DE(e);
  } catch {
    return "Object";
  }
}, PE = dt, AE = is, LE = TypeError, Hr = function(e) {
  if (PE(e)) return e;
  throw LE(AE(e) + " is not a function");
}, VE = Hr, zE = wu, Jv = function(e, n) {
  var t = e[n];
  return zE(t) ? void 0 : VE(t);
}, dc = Nt, mc = dt, fc = mr, ME = TypeError, UE = function(e, n) {
  var t, i;
  if (n === "string" && mc(t = e.toString) && !fc(i = dc(t, e)) || mc(t = e.valueOf) && !fc(i = dc(t, e)) || n !== "string" && mc(t = e.toString) && !fc(i = dc(t, e))) return i;
  throw ME("Can't convert object to primitive value");
}, Dw = { exports: {} }, BE = !0, ag = ht, qE = Object.defineProperty, HE = function(e, n) {
  try {
    qE(ag, e, { value: n, configurable: !0, writable: !0 });
  } catch {
    ag[e] = n;
  }
  return n;
}, KE = ht, WE = HE, og = "__core-js_shared__", GE = KE[og] || WE(og, {}), Qv = GE, sg = Qv;
(Dw.exports = function(e, n) {
  return sg[e] || (sg[e] = n !== void 0 ? n : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var as = Dw.exports, YE = Yv, JE = Object, Oa = function(e) {
  return JE(YE(e));
}, QE = yt, XE = Oa, ZE = QE({}.hasOwnProperty), Gt = Object.hasOwn || function(n, t) {
  return ZE(XE(n), t);
}, eT = yt, nT = 0, tT = Math.random(), rT = eT(1 .toString), Xv = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + rT(++nT + tT, 36);
}, iT = ht, aT = as, lg = Gt, oT = Xv, sT = Ta, lT = Rw, da = iT.Symbol, pc = aT("wks"), uT = lT ? da.for || da : da && da.withoutSetter || oT, st = function(e) {
  return lg(pc, e) || (pc[e] = sT && lg(da, e) ? da[e] : uT("Symbol." + e)), pc[e];
}, cT = Nt, ug = mr, cg = Fu, dT = Jv, mT = UE, fT = st, pT = TypeError, vT = fT("toPrimitive"), hT = function(e, n) {
  if (!ug(e) || cg(e)) return e;
  var t = dT(e, vT), i;
  if (t) {
    if (n === void 0 && (n = "default"), i = cT(t, e, n), !ug(i) || cg(i)) return i;
    throw pT("Can't convert object to primitive value");
  }
  return n === void 0 && (n = "number"), mT(e, n);
}, yT = hT, gT = Fu, Iu = function(e) {
  var n = yT(e, "string");
  return gT(n) ? n : n + "";
}, kT = ht, dg = mr, Up = kT.document, bT = dg(Up) && dg(Up.createElement), Zv = function(e) {
  return bT ? Up.createElement(e) : {};
}, _T = ir, xT = ot, ST = Zv, Pw = !_T && !xT(function() {
  return Object.defineProperty(ST("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), NT = ir, wT = Nt, jT = Nu, CT = qi, FT = si, IT = Iu, $T = Gt, ET = Pw, mg = Object.getOwnPropertyDescriptor;
Ea.f = NT ? mg : function(n, t) {
  if (n = FT(n), t = IT(t), ET) try {
    return mg(n, t);
  } catch {
  }
  if ($T(n, t)) return CT(!wT(jT.f, n, t), n[t]);
};
var TT = ot, OT = dt, RT = /#|\.prototype\./, os = function(e, n) {
  var t = PT[DT(e)];
  return t === LT ? !0 : t === AT ? !1 : OT(n) ? TT(n) : !!n;
}, DT = os.normalize = function(e) {
  return String(e).replace(RT, ".").toLowerCase();
}, PT = os.data = {}, AT = os.NATIVE = "N", LT = os.POLYFILL = "P", Aw = os, fg = Wv, VT = Hr, zT = Su, MT = fg(fg.bind), ss = function(e, n) {
  return VT(e), n === void 0 ? e : zT ? MT(e, n) : function() {
    return e.apply(n, arguments);
  };
}, Er = {}, UT = ir, BT = ot, Lw = UT && BT(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), qT = mr, HT = String, KT = TypeError, Tr = function(e) {
  if (qT(e)) return e;
  throw KT(HT(e) + " is not an object");
}, WT = ir, GT = Pw, YT = Lw, $s = Tr, pg = Iu, JT = TypeError, vc = Object.defineProperty, QT = Object.getOwnPropertyDescriptor, hc = "enumerable", yc = "configurable", gc = "writable";
Er.f = WT ? YT ? function(n, t, i) {
  if ($s(n), t = pg(t), $s(i), typeof n == "function" && t === "prototype" && "value" in i && gc in i && !i[gc]) {
    var a = QT(n, t);
    a && a[gc] && (n[t] = i.value, i = {
      configurable: yc in i ? i[yc] : a[yc],
      enumerable: hc in i ? i[hc] : a[hc],
      writable: !1
    });
  }
  return vc(n, t, i);
} : vc : function(n, t, i) {
  if ($s(n), t = pg(t), $s(i), GT) try {
    return vc(n, t, i);
  } catch {
  }
  if ("get" in i || "set" in i) throw JT("Accessors not supported");
  return "value" in i && (n[t] = i.value), n;
};
var XT = ir, ZT = Er, eO = qi, bi = XT ? function(e, n, t) {
  return ZT.f(e, n, eO(1, t));
} : function(e, n, t) {
  return e[n] = t, e;
}, Es = ht, nO = Kv, tO = Wv, rO = dt, iO = Ea.f, aO = Aw, Yi = fr, oO = ss, Ji = bi, vg = Gt, sO = function(e) {
  var n = function(t, i, a) {
    if (this instanceof n) {
      switch (arguments.length) {
        case 0:
          return new e();
        case 1:
          return new e(t);
        case 2:
          return new e(t, i);
      }
      return new e(t, i, a);
    }
    return nO(e, this, arguments);
  };
  return n.prototype = e.prototype, n;
}, Xn = function(e, n) {
  var t = e.target, i = e.global, a = e.stat, o = e.proto, s = i ? Es : a ? Es[t] : (Es[t] || {}).prototype, l = i ? Yi : Yi[t] || Ji(Yi, t, {})[t], c = l.prototype, m, d, p, v, y, S, b, j, x;
  for (v in n)
    m = aO(i ? v : t + (a ? "." : "#") + v, e.forced), d = !m && s && vg(s, v), S = l[v], d && (e.dontCallGetSet ? (x = iO(s, v), b = x && x.value) : b = s[v]), y = d && b ? b : n[v], !(d && typeof S == typeof y) && (e.bind && d ? j = oO(y, Es) : e.wrap && d ? j = sO(y) : o && rO(y) ? j = tO(y) : j = y, (e.sham || y && y.sham || S && S.sham) && Ji(j, "sham", !0), Ji(l, v, j), o && (p = t + "Prototype", vg(Yi, p) || Ji(Yi, p, {}), Ji(Yi[p], v, y), e.real && c && (m || !c[v]) && Ji(c, v, y)));
}, lO = yt, uO = Hr, cO = function(e, n, t) {
  try {
    return lO(uO(Object.getOwnPropertyDescriptor(e, n)[t]));
  } catch {
  }
}, dO = dt, mO = String, fO = TypeError, pO = function(e) {
  if (typeof e == "object" || dO(e)) return e;
  throw fO("Can't set " + mO(e) + " as a prototype");
}, vO = cO, hO = Tr, yO = pO, Vw = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, n = {}, t;
  try {
    t = vO(Object.prototype, "__proto__", "set"), t(n, []), e = n instanceof Array;
  } catch {
  }
  return function(a, o) {
    return hO(a), yO(o), e ? t(a, o) : a.__proto__ = o, a;
  };
}() : void 0), gO = Xn, kO = Vw;
gO({ target: "Object", stat: !0 }, {
  setPrototypeOf: kO
});
var bO = fr;
bO.Object.setPrototypeOf;
var eh = {}, _O = Math.ceil, xO = Math.floor, SO = Math.trunc || function(n) {
  var t = +n;
  return (t > 0 ? xO : _O)(t);
}, NO = SO, nh = function(e) {
  var n = +e;
  return n !== n || n === 0 ? 0 : NO(n);
}, wO = nh, jO = Math.max, CO = Math.min, th = function(e, n) {
  var t = wO(e);
  return t < 0 ? jO(t + n, 0) : CO(t, n);
}, FO = nh, IO = Math.min, $O = function(e) {
  return e > 0 ? IO(FO(e), 9007199254740991) : 0;
}, EO = $O, Ra = function(e) {
  return EO(e.length);
}, TO = si, OO = th, RO = Ra, DO = function(e) {
  return function(n, t, i) {
    var a = TO(n), o = RO(a), s = OO(i, o), l;
    if (e && t !== t) {
      for (; o > s; )
        if (l = a[s++], l !== l) return !0;
    } else for (; o > s; s++)
      if ((e || s in a) && a[s] === t) return e || s || 0;
    return !e && -1;
  };
}, zw = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: DO(!1)
}, $u = {}, PO = yt, kc = Gt, AO = si, LO = zw.indexOf, VO = $u, hg = PO([].push), Mw = function(e, n) {
  var t = AO(e), i = 0, a = [], o;
  for (o in t) !kc(VO, o) && kc(t, o) && hg(a, o);
  for (; n.length > i; ) kc(t, o = n[i++]) && (~LO(a, o) || hg(a, o));
  return a;
}, rh = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], zO = Mw, MO = rh, ih = Object.keys || function(n) {
  return zO(n, MO);
}, UO = ir, BO = Lw, qO = Er, HO = Tr, KO = si, WO = ih;
eh.f = UO && !BO ? Object.defineProperties : function(n, t) {
  HO(n);
  for (var i = KO(t), a = WO(t), o = a.length, s = 0, l; o > s; ) qO.f(n, l = a[s++], i[l]);
  return n;
};
var GO = pr, Uw = GO("document", "documentElement"), YO = as, JO = Xv, yg = YO("keys"), Eu = function(e) {
  return yg[e] || (yg[e] = JO(e));
}, QO = Tr, XO = eh, gg = rh, ZO = $u, eR = Uw, nR = Zv, tR = Eu, kg = ">", bg = "<", Bp = "prototype", qp = "script", Bw = tR("IE_PROTO"), bc = function() {
}, qw = function(e) {
  return bg + qp + kg + e + bg + "/" + qp + kg;
}, _g = function(e) {
  e.write(qw("")), e.close();
  var n = e.parentWindow.Object;
  return e = null, n;
}, rR = function() {
  var e = nR("iframe"), n = "java" + qp + ":", t;
  return e.style.display = "none", eR.appendChild(e), e.src = String(n), t = e.contentWindow.document, t.open(), t.write(qw("document.F=Object")), t.close(), t.F;
}, Ts, xl = function() {
  try {
    Ts = new ActiveXObject("htmlfile");
  } catch {
  }
  xl = typeof document < "u" ? document.domain && Ts ? _g(Ts) : rR() : _g(Ts);
  for (var e = gg.length; e--; ) delete xl[Bp][gg[e]];
  return xl();
};
ZO[Bw] = !0;
var ls = Object.create || function(n, t) {
  var i;
  return n !== null ? (bc[Bp] = QO(n), i = new bc(), bc[Bp] = null, i[Bw] = n) : i = xl(), t === void 0 ? i : XO.f(i, t);
}, iR = Xn, aR = ir, oR = ls;
iR({ target: "Object", stat: !0, sham: !aR }, {
  create: oR
});
var sR = fr;
sR.Object;
var us = {};
us.f = Object.getOwnPropertySymbols;
var xg = ir, lR = yt, uR = Nt, cR = ot, _c = ih, dR = us, mR = Nu, fR = Oa, pR = Gv, Qi = Object.assign, Sg = Object.defineProperty, vR = lR([].concat), hR = !Qi || cR(function() {
  if (xg && Qi({ b: 1 }, Qi(Sg({}, "a", {
    enumerable: !0,
    get: function() {
      Sg(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1) return !0;
  var e = {}, n = {}, t = Symbol("assign detection"), i = "abcdefghijklmnopqrst";
  return e[t] = 7, i.split("").forEach(function(a) {
    n[a] = a;
  }), Qi({}, e)[t] !== 7 || _c(Qi({}, n)).join("") !== i;
}) ? function(n, t) {
  for (var i = fR(n), a = arguments.length, o = 1, s = dR.f, l = mR.f; a > o; )
    for (var c = pR(arguments[o++]), m = s ? vR(_c(c), s(c)) : _c(c), d = m.length, p = 0, v; d > p; )
      v = m[p++], (!xg || uR(l, c, v)) && (i[v] = c[v]);
  return i;
} : Qi, yR = Xn, Ng = hR;
yR({ target: "Object", stat: !0, forced: Object.assign !== Ng }, {
  assign: Ng
});
var gR = fr;
gR.Object.assign;
var kR = ot, bR = function(e, n) {
  var t = [][e];
  return !!t && kR(function() {
    t.call(null, n || function() {
      return 1;
    }, 1);
  });
}, _R = Xn, xR = Wv, SR = zw.indexOf, NR = bR, Hp = xR([].indexOf), Hw = !!Hp && 1 / Hp([1], 1, -0) < 0, wR = Hw || !NR("indexOf");
_R({ target: "Array", proto: !0, forced: wR }, {
  indexOf: function(n) {
    var t = arguments.length > 1 ? arguments[1] : void 0;
    return Hw ? Hp(this, n, t) || 0 : SR(this, n, t);
  }
});
var jR = fr, ah = function(e) {
  return jR[e + "Prototype"];
}, CR = ah;
CR("Array").indexOf;
var FR = st, IR = FR("toStringTag"), Kw = {};
Kw[IR] = "z";
var oh = String(Kw) === "[object z]", $R = oh, ER = dt, Sl = Bi, TR = st, OR = TR("toStringTag"), RR = Object, DR = Sl(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", PR = function(e, n) {
  try {
    return e[n];
  } catch {
  }
}, cs = $R ? Sl : function(e) {
  var n, t, i;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t = PR(n = RR(e), OR)) == "string" ? t : DR ? Sl(n) : (i = Sl(n)) === "Object" && ER(n.callee) ? "Arguments" : i;
}, AR = cs, LR = String, Da = function(e) {
  if (AR(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return LR(e);
}, Tu = {}, VR = Mw, zR = rh, MR = zR.concat("length", "prototype");
Tu.f = Object.getOwnPropertyNames || function(n) {
  return VR(n, MR);
};
var Ww = {}, UR = Iu, BR = Er, qR = qi, sh = function(e, n, t) {
  var i = UR(n);
  i in e ? BR.f(e, i, qR(0, t)) : e[i] = t;
}, wg = th, HR = Ra, KR = sh, WR = Array, GR = Math.max, YR = function(e, n, t) {
  for (var i = HR(e), a = wg(n, i), o = wg(t === void 0 ? i : t, i), s = WR(GR(o - a, 0)), l = 0; a < o; a++, l++) KR(s, l, e[a]);
  return s.length = l, s;
}, JR = Bi, QR = si, Gw = Tu.f, XR = YR, Yw = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], ZR = function(e) {
  try {
    return Gw(e);
  } catch {
    return XR(Yw);
  }
};
Ww.f = function(n) {
  return Yw && JR(n) === "Window" ? ZR(n) : Gw(QR(n));
};
var eD = bi, ds = function(e, n, t, i) {
  return i && i.enumerable ? e[n] = t : eD(e, n, t), e;
}, nD = Er, Jw = function(e, n, t) {
  return nD.f(e, n, t);
}, ms = {}, tD = st;
ms.f = tD;
var jg = fr, rD = Gt, iD = ms, aD = Er.f, Yt = function(e) {
  var n = jg.Symbol || (jg.Symbol = {});
  rD(n, e) || aD(n, e, {
    value: iD.f(e)
  });
}, oD = Nt, sD = pr, lD = st, uD = ds, Qw = function() {
  var e = sD("Symbol"), n = e && e.prototype, t = n && n.valueOf, i = lD("toPrimitive");
  n && !n[i] && uD(n, i, function(a) {
    return oD(t, this);
  }, {});
}, cD = oh, dD = cs, mD = cD ? {}.toString : function() {
  return "[object " + dD(this) + "]";
}, fD = oh, pD = Er.f, vD = bi, hD = Gt, yD = mD, gD = st, Cg = gD("toStringTag"), Pa = function(e, n, t, i) {
  if (e) {
    var a = t ? e : e.prototype;
    hD(a, Cg) || pD(a, Cg, { configurable: !0, value: n }), i && !fD && vD(a, "toString", yD);
  }
}, kD = ht, bD = dt, Fg = kD.WeakMap, _D = bD(Fg) && /native code/.test(String(Fg)), xD = _D, Xw = ht, SD = mr, ND = bi, xc = Gt, Sc = Qv, wD = Eu, jD = $u, Ig = "Object already initialized", Kp = Xw.TypeError, CD = Xw.WeakMap, Ul, Wo, Bl, FD = function(e) {
  return Bl(e) ? Wo(e) : Ul(e, {});
}, ID = function(e) {
  return function(n) {
    var t;
    if (!SD(n) || (t = Wo(n)).type !== e)
      throw Kp("Incompatible receiver, " + e + " required");
    return t;
  };
};
if (xD || Sc.state) {
  var Rr = Sc.state || (Sc.state = new CD());
  Rr.get = Rr.get, Rr.has = Rr.has, Rr.set = Rr.set, Ul = function(e, n) {
    if (Rr.has(e)) throw Kp(Ig);
    return n.facade = e, Rr.set(e, n), n;
  }, Wo = function(e) {
    return Rr.get(e) || {};
  }, Bl = function(e) {
    return Rr.has(e);
  };
} else {
  var Xi = wD("state");
  jD[Xi] = !0, Ul = function(e, n) {
    if (xc(e, Xi)) throw Kp(Ig);
    return n.facade = e, ND(e, Xi, n), n;
  }, Wo = function(e) {
    return xc(e, Xi) ? e[Xi] : {};
  }, Bl = function(e) {
    return xc(e, Xi);
  };
}
var Ou = {
  set: Ul,
  get: Wo,
  has: Bl,
  enforce: FD,
  getterFor: ID
}, $D = Bi, Ru = Array.isArray || function(n) {
  return $D(n) === "Array";
}, ED = yt, TD = dt, Wp = Qv, OD = ED(Function.toString);
TD(Wp.inspectSource) || (Wp.inspectSource = function(e) {
  return OD(e);
});
var Zw = Wp.inspectSource, RD = yt, DD = ot, ej = dt, PD = cs, AD = pr, LD = Zw, nj = function() {
}, VD = [], tj = AD("Reflect", "construct"), lh = /^\s*(?:class|function)\b/, zD = RD(lh.exec), MD = !lh.exec(nj), Ja = function(n) {
  if (!ej(n)) return !1;
  try {
    return tj(nj, VD, n), !0;
  } catch {
    return !1;
  }
}, rj = function(n) {
  if (!ej(n)) return !1;
  switch (PD(n)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return MD || !!zD(lh, LD(n));
  } catch {
    return !0;
  }
};
rj.sham = !0;
var uh = !tj || DD(function() {
  var e;
  return Ja(Ja.call) || !Ja(Object) || !Ja(function() {
    e = !0;
  }) || e;
}) ? rj : Ja, $g = Ru, UD = uh, BD = mr, qD = st, HD = qD("species"), Eg = Array, KD = function(e) {
  var n;
  return $g(e) && (n = e.constructor, UD(n) && (n === Eg || $g(n.prototype)) ? n = void 0 : BD(n) && (n = n[HD], n === null && (n = void 0))), n === void 0 ? Eg : n;
}, WD = KD, ij = function(e, n) {
  return new (WD(e))(n === 0 ? 0 : n);
}, GD = ss, YD = yt, JD = Gv, QD = Oa, XD = Ra, ZD = ij, Tg = YD([].push), eP = function(e) {
  var n = e === 1, t = e === 2, i = e === 3, a = e === 4, o = e === 6, s = e === 7, l = e === 5 || o;
  return function(c, m, d, p) {
    for (var v = QD(c), y = JD(v), S = GD(m, d), b = XD(y), j = 0, x = p || ZD, h = n ? x(c, b) : t || s ? x(c, 0) : void 0, P, N; b > j; j++) if ((l || j in y) && (P = y[j], N = S(P, j, v), e))
      if (n) h[j] = N;
      else if (N) switch (e) {
        case 3:
          return !0;
        // some
        case 5:
          return P;
        // find
        case 6:
          return j;
        // findIndex
        case 2:
          Tg(h, P);
      }
      else switch (e) {
        case 4:
          return !1;
        // every
        case 7:
          Tg(h, P);
      }
    return o ? -1 : i || a ? a : h;
  };
}, nP = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: eP(0)
}, Du = Xn, ch = ht, dh = Nt, tP = yt, xa = ir, Sa = Ta, rP = ot, gt = Gt, iP = rs, Gp = Tr, Pu = si, mh = Iu, aP = Da, Yp = qi, Go = ls, aj = ih, oP = Tu, oj = Ww, sP = us, sj = Ea, lj = Er, lP = eh, uj = Nu, Og = ds, uP = Jw, fh = as, cP = Eu, cj = $u, Rg = Xv, dP = st, mP = ms, fP = Yt, pP = Qw, vP = Pa, dj = Ou, Au = nP.forEach, Mt = cP("hidden"), Lu = "Symbol", Yo = "prototype", hP = dj.set, Dg = dj.getterFor(Lu), wr = Object[Yo], Li = ch.Symbol, Oo = Li && Li[Yo], yP = ch.TypeError, Nc = ch.QObject, mj = sj.f, Ei = lj.f, fj = oj.f, gP = uj.f, pj = tP([].push), ai = fh("symbols"), fs = fh("op-symbols"), kP = fh("wks"), Jp = !Nc || !Nc[Yo] || !Nc[Yo].findChild, Qp = xa && rP(function() {
  return Go(Ei({}, "a", {
    get: function() {
      return Ei(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? function(e, n, t) {
  var i = mj(wr, n);
  i && delete wr[n], Ei(e, n, t), i && e !== wr && Ei(wr, n, i);
} : Ei, wc = function(e, n) {
  var t = ai[e] = Go(Oo);
  return hP(t, {
    type: Lu,
    tag: e,
    description: n
  }), xa || (t.description = n), t;
}, Vu = function(n, t, i) {
  n === wr && Vu(fs, t, i), Gp(n);
  var a = mh(t);
  return Gp(i), gt(ai, a) ? (i.enumerable ? (gt(n, Mt) && n[Mt][a] && (n[Mt][a] = !1), i = Go(i, { enumerable: Yp(0, !1) })) : (gt(n, Mt) || Ei(n, Mt, Yp(1, {})), n[Mt][a] = !0), Qp(n, a, i)) : Ei(n, a, i);
}, ph = function(n, t) {
  Gp(n);
  var i = Pu(t), a = aj(i).concat(gj(i));
  return Au(a, function(o) {
    (!xa || dh(vj, i, o)) && Vu(n, o, i[o]);
  }), n;
}, bP = function(n, t) {
  return t === void 0 ? Go(n) : ph(Go(n), t);
}, vj = function(n) {
  var t = mh(n), i = dh(gP, this, t);
  return this === wr && gt(ai, t) && !gt(fs, t) ? !1 : i || !gt(this, t) || !gt(ai, t) || gt(this, Mt) && this[Mt][t] ? i : !0;
}, hj = function(n, t) {
  var i = Pu(n), a = mh(t);
  if (!(i === wr && gt(ai, a) && !gt(fs, a))) {
    var o = mj(i, a);
    return o && gt(ai, a) && !(gt(i, Mt) && i[Mt][a]) && (o.enumerable = !0), o;
  }
}, yj = function(n) {
  var t = fj(Pu(n)), i = [];
  return Au(t, function(a) {
    !gt(ai, a) && !gt(cj, a) && pj(i, a);
  }), i;
}, gj = function(e) {
  var n = e === wr, t = fj(n ? fs : Pu(e)), i = [];
  return Au(t, function(a) {
    gt(ai, a) && (!n || gt(wr, a)) && pj(i, ai[a]);
  }), i;
};
Sa || (Li = function() {
  if (iP(Oo, this)) throw yP("Symbol is not a constructor");
  var n = !arguments.length || arguments[0] === void 0 ? void 0 : aP(arguments[0]), t = Rg(n), i = function(a) {
    this === wr && dh(i, fs, a), gt(this, Mt) && gt(this[Mt], t) && (this[Mt][t] = !1), Qp(this, t, Yp(1, a));
  };
  return xa && Jp && Qp(wr, t, { configurable: !0, set: i }), wc(t, n);
}, Oo = Li[Yo], Og(Oo, "toString", function() {
  return Dg(this).tag;
}), Og(Li, "withoutSetter", function(e) {
  return wc(Rg(e), e);
}), uj.f = vj, lj.f = Vu, lP.f = ph, sj.f = hj, oP.f = oj.f = yj, sP.f = gj, mP.f = function(e) {
  return wc(dP(e), e);
}, xa && uP(Oo, "description", {
  configurable: !0,
  get: function() {
    return Dg(this).description;
  }
}));
Du({ global: !0, wrap: !0, forced: !Sa, sham: !Sa }, {
  Symbol: Li
});
Au(aj(kP), function(e) {
  fP(e);
});
Du({ target: Lu, stat: !0, forced: !Sa }, {
  useSetter: function() {
    Jp = !0;
  },
  useSimple: function() {
    Jp = !1;
  }
});
Du({ target: "Object", stat: !0, forced: !Sa, sham: !xa }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: bP,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: Vu,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: ph,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: hj
});
Du({ target: "Object", stat: !0, forced: !Sa }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: yj
});
pP();
vP(Li, Lu);
cj[Mt] = !0;
var _P = Ta, kj = _P && !!Symbol.for && !!Symbol.keyFor, xP = Xn, SP = pr, NP = Gt, wP = Da, bj = as, jP = kj, jc = bj("string-to-symbol-registry"), CP = bj("symbol-to-string-registry");
xP({ target: "Symbol", stat: !0, forced: !jP }, {
  for: function(e) {
    var n = wP(e);
    if (NP(jc, n)) return jc[n];
    var t = SP("Symbol")(n);
    return jc[n] = t, CP[t] = n, t;
  }
});
var FP = Xn, IP = Gt, $P = Fu, EP = is, TP = as, OP = kj, Pg = TP("symbol-to-string-registry");
FP({ target: "Symbol", stat: !0, forced: !OP }, {
  keyFor: function(n) {
    if (!$P(n)) throw TypeError(EP(n) + " is not a symbol");
    if (IP(Pg, n)) return Pg[n];
  }
});
var RP = yt, vh = RP([].slice), DP = yt, Ag = Ru, PP = dt, Lg = Bi, AP = Da, Vg = DP([].push), LP = function(e) {
  if (PP(e)) return e;
  if (Ag(e)) {
    for (var n = e.length, t = [], i = 0; i < n; i++) {
      var a = e[i];
      typeof a == "string" ? Vg(t, a) : (typeof a == "number" || Lg(a) === "Number" || Lg(a) === "String") && Vg(t, AP(a));
    }
    var o = t.length, s = !0;
    return function(l, c) {
      if (s)
        return s = !1, c;
      if (Ag(this)) return c;
      for (var m = 0; m < o; m++) if (t[m] === l) return c;
    };
  }
}, VP = Xn, _j = pr, xj = Kv, zP = Nt, ps = yt, Sj = ot, zg = dt, Mg = Fu, Nj = vh, MP = LP, UP = Ta, BP = String, yi = _j("JSON", "stringify"), Os = ps(/./.exec), Ug = ps("".charAt), qP = ps("".charCodeAt), HP = ps("".replace), KP = ps(1 .toString), WP = /[\uD800-\uDFFF]/g, Bg = /^[\uD800-\uDBFF]$/, qg = /^[\uDC00-\uDFFF]$/, Hg = !UP || Sj(function() {
  var e = _j("Symbol")("stringify detection");
  return yi([e]) !== "[null]" || yi({ a: e }) !== "{}" || yi(Object(e)) !== "{}";
}), Kg = Sj(function() {
  return yi("\uDF06\uD834") !== '"\\udf06\\ud834"' || yi("\uDEAD") !== '"\\udead"';
}), GP = function(e, n) {
  var t = Nj(arguments), i = MP(n);
  if (!(!zg(i) && (e === void 0 || Mg(e))))
    return t[1] = function(a, o) {
      if (zg(i) && (o = zP(i, this, BP(a), o)), !Mg(o)) return o;
    }, xj(yi, null, t);
}, YP = function(e, n, t) {
  var i = Ug(t, n - 1), a = Ug(t, n + 1);
  return Os(Bg, e) && !Os(qg, a) || Os(qg, e) && !Os(Bg, i) ? "\\u" + KP(qP(e, 0), 16) : e;
};
yi && VP({ target: "JSON", stat: !0, forced: Hg || Kg }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(n, t, i) {
    var a = Nj(arguments), o = xj(Hg ? GP : yi, null, a);
    return Kg && typeof o == "string" ? HP(o, WP, YP) : o;
  }
});
var JP = Xn, QP = Ta, XP = ot, wj = us, ZP = Oa, eA = !QP || XP(function() {
  wj.f(1);
});
JP({ target: "Object", stat: !0, forced: eA }, {
  getOwnPropertySymbols: function(n) {
    var t = wj.f;
    return t ? t(ZP(n)) : [];
  }
});
var nA = fr;
nA.Object.getOwnPropertySymbols;
var tA = Xn, rA = ot, iA = si, jj = Ea.f, Cj = ir, aA = !Cj || rA(function() {
  jj(1);
});
tA({ target: "Object", stat: !0, forced: aA, sham: !Cj }, {
  getOwnPropertyDescriptor: function(n, t) {
    return jj(iA(n), t);
  }
});
var oA = fr, sA = oA.Object;
sA.getOwnPropertyDescriptor.sham;
var lA = Xn, uA = ir, Wg = Er.f;
lA({ target: "Object", stat: !0, forced: Object.defineProperty !== Wg, sham: !uA }, {
  defineProperty: Wg
});
var cA = fr, dA = cA.Object;
dA.defineProperty.sham;
var mA = ot, fA = !mA(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), pA = Gt, vA = dt, hA = Oa, yA = Eu, gA = fA, Gg = yA("IE_PROTO"), Xp = Object, kA = Xp.prototype, hh = gA ? Xp.getPrototypeOf : function(e) {
  var n = hA(e);
  if (pA(n, Gg)) return n[Gg];
  var t = n.constructor;
  return vA(t) && n instanceof t ? t.prototype : n instanceof Xp ? kA : null;
}, bA = pr, _A = yt, xA = Tu, SA = us, NA = Tr, wA = _A([].concat), jA = bA("Reflect", "ownKeys") || function(n) {
  var t = xA.f(NA(n)), i = SA.f;
  return i ? wA(t, i(n)) : t;
}, Yg = Gt, CA = jA, FA = Ea, IA = Er, $A = function(e, n, t) {
  for (var i = CA(n), a = IA.f, o = FA.f, s = 0; s < i.length; s++) {
    var l = i[s];
    !Yg(e, l) && !(t && Yg(t, l)) && a(e, l, o(n, l));
  }
}, EA = mr, TA = bi, OA = function(e, n) {
  EA(n) && "cause" in n && TA(e, "cause", n.cause);
}, RA = yt, Fj = Error, DA = RA("".replace), PA = function(e) {
  return String(Fj(e).stack);
}("zxcasd"), Ij = /\n\s*at [^:]*:[^\n]*/, AA = Ij.test(PA), LA = function(e, n) {
  if (AA && typeof e == "string" && !Fj.prepareStackTrace)
    for (; n--; ) e = DA(e, Ij, "");
  return e;
}, VA = ot, zA = qi, MA = !VA(function() {
  var e = Error("a");
  return "stack" in e ? (Object.defineProperty(e, "stack", zA(1, 7)), e.stack !== 7) : !0;
}), UA = bi, BA = LA, qA = MA, Jg = Error.captureStackTrace, HA = function(e, n, t, i) {
  qA && (Jg ? Jg(e, n) : UA(e, "stack", BA(t, i)));
}, Aa = {}, KA = st, WA = Aa, GA = KA("iterator"), YA = Array.prototype, JA = function(e) {
  return e !== void 0 && (WA.Array === e || YA[GA] === e);
}, QA = cs, Qg = Jv, XA = wu, ZA = Aa, eL = st, nL = eL("iterator"), $j = function(e) {
  if (!XA(e)) return Qg(e, nL) || Qg(e, "@@iterator") || ZA[QA(e)];
}, tL = Nt, rL = Hr, iL = Tr, aL = is, oL = $j, sL = TypeError, lL = function(e, n) {
  var t = arguments.length < 2 ? oL(e) : n;
  if (rL(t)) return iL(tL(t, e));
  throw sL(aL(e) + " is not iterable");
}, uL = Nt, Xg = Tr, cL = Jv, dL = function(e, n, t) {
  var i, a;
  Xg(e);
  try {
    if (i = cL(e, "return"), !i) {
      if (n === "throw") throw t;
      return t;
    }
    i = uL(i, e);
  } catch (o) {
    a = !0, i = o;
  }
  if (n === "throw") throw t;
  if (a) throw i;
  return Xg(i), t;
}, mL = ss, fL = Nt, pL = Tr, vL = is, hL = JA, yL = Ra, Zg = rs, gL = lL, kL = $j, ek = dL, bL = TypeError, Nl = function(e, n) {
  this.stopped = e, this.result = n;
}, nk = Nl.prototype, vs = function(e, n, t) {
  var i = t && t.that, a = !!(t && t.AS_ENTRIES), o = !!(t && t.IS_RECORD), s = !!(t && t.IS_ITERATOR), l = !!(t && t.INTERRUPTED), c = mL(n, i), m, d, p, v, y, S, b, j = function(h) {
    return m && ek(m, "normal", h), new Nl(!0, h);
  }, x = function(h) {
    return a ? (pL(h), l ? c(h[0], h[1], j) : c(h[0], h[1])) : l ? c(h, j) : c(h);
  };
  if (o)
    m = e.iterator;
  else if (s)
    m = e;
  else {
    if (d = kL(e), !d) throw bL(vL(e) + " is not iterable");
    if (hL(d)) {
      for (p = 0, v = yL(e); v > p; p++)
        if (y = x(e[p]), y && Zg(nk, y)) return y;
      return new Nl(!1);
    }
    m = gL(e, d);
  }
  for (S = o ? e.next : m.next; !(b = fL(S, m)).done; ) {
    try {
      y = x(b.value);
    } catch (h) {
      ek(m, "throw", h);
    }
    if (typeof y == "object" && y && Zg(nk, y)) return y;
  }
  return new Nl(!1);
}, _L = Da, xL = function(e, n) {
  return e === void 0 ? arguments.length < 2 ? "" : n : _L(e);
}, SL = Xn, NL = rs, wL = hh, ql = Vw, jL = $A, Ej = ls, Cc = bi, Fc = qi, CL = OA, FL = HA, IL = vs, $L = xL, EL = st, TL = EL("toStringTag"), Hl = Error, OL = [].push, Na = function(n, t) {
  var i = NL(Ic, this), a;
  ql ? a = ql(Hl(), i ? wL(this) : Ic) : (a = i ? this : Ej(Ic), Cc(a, TL, "Error")), t !== void 0 && Cc(a, "message", $L(t)), FL(a, Na, a.stack, 1), arguments.length > 2 && CL(a, arguments[2]);
  var o = [];
  return IL(n, OL, { that: o }), Cc(a, "errors", o), a;
};
ql ? ql(Na, Hl) : jL(Na, Hl, { name: !0 });
var Ic = Na.prototype = Ej(Hl.prototype, {
  constructor: Fc(1, Na),
  message: Fc(1, ""),
  name: Fc(1, "AggregateError")
});
SL({ global: !0 }, {
  AggregateError: Na
});
var Zp = ir, RL = Gt, Tj = Function.prototype, DL = Zp && Object.getOwnPropertyDescriptor, Oj = RL(Tj, "name"), PL = Oj && (function() {
}).name === "something";
Oj && (!Zp || Zp && DL(Tj, "name").configurable);
var AL = {
  PROPER: PL
}, LL = ot, VL = dt, zL = mr, ML = ls, tk = hh, UL = ds, BL = st, ev = BL("iterator"), Rj = !1, ii, $c, Ec;
[].keys && (Ec = [].keys(), "next" in Ec ? ($c = tk(tk(Ec)), $c !== Object.prototype && (ii = $c)) : Rj = !0);
var qL = !zL(ii) || LL(function() {
  var e = {};
  return ii[ev].call(e) !== e;
});
qL ? ii = {} : ii = ML(ii);
VL(ii[ev]) || UL(ii, ev, function() {
  return this;
});
var Dj = {
  IteratorPrototype: ii,
  BUGGY_SAFARI_ITERATORS: Rj
}, HL = Dj.IteratorPrototype, KL = ls, WL = qi, GL = Pa, YL = Aa, JL = function() {
  return this;
}, QL = function(e, n, t, i) {
  var a = n + " Iterator";
  return e.prototype = KL(HL, { next: WL(+!i, t) }), GL(e, a, !1, !0), YL[a] = JL, e;
}, XL = Xn, ZL = Nt, e2 = AL, n2 = QL, t2 = hh, r2 = Pa, rk = ds, i2 = st, ik = Aa, a2 = Dj, o2 = e2.PROPER, Rs = a2.BUGGY_SAFARI_ITERATORS, Tc = i2("iterator"), ak = "keys", Ds = "values", ok = "entries", s2 = function() {
  return this;
}, Pj = function(e, n, t, i, a, o, s) {
  n2(t, n, i);
  var l = function(x) {
    if (x === a && v) return v;
    if (!Rs && x in d) return d[x];
    switch (x) {
      case ak:
        return function() {
          return new t(this, x);
        };
      case Ds:
        return function() {
          return new t(this, x);
        };
      case ok:
        return function() {
          return new t(this, x);
        };
    }
    return function() {
      return new t(this);
    };
  }, c = n + " Iterator", m = !1, d = e.prototype, p = d[Tc] || d["@@iterator"] || a && d[a], v = !Rs && p || l(a), y = n === "Array" && d.entries || p, S, b, j;
  if (y && (S = t2(y.call(new e())), S !== Object.prototype && S.next && (r2(S, c, !0, !0), ik[c] = s2)), o2 && a === Ds && p && p.name !== Ds && (m = !0, v = function() {
    return ZL(p, this);
  }), a)
    if (b = {
      values: l(Ds),
      keys: o ? v : l(ak),
      entries: l(ok)
    }, s) for (j in b)
      (Rs || m || !(j in d)) && rk(d, j, b[j]);
    else XL({ target: n, proto: !0, forced: Rs || m }, b);
  return s && d[Tc] !== v && rk(d, Tc, v, {}), ik[n] = v, b;
}, Aj = function(e, n) {
  return { value: e, done: n };
}, l2 = si, sk = Aa, Lj = Ou;
Er.f;
var u2 = Pj, Ps = Aj, Vj = "Array Iterator", c2 = Lj.set, d2 = Lj.getterFor(Vj);
u2(Array, "Array", function(e, n) {
  c2(this, {
    type: Vj,
    target: l2(e),
    // target
    index: 0,
    // next index
    kind: n
    // kind
  });
}, function() {
  var e = d2(this), n = e.target, t = e.kind, i = e.index++;
  if (!n || i >= n.length)
    return e.target = void 0, Ps(void 0, !0);
  switch (t) {
    case "keys":
      return Ps(i, !1);
    case "values":
      return Ps(n[i], !1);
  }
  return Ps([i, n[i]], !1);
}, "values");
sk.Arguments = sk.Array;
var m2 = ht, f2 = Bi, zu = f2(m2.process) === "process", p2 = pr, v2 = Jw, h2 = st, y2 = ir, lk = h2("species"), g2 = function(e) {
  var n = p2(e);
  y2 && n && !n[lk] && v2(n, lk, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, k2 = rs, b2 = TypeError, _2 = function(e, n) {
  if (k2(n, e)) return e;
  throw b2("Incorrect invocation");
}, x2 = uh, S2 = is, N2 = TypeError, w2 = function(e) {
  if (x2(e)) return e;
  throw N2(S2(e) + " is not a constructor");
}, uk = Tr, j2 = w2, C2 = wu, F2 = st, I2 = F2("species"), zj = function(e, n) {
  var t = uk(e).constructor, i;
  return t === void 0 || C2(i = uk(t)[I2]) ? n : j2(i);
}, $2 = TypeError, E2 = function(e, n) {
  if (e < n) throw $2("Not enough arguments");
  return e;
}, T2 = ju, Mj = /(?:ipad|iphone|ipod).*applewebkit/i.test(T2), er = ht, O2 = Kv, R2 = ss, ck = dt, D2 = Gt, Uj = ot, dk = Uw, P2 = vh, mk = Zv, A2 = E2, L2 = Mj, V2 = zu, nv = er.setImmediate, fk = er.clearImmediate, z2 = er.process, Oc = er.Dispatch, M2 = er.Function, pk = er.MessageChannel, U2 = er.String, Rc = 0, Do = {}, vk = "onreadystatechange", Jo, wi, Dc, Pc;
Uj(function() {
  Jo = er.location;
});
var yh = function(e) {
  if (D2(Do, e)) {
    var n = Do[e];
    delete Do[e], n();
  }
}, Ac = function(e) {
  return function() {
    yh(e);
  };
}, hk = function(e) {
  yh(e.data);
}, yk = function(e) {
  er.postMessage(U2(e), Jo.protocol + "//" + Jo.host);
};
(!nv || !fk) && (nv = function(n) {
  A2(arguments.length, 1);
  var t = ck(n) ? n : M2(n), i = P2(arguments, 1);
  return Do[++Rc] = function() {
    O2(t, void 0, i);
  }, wi(Rc), Rc;
}, fk = function(n) {
  delete Do[n];
}, V2 ? wi = function(e) {
  z2.nextTick(Ac(e));
} : Oc && Oc.now ? wi = function(e) {
  Oc.now(Ac(e));
} : pk && !L2 ? (Dc = new pk(), Pc = Dc.port2, Dc.port1.onmessage = hk, wi = R2(Pc.postMessage, Pc)) : er.addEventListener && ck(er.postMessage) && !er.importScripts && Jo && Jo.protocol !== "file:" && !Uj(yk) ? (wi = yk, er.addEventListener("message", hk, !1)) : vk in mk("script") ? wi = function(e) {
  dk.appendChild(mk("script"))[vk] = function() {
    dk.removeChild(this), yh(e);
  };
} : wi = function(e) {
  setTimeout(Ac(e), 0);
});
var Bj = {
  set: nv
}, qj = function() {
  this.head = null, this.tail = null;
};
qj.prototype = {
  add: function(e) {
    var n = { item: e, next: null }, t = this.tail;
    t ? t.next = n : this.head = n, this.tail = n;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var n = this.head = e.next;
      return n === null && (this.tail = null), e.item;
    }
  }
};
var Hj = qj, B2 = ju, q2 = /ipad|iphone|ipod/i.test(B2) && typeof Pebble < "u", H2 = ju, K2 = /web0s(?!.*chrome)/i.test(H2), Ui = ht, gk = ss, W2 = Ea.f, Lc = Bj.set, G2 = Hj, Y2 = Mj, J2 = q2, Q2 = K2, Vc = zu, kk = Ui.MutationObserver || Ui.WebKitMutationObserver, bk = Ui.document, _k = Ui.process, As = Ui.Promise, xk = W2(Ui, "queueMicrotask"), tv = xk && xk.value, Zi, zc, Mc, Ls, Sk;
if (!tv) {
  var Vs = new G2(), zs = function() {
    var e, n;
    for (Vc && (e = _k.domain) && e.exit(); n = Vs.get(); ) try {
      n();
    } catch (t) {
      throw Vs.head && Zi(), t;
    }
    e && e.enter();
  };
  !Y2 && !Vc && !Q2 && kk && bk ? (zc = !0, Mc = bk.createTextNode(""), new kk(zs).observe(Mc, { characterData: !0 }), Zi = function() {
    Mc.data = zc = !zc;
  }) : !J2 && As && As.resolve ? (Ls = As.resolve(void 0), Ls.constructor = As, Sk = gk(Ls.then, Ls), Zi = function() {
    Sk(zs);
  }) : Vc ? Zi = function() {
    _k.nextTick(zs);
  } : (Lc = gk(Lc, Ui), Zi = function() {
    Lc(zs);
  }), tv = function(e) {
    Vs.head || Zi(), Vs.add(e);
  };
}
var X2 = tv, Z2 = function(e, n) {
  try {
    arguments.length === 1 ? console.error(e) : console.error(e, n);
  } catch {
  }
}, hs = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (n) {
    return { error: !0, value: n };
  }
}, eV = ht, La = eV.Promise, Kj = typeof Deno == "object" && Deno && typeof Deno.version == "object", nV = Kj, tV = zu, rV = !nV && !tV && typeof window == "object" && typeof document == "object", iV = ht, Po = La, aV = dt, oV = Aw, sV = Zw, lV = st, uV = rV, cV = Kj, Uc = Cu, Nk = Po && Po.prototype, dV = lV("species"), wk = !1, Wj = aV(iV.PromiseRejectionEvent), mV = oV("Promise", function() {
  var e = sV(Po), n = e !== String(Po);
  if (!n && Uc === 66 || !(Nk.catch && Nk.finally)) return !0;
  if (!Uc || Uc < 51 || !/native code/.test(e)) {
    var t = new Po(function(o) {
      o(1);
    }), i = function(o) {
      o(function() {
      }, function() {
      });
    }, a = t.constructor = {};
    if (a[dV] = i, wk = t.then(function() {
    }) instanceof i, !wk) return !0;
  }
  return !n && (uV || cV) && !Wj;
}), ys = {
  CONSTRUCTOR: mV,
  REJECTION_EVENT: Wj
}, _i = {}, jk = Hr, fV = TypeError, pV = function(e) {
  var n, t;
  this.promise = new e(function(i, a) {
    if (n !== void 0 || t !== void 0) throw fV("Bad Promise constructor");
    n = i, t = a;
  }), this.resolve = jk(n), this.reject = jk(t);
};
_i.f = function(e) {
  return new pV(e);
};
var vV = Xn, Kl = zu, ki = ht, gs = Nt, hV = ds, yV = Pa, gV = g2, kV = Hr, rv = dt, bV = mr, _V = _2, xV = zj, Gj = Bj.set, gh = X2, SV = Z2, NV = hs, wV = Hj, Yj = Ou, iv = La, Jj = ys, Qj = _i, Mu = "Promise", Xj = Jj.CONSTRUCTOR, jV = Jj.REJECTION_EVENT, Bc = Yj.getterFor(Mu), CV = Yj.set, FV = iv && iv.prototype, ma = iv, qc = FV, Zj = ki.TypeError, av = ki.document, kh = ki.process, ov = Qj.f, IV = ov, $V = !!(av && av.createEvent && ki.dispatchEvent), e1 = "unhandledrejection", EV = "rejectionhandled", Ck = 0, n1 = 1, TV = 2, bh = 1, t1 = 2, Ms, Fk, OV, r1 = function(e) {
  var n;
  return bV(e) && rv(n = e.then) ? n : !1;
}, i1 = function(e, n) {
  var t = n.value, i = n.state === n1, a = i ? e.ok : e.fail, o = e.resolve, s = e.reject, l = e.domain, c, m, d;
  try {
    a ? (i || (n.rejection === t1 && DV(n), n.rejection = bh), a === !0 ? c = t : (l && l.enter(), c = a(t), l && (l.exit(), d = !0)), c === e.promise ? s(Zj("Promise-chain cycle")) : (m = r1(c)) ? gs(m, c, o, s) : o(c)) : s(t);
  } catch (p) {
    l && !d && l.exit(), s(p);
  }
}, a1 = function(e, n) {
  e.notified || (e.notified = !0, gh(function() {
    for (var t = e.reactions, i; i = t.get(); )
      i1(i, e);
    e.notified = !1, n && !e.rejection && RV(e);
  }));
}, o1 = function(e, n, t) {
  var i, a;
  $V ? (i = av.createEvent("Event"), i.promise = n, i.reason = t, i.initEvent(e, !1, !0), ki.dispatchEvent(i)) : i = { promise: n, reason: t }, !jV && (a = ki["on" + e]) ? a(i) : e === e1 && SV("Unhandled promise rejection", t);
}, RV = function(e) {
  gs(Gj, ki, function() {
    var n = e.facade, t = e.value, i = Ik(e), a;
    if (i && (a = NV(function() {
      Kl ? kh.emit("unhandledRejection", t, n) : o1(e1, n, t);
    }), e.rejection = Kl || Ik(e) ? t1 : bh, a.error))
      throw a.value;
  });
}, Ik = function(e) {
  return e.rejection !== bh && !e.parent;
}, DV = function(e) {
  gs(Gj, ki, function() {
    var n = e.facade;
    Kl ? kh.emit("rejectionHandled", n) : o1(EV, n, e.value);
  });
}, fa = function(e, n, t) {
  return function(i) {
    e(n, i, t);
  };
}, va = function(e, n, t) {
  e.done || (e.done = !0, t && (e = t), e.value = n, e.state = TV, a1(e, !0));
}, sv = function(e, n, t) {
  if (!e.done) {
    e.done = !0, t && (e = t);
    try {
      if (e.facade === n) throw Zj("Promise can't be resolved itself");
      var i = r1(n);
      i ? gh(function() {
        var a = { done: !1 };
        try {
          gs(
            i,
            n,
            fa(sv, a, e),
            fa(va, a, e)
          );
        } catch (o) {
          va(a, o, e);
        }
      }) : (e.value = n, e.state = n1, a1(e, !1));
    } catch (a) {
      va({ done: !1 }, a, e);
    }
  }
};
Xj && (ma = function(n) {
  _V(this, qc), kV(n), gs(Ms, this);
  var t = Bc(this);
  try {
    n(fa(sv, t), fa(va, t));
  } catch (i) {
    va(t, i);
  }
}, qc = ma.prototype, Ms = function(n) {
  CV(this, {
    type: Mu,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new wV(),
    rejection: !1,
    state: Ck,
    value: void 0
  });
}, Ms.prototype = hV(qc, "then", function(n, t) {
  var i = Bc(this), a = ov(xV(this, ma));
  return i.parent = !0, a.ok = rv(n) ? n : !0, a.fail = rv(t) && t, a.domain = Kl ? kh.domain : void 0, i.state === Ck ? i.reactions.add(a) : gh(function() {
    i1(a, i);
  }), a.promise;
}), Fk = function() {
  var e = new Ms(), n = Bc(e);
  this.promise = e, this.resolve = fa(sv, n), this.reject = fa(va, n);
}, Qj.f = ov = function(e) {
  return e === ma || e === OV ? new Fk(e) : IV(e);
});
vV({ global: !0, wrap: !0, forced: Xj }, {
  Promise: ma
});
yV(ma, Mu, !1, !0);
gV(Mu);
var PV = st, s1 = PV("iterator"), l1 = !1;
try {
  var AV = 0, $k = {
    next: function() {
      return { done: !!AV++ };
    },
    return: function() {
      l1 = !0;
    }
  };
  $k[s1] = function() {
    return this;
  }, Array.from($k, function() {
    throw 2;
  });
} catch {
}
var LV = function(e, n) {
  if (!n && !l1) return !1;
  var t = !1;
  try {
    var i = {};
    i[s1] = function() {
      return {
        next: function() {
          return { done: t = !0 };
        }
      };
    }, e(i);
  } catch {
  }
  return t;
}, VV = La, zV = LV, MV = ys.CONSTRUCTOR, Uu = MV || !zV(function(e) {
  VV.all(e).then(void 0, function() {
  });
}), UV = Xn, BV = Nt, qV = Hr, HV = _i, KV = hs, WV = vs, GV = Uu;
UV({ target: "Promise", stat: !0, forced: GV }, {
  all: function(n) {
    var t = this, i = HV.f(t), a = i.resolve, o = i.reject, s = KV(function() {
      var l = qV(t.resolve), c = [], m = 0, d = 1;
      WV(n, function(p) {
        var v = m++, y = !1;
        d++, BV(l, t, p).then(function(S) {
          y || (y = !0, c[v] = S, --d || a(c));
        }, o);
      }), --d || a(c);
    });
    return s.error && o(s.value), i.promise;
  }
});
var YV = Xn, JV = ys.CONSTRUCTOR, Ek = La;
Ek && Ek.prototype;
YV({ target: "Promise", proto: !0, forced: JV, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
var QV = Xn, XV = Nt, ZV = Hr, e3 = _i, n3 = hs, t3 = vs, r3 = Uu;
QV({ target: "Promise", stat: !0, forced: r3 }, {
  race: function(n) {
    var t = this, i = e3.f(t), a = i.reject, o = n3(function() {
      var s = ZV(t.resolve);
      t3(n, function(l) {
        XV(s, t, l).then(i.resolve, a);
      });
    });
    return o.error && a(o.value), i.promise;
  }
});
var i3 = Xn, a3 = Nt, o3 = _i, s3 = ys.CONSTRUCTOR;
i3({ target: "Promise", stat: !0, forced: s3 }, {
  reject: function(n) {
    var t = o3.f(this);
    return a3(t.reject, void 0, n), t.promise;
  }
});
var l3 = Tr, u3 = mr, c3 = _i, u1 = function(e, n) {
  if (l3(e), u3(n) && n.constructor === e) return n;
  var t = c3.f(e), i = t.resolve;
  return i(n), t.promise;
}, d3 = Xn, m3 = pr, f3 = BE, p3 = La, v3 = ys.CONSTRUCTOR, h3 = u1, y3 = m3("Promise"), g3 = !v3;
d3({ target: "Promise", stat: !0, forced: f3 }, {
  resolve: function(n) {
    return h3(g3 && this === y3 ? p3 : this, n);
  }
});
var k3 = Xn, b3 = Nt, _3 = Hr, x3 = _i, S3 = hs, N3 = vs, w3 = Uu;
k3({ target: "Promise", stat: !0, forced: w3 }, {
  allSettled: function(n) {
    var t = this, i = x3.f(t), a = i.resolve, o = i.reject, s = S3(function() {
      var l = _3(t.resolve), c = [], m = 0, d = 1;
      N3(n, function(p) {
        var v = m++, y = !1;
        d++, b3(l, t, p).then(function(S) {
          y || (y = !0, c[v] = { status: "fulfilled", value: S }, --d || a(c));
        }, function(S) {
          y || (y = !0, c[v] = { status: "rejected", reason: S }, --d || a(c));
        });
      }), --d || a(c);
    });
    return s.error && o(s.value), i.promise;
  }
});
var j3 = Xn, C3 = Nt, F3 = Hr, I3 = pr, $3 = _i, E3 = hs, T3 = vs, O3 = Uu, Tk = "No one promise resolved";
j3({ target: "Promise", stat: !0, forced: O3 }, {
  any: function(n) {
    var t = this, i = I3("AggregateError"), a = $3.f(t), o = a.resolve, s = a.reject, l = E3(function() {
      var c = F3(t.resolve), m = [], d = 0, p = 1, v = !1;
      T3(n, function(y) {
        var S = d++, b = !1;
        p++, C3(c, t, y).then(function(j) {
          b || v || (v = !0, o(j));
        }, function(j) {
          b || v || (b = !0, m[S] = j, --p || s(new i(m, Tk)));
        });
      }), --p || s(new i(m, Tk));
    });
    return l.error && s(l.value), a.promise;
  }
});
var R3 = Xn, lv = La, D3 = ot, P3 = pr, A3 = dt, L3 = zj, Ok = u1, V3 = lv && lv.prototype, z3 = !!lv && D3(function() {
  V3.finally.call({ then: function() {
  } }, function() {
  });
});
R3({ target: "Promise", proto: !0, real: !0, forced: z3 }, {
  finally: function(e) {
    var n = L3(this, P3("Promise")), t = A3(e);
    return this.then(
      t ? function(i) {
        return Ok(n, e()).then(function() {
          return i;
        });
      } : e,
      t ? function(i) {
        return Ok(n, e()).then(function() {
          throw i;
        });
      } : e
    );
  }
});
var _h = yt, M3 = nh, U3 = Da, B3 = Yv, q3 = _h("".charAt), Rk = _h("".charCodeAt), H3 = _h("".slice), K3 = function(e) {
  return function(n, t) {
    var i = U3(B3(n)), a = M3(t), o = i.length, s, l;
    return a < 0 || a >= o ? e ? "" : void 0 : (s = Rk(i, a), s < 55296 || s > 56319 || a + 1 === o || (l = Rk(i, a + 1)) < 56320 || l > 57343 ? e ? q3(i, a) : s : e ? H3(i, a, a + 2) : (s - 55296 << 10) + (l - 56320) + 65536);
  };
}, W3 = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: K3(!0)
}, G3 = W3.charAt, Y3 = Da, c1 = Ou, J3 = Pj, Dk = Aj, d1 = "String Iterator", Q3 = c1.set, X3 = c1.getterFor(d1);
J3(String, "String", function(e) {
  Q3(this, {
    type: d1,
    string: Y3(e),
    index: 0
  });
}, function() {
  var n = X3(this), t = n.string, i = n.index, a;
  return i >= t.length ? Dk(void 0, !0) : (a = G3(t, i), n.index += a.length, Dk(a, !1));
});
var Z3 = fr, ez = Z3.Promise, nz = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, tz = nz, rz = ht, iz = cs, az = bi, Pk = Aa, oz = st, Ak = oz("toStringTag");
for (var Hc in tz) {
  var Lk = rz[Hc], Kc = Lk && Lk.prototype;
  Kc && iz(Kc) !== Ak && az(Kc, Ak, Hc), Pk[Hc] = Pk.Array;
}
var sz = ez, lz = sz, uz = lz, cz = /* @__PURE__ */ tE(uz), dz = TypeError, mz = 9007199254740991, fz = function(e) {
  if (e > mz) throw dz("Maximum allowed index exceeded");
  return e;
}, pz = ot, vz = st, hz = Cu, yz = vz("species"), m1 = function(e) {
  return hz >= 51 || !pz(function() {
    var n = [], t = n.constructor = {};
    return t[yz] = function() {
      return { foo: 1 };
    }, n[e](Boolean).foo !== 1;
  });
}, gz = Xn, kz = ot, bz = Ru, _z = mr, xz = Oa, Sz = Ra, Vk = fz, zk = sh, Nz = ij, wz = m1, jz = st, Cz = Cu, f1 = jz("isConcatSpreadable"), Fz = Cz >= 51 || !kz(function() {
  var e = [];
  return e[f1] = !1, e.concat()[0] !== e;
}), Iz = function(e) {
  if (!_z(e)) return !1;
  var n = e[f1];
  return n !== void 0 ? !!n : bz(e);
}, $z = !Fz || !wz("concat");
gz({ target: "Array", proto: !0, forced: $z }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(n) {
    var t = xz(this), i = Nz(t, 0), a = 0, o, s, l, c, m;
    for (o = -1, l = arguments.length; o < l; o++)
      if (m = o === -1 ? t : arguments[o], Iz(m))
        for (c = Sz(m), Vk(a + c), s = 0; s < c; s++, a++) s in m && zk(i, a, m[s]);
      else
        Vk(a + 1), zk(i, a++, m);
    return i.length = a, i;
  }
});
var Ez = Yt;
Ez("asyncIterator");
var Tz = Yt;
Tz("hasInstance");
var Oz = Yt;
Oz("isConcatSpreadable");
var Rz = Yt;
Rz("iterator");
var Dz = Yt;
Dz("match");
var Pz = Yt;
Pz("matchAll");
var Az = Yt;
Az("replace");
var Lz = Yt;
Lz("search");
var Vz = Yt;
Vz("species");
var zz = Yt;
zz("split");
var Mz = Yt, Uz = Qw;
Mz("toPrimitive");
Uz();
var Bz = pr, qz = Yt, Hz = Pa;
qz("toStringTag");
Hz(Bz("Symbol"), "Symbol");
var Kz = Yt;
Kz("unscopables");
var Wz = ht, Gz = Pa;
Gz(Wz.JSON, "JSON", !0);
var Yz = fr;
Yz.Symbol;
var Jz = ms;
Jz.f("iterator");
var Qz = ah;
Qz("Array").concat;
var Xz = Xn, Mk = Ru, Zz = uh, eM = mr, Uk = th, nM = Ra, tM = si, rM = sh, iM = st, aM = m1, oM = vh, sM = aM("slice"), lM = iM("species"), Wc = Array, uM = Math.max;
Xz({ target: "Array", proto: !0, forced: !sM }, {
  slice: function(n, t) {
    var i = tM(this), a = nM(i), o = Uk(n, a), s = Uk(t === void 0 ? a : t, a), l, c, m;
    if (Mk(i) && (l = i.constructor, Zz(l) && (l === Wc || Mk(l.prototype)) ? l = void 0 : eM(l) && (l = l[lM], l === null && (l = void 0)), l === Wc || l === void 0))
      return oM(i, o, s);
    for (c = new (l === void 0 ? Wc : l)(uM(s - o, 0)), m = 0; o < s; o++, m++) o in i && rM(c, m, i[o]);
    return c.length = m, c;
  }
});
var cM = ah;
cM("Array").slice;
var dM = ms;
dM.f("asyncIterator");
function Gc(e, n, t, i) {
  function a(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = cz))(function(o, s) {
    function l(d) {
      try {
        m(i.next(d));
      } catch (p) {
        s(p);
      }
    }
    function c(d) {
      try {
        m(i.throw(d));
      } catch (p) {
        s(p);
      }
    }
    function m(d) {
      d.done ? o(d.value) : a(d.value).then(l, c);
    }
    m((i = i.apply(e, [])).next());
  });
}
class mM {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    var n;
    return window.electron ? !!window.electron : !!(!((n = process == null ? void 0 : process.versions) === null || n === void 0) && n.electron) || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  getVersion() {
    return Gc(this, void 0, void 0, function* () {
      return window.electron ? (yield window.electron.getVersion()).split("-")[0] : "0.0.0";
    });
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  isStandaloneBuild() {
    return Gc(this, void 0, void 0, function* () {
      var n;
      return !((n = window.electron) === null || n === void 0) && n.isStandaloneBuild ? yield window.electron.isStandaloneBuild() : null;
    });
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  isMsiBuild() {
    return Gc(this, void 0, void 0, function* () {
      var n;
      return !((n = window.electron) === null || n === void 0) && n.isMsiBuild ? yield window.electron.isMsiBuild() : null;
    });
  }
}
const Bk = new mM();
function fM(e, n) {
  return qk(e), qk(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function qk(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const pM = Object.prototype.toString;
function vM(e, n) {
  return pM.call(e) === `[object ${n}]`;
}
function hM(e) {
  return vM(e, "Object");
}
function yM(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Ao = "8.36.0", oi = globalThis;
function xh(e, n, t) {
  const i = t || oi, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Ao] = a[Ao] || {};
  return o[e] || (o[e] = n());
}
const p1 = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, gM = "Sentry Logger ", Hk = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Kk = {};
function v1(e) {
  if (!("console" in oi))
    return e();
  const n = oi.console, t = {}, i = Object.keys(Kk);
  i.forEach((a) => {
    const o = Kk[a];
    t[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = t[a];
    });
  }
}
function kM() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return p1 ? Hk.forEach((t) => {
    n[t] = (...i) => {
      e && v1(() => {
        oi.console[t](`${gM}[${t}]:`, ...i);
      });
    };
  }) : Hk.forEach((t) => {
    n[t] = () => {
    };
  }), n;
}
const wl = xh("logger", kM);
function bM(e, n, t) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    p1 && wl.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const h1 = 1e3;
function Sh() {
  return Date.now() / h1;
}
function _M() {
  const { performance: e } = oi;
  if (!e || !e.now)
    return Sh;
  const n = Date.now() - e.now(), t = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (t + e.now()) / h1;
}
const xM = _M();
(() => {
  const { performance: e } = oi;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, t = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + t - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, c = typeof s == "number" ? Math.abs(s + t - i) : n, m = c < n;
  return o || m ? a <= c ? e.timeOrigin : s : i;
})();
function ha() {
  const e = oi, n = e.crypto || e.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (t = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (t() & 15) >> i / 4).toString(16)
    )
  );
}
function Wk() {
  return {
    traceId: ha(),
    spanId: ha().substring(16)
  };
}
function Nh() {
  return wh(oi), oi;
}
function wh(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Ao, n[Ao] = n[Ao] || {};
}
function SM(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || xM(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : ha()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const t = e.timestamp - e.started;
    e.duration = t >= 0 ? t : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const uv = "_sentrySpan";
function Gk(e, n) {
  n ? bM(e, uv, n) : delete e[uv];
}
function Yk(e) {
  return e[uv];
}
const NM = 100;
class jh {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Wk();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new jh();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Gk(n, Yk(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && SM(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, t) {
    return this._tags = { ...this._tags, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, t) {
    return this._extra = { ...this._extra, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, t) {
    return t === null ? delete this._contexts[n] : this._contexts[n] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const t = typeof n == "function" ? n(this) : n, [i, a] = t instanceof wa ? [t.getScopeData(), t.getRequestSession()] : hM(t) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: c, level: m, fingerprint: d = [], propagationContext: p } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...c }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), d.length && (this._fingerprint = d), p && (this._propagationContext = p), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Gk(this, void 0), this._attachments = [], this._propagationContext = Wk(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, t) {
    const i = typeof t == "number" ? t : NM;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Sh(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Yk(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, t) {
    const i = t && t.event_id ? t.event_id : ha();
    if (!this._client)
      return wl.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...t,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, t, i) {
    const a = i && i.event_id ? i.event_id : ha();
    if (!this._client)
      return wl.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      t,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, t) {
    const i = t && t.event_id ? t.event_id : ha();
    return this._client ? (this._client.captureEvent(n, { ...t, event_id: i }, this), i) : (wl.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const wa = jh;
function wM() {
  return xh("defaultCurrentScope", () => new wa());
}
function jM() {
  return xh("defaultIsolationScope", () => new wa());
}
class CM {
  constructor(n, t) {
    let i;
    n ? i = n : i = new wa();
    let a;
    t ? a = t : a = new wa(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const t = this._pushScope();
    let i;
    try {
      i = n(t);
    } catch (a) {
      throw this._popScope(), a;
    }
    return yM(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function ja() {
  const e = Nh(), n = wh(e);
  return n.stack = n.stack || new CM(wM(), jM());
}
function FM(e) {
  return ja().withScope(e);
}
function IM(e, n) {
  const t = ja();
  return t.withScope(() => (t.getStackTop().scope = e, n(e)));
}
function Jk(e) {
  return ja().withScope(() => e(ja().getIsolationScope()));
}
function $M() {
  return {
    withIsolationScope: Jk,
    withScope: FM,
    withSetScope: IM,
    withSetIsolationScope: (e, n) => Jk(n),
    getCurrentScope: () => ja().getScope(),
    getIsolationScope: () => ja().getIsolationScope()
  };
}
function y1(e) {
  const n = wh(e);
  return n.acs ? n.acs : $M();
}
function Ch() {
  const e = Nh();
  return y1(e).getCurrentScope();
}
function g1() {
  const e = Nh();
  return y1(e).getIsolationScope();
}
function EM() {
  return Ch().getClient();
}
function TM(e) {
  if (e)
    return OM(e) ? { captureContext: e } : DM(e) ? {
      captureContext: e
    } : e;
}
function OM(e) {
  return e instanceof wa || typeof e == "function";
}
const RM = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function DM(e) {
  return Object.keys(e).some((n) => RM.includes(n));
}
function Qk(e, n) {
  return Ch().captureException(e, TM(n));
}
function PM(e, n) {
  const t = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Ch().captureMessage(e, t, i);
}
function AM(e, n) {
  g1().setContext(e, n);
}
const LM = 100;
function Ci(e, n) {
  const t = EM(), i = g1();
  if (!t) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = LM } = t.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Sh(), ...e }, c = a ? v1(() => a(l, n)) : l;
  c !== null && (t.emit && t.emit("beforeAddBreadcrumb", c, n), i.addBreadcrumb(c, o));
}
var Qo;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Qo || (Qo = {}));
function ya(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const t = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(t, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const VM = Ll.backendDomain ? {
  "backend-domain": Ll.backendDomain
} : void 0;
function jl() {
  const e = new URLSearchParams(Object.assign({ noToken: "true" }, VM)).toString();
  document.location.href = `${Ll.url.logIn}?${e}`;
}
const Yc = "authData", Jc = 30, zM = 600, Xk = 5;
class MM {
  constructor() {
    Object.defineProperty(this, "authData", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "accessTokenExpiresAt", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "clientServerTimeDiff", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Xk || this.clientServerTimeDiff <= -5 ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + zM, a = ya(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Xk) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Yc, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Yc), t = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(t) && (this.authData = t), t;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Yc);
  }
  getAccessToken() {
    var n;
    return ((n = this.authData) === null || n === void 0 ? void 0 : n.access_token) || null;
  }
  getRefreshToken() {
    var n;
    return ((n = this.authData) === null || n === void 0 ? void 0 : n.refresh_token) || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const t = this.accessTokenExpiresAt - Jc;
    return this.estimatedServerTime() >= t;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const t = ya(n), i = t.exp - Jc;
    return !t || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Jc - this.estimatedServerTime()) * 1e3;
  }
}
const kt = new MM();
var UM = function(e, n, t, i) {
  function a(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = Promise))(function(o, s) {
    function l(d) {
      try {
        m(i.next(d));
      } catch (p) {
        s(p);
      }
    }
    function c(d) {
      try {
        m(i.throw(d));
      } catch (p) {
        s(p);
      }
    }
    function m(d) {
      d.done ? o(d.value) : a(d.value).then(l, c);
    }
    m((i = i.apply(e, n || [])).next());
  });
};
function BM(e) {
  return UM(this, void 0, void 0, function* () {
    var n, t;
    const i = window.location.origin.replace(/^https?:\/\//, ""), a = ["localhost:8080", "uptrends-monitor"];
    if (!(!e.response || a.some((o) => i.includes(o)))) {
      try {
        const o = (n = e.response.config.headers.Authorization) !== null && n !== void 0 ? n : "", s = o ? (t = o.toString()) === null || t === void 0 ? void 0 : t.split("Basic ")[1] : "", l = s ? atob(s).split("token:")[1] : "", c = l ? ya(l).exp : "None", m = yield Fh.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), p = m == null ? void 0 : m.access_token, v = m == null ? void 0 : m.refresh_token, y = p ? ya(p).exp : "None", S = v ? ya(v).exp : "None", b = typeof c == "number" ? d - c : "Unknown", j = typeof y == "number" ? d - y : "Unknown", x = typeof S == "number" ? d - S : "Unknown", h = e.response.headers["x-dixa-rid"];
        AM("Expires", {
          currentTimestamp: d,
          accessTokenFromHeader: c,
          accessTokenFromHeaderDiff: b,
          accessTokenFromLocalStorage: y,
          accessTokenFromLocalStorageDiff: j,
          refreshTokenFromLocalStorage: S,
          refreshTokenFromLocalStorageDiff: x,
          xDixaRid: h,
          navigatorOnline: navigator.onLine
        });
      } catch (o) {
        console.error("Error adding Sentry error context", o);
      }
      PM("401 unauthorized interceptor", {
        level: "debug",
        tags: {
          team: Qo.Platform,
          domain: i
        }
      });
    }
  });
}
const Qc = /* @__PURE__ */ new Map(), qM = 3;
function HM(e) {
  e.interceptors.response.use((n) => (Qc.delete(n.config.url), n), (n) => {
    var t;
    if (n.response) {
      const { status: i } = n.response;
      switch (i) {
        case cv.Unauthorized:
          if (!Fh.isRefreshTokenExpired() && n.config) {
            Ci({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const a = (t = Qc.get(n.config.url)) !== null && t !== void 0 ? t : 0;
            if (console.log(`Retrying request (${a + 1}): ${n.config.url}`), a <= qM)
              return Qc.set(n.config.url, a + 1), e(n.config);
          }
          BM(n), console.error("401 unauthorized interceptor"), jl();
          break;
      }
    }
    return Promise.reject(n);
  });
}
var mi = function(e, n, t, i) {
  function a(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = Promise))(function(o, s) {
    function l(d) {
      try {
        m(i.next(d));
      } catch (p) {
        s(p);
      }
    }
    function c(d) {
      try {
        m(i.throw(d));
      } catch (p) {
        s(p);
      }
    }
    function m(d) {
      d.done ? o(d.value) : a(d.value).then(l, c);
    }
    m((i = i.apply(e, n || [])).next());
  });
};
const k1 = at.create();
HM(k1);
const Gr = console.log;
function Zk(e) {
  return mi(this, void 0, void 0, function* () {
    return new Promise((n) => setTimeout(n, e * 1e3));
  });
}
class KM extends Error {
  constructor(n, t) {
    super(n, t);
  }
}
function WM(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const GM = 5;
class YM {
  constructor() {
    Object.defineProperty(this, "authDataPromise", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  init(n) {
    return mi(this, void 0, void 0, function* () {
      const t = yield this.refresh(n);
      if (t)
        kt.setAuthData(t);
      else {
        const i = kt.isRefreshTokenExpired(n) ? "expired" : "unknown";
        throw new KM("Failed to init refresh token", {
          cause: i
        });
      }
    });
  }
  getDebugInfo() {
    const n = kt.getAccessToken();
    if (!n)
      return {};
    const t = ya(n), { exp: i } = t;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  getAuthData() {
    return mi(this, arguments, void 0, function* ({ localStorageOnly: n = !1 } = {}) {
      if (n)
        return kt.getAuthData();
      if (this.authDataPromise)
        return yield this.authDataPromise;
      const t = kt.getAuthData();
      return t ? kt.isAccessTokenExpired() ? (Ci({
        category: "refreshToken",
        // Cannot include "token" in the message, as it will be redacted
        message: "expired or about to expire",
        level: "debug",
        data: this.getDebugInfo()
      }), this.authDataPromise = this.refresh(t.refresh_token).then((i) => (i && kt.setAuthData(i), this.authDataPromise = null, i)), yield this.authDataPromise) : t : null;
    });
  }
  removeAuthData() {
    return kt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return kt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return kt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = kt.getAuthData();
    return n ? kt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  isSupported() {
    return mi(this, void 0, void 0, function* () {
      if (!Bk.isElectron())
        return !0;
      const n = yield Bk.getVersion();
      return fM(n, "3.7.0") === 1;
    });
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  refresh(n) {
    return mi(this, arguments, void 0, function* (t, i = GM) {
      try {
        return yield k1.post(`${Ll.url.rest}/v2/login/refresh`, {
          refreshToken: t
        }).then((a) => (this.retryCount = 0, a.data.data));
      } catch (a) {
        return yield this.handleRefreshError(a, t, i);
      }
    });
  }
  waitUntilOnline() {
    return mi(this, void 0, void 0, function* () {
      const n = navigator.onLine === !1;
      for (n && (Gr("AUTH", "Network connection offline - waiting..."), Ci({
        category: "refreshToken",
        message: "Network connection offline - waiting...",
        level: "debug"
      })); navigator.onLine === !1; )
        yield Zk(5);
      n && (Gr("AUTH", "Network connection restored"), Ci({
        category: "refreshToken",
        message: "Network connection restored",
        level: "debug"
      }));
    });
  }
  retryRefresh(n, t) {
    return mi(this, void 0, void 0, function* () {
      yield this.waitUntilOnline(), this.retryCount++;
      const i = WM(this.retryCount);
      return Gr("AUTH", `Retrying in ${i} seconds`), yield Zk(i), yield this.refresh(n, t);
    });
  }
  handleRefreshError(n, t, i) {
    return mi(this, void 0, void 0, function* () {
      var a;
      if (kt.isRefreshTokenExpired(t))
        return Gr("AUTH", "Refresh token expired"), Ci({
          category: "refreshToken",
          message: "Refresh token expired",
          level: "debug"
        }), kt.removeAuthData(), jl(), null;
      if (nE(n)) {
        if (n.message === "timeout exceeded")
          return Gr("AUTH", "Timeout exceeded"), Ci({
            category: "refreshToken",
            message: "Timeout exceeded",
            level: "debug"
          }), yield this.retryRefresh(t, i);
        if (n.message === "Network Error")
          return Gr("AUTH", "Network error"), Ci({
            category: "refreshToken",
            message: "Network error",
            level: "debug"
          }), yield this.retryRefresh(t, i);
        if (((a = n.response) === null || a === void 0 ? void 0 : a.status) === 401)
          return Gr("AUTH", "Refresh token invalid (401)"), kt.removeAuthData(), jl(), null;
        Qk(n, {
          level: "error",
          tags: {
            team: Qo.Platform,
            errorSource: "authManager.refresh"
          }
        });
      }
      return i <= 0 ? (Gr("AUTH", "Retries exhausted, logging out"), Qk(n, {
        level: "error",
        tags: {
          team: Qo.Platform,
          errorSource: "authManager.refresh"
        }
      }), kt.removeAuthData(), jl(), null) : (Gr("AUTH", `Retrying ${i} more times`), yield this.retryRefresh(t, i - 1));
    });
  }
  accessTokenExpiresInMs() {
    return kt.accessTokenExpiresInMs();
  }
}
const Fh = new YM();
var cv;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(cv || (cv = {}));
const JM = new QN((e, n) => new mI((t) => {
  Fh.getAuthData().then((i) => {
    const a = i == null ? void 0 : i.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(t);
  }).catch((i) => t.error(i));
}));
var Xc = "Invariant Violation", eb = Object.setPrototypeOf, QM = eb === void 0 ? function(e, n) {
  return e.__proto__ = n, e;
} : eb, b1 = (
  /** @class */
  function(e) {
    _I(n, e);
    function n(t) {
      t === void 0 && (t = Xc);
      var i = e.call(this, typeof t == "number" ? Xc + ": " + t + " (see https://github.com/apollographql/invariant-packages)" : t) || this;
      return i.framesToPop = 1, i.name = Xc, QM(i, n.prototype), i;
    }
    return n;
  }(Error)
);
function Ti(e, n) {
  if (!e)
    throw new b1(n);
}
var _1 = ["debug", "log", "warn", "error", "silent"], XM = _1.indexOf("log");
function Us(e) {
  return function() {
    if (_1.indexOf(e) >= XM) {
      var n = console[e] || console.log;
      return n.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = Us("debug"), e.log = Us("log"), e.warn = Us("warn"), e.error = Us("error");
})(Ti || (Ti = {}));
var x1 = "3.9.6";
function ea(e) {
  try {
    return e();
  } catch {
  }
}
const nb = ea(function() {
  return globalThis;
}) || ea(function() {
  return window;
}) || ea(function() {
  return self;
}) || ea(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
ea(function() {
  return ea.constructor("return this")();
});
var tb = /* @__PURE__ */ new Map();
function ZM(e) {
  var n = tb.get(e) || 1;
  return tb.set(e, n + 1), "".concat(e, ":").concat(n, ":").concat(Math.random().toString(36).slice(2));
}
function eU(e, n) {
  var t = ZM("stringifyForDisplay");
  return JSON.stringify(e, function(i, a) {
    return a === void 0 ? t : a;
  }, n).split(JSON.stringify(t)).join("<undefined>");
}
function Bs(e) {
  return function(n) {
    for (var t = [], i = 1; i < arguments.length; i++)
      t[i - 1] = arguments[i];
    if (typeof n == "number") {
      var a = n;
      n = Ih(a), n || (n = $h(a, t), t = []);
    }
    e.apply(void 0, [n].concat(t));
  };
}
var nU = Object.assign(function(n, t) {
  for (var i = [], a = 2; a < arguments.length; a++)
    i[a - 2] = arguments[a];
  n || Ti(n, Ih(t, i) || $h(t, i));
}, {
  debug: Bs(Ti.debug),
  log: Bs(Ti.log),
  warn: Bs(Ti.warn),
  error: Bs(Ti.error)
});
function S1(e) {
  for (var n = [], t = 1; t < arguments.length; t++)
    n[t - 1] = arguments[t];
  return new b1(Ih(e, n) || $h(e, n));
}
var rb = Symbol.for("ApolloErrorMessageHandler_" + x1);
function N1(e) {
  return typeof e == "string" ? e : eU(e, 2).slice(0, 1e3);
}
function Ih(e, n) {
  if (n === void 0 && (n = []), !!e)
    return nb[rb] && nb[rb](e, n.map(N1));
}
function $h(e, n) {
  if (n === void 0 && (n = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: x1,
      message: e,
      args: n.map(N1)
    })));
}
function tU(e) {
  return e.definitions.filter(function(n) {
    return n.kind === "OperationDefinition" && !!n.name;
  }).map(function(n) {
    return n.name.value;
  })[0] || null;
}
function rU(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = iU(e)) || n) {
    t && (e = t);
    var i = 0;
    return function() {
      return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iU(e, n) {
  if (e) {
    if (typeof e == "string") return ib(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ib(e, n);
  }
}
function ib(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, i = new Array(n); t < n; t++)
    i[t] = e[t];
  return i;
}
function ab(e, n) {
  for (var t = 0; t < n.length; t++) {
    var i = n[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function Eh(e, n, t) {
  return n && ab(e.prototype, n), t && ab(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Th = function() {
  return typeof Symbol == "function";
}, Oh = function(e) {
  return Th() && !!Symbol[e];
}, Rh = function(e) {
  return Oh(e) ? Symbol[e] : "@@" + e;
};
Th() && !Oh("observable") && (Symbol.observable = Symbol("observable"));
var aU = Rh("iterator"), dv = Rh("observable"), w1 = Rh("species");
function Wl(e, n) {
  var t = e[n];
  if (t != null) {
    if (typeof t != "function") throw new TypeError(t + " is not a function");
    return t;
  }
}
function Qa(e) {
  var n = e.constructor;
  return n !== void 0 && (n = n[w1], n === null && (n = void 0)), n !== void 0 ? n : wt;
}
function oU(e) {
  return e instanceof wt;
}
function Ca(e) {
  Ca.log ? Ca.log(e) : setTimeout(function() {
    throw e;
  });
}
function Cl(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (n) {
      Ca(n);
    }
  });
}
function j1(e) {
  var n = e._cleanup;
  if (n !== void 0 && (e._cleanup = void 0, !!n))
    try {
      if (typeof n == "function")
        n();
      else {
        var t = Wl(n, "unsubscribe");
        t && t.call(n);
      }
    } catch (i) {
      Ca(i);
    }
}
function mv(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function sU(e) {
  var n = e._queue;
  if (n) {
    e._queue = void 0, e._state = "ready";
    for (var t = 0; t < n.length && (C1(e, n[t].type, n[t].value), e._state !== "closed"); ++t)
      ;
  }
}
function C1(e, n, t) {
  e._state = "running";
  var i = e._observer;
  try {
    var a = Wl(i, n);
    switch (n) {
      case "next":
        a && a.call(i, t);
        break;
      case "error":
        if (mv(e), a) a.call(i, t);
        else throw t;
        break;
      case "complete":
        mv(e), a && a.call(i);
        break;
    }
  } catch (o) {
    Ca(o);
  }
  e._state === "closed" ? j1(e) : e._state === "running" && (e._state = "ready");
}
function Zc(e, n, t) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: n,
        value: t
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: n,
        value: t
      }], Cl(function() {
        return sU(e);
      });
      return;
    }
    C1(e, n, t);
  }
}
var lU = /* @__PURE__ */ function() {
  function e(t, i) {
    this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
    var a = new uU(this);
    try {
      this._cleanup = i.call(void 0, a);
    } catch (o) {
      a.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var n = e.prototype;
  return n.unsubscribe = function() {
    this._state !== "closed" && (mv(this), j1(this));
  }, Eh(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
}(), uU = /* @__PURE__ */ function() {
  function e(t) {
    this._subscription = t;
  }
  var n = e.prototype;
  return n.next = function(i) {
    Zc(this._subscription, "next", i);
  }, n.error = function(i) {
    Zc(this._subscription, "error", i);
  }, n.complete = function() {
    Zc(this._subscription, "complete");
  }, Eh(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
}(), wt = /* @__PURE__ */ function() {
  function e(t) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof t != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = t;
  }
  var n = e.prototype;
  return n.subscribe = function(i) {
    return (typeof i != "object" || i === null) && (i = {
      next: i,
      error: arguments[1],
      complete: arguments[2]
    }), new lU(i, this._subscriber);
  }, n.forEach = function(i) {
    var a = this;
    return new Promise(function(o, s) {
      if (typeof i != "function") {
        s(new TypeError(i + " is not a function"));
        return;
      }
      function l() {
        c.unsubscribe(), o();
      }
      var c = a.subscribe({
        next: function(m) {
          try {
            i(m, l);
          } catch (d) {
            s(d), c.unsubscribe();
          }
        },
        error: s,
        complete: o
      });
    });
  }, n.map = function(i) {
    var a = this;
    if (typeof i != "function") throw new TypeError(i + " is not a function");
    var o = Qa(this);
    return new o(function(s) {
      return a.subscribe({
        next: function(l) {
          try {
            l = i(l);
          } catch (c) {
            return s.error(c);
          }
          s.next(l);
        },
        error: function(l) {
          s.error(l);
        },
        complete: function() {
          s.complete();
        }
      });
    });
  }, n.filter = function(i) {
    var a = this;
    if (typeof i != "function") throw new TypeError(i + " is not a function");
    var o = Qa(this);
    return new o(function(s) {
      return a.subscribe({
        next: function(l) {
          try {
            if (!i(l)) return;
          } catch (c) {
            return s.error(c);
          }
          s.next(l);
        },
        error: function(l) {
          s.error(l);
        },
        complete: function() {
          s.complete();
        }
      });
    });
  }, n.reduce = function(i) {
    var a = this;
    if (typeof i != "function") throw new TypeError(i + " is not a function");
    var o = Qa(this), s = arguments.length > 1, l = !1, c = arguments[1], m = c;
    return new o(function(d) {
      return a.subscribe({
        next: function(p) {
          var v = !l;
          if (l = !0, !v || s)
            try {
              m = i(m, p);
            } catch (y) {
              return d.error(y);
            }
          else
            m = p;
        },
        error: function(p) {
          d.error(p);
        },
        complete: function() {
          if (!l && !s) return d.error(new TypeError("Cannot reduce an empty sequence"));
          d.next(m), d.complete();
        }
      });
    });
  }, n.concat = function() {
    for (var i = this, a = arguments.length, o = new Array(a), s = 0; s < a; s++)
      o[s] = arguments[s];
    var l = Qa(this);
    return new l(function(c) {
      var m, d = 0;
      function p(v) {
        m = v.subscribe({
          next: function(y) {
            c.next(y);
          },
          error: function(y) {
            c.error(y);
          },
          complete: function() {
            d === o.length ? (m = void 0, c.complete()) : p(l.from(o[d++]));
          }
        });
      }
      return p(i), function() {
        m && (m.unsubscribe(), m = void 0);
      };
    });
  }, n.flatMap = function(i) {
    var a = this;
    if (typeof i != "function") throw new TypeError(i + " is not a function");
    var o = Qa(this);
    return new o(function(s) {
      var l = [], c = a.subscribe({
        next: function(d) {
          if (i)
            try {
              d = i(d);
            } catch (v) {
              return s.error(v);
            }
          var p = o.from(d).subscribe({
            next: function(v) {
              s.next(v);
            },
            error: function(v) {
              s.error(v);
            },
            complete: function() {
              var v = l.indexOf(p);
              v >= 0 && l.splice(v, 1), m();
            }
          });
          l.push(p);
        },
        error: function(d) {
          s.error(d);
        },
        complete: function() {
          m();
        }
      });
      function m() {
        c.closed && l.length === 0 && s.complete();
      }
      return function() {
        l.forEach(function(d) {
          return d.unsubscribe();
        }), c.unsubscribe();
      };
    });
  }, n[dv] = function() {
    return this;
  }, e.from = function(i) {
    var a = typeof this == "function" ? this : e;
    if (i == null) throw new TypeError(i + " is not an object");
    var o = Wl(i, dv);
    if (o) {
      var s = o.call(i);
      if (Object(s) !== s) throw new TypeError(s + " is not an object");
      return oU(s) && s.constructor === a ? s : new a(function(l) {
        return s.subscribe(l);
      });
    }
    if (Oh("iterator") && (o = Wl(i, aU), o))
      return new a(function(l) {
        Cl(function() {
          if (!l.closed) {
            for (var c = rU(o.call(i)), m; !(m = c()).done; ) {
              var d = m.value;
              if (l.next(d), l.closed) return;
            }
            l.complete();
          }
        });
      });
    if (Array.isArray(i))
      return new a(function(l) {
        Cl(function() {
          if (!l.closed) {
            for (var c = 0; c < i.length; ++c)
              if (l.next(i[c]), l.closed) return;
            l.complete();
          }
        });
      });
    throw new TypeError(i + " is not observable");
  }, e.of = function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    var s = typeof this == "function" ? this : e;
    return new s(function(l) {
      Cl(function() {
        if (!l.closed) {
          for (var c = 0; c < a.length; ++c)
            if (l.next(a[c]), l.closed) return;
          l.complete();
        }
      });
    });
  }, Eh(e, null, [{
    key: w1,
    get: function() {
      return this;
    }
  }]), e;
}();
Th() && Object.defineProperty(wt, Symbol("extensions"), {
  value: {
    symbol: dv,
    hostReportError: Ca
  },
  configurable: !0
});
function cU(e) {
  var n, t = e.Symbol;
  if (typeof t == "function")
    if (t.observable)
      n = t.observable;
    else {
      typeof t.for == "function" ? n = t.for("https://github.com/benlesh/symbol-observable") : n = t("https://github.com/benlesh/symbol-observable");
      try {
        t.observable = n;
      } catch {
      }
    }
  else
    n = "@@observable";
  return n;
}
var ua;
typeof self < "u" ? ua = self : typeof window < "u" ? ua = window : typeof global < "u" ? ua = global : typeof module < "u" ? ua = module : ua = Function("return this")();
cU(ua);
var ob = wt.prototype, sb = "@@observable";
ob[sb] || (ob[sb] = function() {
  return this;
});
function dU(e) {
  for (var n = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], t = 0, i = Object.keys(e); t < i.length; t++) {
    var a = i[t];
    if (n.indexOf(a) < 0)
      throw S1(43, a);
  }
  return e;
}
function mU(e, n) {
  var t = ei({}, e), i = function(o) {
    typeof o == "function" ? t = ei(ei({}, t), o(t)) : t = ei(ei({}, t), o);
  }, a = function() {
    return ei({}, t);
  };
  return Object.defineProperty(n, "setContext", {
    enumerable: !1,
    value: i
  }), Object.defineProperty(n, "getContext", {
    enumerable: !1,
    value: a
  }), n;
}
function fU(e) {
  var n = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return n.operationName || (n.operationName = typeof n.query != "string" ? tU(n.query) || void 0 : ""), n;
}
function lb(e, n) {
  return n ? n(e) : wt.of();
}
function Xa(e) {
  return typeof e == "function" ? new F1(e) : e;
}
function qs(e) {
  return e.request.length <= 1;
}
var F1 = (
  /** @class */
  function() {
    function e(n) {
      n && (this.request = n);
    }
    return e.empty = function() {
      return new e(function() {
        return wt.of();
      });
    }, e.from = function(n) {
      return n.length === 0 ? e.empty() : n.map(Xa).reduce(function(t, i) {
        return t.concat(i);
      });
    }, e.split = function(n, t, i) {
      var a = Xa(t), o = Xa(i || new e(lb)), s;
      return qs(a) && qs(o) ? s = new e(function(l) {
        return n(l) ? a.request(l) || wt.of() : o.request(l) || wt.of();
      }) : s = new e(function(l, c) {
        return n(l) ? a.request(l, c) || wt.of() : o.request(l, c) || wt.of();
      }), Object.assign(s, { left: a, right: o });
    }, e.execute = function(n, t) {
      return n.request(mU(t.context, fU(dU(t)))) || wt.of();
    }, e.concat = function(n, t) {
      var i = Xa(n);
      if (qs(i))
        return globalThis.__DEV__ !== !1 && nU.warn(35, i), i;
      var a = Xa(t), o;
      return qs(a) ? o = new e(function(s) {
        return i.request(s, function(l) {
          return a.request(l) || wt.of();
        }) || wt.of();
      }) : o = new e(function(s, l) {
        return i.request(s, function(c) {
          return a.request(c, l) || wt.of();
        }) || wt.of();
      }), Object.assign(o, { left: i, right: a });
    }, e.prototype.split = function(n, t, i) {
      return this.concat(e.split(n, t, i || new e(lb)));
    }, e.prototype.concat = function(n) {
      return e.concat(this, n);
    }, e.prototype.request = function(n, t) {
      throw S1(36);
    }, e.prototype.onError = function(n, t) {
      if (t && t.error)
        return t.error(n), !1;
      throw n;
    }, e.prototype.setOnError = function(n) {
      return this.onError = n, this;
    }, e;
  }()
);
function pU(e) {
  return new F1(function(n, t) {
    var i = ZN(n, []);
    return new wt(function(a) {
      var o, s = !1;
      return Promise.resolve(i).then(function(l) {
        return e(l, n.getContext());
      }).then(n.setContext).then(function() {
        s || (o = t(n).subscribe({
          next: a.next.bind(a),
          error: a.error.bind(a),
          complete: a.complete.bind(a)
        }));
      }).catch(a.error.bind(a)), function() {
        s = !0, o && o.unsubscribe();
      };
    });
  });
}
const vU = pU(
  (e, n) => {
    const { headers: t, widgetId: i, widgetType: a, operationName: o } = n;
    return {
      ...n,
      headers: {
        ...t,
        ...i && { "x-integration-widget-id": i },
        ...a && { "x-integration-widget-type": a },
        ...o && {
          "x-integration-widget-operation": o
        }
      }
    };
  }
), hU = new AbortController(), I1 = (e) => new fI({
  queryDeduplication: !1,
  cache: new pI(),
  link: QN.from([
    JM,
    vU,
    vI({
      uri: `${e}/graphql`,
      fetch: bI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: hU.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), yU = ({
  configuration: e,
  children: n
}) => {
  const t = At(
    () => I1(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ qe.jsx(hI, { client: t, children: n });
}, $1 = ({
  integrationId: e,
  type: n,
  configuration: t,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ qe.jsx(yU, { configuration: t, children: s ? /* @__PURE__ */ qe.jsx(yI, { children: (l) => /* @__PURE__ */ qe.jsx(
    WF,
    {
      value: {
        useMutation: QF(e, n),
        useQuery: JF(e, n),
        useLazyQuery: YF(e, n),
        executeQuery: GF(e, n, l),
        showNotification: i,
        showModal: a ?? (() => null)
      },
      children: o
    }
  ) }) : o });
}, gU = es`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function kU(e) {
  const [n, t] = me([]), [i, a] = me(!1);
  return Ge(() => {
    a(!0), I1(e).query({
      query: gU
    }).then(({ data: o }) => {
      var s;
      t((s = o == null ? void 0 : o.Management) == null ? void 0 : s.widgetConfigurations), a(!1);
    }).catch(() => a(!1));
  }, [e]), {
    isLoading: i,
    widgets: n
  };
}
const E1 = ({
  headline: e,
  text: n,
  children: t,
  onConfirm: i,
  onCancel: a,
  confirmLabel: o,
  cancelLabel: s = "Cancel",
  confirmVariant: l = "primary",
  cancelVariant: c = "secondary",
  isOpen: m,
  setIsOpen: d,
  showOnClose: p = !1
}) => /* @__PURE__ */ qe.jsxs(
  Ht,
  {
    isOpen: m,
    onClose: () => {
      a && a(), d(!1);
    },
    children: [
      /* @__PURE__ */ qe.jsx(
        Kt,
        {
          title: e,
          onClose: p ? a : void 0
        }
      ),
      /* @__PURE__ */ qe.jsxs(Wt, { children: [
        n && /* @__PURE__ */ qe.jsx("div", { style: { width: "600px" }, children: n }),
        t
      ] }),
      /* @__PURE__ */ qe.jsx(
        rr,
        {
          confirmOnClick: i ? () => {
            i(), d(!1);
          } : void 0,
          cancelOnClick: () => {
            a && a(), d(!1);
          },
          confirmName: o,
          cancelName: s,
          confirmProps: { variant: l },
          cancelProps: { variant: c }
        }
      )
    ]
  }
);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ed = { exports: {} }, Za = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ub;
function bU() {
  if (ub) return Za;
  ub = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return Za.Fragment = t, Za.jsx = s, Za.jsxs = s, Za;
}
var Hs = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cb;
function _U() {
  return cb || (cb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    Hs.Fragment = i, Hs.jsx = Mn, Hs.jsxs = Un;
  }()), Hs;
}
var db;
function xU() {
  return db || (db = 1, process.env.NODE_ENV === "production" ? ed.exports = bU() : ed.exports = _U()), ed.exports;
}
var ue = xU();
const SU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, NU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, wU = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": SU,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": NU
};
function T1(e) {
  return wU[e] ?? {};
}
const jU = T1(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), CU = T1(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), FU = "_copyIcon_1wjfs_48", IU = "_list_1wjfs_53", $U = "_listItem_1wjfs_63", EU = "_collapsible_1wjfs_72", TU = "_collapsibleIsOpen_1wjfs_80", OU = "_collapsibleHeader_1wjfs_83", RU = "_collapsibleIconTrue_1wjfs_86", DU = "_collapsibleIconFalse_1wjfs_89", Tn = {
  copyIcon: FU,
  list: IU,
  listItem: $U,
  collapsible: EU,
  collapsibleIsOpen: TU,
  collapsibleHeader: OU,
  collapsibleIconTrue: RU,
  collapsibleIconFalse: DU
}, PU = ({
  app: e,
  openByDefault: n
}) => {
  const [t, i] = me(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: c,
    last_used: m
  } = e;
  return /* @__PURE__ */ ue.jsxs(
    _,
    {
      className: ct(Tn.collapsible, {
        [Tn.collapsibleIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ue.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Tn.collapsibleHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ue.jsx(
                qr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ ue.jsxs(Je, { className: Tn.list, children: [
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: An(c).format(vt) })
          ] }) }),
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: An(m).format(vt) })
          ] }) })
        ] })
      ]
    }
  );
}, AU = ({ apps: e }) => {
  const n = e && (e == null ? void 0 : e.length) > 0;
  return /* @__PURE__ */ ue.jsxs(_, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ue.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ue.jsx(q.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ue.jsx(Jn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ue.jsx(
      q.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e == null ? void 0 : e.map((t, i) => /* @__PURE__ */ ue.jsx(PU, { app: t, openByDefault: i === 0 }, i))
  ] });
}, LU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, t = Object.keys(n).length > 0;
  return /* @__PURE__ */ ue.jsx(ue.Fragment, { children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ue.jsx(q.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !t && /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    t && /* @__PURE__ */ ue.jsx(Je, { className: Tn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ue.jsx(
      Je.Text,
      {
        variant: "dense",
        className: Tn.listItem,
        children: /* @__PURE__ */ ue.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: i }),
          HN(a)
        ] })
      },
      o
    )) })
  ] }) });
}, VU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, t = n == null ? void 0 : n.sort(
    (a, o) => (o == null ? void 0 : o.count) - (a == null ? void 0 : a.count)
  ), i = t && t.length > 0;
  return /* @__PURE__ */ ue.jsx(ue.Fragment, { children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ue.jsx(q.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ue.jsx(Je, { className: Tn.list, children: t.map((a, o) => /* @__PURE__ */ ue.jsx(
      Je.Text,
      {
        variant: "dense",
        className: Tn.listItem,
        children: /* @__PURE__ */ ue.jsxs(_, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ue.jsx(
            nn,
            {
              content: /* @__PURE__ */ ue.jsxs(_, { flexDirection: "column", children: [
                /* @__PURE__ */ ue.jsx(_, { children: `First ${An(a == null ? void 0 : a.first).format(
                  vt
                )}` }),
                /* @__PURE__ */ ue.jsx(_, { children: `Last ${An(a == null ? void 0 : a.last).format(
                  vt
                )}` })
              ] }),
              children: /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: a == null ? void 0 : a.name })
            }
          ),
          /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", children: a == null ? void 0 : a.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Gl = ({
  state: e,
  noTooltip: n = !1,
  isPush: t = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const c = t ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${c}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${c}.` : `Opted in: The user has explicitly confirmed they want to receive ${c}.`;
  };
  return /* @__PURE__ */ ue.jsx(nn, { content: n ? null : l(), children: /* @__PURE__ */ ue.jsx(_, { alignItems: "center", children: /* @__PURE__ */ ue.jsx(ye, { size: 14, name: o(), color: s() }) }) });
}, zU = "_wrapper_1xucg_1", MU = "_externalLink_1xucg_7", nd = {
  wrapper: zU,
  externalLink: MU
}, UU = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: t } = ri(), { isCopied: i, copy: a } = ri(), { isCopied: o, copy: s } = ri();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: c,
    home_city: m,
    country: d,
    email: p,
    phone: v,
    dob: y,
    created_at: S,
    email_subscribe: b,
    push_subscribe: j
  } = e, x = 14, h = `${l || ""} ${c || ""}`.trim() || "A customer has no name", P = `${m ? `${m} /` : ""} ${d || ""}`.trim(), N = y ? An(y).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ue.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ue.jsxs(_, { className: nd.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ue.jsxs(
      _,
      {
        justifyContent: "space-between",
        className: nd.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ue.jsx(q.Heading, { variant: "heading-2", children: h }),
          N && /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    S && /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: An(S).format(vt) })
    ] }),
    P && /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ue.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ue.jsx(ye, { size: x, name: "map-pin" }),
        /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: P })
      ] }),
      /* @__PURE__ */ ue.jsx(nn, { content: "Copy location", children: /* @__PURE__ */ ue.jsx(_, { alignItems: "center", children: /* @__PURE__ */ ue.jsx(
        ye,
        {
          size: x,
          name: o ? "done" : "copy",
          onClick: () => s(P),
          className: Tn.copyIcon
        }
      ) }) })
    ] }),
    p && /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ue.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ue.jsx(ye, { size: x, name: "mail" }),
        /* @__PURE__ */ ue.jsx("span", { className: nd.externalLink, children: p })
      ] }),
      /* @__PURE__ */ ue.jsx(nn, { content: "Copy email", children: /* @__PURE__ */ ue.jsx(_, { alignItems: "center", children: /* @__PURE__ */ ue.jsx(
        ye,
        {
          size: x,
          name: n ? "done" : "copy",
          onClick: () => t(p),
          className: Tn.copyIcon
        }
      ) }) })
    ] }),
    v && /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ue.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ue.jsx(ye, { size: x, name: "phone" }),
        /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: v })
      ] }),
      /* @__PURE__ */ ue.jsx(nn, { content: "Copy phone number", children: /* @__PURE__ */ ue.jsx(_, { alignItems: "center", children: /* @__PURE__ */ ue.jsx(
        ye,
        {
          size: x,
          name: i ? "done" : "copy",
          onClick: () => a(v),
          className: Tn.copyIcon
        }
      ) }) })
    ] }),
    b && /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ue.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ue.jsx(ye, { size: x, name: "sync" }),
        /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ue.jsx(Gl, { state: b })
    ] }),
    j && /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ue.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ue.jsx(ye, { size: x, name: "bell" }),
        /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ue.jsx(Gl, { isPush: !0, state: j })
    ] })
  ] }) });
}, BU = ({
  device: e,
  openByDefault: n
}) => {
  const [t, i] = me(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: c,
    idfa: m,
    idfv: d,
    google_ad_id: p,
    roku_ad_id: v
  } = e;
  return /* @__PURE__ */ ue.jsxs(
    _,
    {
      className: ct(Tn.collapsible, {
        [Tn.collapsibleIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ue.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Tn.collapsibleHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ue.jsx(
                qr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ ue.jsxs(Je, { className: Tn.list, children: [
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ue.jsx(
              ye,
              {
                size: a,
                className: ct({
                  [Tn.collapsibleIconTrue]: c,
                  [Tn.collapsibleIconFalse]: !c
                }),
                name: c ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ue.jsx(nn, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(
            _,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: d })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ue.jsx(nn, { content: "For iOS", children: /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(
            _,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(
            _,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: v })
              ]
            }
          ) }),
          /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(
            _,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", color: "secondary", children: p })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, qU = ({ devices: e }) => {
  const n = e && (e == null ? void 0 : e.length) > 0;
  return /* @__PURE__ */ ue.jsxs(_, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ue.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ue.jsx(q.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ue.jsx(Jn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ue.jsx(
      q.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e == null ? void 0 : e.map((t, i) => /* @__PURE__ */ ue.jsx(BU, { device: t, openByDefault: i === 0 }, i))
  ] });
}, eo = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, Ks = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: t
}) => {
  const { track: i } = bn(), { useMutation: a } = pn(), [o, s] = me(!1), [l] = a(
    CU,
    {
      onCompleted: (m) => {
        var d, p;
        ((p = (d = m == null ? void 0 : m.Braze) == null ? void 0 : d.updateEmailSubscriptionStatus) == null ? void 0 : p.message) === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), c = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: eo[n].parameter
        }
      }
    }), setTimeout(async () => {
      await t().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ue.jsx(nn, { content: eo[n].tooltipContent, children: /* @__PURE__ */ ue.jsx(
    Qn,
    {
      variant: "secondary",
      color: eo[n].color,
      isLoading: o,
      onClick: () => c(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ue.jsxs(_, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ue.jsx(
          Gl,
          {
            noTooltip: !0,
            state: eo[n].parameter
          }
        ),
        eo[n].label
      ] })
    }
  ) });
}, HU = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: t
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ue.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ue.jsx(q.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ue.jsx(Je, { className: Tn.list, children: /* @__PURE__ */ ue.jsx(Je.Text, { variant: "dense", className: Tn.listItem, children: /* @__PURE__ */ ue.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ue.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ue.jsx(ye, { size: 14, name: "sync" }),
        /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ue.jsx(Gl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ue.jsxs(_, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ue.jsxs(ue.Fragment, { children: [
        /* @__PURE__ */ ue.jsx(
          Ks,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: t
          }
        ),
        /* @__PURE__ */ ue.jsx(
          Ks,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: t
          }
        )
      ] }),
      s && /* @__PURE__ */ ue.jsx(
        Ks,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: t
        }
      ),
      l && /* @__PURE__ */ ue.jsx(
        Ks,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: t
        }
      )
    ] })
  ] }) });
}, KU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, t = n == null ? void 0 : n.sort(
    (a, o) => (o == null ? void 0 : o.count) - (a == null ? void 0 : a.count)
  ), i = t && t.length > 0;
  return /* @__PURE__ */ ue.jsx(ue.Fragment, { children: /* @__PURE__ */ ue.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ue.jsx(q.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ue.jsx(Je, { className: Tn.list, children: t.map((a, o) => /* @__PURE__ */ ue.jsx(
      Je.Text,
      {
        variant: "dense",
        className: Tn.listItem,
        children: /* @__PURE__ */ ue.jsxs(_, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ue.jsx(
            nn,
            {
              content: /* @__PURE__ */ ue.jsxs(_, { flexDirection: "column", children: [
                /* @__PURE__ */ ue.jsx(_, { children: `First ${An(a == null ? void 0 : a.first).format(
                  vt
                )}` }),
                /* @__PURE__ */ ue.jsx(_, { children: `Last ${An(a == null ? void 0 : a.last).format(
                  vt
                )}` })
              ] }),
              children: /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "4", children: a == null ? void 0 : a.name })
            }
          ),
          /* @__PURE__ */ ue.jsx(q.Paragraph, { variant: "5", children: a == null ? void 0 : a.count })
        ] })
      },
      o
    )) })
  ] }) });
}, WU = ({
  conversationContext: e,
  settings: n
}) => {
  var t, i;
  const { track: a } = bn(), { useMutation: o } = pn(), [s, l] = me(), [c, m] = me(!1), [d, p] = me(!1), v = (t = e == null ? void 0 : e.customer) == null ? void 0 : t.email, y = (i = e == null ? void 0 : e.customer) == null ? void 0 : i.phone_number, S = n.displayCustomerDetails ?? !1, b = n.updateEmailSubscriptionState ?? !1, j = n.displayCustomAttributes ?? !1, x = n.displayCustomEvents ?? !1, h = n.displayPuchases ?? !1, P = n.displayDevices ?? !1, N = n.displayApps ?? !1, $ = !S && !b && !j && !x && !h, [O, { error: B }] = o(
    jU,
    {
      onError: () => {
      },
      onCompleted: (Y) => {
        var ee, J, K;
        const V = (K = (J = (ee = Y == null ? void 0 : Y.Braze) == null ? void 0 : ee.exportUserDetails) == null ? void 0 : J.users) == null ? void 0 : K[0];
        V ? (l(V), m(!1), a("braze:profile:received")) : (l(void 0), m(!0));
      }
    }
  ), Z = async () => {
    v || y ? await O({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...v ? { email_address: v } : { phone: y },
          fields_to_export: [
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : m(!0);
  };
  return Ge(() => {
    async function Y() {
      p(!0), await Z();
    }
    Y().finally(() => p(!1));
  }, [v, y]), B ? Pv({ errors: B.graphQLErrors }) ? /* @__PURE__ */ ue.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-forbidden-error",
      children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
    }
  ) : Av({ errors: B.graphQLErrors }) ? /* @__PURE__ */ ue.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-authorization-error",
      children: "The integration could not authorize against Braze. Please contact your administrator."
    }
  ) : /* @__PURE__ */ ue.jsx(Fn, { error: B }) : d ? /* @__PURE__ */ ue.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ue.jsx(fn, {}) }) : $ ? /* @__PURE__ */ ue.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : c ? /* @__PURE__ */ ue.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ue.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        S && /* @__PURE__ */ ue.jsx(UU, { customerDetails: s }),
        b && !!s && /* @__PURE__ */ ue.jsx(
          HU,
          {
            customerDetails: s,
            showCustomerDetails: S,
            refetchCustomerDetails: async () => await Z()
          }
        ),
        j && !!s && /* @__PURE__ */ ue.jsx(LU, { customerDetails: s }),
        x && !!s && /* @__PURE__ */ ue.jsx(VU, { customerDetails: s }),
        h && !!s && /* @__PURE__ */ ue.jsx(KU, { customerDetails: s }),
        P && !!s && /* @__PURE__ */ ue.jsx(qU, { devices: s == null ? void 0 : s.devices }),
        N && !!s && /* @__PURE__ */ ue.jsx(AU, { apps: s == null ? void 0 : s.apps })
      ]
    }
  );
}, GU = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => qN(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function YU() {
  var e = pa(!1), n = ut(function() {
    return e.current;
  }, []);
  return Ge(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var JU = function(e) {
  e === void 0 && (e = {});
  var n = me(e), t = n[0], i = n[1], a = ut(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [t, a];
}, QU = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, mb = function(e) {
  return tI(QU, e);
}, td, fb;
function XU() {
  return fb || (fb = 1, td = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, t = [], i = 0; i < e.rangeCount; i++)
      t.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || t.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), td;
}
var rd, pb;
function ZU() {
  if (pb) return rd;
  pb = 1;
  var e = XU(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, t = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, c, m, d, p, v, y = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), d = document.createRange(), p = document.getSelection(), v = document.createElement("span"), v.textContent = o, v.ariaHidden = "true", v.style.all = "unset", v.style.position = "fixed", v.style.top = 0, v.style.clip = "rect(0, 0, 0, 0)", v.style.whiteSpace = "pre", v.style.webkitUserSelect = "text", v.style.MozUserSelect = "text", v.style.msUserSelect = "text", v.style.userSelect = "text", v.addEventListener("copy", function(b) {
        if (b.stopPropagation(), s.format)
          if (b.preventDefault(), typeof b.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            b.clipboardData.clearData(), b.clipboardData.setData(s.format, o);
        s.onCopy && (b.preventDefault(), s.onCopy(b.clipboardData));
      }), document.body.appendChild(v), d.selectNodeContents(v), p.addRange(d);
      var S = document.execCommand("copy");
      if (!S)
        throw new Error("copy command was unsuccessful");
      y = !0;
    } catch (b) {
      l && console.error("unable to copy using execCommand: ", b), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), y = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), c = i("message" in s ? s.message : t), window.prompt(c, o);
      }
    } finally {
      p && (typeof p.removeRange == "function" ? p.removeRange(d) : p.removeAllRanges()), v && document.body.removeChild(v), m();
    }
    return y;
  }
  return rd = a, rd;
}
var e4 = ZU();
const n4 = /* @__PURE__ */ Uv(e4);
var O1 = function() {
  var e = YU(), n = JU({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), t = n[0], i = n[1], a = ut(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var c = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(c), i({
            value: o,
            error: c,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var c = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(c), i({
            value: o,
            error: c,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = n4(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [t, a];
};
function t4(e, n) {
  var t = pa(!1), i = pa(), a = pa(e), o = ut(function() {
    return t.current;
  }, []), s = ut(function() {
    t.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      t.current = !0, a.current();
    }, n);
  }, [n]), l = ut(function() {
    t.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Ge(function() {
    a.current = e;
  }, [e]), Ge(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Va(e, n, t) {
  t === void 0 && (t = []);
  var i = t4(e, n), a = i[0], o = i[1], s = i[2];
  return Ge(s, t), [a, o];
}
var r4 = function(e) {
  Ge(e, []);
}, i4 = function(e, n) {
  var t = pa(function() {
  });
  Ge(function() {
    t.current = e;
  }), Ge(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return t.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, a4 = function(e) {
  e === void 0 && (e = {});
  var n = me(e), t = n[0], i = n[1], a = At(function() {
    return {
      set: function(s, l) {
        i(function(c) {
          var m;
          return ei(ei({}, c), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var c = l, m = s;
          c[m];
          var d = ZN(c, [typeof m == "symbol" ? m : m + ""]);
          return d;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = ei({ get: ut(function(s) {
    return t[s];
  }, [t]) }, a);
  return [t, o];
}, o4 = function(e) {
  var n = pa(e);
  n.current = e, r4(function() {
    return function() {
      return n.current();
    };
  });
}, ks = (e) => e.type === "checkbox", Ri = (e) => e instanceof Date, Ot = (e) => e == null;
const R1 = (e) => typeof e == "object";
var tt = (e) => !Ot(e) && !Array.isArray(e) && R1(e) && !Ri(e), D1 = (e) => tt(e) && e.target ? ks(e.target) ? e.target.checked : e.target.value : e, s4 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, P1 = (e, n) => e.has(s4(n)), l4 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return tt(n) && n.hasOwnProperty("isPrototypeOf");
}, Dh = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function _t(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Dh && (e instanceof Blob || i)) && (t || tt(e)))
    if (n = t ? [] : {}, !t && !l4(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = _t(e[a]));
  else
    return e;
  return n;
}
var Bu = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Zn = (e) => e === void 0, He = (e, n, t) => {
  if (!n || !tt(e))
    return t;
  const i = Bu(n.split(/[,[\].]+?/)).reduce((a, o) => Ot(a) ? a : a[o], e);
  return Zn(i) || i === e ? Zn(e[n]) ? t : e[n] : i;
}, Qt = (e) => typeof e == "boolean", Ph = (e) => /^\w*$/.test(e), A1 = (e) => Bu(e.replace(/["|']|\]/g, "").split(/\.|\[/)), qn = (e, n, t) => {
  let i = -1;
  const a = Ph(n) ? [n] : A1(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let c = t;
    if (i !== s) {
      const m = e[l];
      c = tt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = c, e = e[l];
  }
};
const Yl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, kr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Yr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, u4 = we.createContext(null), Ah = () => we.useContext(u4);
var L1 = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== kr.all && (n._proxyFormState[s] = !i || kr.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function c4(e) {
  const n = Ah(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = we.useState(t._formState), c = we.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = we.useRef(a);
  return m.current = a, we.useEffect(() => t._subscribe({
    name: m.current,
    formState: c.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...t._formState,
        ...d
      });
    }
  }), [t, i, o]), we.useEffect(() => {
    c.current.isValid && t._setValid(!0);
  }, [t]), we.useMemo(() => L1(s, t, c.current, !1), [s, t]);
}
var Vr = (e) => typeof e == "string", V1 = (e, n, t, i, a) => Vr(e) ? (i && n.watch.add(e), He(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), He(t, o))) : (i && (n.watchAll = !0), t);
function d4(e) {
  const n = Ah(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = we.useRef(i), c = we.useRef(a);
  l.current = i, we.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (p) => !o && d(V1(l.current, t._names, p.values || t._formValues, !1, c.current))
  }), [t, o, s]);
  const [m, d] = we.useState(t._getWatch(i, a));
  return we.useEffect(() => t._removeUnmounted()), m;
}
function z1(e) {
  const n = Ah(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = P1(a._names.array, t), l = d4({
    control: a,
    name: t,
    defaultValue: He(a._formValues, t, He(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), c = c4({
    control: a,
    name: t,
    exact: !0
  }), m = we.useRef(e), d = we.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...Qt(e.disabled) ? { disabled: e.disabled } : {}
  })), p = we.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!He(c.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!He(c.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!He(c.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!He(c.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => He(c.errors, t)
    }
  }), [c, t]), v = we.useCallback((j) => d.current.onChange({
    target: {
      value: D1(j),
      name: t
    },
    type: Yl.CHANGE
  }), [t]), y = we.useCallback(() => d.current.onBlur({
    target: {
      value: He(a._formValues, t),
      name: t
    },
    type: Yl.BLUR
  }), [t, a._formValues]), S = we.useCallback((j) => {
    const x = He(a._fields, t);
    x && j && (x._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (h) => j.setCustomValidity(h),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, t]), b = we.useMemo(() => ({
    name: t,
    value: l,
    ...Qt(i) || c.disabled ? { disabled: c.disabled || i } : {},
    onChange: v,
    onBlur: y,
    ref: S
  }), [t, i, c.disabled, v, y, S, l]);
  return we.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...Qt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const x = (h, P) => {
      const N = He(a._fields, h);
      N && N._f && (N._f.mount = P);
    };
    if (x(t, !0), j) {
      const h = _t(He(a._options.defaultValues, t));
      qn(a._defaultValues, t, h), Zn(He(a._formValues, t)) && qn(a._formValues, t, h);
    }
    return !s && a.register(t), () => {
      (s ? j && !a._state.action : j) ? a.unregister(t) : x(t, !1);
    };
  }, [t, a, s, o]), we.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), we.useMemo(() => ({
    field: b,
    formState: c,
    fieldState: p
  }), [b, c, p]);
}
const Ut = (e) => e.render(z1(e));
var m4 = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, Lo = (e) => Array.isArray(e) ? e : [e], vb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, fv = (e) => Ot(e) || !R1(e);
function fi(e, n) {
  if (fv(e) || fv(n))
    return e === n;
  if (Ri(e) && Ri(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ri(o) && Ri(s) || tt(o) && tt(s) || Array.isArray(o) && Array.isArray(s) ? !fi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var $t = (e) => tt(e) && !Object.keys(e).length, Lh = (e) => e.type === "file", br = (e) => typeof e == "function", Jl = (e) => {
  if (!Dh)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, M1 = (e) => e.type === "select-multiple", Vh = (e) => e.type === "radio", f4 = (e) => Vh(e) || ks(e), id = (e) => Jl(e) && e.isConnected;
function p4(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = Zn(e) ? i++ : e[n[i++]];
  return e;
}
function v4(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !Zn(e[n]))
      return !1;
  return !0;
}
function mt(e, n) {
  const t = Array.isArray(n) ? n : Ph(n) ? [n] : A1(n), i = t.length === 1 ? e : p4(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (tt(i) && $t(i) || Array.isArray(i) && v4(i)) && mt(e, t.slice(0, -1)), e;
}
var U1 = (e) => {
  for (const n in e)
    if (br(e[n]))
      return !0;
  return !1;
};
function Ql(e, n = {}) {
  const t = Array.isArray(e);
  if (tt(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || tt(e[i]) && !U1(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ql(e[i], n[i])) : Ot(e[i]) || (n[i] = !0);
  return n;
}
function B1(e, n, t) {
  const i = Array.isArray(e);
  if (tt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || tt(e[a]) && !U1(e[a]) ? Zn(n) || fv(t[a]) ? t[a] = Array.isArray(e[a]) ? Ql(e[a], []) : { ...Ql(e[a]) } : B1(e[a], Ot(n) ? {} : n[a], t[a]) : t[a] = !fi(e[a], n[a]);
  return t;
}
var no = (e, n) => B1(e, n, Ql(n));
const hb = {
  value: !1,
  isValid: !1
}, yb = { value: !0, isValid: !0 };
var q1 = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Zn(e[0].attributes.value) ? Zn(e[0].value) || e[0].value === "" ? yb : { value: e[0].value, isValid: !0 } : yb
    ) : hb;
  }
  return hb;
}, H1 = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => Zn(e) ? e : n ? e === "" ? NaN : e && +e : t && Vr(e) ? new Date(e) : i ? i(e) : e;
const gb = {
  isValid: !1,
  value: null
};
var K1 = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, gb) : gb;
function kb(e) {
  const n = e.ref;
  return Lh(n) ? n.files : Vh(n) ? K1(e.refs).value : M1(n) ? [...n.selectedOptions].map(({ value: t }) => t) : ks(n) ? q1(e.refs).value : H1(Zn(n.value) ? e.ref.value : n.value, e);
}
var h4 = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = He(n, o);
    s && qn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Xl = (e) => e instanceof RegExp, to = (e) => Zn(e) ? e : Xl(e) ? e.source : tt(e) ? Xl(e.value) ? e.value.source : e.value : e, bb = (e) => ({
  isOnSubmit: !e || e === kr.onSubmit,
  isOnBlur: e === kr.onBlur,
  isOnChange: e === kr.onChange,
  isOnAll: e === kr.all,
  isOnTouch: e === kr.onTouched
});
const _b = "AsyncFunction";
var y4 = (e) => !!e && !!e.validate && !!(br(e.validate) && e.validate.constructor.name === _b || tt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === _b)), g4 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), xb = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Vo = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = He(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Vo(l, n))
          break;
      } else if (tt(l) && Vo(l, n))
        break;
    }
  }
};
function Sb(e, n, t) {
  const i = He(e, t);
  if (i || Ph(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = He(n, o), l = He(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var k4 = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return $t(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || kr.all));
}, b4 = (e, n, t) => !e || !n || e === n || Lo(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), _4 = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, x4 = (e, n) => !Bu(He(e, n)).length && mt(e, n), S4 = (e, n, t) => {
  const i = Lo(He(e, t));
  return qn(i, "root", n[t]), qn(e, t, i), e;
}, Fl = (e) => Vr(e);
function Nb(e, n, t = "validate") {
  if (Fl(e) || Array.isArray(e) && e.every(Fl) || Qt(e) && !e)
    return {
      type: t,
      message: Fl(e) ? e : "",
      ref: n
    };
}
var na = (e) => tt(e) && !Xl(e) ? e : {
  value: e,
  message: ""
}, wb = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: c, maxLength: m, minLength: d, min: p, max: v, pattern: y, validate: S, name: b, valueAsNumber: j, mount: x } = e._f, h = He(t, b);
  if (!x || n.has(b))
    return {};
  const P = l ? l[0] : s, N = (K) => {
    a && P.reportValidity && (P.setCustomValidity(Qt(K) ? "" : K || ""), P.reportValidity());
  }, $ = {}, O = Vh(s), B = ks(s), Z = O || B, Y = (j || Lh(s)) && Zn(s.value) && Zn(h) || Jl(s) && s.value === "" || h === "" || Array.isArray(h) && !h.length, ee = m4.bind(null, b, i, $), J = (K, V, Q, ne = Yr.maxLength, ce = Yr.minLength) => {
    const ae = K ? V : Q;
    $[b] = {
      type: K ? ne : ce,
      message: ae,
      ref: s,
      ...ee(K ? ne : ce, ae)
    };
  };
  if (o ? !Array.isArray(h) || !h.length : c && (!Z && (Y || Ot(h)) || Qt(h) && !h || B && !q1(l).isValid || O && !K1(l).isValid)) {
    const { value: K, message: V } = Fl(c) ? { value: !!c, message: c } : na(c);
    if (K && ($[b] = {
      type: Yr.required,
      message: V,
      ref: P,
      ...ee(Yr.required, V)
    }, !i))
      return N(V), $;
  }
  if (!Y && (!Ot(p) || !Ot(v))) {
    let K, V;
    const Q = na(v), ne = na(p);
    if (!Ot(h) && !isNaN(h)) {
      const ce = s.valueAsNumber || h && +h;
      Ot(Q.value) || (K = ce > Q.value), Ot(ne.value) || (V = ce < ne.value);
    } else {
      const ce = s.valueAsDate || new Date(h), ae = (G) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + G), ve = s.type == "time", je = s.type == "week";
      Vr(Q.value) && h && (K = ve ? ae(h) > ae(Q.value) : je ? h > Q.value : ce > new Date(Q.value)), Vr(ne.value) && h && (V = ve ? ae(h) < ae(ne.value) : je ? h < ne.value : ce < new Date(ne.value));
    }
    if ((K || V) && (J(!!K, Q.message, ne.message, Yr.max, Yr.min), !i))
      return N($[b].message), $;
  }
  if ((m || d) && !Y && (Vr(h) || o && Array.isArray(h))) {
    const K = na(m), V = na(d), Q = !Ot(K.value) && h.length > +K.value, ne = !Ot(V.value) && h.length < +V.value;
    if ((Q || ne) && (J(Q, K.message, V.message), !i))
      return N($[b].message), $;
  }
  if (y && !Y && Vr(h)) {
    const { value: K, message: V } = na(y);
    if (Xl(K) && !h.match(K) && ($[b] = {
      type: Yr.pattern,
      message: V,
      ref: s,
      ...ee(Yr.pattern, V)
    }, !i))
      return N(V), $;
  }
  if (S) {
    if (br(S)) {
      const K = await S(h, t), V = Nb(K, P);
      if (V && ($[b] = {
        ...V,
        ...ee(Yr.validate, V.message)
      }, !i))
        return N(V.message), $;
    } else if (tt(S)) {
      let K = {};
      for (const V in S) {
        if (!$t(K) && !i)
          break;
        const Q = Nb(await S[V](h, t), P, V);
        Q && (K = {
          ...Q,
          ...ee(V, Q.message)
        }, N(Q.message), i && ($[b] = K));
      }
      if (!$t(K) && ($[b] = {
        ref: P,
        ...K
      }, !i))
        return $;
    }
  }
  return N(!0), $;
};
const N4 = {
  mode: kr.onSubmit,
  reValidateMode: kr.onChange,
  shouldFocusError: !0
};
function w4(e = {}) {
  let n = {
    ...N4,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: br(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = tt(n.defaultValues) || tt(n.values) ? _t(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : _t(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let p = {
    ...d
  };
  const v = {
    array: vb(),
    state: vb()
  }, y = bb(n.mode), S = bb(n.reValidateMode), b = n.criteriaMode === kr.all, j = (k) => (F) => {
    clearTimeout(m), m = setTimeout(k, F);
  }, x = async (k) => {
    if (!n.disabled && (d.isValid || p.isValid || k)) {
      const F = n.resolver ? $t((await Y()).errors) : await J(i, !0);
      F !== t.isValid && v.state.next({
        isValid: F
      });
    }
  }, h = (k, F) => {
    !n.disabled && (d.isValidating || d.validatingFields || p.isValidating || p.validatingFields) && ((k || Array.from(l.mount)).forEach((W) => {
      W && (F ? qn(t.validatingFields, W, F) : mt(t.validatingFields, W));
    }), v.state.next({
      validatingFields: t.validatingFields,
      isValidating: !$t(t.validatingFields)
    }));
  }, P = (k, F = [], W, X, T = !0, U = !0) => {
    if (X && W && !n.disabled) {
      if (s.action = !0, U && Array.isArray(He(i, k))) {
        const te = W(He(i, k), X.argA, X.argB);
        T && qn(i, k, te);
      }
      if (U && Array.isArray(He(t.errors, k))) {
        const te = W(He(t.errors, k), X.argA, X.argB);
        T && qn(t.errors, k, te), x4(t.errors, k);
      }
      if ((d.touchedFields || p.touchedFields) && U && Array.isArray(He(t.touchedFields, k))) {
        const te = W(He(t.touchedFields, k), X.argA, X.argB);
        T && qn(t.touchedFields, k, te);
      }
      (d.dirtyFields || p.dirtyFields) && (t.dirtyFields = no(a, o)), v.state.next({
        name: k,
        isDirty: V(k, F),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      qn(o, k, F);
  }, N = (k, F) => {
    qn(t.errors, k, F), v.state.next({
      errors: t.errors
    });
  }, $ = (k) => {
    t.errors = k, v.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, O = (k, F, W, X) => {
    const T = He(i, k);
    if (T) {
      const U = He(o, k, Zn(W) ? He(a, k) : W);
      Zn(U) || X && X.defaultChecked || F ? qn(o, k, F ? U : kb(T._f)) : ce(k, U), s.mount && x();
    }
  }, B = (k, F, W, X, T) => {
    let U = !1, te = !1;
    const pe = {
      name: k
    };
    if (!n.disabled) {
      if (!W || X) {
        (d.isDirty || p.isDirty) && (te = t.isDirty, t.isDirty = pe.isDirty = V(), U = te !== pe.isDirty);
        const Se = fi(He(a, k), F);
        te = !!He(t.dirtyFields, k), Se ? mt(t.dirtyFields, k) : qn(t.dirtyFields, k, !0), pe.dirtyFields = t.dirtyFields, U = U || (d.dirtyFields || p.dirtyFields) && te !== !Se;
      }
      if (W) {
        const Se = He(t.touchedFields, k);
        Se || (qn(t.touchedFields, k, W), pe.touchedFields = t.touchedFields, U = U || (d.touchedFields || p.touchedFields) && Se !== W);
      }
      U && T && v.state.next(pe);
    }
    return U ? pe : {};
  }, Z = (k, F, W, X) => {
    const T = He(t.errors, k), U = (d.isValid || p.isValid) && Qt(F) && t.isValid !== F;
    if (n.delayError && W ? (c = j(() => N(k, W)), c(n.delayError)) : (clearTimeout(m), c = null, W ? qn(t.errors, k, W) : mt(t.errors, k)), (W ? !fi(T, W) : T) || !$t(X) || U) {
      const te = {
        ...X,
        ...U && Qt(F) ? { isValid: F } : {},
        errors: t.errors,
        name: k
      };
      t = {
        ...t,
        ...te
      }, v.state.next(te);
    }
  }, Y = async (k) => {
    h(k, !0);
    const F = await n.resolver(o, n.context, h4(k || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return h(k), F;
  }, ee = async (k) => {
    const { errors: F } = await Y(k);
    if (k)
      for (const W of k) {
        const X = He(F, W);
        X ? qn(t.errors, W, X) : mt(t.errors, W);
      }
    else
      t.errors = F;
    return F;
  }, J = async (k, F, W = {
    valid: !0
  }) => {
    for (const X in k) {
      const T = k[X];
      if (T) {
        const { _f: U, ...te } = T;
        if (U) {
          const pe = l.array.has(U.name), Se = T._f && y4(T._f);
          Se && d.validatingFields && h([X], !0);
          const Ze = await wb(T, l.disabled, o, b, n.shouldUseNativeValidation && !F, pe);
          if (Se && d.validatingFields && h([X]), Ze[U.name] && (W.valid = !1, F))
            break;
          !F && (He(Ze, U.name) ? pe ? S4(t.errors, Ze, U.name) : qn(t.errors, U.name, Ze[U.name]) : mt(t.errors, U.name));
        }
        !$t(te) && await J(te, F, W);
      }
    }
    return W.valid;
  }, K = () => {
    for (const k of l.unMount) {
      const F = He(i, k);
      F && (F._f.refs ? F._f.refs.every((W) => !id(W)) : !id(F._f.ref)) && Oe(k);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, V = (k, F) => !n.disabled && (k && F && qn(o, k, F), !fi(he(), a)), Q = (k, F, W) => V1(k, l, {
    ...s.mount ? o : Zn(F) ? a : Vr(k) ? { [k]: F } : F
  }, W, F), ne = (k) => Bu(He(s.mount ? o : a, k, n.shouldUnregister ? He(a, k, []) : [])), ce = (k, F, W = {}) => {
    const X = He(i, k);
    let T = F;
    if (X) {
      const U = X._f;
      U && (!U.disabled && qn(o, k, H1(F, U)), T = Jl(U.ref) && Ot(F) ? "" : F, M1(U.ref) ? [...U.ref.options].forEach((te) => te.selected = T.includes(te.value)) : U.refs ? ks(U.ref) ? U.refs.length > 1 ? U.refs.forEach((te) => (!te.defaultChecked || !te.disabled) && (te.checked = Array.isArray(T) ? !!T.find((pe) => pe === te.value) : T === te.value)) : U.refs[0] && (U.refs[0].checked = !!T) : U.refs.forEach((te) => te.checked = te.value === T) : Lh(U.ref) ? U.ref.value = "" : (U.ref.value = T, U.ref.type || v.state.next({
        name: k,
        values: _t(o)
      })));
    }
    (W.shouldDirty || W.shouldTouch) && B(k, T, W.shouldTouch, W.shouldDirty, !0), W.shouldValidate && le(k);
  }, ae = (k, F, W) => {
    for (const X in F) {
      const T = F[X], U = `${k}.${X}`, te = He(i, U);
      (l.array.has(k) || tt(T) || te && !te._f) && !Ri(T) ? ae(U, T, W) : ce(U, T, W);
    }
  }, ve = (k, F, W = {}) => {
    const X = He(i, k), T = l.array.has(k), U = _t(F);
    qn(o, k, U), T ? (v.array.next({
      name: k,
      values: _t(o)
    }), (d.isDirty || d.dirtyFields || p.isDirty || p.dirtyFields) && W.shouldDirty && v.state.next({
      name: k,
      dirtyFields: no(a, o),
      isDirty: V(k, U)
    })) : X && !X._f && !Ot(U) ? ae(k, U, W) : ce(k, U, W), xb(k, l) && v.state.next({ ...t }), v.state.next({
      name: s.mount ? k : void 0,
      values: _t(o)
    });
  }, je = async (k) => {
    s.mount = !0;
    const F = k.target;
    let W = F.name, X = !0;
    const T = He(i, W), U = (te) => {
      X = Number.isNaN(te) || Ri(te) && isNaN(te.getTime()) || fi(te, He(o, W, te));
    };
    if (T) {
      let te, pe;
      const Se = F.type ? kb(T._f) : D1(k), Ze = k.type === Yl.BLUR || k.type === Yl.FOCUS_OUT, un = !g4(T._f) && !n.resolver && !He(t.errors, W) && !T._f.deps || _4(Ze, He(t.touchedFields, W), t.isSubmitted, S, y), en = xb(W, l, Ze);
      qn(o, W, Se), Ze ? (T._f.onBlur && T._f.onBlur(k), c && c(0)) : T._f.onChange && T._f.onChange(k);
      const tn = B(W, Se, Ze), mn = !$t(tn) || en;
      if (!Ze && v.state.next({
        name: W,
        type: k.type,
        values: _t(o)
      }), un)
        return (d.isValid || p.isValid) && (n.mode === "onBlur" ? Ze && x() : Ze || x()), mn && v.state.next({ name: W, ...en ? {} : tn });
      if (!Ze && en && v.state.next({ ...t }), n.resolver) {
        const { errors: cn } = await Y([W]);
        if (U(Se), X) {
          const vn = Sb(t.errors, i, W), Qe = Sb(cn, i, vn.name || W);
          te = Qe.error, W = Qe.name, pe = $t(cn);
        }
      } else
        h([W], !0), te = (await wb(T, l.disabled, o, b, n.shouldUseNativeValidation))[W], h([W]), U(Se), X && (te ? pe = !1 : (d.isValid || p.isValid) && (pe = await J(i, !0)));
      X && (T._f.deps && le(T._f.deps), Z(W, pe, te, tn));
    }
  }, G = (k, F) => {
    if (He(t.errors, F) && k.focus)
      return k.focus(), 1;
  }, le = async (k, F = {}) => {
    let W, X;
    const T = Lo(k);
    if (n.resolver) {
      const U = await ee(Zn(k) ? k : T);
      W = $t(U), X = k ? !T.some((te) => He(U, te)) : W;
    } else k ? (X = (await Promise.all(T.map(async (U) => {
      const te = He(i, U);
      return await J(te && te._f ? { [U]: te } : te);
    }))).every(Boolean), !(!X && !t.isValid) && x()) : X = W = await J(i);
    return v.state.next({
      ...!Vr(k) || (d.isValid || p.isValid) && W !== t.isValid ? {} : { name: k },
      ...n.resolver || !k ? { isValid: W } : {},
      errors: t.errors
    }), F.shouldFocus && !X && Vo(i, G, k ? T : l.mount), X;
  }, he = (k) => {
    const F = {
      ...s.mount ? o : a
    };
    return Zn(k) ? F : Vr(k) ? He(F, k) : k.map((W) => He(F, W));
  }, M = (k, F) => ({
    invalid: !!He((F || t).errors, k),
    isDirty: !!He((F || t).dirtyFields, k),
    error: He((F || t).errors, k),
    isValidating: !!He(t.validatingFields, k),
    isTouched: !!He((F || t).touchedFields, k)
  }), Ae = (k) => {
    k && Lo(k).forEach((F) => mt(t.errors, F)), v.state.next({
      errors: k ? t.errors : {}
    });
  }, Ve = (k, F, W) => {
    const X = (He(i, k, { _f: {} })._f || {}).ref, T = He(t.errors, k) || {}, { ref: U, message: te, type: pe, ...Se } = T;
    qn(t.errors, k, {
      ...Se,
      ...F,
      ref: X
    }), v.state.next({
      name: k,
      errors: t.errors,
      isValid: !1
    }), W && W.shouldFocus && X && X.focus && X.focus();
  }, Te = (k, F) => br(k) ? v.state.subscribe({
    next: (W) => k(Q(void 0, F), W)
  }) : Q(k, F, !0), ze = (k) => v.state.subscribe({
    next: (F) => {
      b4(k.name, F.name, k.exact) && k4(F, k.formState || d, Ie, k.reRenderRoot) && k.callback({
        values: { ...o },
        ...t,
        ...F
      });
    }
  }).unsubscribe, ge = (k) => (s.mount = !0, p = {
    ...p,
    ...k.formState
  }, ze({
    ...k,
    formState: p
  })), Oe = (k, F = {}) => {
    for (const W of k ? Lo(k) : l.mount)
      l.mount.delete(W), l.array.delete(W), F.keepValue || (mt(i, W), mt(o, W)), !F.keepError && mt(t.errors, W), !F.keepDirty && mt(t.dirtyFields, W), !F.keepTouched && mt(t.touchedFields, W), !F.keepIsValidating && mt(t.validatingFields, W), !n.shouldUnregister && !F.keepDefaultValue && mt(a, W);
    v.state.next({
      values: _t(o)
    }), v.state.next({
      ...t,
      ...F.keepDirty ? { isDirty: V() } : {}
    }), !F.keepIsValid && x();
  }, $e = ({ disabled: k, name: F }) => {
    (Qt(k) && s.mount || k || l.disabled.has(F)) && (k ? l.disabled.add(F) : l.disabled.delete(F));
  }, Ye = (k, F = {}) => {
    let W = He(i, k);
    const X = Qt(F.disabled) || Qt(n.disabled);
    return qn(i, k, {
      ...W || {},
      _f: {
        ...W && W._f ? W._f : { ref: { name: k } },
        name: k,
        mount: !0,
        ...F
      }
    }), l.mount.add(k), W ? $e({
      disabled: Qt(F.disabled) ? F.disabled : n.disabled,
      name: k
    }) : O(k, !0, F.value), {
      ...X ? { disabled: F.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!F.required,
        min: to(F.min),
        max: to(F.max),
        minLength: to(F.minLength),
        maxLength: to(F.maxLength),
        pattern: to(F.pattern)
      } : {},
      name: k,
      onChange: je,
      onBlur: je,
      ref: (T) => {
        if (T) {
          Ye(k, F), W = He(i, k);
          const U = Zn(T.value) && T.querySelectorAll && T.querySelectorAll("input,select,textarea")[0] || T, te = f4(U), pe = W._f.refs || [];
          if (te ? pe.find((Se) => Se === U) : U === W._f.ref)
            return;
          qn(i, k, {
            _f: {
              ...W._f,
              ...te ? {
                refs: [
                  ...pe.filter(id),
                  U,
                  ...Array.isArray(He(a, k)) ? [{}] : []
                ],
                ref: { type: U.type, name: k }
              } : { ref: U }
            }
          }), O(k, !1, void 0, U);
        } else
          W = He(i, k, {}), W._f && (W._f.mount = !1), (n.shouldUnregister || F.shouldUnregister) && !(P1(l.array, k) && s.action) && l.unMount.add(k);
      }
    };
  }, xe = () => n.shouldFocusError && Vo(i, G, l.mount), Ue = (k) => {
    Qt(k) && (v.state.next({ disabled: k }), Vo(i, (F, W) => {
      const X = He(i, W);
      X && (F.disabled = X._f.disabled || k, Array.isArray(X._f.refs) && X._f.refs.forEach((T) => {
        T.disabled = X._f.disabled || k;
      }));
    }, 0, !1));
  }, Be = (k, F) => async (W) => {
    let X;
    W && (W.preventDefault && W.preventDefault(), W.persist && W.persist());
    let T = _t(o);
    if (v.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: U, values: te } = await Y();
      t.errors = U, T = te;
    } else
      await J(i);
    if (l.disabled.size)
      for (const U of l.disabled)
        qn(T, U, void 0);
    if (mt(t.errors, "root"), $t(t.errors)) {
      v.state.next({
        errors: {}
      });
      try {
        await k(T, W);
      } catch (U) {
        X = U;
      }
    } else
      F && await F({ ...t.errors }, W), xe(), setTimeout(xe);
    if (v.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: $t(t.errors) && !X,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), X)
      throw X;
  }, re = (k, F = {}) => {
    He(i, k) && (Zn(F.defaultValue) ? ve(k, _t(He(a, k))) : (ve(k, F.defaultValue), qn(a, k, _t(F.defaultValue))), F.keepTouched || mt(t.touchedFields, k), F.keepDirty || (mt(t.dirtyFields, k), t.isDirty = F.defaultValue ? V(k, _t(He(a, k))) : V()), F.keepError || (mt(t.errors, k), d.isValid && x()), v.state.next({ ...t }));
  }, be = (k, F = {}) => {
    const W = k ? _t(k) : a, X = _t(W), T = $t(k), U = T ? a : X;
    if (F.keepDefaultValues || (a = W), !F.keepValues) {
      if (F.keepDirtyValues) {
        const te = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(no(a, o))
        ]);
        for (const pe of Array.from(te))
          He(t.dirtyFields, pe) ? qn(U, pe, He(o, pe)) : ve(pe, He(U, pe));
      } else {
        if (Dh && Zn(k))
          for (const te of l.mount) {
            const pe = He(i, te);
            if (pe && pe._f) {
              const Se = Array.isArray(pe._f.refs) ? pe._f.refs[0] : pe._f.ref;
              if (Jl(Se)) {
                const Ze = Se.closest("form");
                if (Ze) {
                  Ze.reset();
                  break;
                }
              }
            }
          }
        for (const te of l.mount)
          ve(te, He(U, te));
      }
      o = _t(U), v.array.next({
        values: { ...U }
      }), v.state.next({
        values: { ...U }
      });
    }
    l = {
      mount: F.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!F.keepIsValid || !!F.keepDirtyValues, s.watch = !!n.shouldUnregister, v.state.next({
      submitCount: F.keepSubmitCount ? t.submitCount : 0,
      isDirty: T ? !1 : F.keepDirty ? t.isDirty : !!(F.keepDefaultValues && !fi(k, a)),
      isSubmitted: F.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: T ? {} : F.keepDirtyValues ? F.keepDefaultValues && o ? no(a, o) : t.dirtyFields : F.keepDefaultValues && k ? no(a, k) : F.keepDirty ? t.dirtyFields : {},
      touchedFields: F.keepTouched ? t.touchedFields : {},
      errors: F.keepErrors ? t.errors : {},
      isSubmitSuccessful: F.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ne = (k, F) => be(br(k) ? k(o) : k, F), Pe = (k, F = {}) => {
    const W = He(i, k), X = W && W._f;
    if (X) {
      const T = X.refs ? X.refs[0] : X.ref;
      T.focus && (T.focus(), F.shouldSelect && br(T.select) && T.select());
    }
  }, Ie = (k) => {
    t = {
      ...t,
      ...k
    };
  }, C = {
    control: {
      register: Ye,
      unregister: Oe,
      getFieldState: M,
      handleSubmit: Be,
      setError: Ve,
      _subscribe: ze,
      _runSchema: Y,
      _getWatch: Q,
      _getDirty: V,
      _setValid: x,
      _setFieldArray: P,
      _setDisabledField: $e,
      _setErrors: $,
      _getFieldArray: ne,
      _reset: be,
      _resetDefaultValues: () => br(n.defaultValues) && n.defaultValues().then((k) => {
        Ne(k, n.resetOptions), v.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: K,
      _disableForm: Ue,
      _subjects: v,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(k) {
        s = k;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(k) {
        l = k;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(k) {
        n = {
          ...n,
          ...k
        };
      }
    },
    subscribe: ge,
    trigger: le,
    register: Ye,
    handleSubmit: Be,
    watch: Te,
    setValue: ve,
    getValues: he,
    reset: Ne,
    resetField: re,
    clearErrors: Ae,
    unregister: Oe,
    setError: Ve,
    setFocus: Pe,
    getFieldState: M
  };
  return {
    ...C,
    formControl: C
  };
}
function xi(e = {}) {
  const n = we.useRef(void 0), t = we.useRef(void 0), [i, a] = we.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: br(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: br(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : w4(e),
    formState: i
  }, e.formControl && e.defaultValues && !br(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, we.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), we.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), we.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), we.useEffect(() => {
    e.values && !fi(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), we.useEffect(() => {
    e.errors && !$t(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), we.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), we.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = L1(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ad = { exports: {} }, ro = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jb;
function j4() {
  if (jb) return ro;
  jb = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return ro.Fragment = t, ro.jsx = s, ro.jsxs = s, ro;
}
var Ws = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cb;
function C4() {
  return Cb || (Cb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    Ws.Fragment = i, Ws.jsx = Mn, Ws.jsxs = Un;
  }()), Ws;
}
var Fb;
function F4() {
  return Fb || (Fb = 1, process.env.NODE_ENV === "production" ? ad.exports = j4() : ad.exports = C4()), ad.exports;
}
var _e = F4();
const I4 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, $4 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, E4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, T4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, O4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, R4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, D4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, P4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, A4 = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": E4,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": T4,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": O4,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": I4,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": $4,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": R4,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": D4,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": P4
};
function za(e) {
  return A4[e] ?? {};
}
const L4 = za(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), V4 = za(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), z4 = za(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Ib = ({
  owner: e,
  repository: n,
  number: t
}) => `https://github.com/${e}/${n}/issues/${t}`, or = ({
  owner: e,
  repository: n,
  number: t
}) => `${e}/${n} #${t}`, M4 = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), $b = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, pv = (e, n, t) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: t,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ _e.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: t,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ _e.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: t,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: t,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: t,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function U4({
  conversationId: e,
  githubOrganization: n
}) {
  var t, i;
  const a = {
    github: { issues: [], pullRequests: [] }
  }, [o, s] = me(
    []
  ), [l, c] = me([]), [m, d] = me([]), [p, v] = me([]), [y, S] = me(), { showNotification: b, showModal: j, executeQuery: x } = pn(), { track: h } = bn(), {
    loading: P,
    data: N,
    error: $,
    store: O
  } = Lv(e ?? null), B = ((t = N == null ? void 0 : N.github) == null ? void 0 : t.issues) || [], Z = ((i = N == null ? void 0 : N.github) == null ? void 0 : i.pullRequests) || [], [Y, ee] = me(!1), [J, K] = me();
  Ge(
    () => S($ || J || void 0),
    [$, J]
  ), Ge(
    () => {
      !P && (B != null && B.length || Z != null && Z.length) ? (s(B), c(Z), Q(B, Z)) : (s([]), c([]), d([]), v([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [N]
  );
  const V = async (le, he) => {
    await O(le).then(() => {
      b({
        icon: "check-circle-filled",
        severity: "success",
        title: he.success.title,
        text: he.success.text
      });
    }).catch((M) => {
      b({
        title: he.error.title,
        text: `${he.error.text} ${M.message && " (" + M.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, Q = (le, he) => {
    if (!(le != null && le.length) && !(he != null && he.length)) {
      d([]), v([]);
      return;
    }
    const M = (le || []).map(
      (Te) => x(V4, {
        owner: Te.owner,
        repositoryName: Te.repository,
        issueNumber: Te.number
      })
    ), Ae = (he || []).map(
      (Te) => x(z4, {
        owner: Te.owner,
        repositoryName: Te.repository,
        prNumber: Te.number
      })
    ), Ve = [...M, ...Ae];
    ee(!0), Promise.all(Ve).then((Te) => {
      const ze = [], ge = [];
      Te.forEach((Oe) => {
        var $e;
        const Ye = ($e = Oe == null ? void 0 : Oe.data) == null ? void 0 : $e.GitHub;
        if (!Ye) {
          d([]), v([]);
          return;
        }
        Object.keys(Ye).forEach((xe) => {
          if (xe.startsWith("repository")) {
            const Ue = Ye[xe];
            Object.keys(Ue).forEach((Be) => {
              var re, be, Ne;
              const Pe = Ue[Be], Ie = {
                number: Pe == null ? void 0 : Pe.number,
                owner: (be = (re = Pe == null ? void 0 : Pe.repository) == null ? void 0 : re.owner) == null ? void 0 : be.login,
                repository: (Ne = Pe == null ? void 0 : Pe.repository) == null ? void 0 : Ne.name
              };
              Be.startsWith("issue") && ze.push({
                ...Pe,
                type: "ISSUE",
                key: Ie
              }), Be.startsWith("pullRequest") && ge.push({
                ...Pe,
                type: "PR",
                key: Ie
              });
            });
          }
        });
      }), d(ze), v(ge);
    }).catch(K).finally(() => {
      ee(!1);
    });
  }, ne = ({ key: le, type: he }) => {
    h("github:link:issue:clicked", {
      githubOrganization: n
    });
    const M = N && (B.length || Z.length) ? N : a, Ae = he === "ISSUE" ? "issues" : "pullRequests";
    M.github[Ae] = Array.from(
      new Set(M.github[Ae]).add(le)
    ), V(M, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${or(
          le
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${or(le)} failed. Please try again.`
      }
    });
  }, ce = async ({ key: le, type: he }) => {
    h("github:link:issue:clicked", {
      githubOrganization: n
    });
    const M = N && (B.length || Z.length) ? N : a, Ae = he === "ISSUE" ? "issues" : "pullRequests";
    M.github[Ae] = Array.from(
      new Set(M.github[Ae]).add(le)
    ), await O(M).catch((Ve) => {
      b({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${Ve.message && " (" + Ve.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ae = ({ key: le, type: he }) => {
    h("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const M = he === "ISSUE" ? "issue" : "pull request";
    j({
      headline: `Unlink ${M} ${or(le)}?`,
      text: `You are about to unlink the ${M} ${or(
        le
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${M}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        var Ae;
        const Ve = he === "ISSUE" ? "issues" : "pullRequests";
        if (!N)
          return;
        const Te = {
          ...N,
          github: {
            ...N == null ? void 0 : N.github,
            [Ve]: (Ae = N == null ? void 0 : N.github) == null ? void 0 : Ae[Ve].filter(
              (ze) => ze.number !== le.number || ze.owner !== le.owner || ze.repository !== le.repository
            )
          }
        };
        h("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), V(Te, {
          success: {
            title: `GitHub ${M} unlinked`,
            text: `You unlinked the GitHub ${M} ${or(
              le
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${or(le)} failed.`
          }
        });
      },
      onCancel: () => {
        h("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ve = () => {
    h("github:unlink:all:clicked", {
      githubOrganization: n
    }), j({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        h("github:unlink:all:confirmed", {
          githubOrganization: n
        }), V(a, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        h("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, je = B.filter(
    (le) => !(o != null && o.includes(le))
  ) || [], G = Z.filter(
    (le) => !(l != null && l.includes(le))
  ) || [];
  return {
    linkGithubItem: ne,
    linkGithubItemQuietly: ce,
    unlinkGithubItem: ae,
    loadGithubItems: Q,
    removeDanglingGithubItemLinks: () => {
      const le = {
        ...N,
        github: {
          ...N == null ? void 0 : N.github,
          issues: B.filter(
            (he) => !je.includes(he)
          ) || [],
          pullRequests: Z.filter(
            (he) => !G.includes(he)
          ) || []
        }
      };
      O(le);
    },
    unlinkAllGithubItems: ve,
    isLoadingGithubItemLinks: P,
    danglingIssueLinks: je,
    danglingPullRequestLinks: G,
    isLoadingGithubItems: Y,
    issues: m,
    pullRequests: p,
    error: y
  };
}
const B4 = "_contentWrapper_1vx3c_1", q4 = "_contentWrapperHeadline_1vx3c_4", H4 = "_contentWrapperBody_1vx3c_11", K4 = "_contentWrapperAssigneeIcon_1vx3c_15", W4 = "_contentWrapperStatusTag_1vx3c_20", Jr = {
  contentWrapper: B4,
  contentWrapperHeadline: q4,
  contentWrapperBody: H4,
  contentWrapperAssigneeIcon: K4,
  contentWrapperStatusTag: W4
}, W1 = ({
  description: e,
  assignees: n,
  labels: t
}) => /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
  e && /* @__PURE__ */ _e.jsxs(Wn, { className: Jr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(Wn, { className: Jr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ _e.jsx(Wn, { className: Jr.contentWrapperBody, children: e })
  ] }),
  (n == null ? void 0 : n.nodes) && n.nodes.length > 0 && /* @__PURE__ */ _e.jsxs(Wn, { className: Jr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(Wn, { className: Jr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ _e.jsx(Wn, { className: Jr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ _e.jsxs(Wn, { margin: "100 0", children: [
        /* @__PURE__ */ _e.jsx(
          "img",
          {
            className: Jr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  (t == null ? void 0 : t.nodes) && (t == null ? void 0 : t.nodes.length) > 0 && /* @__PURE__ */ _e.jsx(Wn, { className: Jr.contentWrapper, children: t.nodes.map(
    (i) => i && /* @__PURE__ */ _e.jsx(
      Dn,
      {
        className: Jr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), G4 = "_collapse_1bdjy_1", Y4 = "_collapseHeader_1bdjy_10", J4 = "_collapseHeaderKey_1bdjy_31", Q4 = "_collapseHeaderKeyIcon_1bdjy_36", X4 = "_collapseHeaderKeyLink_1bdjy_41", Z4 = "_collapseHeaderIcon_1bdjy_44", eB = "_collapseHeaderTitle_1bdjy_49", nB = "_collapseContent_1bdjy_57", tB = "_collapseContentButtonSpacer_1bdjy_60", rB = "_collapseContentButtonLink_1bdjy_63", Dr = {
  collapse: G4,
  collapseHeader: Y4,
  collapseHeaderKey: J4,
  collapseHeaderKeyIcon: Q4,
  collapseHeaderKeyLink: X4,
  collapseHeaderIcon: Z4,
  collapseHeaderTitle: eB,
  collapseContent: nB,
  collapseContentButtonSpacer: tB,
  collapseContentButtonLink: rB
}, iB = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: t
}) => {
  const i = e.reduce(
    (c, m) => ({ ...c, [m.id]: !1 }),
    {}
  ), [a, o] = me(i), { track: s } = bn(), l = (c, m) => {
    o({ ...a, [c]: m });
  };
  return /* @__PURE__ */ _e.jsx(_, { flexDirection: "column", gap: "250", children: e != null && e.length ? e.map((c) => {
    const {
      id: m,
      number: d,
      key: p,
      title: v,
      bodyText: y,
      repository: S,
      type: b,
      state: j,
      assignees: x,
      labels: h
    } = c, P = a[m];
    return /* @__PURE__ */ _e.jsxs(
      lr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: P,
        className: Dr.collapse,
        children: [
          /* @__PURE__ */ _e.jsx(lr.Header, { className: Dr.collapseHeader, children: /* @__PURE__ */ _e.jsxs(
            _,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ _e.jsx(Wn, { children: /* @__PURE__ */ _e.jsxs(Wn, { as: "span", className: Dr.collapseHeaderKey, children: [
                  pv(
                    b,
                    j,
                    Dr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ _e.jsxs(
                    "a",
                    {
                      href: Ib(p),
                      className: Dr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (N) => {
                        N.stopPropagation();
                      },
                      children: [
                        or(p),
                        /* @__PURE__ */ _e.jsx(
                          ye,
                          {
                            className: Dr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ _e.jsx(Wn, { className: Dr.collapseHeaderTitle, children: v })
              ]
            }
          ) }),
          /* @__PURE__ */ _e.jsx(lr.Content, { className: Dr.collapseContent, children: /* @__PURE__ */ _e.jsxs(_, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ _e.jsx(
              W1,
              {
                description: y,
                assignees: x,
                labels: h
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              Qn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Dr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: d,
                    owner: S == null ? void 0 : S.owner.login,
                    repository: c.repository.name
                  },
                  type: b
                }),
                children: [
                  "Unlink ",
                  $b(b)
                ]
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              Ct,
              {
                slotEnd: /* @__PURE__ */ _e.jsx(ye, { name: "external-link" }),
                variant: "tertiary",
                className: Dr.collapseContentButtonLink,
                navigate: () => {
                  var N;
                  s("github:view:link:clicked", {
                    githubOrganization: t
                  }), (N = window.open(Ib(p), "_blank")) == null || N.focus();
                },
                children: [
                  "View ",
                  $b(b),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ _e.jsx(_e.Fragment, {}) });
}, aB = "_result_1uaom_1", oB = "_resultName_1uaom_21", sB = "_resultItemIcon_1uaom_29", lB = "_resultDescription_1uaom_34", uB = "_resultLinkIcon_1uaom_46", cB = "_tooltip_1uaom_55", dB = "_tooltipName_1uaom_61", mB = "_tooltipTag_1uaom_71", Qr = {
  result: aB,
  resultName: oB,
  resultItemIcon: sB,
  resultDescription: lB,
  resultLinkIcon: uB,
  tooltip: cB,
  tooltipName: dB,
  tooltipTag: mB
}, fB = ({
  item: e,
  onSelect: n
}) => {
  const { key: t, title: i, type: a, state: o, labels: s, bodyText: l, assignees: c } = e, [m, d] = me(!1);
  return /* @__PURE__ */ _e.jsx(
    nn,
    {
      className: Qr.tooltip,
      content: /* @__PURE__ */ _e.jsxs(_, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ _e.jsxs(
          _,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ _e.jsxs(Wn, { as: "span", className: Qr.tooltipName, children: [
                pv(a, o, Qr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ _e.jsx(Dn, { className: Qr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ _e.jsx(
          W1,
          {
            description: l,
            assignees: c,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ _e.jsxs(
        "button",
        {
          className: Qr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => d(!0),
          onMouseLeave: () => d(!1),
          children: [
            /* @__PURE__ */ _e.jsxs(
              _,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ _e.jsx(_, { flexDirection: "row", children: /* @__PURE__ */ _e.jsxs(Wn, { as: "span", className: Qr.resultName, children: [
                    pv(a, o, Qr.resultItemIcon),
                    or(t)
                  ] }) }),
                  /* @__PURE__ */ _e.jsx(Wn, { className: Qr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ _e.jsx(
              ye,
              {
                className: Qr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, pB = ({
  className: e,
  searched: n,
  githubOrganization: t
}) => /* @__PURE__ */ _e.jsx(
  Ct,
  {
    slotEnd: /* @__PURE__ */ _e.jsx(ye, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      var i;
      (i = window.open(
        `https://github.com/search?q=is:issue+org:${t}+${n}`,
        "_blank"
      )) == null || i.focus();
    },
    children: "View matching items on GitHub"
  }
), Zl = "[a-zA-z0-9_.-]+", G1 = "[0-9]+", vB = new RegExp(
  `(${Zl})/(${Zl})/(?:issues|pull)/(${G1})`,
  "i"
), Eb = new RegExp(`^${vB.source}$`), Tb = new RegExp(
  `https://github.com/(${Zl})/(${Zl})/(?:issues|pull)/(${G1})`,
  "i"
), hB = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: t,
  linkedPullRequests: i
}) => {
  const a = At(() => (t == null ? void 0 : t.map((O) => O.id)) || [], [t]), o = At(() => (i == null ? void 0 : i.map((O) => O.id)) || [], [i]), [s, l] = me([]), { useLazyQuery: c } = pn(), [m, d] = me(), [p, { loading: v, error: y, data: S, networkStatus: b }] = c(L4, {
    notifyOnNetworkStatusChange: !0
  });
  Va(
    () => {
      !v && m && b === cr.ready ? p({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), Ge(() => {
    var O, B, Z;
    let Y = ((B = (O = S == null ? void 0 : S.GitHub) == null ? void 0 : O.issues) == null ? void 0 : B.nodes) || [], ee = ((Z = S == null ? void 0 : S.GitHub) == null ? void 0 : Z.pullRequests.nodes) || [];
    a.length > 0 && (Y = Y.filter((J) => !a.includes(J.id))), o.length > 0 && (ee = ee.filter(
      (J) => !o.includes(J.id)
    )), l([
      ...Y.map((J) => ({
        ...J,
        type: "ISSUE",
        key: {
          number: J.number,
          owner: J.repository.owner.login,
          repository: J.repository.name
        }
      })),
      ...ee.map((J) => ({
        ...J,
        type: "PR",
        key: {
          number: J.number,
          owner: J.repository.owner.login,
          repository: J.repository.name
        }
      }))
    ]);
  }, [S, a, o]);
  function j(O) {
    const B = O == null ? void 0 : O.trim();
    if (Eb.test(B)) {
      const [Z, Y, ee, J] = B.match(Eb) || [];
      return Y !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
    if (Tb.test(B)) {
      const [Z, Y, ee, J] = B.match(Tb) || [];
      return Y !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
  }
  const x = (O) => {
    e({
      key: M4(O),
      type: O.type
    }), d(void 0);
  }, h = (O) => {
    const B = j(O);
    d(
      B ? `org:${B.owner} repo:${B.repository} ${B.number}` : `org:${n} ${O}`
    );
  }, P = () => {
    d(void 0);
  }, N = ({ className: O, searched: B }) => /* @__PURE__ */ _e.jsx(
    pB,
    {
      className: O,
      searched: B,
      githubOrganization: n
    }
  ), $ = ({ item: O, onSelect: B }) => /* @__PURE__ */ _e.jsx(fB, { item: O, onSelect: B });
  return !v && y ? /* @__PURE__ */ _e.jsx(Fn, { error: y }) : /* @__PURE__ */ _e.jsx(
    Fr,
    {
      items: s == null ? void 0 : s.map((O) => ({ name: O.title, ...O })),
      loading: v,
      onSearch: h,
      onSelect: x,
      onClear: P,
      emptyMessage: m ? v ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: N,
      itemComponent: $,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, yB = "_itemButton_3sxfy_1", gB = "_result_3sxfy_6", kB = "_resultName_3sxfy_30", bB = "_resultCheckIcon_3sxfy_38", _B = "_resultAssigneeIcon_3sxfy_41", io = {
  itemButton: yB,
  result: gB,
  resultName: kB,
  resultCheckIcon: bB,
  resultAssigneeIcon: _B
}, Y1 = ({
  item: e,
  checked: n = !1,
  onSelectItem: t
}) => /* @__PURE__ */ _e.jsx(
  _,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ _e.jsx(
      "button",
      {
        onClick: () => {
          t(e);
        },
        className: io.itemButton,
        children: /* @__PURE__ */ _e.jsxs(_, { className: io.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ _e.jsx(Wn, { margin: "100 0", children: /* @__PURE__ */ _e.jsx(
            "img",
            {
              className: io.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ _e.jsx(Wn, { className: io.resultName, children: e.name }),
          n && /* @__PURE__ */ _e.jsx(Wn, { className: io.resultCheckIcon, children: /* @__PURE__ */ _e.jsx(ye, { name: "done" }) })
        ] })
      }
    )
  }
), xB = za(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), SB = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: t,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = pn(), [o, s] = me([]), [l, c] = me(""), m = 2, [d, { loading: p, error: v, data: y, networkStatus: S }] = a(
    xB,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Va(
    () => {
      !p && l && l.length >= m && S === cr.ready ? d({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Ge(() => {
    var b, j, x;
    const h = ((j = (b = y == null ? void 0 : y.GitHub) == null ? void 0 : b.organization) == null ? void 0 : j.teams) || { edges: [] }, P = [];
    (x = h == null ? void 0 : h.edges) == null || x.forEach((N) => {
      var $;
      const O = ($ = N == null ? void 0 : N.node) == null ? void 0 : $.members, B = O == null ? void 0 : O.edges;
      ((B == null ? void 0 : B.length) || 0) > 0 && (B == null || B.forEach((Z) => {
        const Y = Z == null ? void 0 : Z.node;
        Y && (Y != null && Y.id && P.find((ee) => ee.id === Y.id) || P.push(Y));
      }));
    }), s(
      P.sort((N, $) => {
        var O, B, Z, Y;
        const ee = ((O = N.name) == null ? void 0 : O.toLowerCase()) || ((B = N.login) == null ? void 0 : B.toLowerCase()), J = ((Z = $.name) == null ? void 0 : Z.toLowerCase()) || ((Y = $.login) == null ? void 0 : Y.toLowerCase());
        return ee.localeCompare(J, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [y]), !p && v ? /* @__PURE__ */ _e.jsx(Fn, { error: v }) : /* @__PURE__ */ _e.jsx(
    Fr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: (o == null ? void 0 : o.map(({ id: b, name: j, login: x, avatarUrl: h }) => ({
        id: b,
        name: j || x,
        iconUrl: h
      }))) || [],
      loading: p,
      onSearch: (b) => c(b),
      onChange: (b, j) => {
        const x = b.id;
        i ? (j && !n.find(
          (h) => h.id === x
        ) && n.push(b), j || (n = n.filter(
          (h) => h.id !== x
        ))) : n = j ? [b] : [], t(n);
      },
      onClear: () => c(""),
      selectedItems: n,
      emptyMessage: l ? p ? "" : "No user found" : "Search users",
      itemComponent: ({ item: b, onSelect: j, checked: x }) => /* @__PURE__ */ _e.jsx(
        Y1,
        {
          item: b,
          checked: x,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, NB = ({
  field: e,
  value: n,
  onChange: t,
  githubOrganization: i
}) => {
  var a;
  const { multiple: o, type: s } = e;
  switch (s) {
    case "any":
      return /* @__PURE__ */ _e.jsx(Cr, { onChange: t, value: n });
    case "array":
      return e != null && e.allowedValues ? /* @__PURE__ */ _e.jsx(
        Fr,
        {
          onSelect: t,
          selectedItems: Array.isArray(n) ? n : [],
          items: e == null ? void 0 : e.allowedValues.map(({ id: l, name: c, value: m }) => ({
            id: l,
            name: c || m
          }))
        }
      ) : /* @__PURE__ */ _e.jsx(
        WN,
        {
          onChange: t,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ _e.jsx(Cr, { type: "number", onChange: t, value: n });
    case "option":
      return /* @__PURE__ */ _e.jsx(
        Fr,
        {
          onSelect: t,
          selectedItems: Array.isArray(n) ? n : [],
          items: ((a = e == null ? void 0 : e.allowedValues) == null ? void 0 : a.map(
            ({ id: l, name: c, value: m }) => ({
              id: l,
              name: c || m
            })
          )) || []
        }
      );
    case "string":
      return /* @__PURE__ */ _e.jsx(Cr, { onChange: t, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ _e.jsx(Tp, { onChange: t, value: n || "" });
    case "user":
      return /* @__PURE__ */ _e.jsx(
        SB,
        {
          githubOrganization: i,
          onChange: t,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: o
        }
      );
    default:
      return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, wB = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: t,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ _e.jsx(_e.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ _e.jsx(
  Ut,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ _e.jsx(
      Vn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: NB({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: t
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), jB = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: t,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ _e.jsxs(
    _,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ _e.jsxs(q.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ _e.jsxs(q.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ _e.jsx(ye, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ _e.jsx(Vn, { label: "GitHub issue link", children: /* @__PURE__ */ _e.jsx(
          Cr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: t ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, CB = "_modalBody_1hk1o_1", FB = "_modalBodyFormFields_1hk1o_4", od = {
  modalBody: CB,
  modalBodyFormFields: FB
}, IB = za(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), $B = za(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), EB = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], TB = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: t,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = pn(), { track: c } = bn(), {
    control: m,
    handleSubmit: d,
    formState: { errors: p },
    reset: v,
    getValues: y
  } = xi(), [S, b] = me(""), [j, x] = me([]), [h, P] = me(), [N, $] = me(!1), [O, B] = me(!1), [Z, Y] = O1(), [
    ee,
    {
      loading: J,
      error: K,
      networkStatus: V
    }
  ] = s(IB, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (he) => {
      var M, Ae;
      x(
        (Ae = (M = he.GitHub.search) == null ? void 0 : M.edges) == null ? void 0 : Ae.map((Ve) => Ve == null ? void 0 : Ve.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), x([]);
    }
  });
  Va(
    () => {
      !J && S && V === cr.ready ? ee({
        variables: {
          query: S,
          maxResults: 10
        }
      }) : x([]);
    },
    500,
    [S]
  );
  const [Q, { error: ne }] = l(
    $B,
    {
      onError: (he) => {
        $(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", he);
      },
      onCompleted: (he) => {
        var M;
        $(!1);
        const Ae = (M = he.GitHub.createIssue) == null ? void 0 : M.issue;
        P(Ae), o({
          title: "Success",
          text: `GitHub issue '${Ae.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), t({
          owner: a,
          repository: Ae.repository.name,
          number: Ae.number
        });
      }
    }
  ), ce = (he) => {
    b(`org:${a} ${he}`);
  }, ae = (he, M) => {
    M(he), b("");
  }, ve = () => {
    b("");
  }, je = (he) => {
    var M;
    c("github:create:issue:confirmed", {
      githubOrganization: a
    }), $(!0), Q({
      variables: {
        input: {
          repositoryId: he.repository.id,
          title: he.title,
          body: he.body,
          assigneeIds: ((M = he.assignees) == null ? void 0 : M.length) > 0 ? he.assignees.map((Ae) => Ae.id) : void 0
        }
      }
    });
  };
  Ge(() => {
    const he = O ? window.setTimeout(() => B(!1), 2e3) : void 0;
    return () => window.clearTimeout(he);
  }, [O]);
  const G = () => {
    b(""), x([]), P(void 0), $(!1), B(!1);
  }, le = () => {
    c("github:create:issue:canceled", {
      githubOrganization: a
    }), G(), v(), n();
  };
  return /* @__PURE__ */ _e.jsxs(
    Ht,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: le,
      children: [
        /* @__PURE__ */ _e.jsx(
          Kt,
          {
            title: h ? "Issue creation successful" : "Create new GitHub issue",
            onClose: le
          }
        ),
        /* @__PURE__ */ _e.jsxs(Wt, { className: od.modalBody, children: [
          !J && K && /* @__PURE__ */ _e.jsx(Fn, { error: K }),
          !N && ne && /* @__PURE__ */ _e.jsx(Fn, { error: ne }),
          h ? /* @__PURE__ */ _e.jsx(
            jB,
            {
              createdIssue: h,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: O,
              setIssueLinkCopied: B,
              copyToClipboard: Y
            }
          ) : /* @__PURE__ */ _e.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: d(je),
              children: /* @__PURE__ */ _e.jsxs(Ir, { children: [
                /* @__PURE__ */ _e.jsx(ln, { children: /* @__PURE__ */ _e.jsx(Vn, { label: "Repository", required: !0, children: /* @__PURE__ */ _e.jsx(
                  Ut,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: he, value: M } }) => /* @__PURE__ */ _e.jsx(
                      Fr,
                      {
                        className: od.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: J,
                        onSearch: ce,
                        onSelect: (Ae) => ae(Ae, he),
                        onClear: ve,
                        selectedItems: [M],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: K ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: Ae, onSelect: Ve, checked: Te }) => /* @__PURE__ */ _e.jsx(
                          Y1,
                          {
                            item: Ae,
                            checked: Te,
                            onSelectItem: Ve
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ _e.jsx(ln, { className: od.modalBodyFormFields, children: /* @__PURE__ */ _e.jsx(
                  wB,
                  {
                    control: m,
                    errors: p,
                    getValues: y,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: EB
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ _e.jsx(
          rr,
          {
            confirmOnClick: h ? le : d(je),
            confirmProps: {
              isLoading: N,
              loadingIndicator: /* @__PURE__ */ _e.jsx(fn, { size: 16 })
            },
            confirmName: h ? "Close" : "Save",
            cancelOnClick: h ? void 0 : le
          }
        )
      ]
    }
  );
}, OB = "_wrapper_19v8w_1", RB = "_inputWrapper_19v8w_6", DB = "_buttonLink_19v8w_19", PB = "_noItemsFound_19v8w_23", AB = "_createIssueButton_19v8w_28", ta = {
  wrapper: OB,
  inputWrapper: RB,
  buttonLink: DB,
  noItemsFound: PB,
  createIssueButton: AB
}, LB = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = me(!1), { track: a } = bn(), o = n == null ? void 0 : n.githubOrganization, s = !!(n != null && n.enableRemoveAllLinks), {
    linkGithubItem: l,
    linkGithubItemQuietly: c,
    unlinkGithubItem: m,
    loadGithubItems: d,
    removeDanglingGithubItemLinks: p,
    unlinkAllGithubItems: v,
    isLoadingGithubItemLinks: y,
    danglingIssueLinks: S,
    danglingPullRequestLinks: b,
    isLoadingGithubItems: j,
    issues: x,
    pullRequests: h,
    error: P
  } = U4({
    conversationId: (e == null ? void 0 : e.conversationId) || null,
    githubOrganization: o
  }), N = (Y) => c({ key: Y, type: "ISSUE" }), $ = !(!!(x != null && x.length)).valueOf() && !(!!(h != null && h.length)).valueOf() && !(!!(S != null && S.length)).valueOf() && !(!!(b != null && b.length)).valueOf(), O = !y && !j && !!(S != null && S.length) && !!(b != null && b.length) && !!(n != null && n.showDanglingLinks), B = n == null ? void 0 : n.enableCreateIssue, Z = !!(x != null && x.length) || !!(h != null && h.length);
  return !j && P ? /* @__PURE__ */ _e.jsx(Fn, { error: P, retry: () => d() }) : /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsxs(_, { className: ta.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ _e.jsxs(_, { className: ta.inputWrapper, flexDirection: "column", children: [
        B && /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
          /* @__PURE__ */ _e.jsx(
            Qn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n == null ? void 0 : n.githubOrganization
                }), i(!0);
              },
              className: ta.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ _e.jsx("div", { className: ta.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ _e.jsx(
          hB,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: x,
            linkedPullRequests: h
          }
        )
      ] }),
      j ? /* @__PURE__ */ _e.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ _e.jsx(fn, { "data-testid": "github-widget-item-spinner" }) }) : Z ? /* @__PURE__ */ _e.jsx(
        iB,
        {
          items: [...x, ...h],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ _e.jsx(q.Paragraph, { align: "center", className: ta.noItemsFound, children: "No linked items found." }),
      O && /* @__PURE__ */ _e.jsxs(
        _,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ _e.jsx(q.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ _e.jsxs(_, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              S.map((Y) => /* @__PURE__ */ _e.jsx(
                Dn,
                {
                  onDelete: () => m({
                    key: Y,
                    type: "ISSUE"
                  }),
                  children: or(Y)
                },
                or(Y)
              )),
              b.map((Y) => /* @__PURE__ */ _e.jsx(
                Dn,
                {
                  onDelete: () => m({ key: Y, type: "PR" }),
                  children: or(Y)
                },
                or(Y)
              ))
            ] }),
            /* @__PURE__ */ _e.jsx(
              Qn,
              {
                variant: "secondary",
                onClick: () => p(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Z && /* @__PURE__ */ _e.jsx(
        Qn,
        {
          variant: "secondary",
          disabled: $,
          onClick: v,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ _e.jsx(
        Ct,
        {
          slotEnd: /* @__PURE__ */ _e.jsx(ye, { name: "external-link" }),
          variant: "tertiary",
          className: ta.buttonLink,
          navigate: () => {
            var Y;
            (Y = window.open(`https://github.com/${o}`, "_blank")) == null || Y.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ _e.jsx(
      TB,
      {
        isOpen: t,
        onClose: () => i(!1),
        linkGithubIssueQuietly: N,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, VB = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vu
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var sd = { exports: {} }, ao = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ob;
function zB() {
  if (Ob) return ao;
  Ob = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return ao.Fragment = t, ao.jsx = s, ao.jsxs = s, ao;
}
var Gs = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rb;
function MB() {
  return Rb || (Rb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    Gs.Fragment = i, Gs.jsx = Mn, Gs.jsxs = Un;
  }()), Gs;
}
var Db;
function UB() {
  return Db || (Db = 1, process.env.NODE_ENV === "production" ? sd.exports = zB() : sd.exports = MB()), sd.exports;
}
var fe = UB();
const zh = (e, n) => {
  const t = (o) => (e.marks || []).map((s) => {
    var l;
    return {
      formatterFunction: (l = n.marks[e.type]) == null ? void 0 : l[s.type],
      mark: s
    };
  }).reduce(
    (s, l) => () => {
      var c;
      return ((c = l.formatterFunction) == null ? void 0 : c.call(l, l.mark, s)) || o;
    },
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => zh(l, s)) : [], a = n.nodes[e.type] || n.default;
  return t(
    a(e, i(e, n))
  );
}, BB = "_jiraCode_h30p6_1", qB = "_jiraCodeInline_h30p6_8", ld = {
  jiraCode: BB,
  jiraCodeInline: qB
}, J1 = {
  default: (e, n) => n().every((t) => typeof t == "string") ? n().join(" ") : /* @__PURE__ */ fe.jsx(fe.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ fe.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ fe.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ fe.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ fe.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ fe.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ fe.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ fe.jsx("pre", { children: /* @__PURE__ */ fe.jsx("code", { className: ld.jiraCode, children: n() }) }),
    heading: (e, n) => {
      var t;
      switch ((t = e.attrs) == null ? void 0 : t.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ fe.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ fe.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ fe.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ fe.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ fe.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ fe.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ fe.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ fe.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ fe.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ fe.jsx("u", { children: n() }),
      link: (e, n) => {
        var t;
        return /* @__PURE__ */ fe.jsx("a", { href: ((t = e.attrs) == null ? void 0 : t.href) || "", target: "_blank", rel: "noreferrer", children: n() });
      },
      code: (e, n) => /* @__PURE__ */ fe.jsx("code", { className: ct(ld.jiraCode, ld.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, eu = ({
  iconUrl: e,
  className: n,
  width: t
}) => {
  const [i, a] = me(!1);
  return !e || i ? /* @__PURE__ */ fe.jsx(ye, { size: t, name: "question", className: n }) : /* @__PURE__ */ fe.jsx(
    "img",
    {
      src: e,
      width: t,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, HB = "_collapse_m2gjh_1", KB = "_collapseHeader_m2gjh_10", WB = "_collapseHeaderLink_m2gjh_31", GB = "_collapseHeaderStatus_m2gjh_40", YB = "_collapseHeaderTitle_m2gjh_51", JB = "_collapseContent_m2gjh_59", QB = "_collapseContentHeadline_m2gjh_62", XB = "_collapseContentButtonSpacer_m2gjh_68", ZB = "_collapseContentButtonLink_m2gjh_71", e5 = "_collapseContentStatusTag_m2gjh_74", n5 = "_collapseContentDescription_m2gjh_77", hr = {
  collapse: HB,
  collapseHeader: KB,
  collapseHeaderLink: WB,
  collapseHeaderStatus: GB,
  collapseHeaderTitle: YB,
  collapseContent: JB,
  collapseContentHeadline: QB,
  collapseContentButtonSpacer: XB,
  collapseContentButtonLink: ZB,
  collapseContentStatusTag: e5,
  collapseContentDescription: n5
}, Q1 = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: t
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : t, t5 = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: t
}) => {
  const i = e.reduce(
    (c, m) => m != null && m.id ? { ...c, [m.id]: !1 } : c,
    {}
  ), [a, o] = me(i), { track: s } = bn(), l = (c, m) => {
    o({ ...a, [c]: m });
  };
  return /* @__PURE__ */ fe.jsx(_, { flexDirection: "column", gap: "250", children: e != null && e.length ? e.map((c) => {
    const { summary: m, description: d, status: p, issuetype: v } = (c == null ? void 0 : c.fields) || {}, y = Q1({
      avatarId: v == null ? void 0 : v.avatarId,
      iconUrl: v == null ? void 0 : v.iconUrl,
      jiraInstanceUrl: n
    }), S = !!(c != null && c.id && a[c.id]);
    return /* @__PURE__ */ fe.jsxs(
      lr,
      {
        onToggle: () => (c == null ? void 0 : c.id) && l(c.id, !a[c.id]),
        isOpen: S,
        className: hr.collapse,
        children: [
          /* @__PURE__ */ fe.jsx(lr.Header, { className: hr.collapseHeader, children: /* @__PURE__ */ fe.jsxs(
            _,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ fe.jsxs(_, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ fe.jsxs(_, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ fe.jsx(eu, { width: 16, iconUrl: y }),
                    /* @__PURE__ */ fe.jsx(
                      "a",
                      {
                        className: hr.collapseHeaderLink,
                        href: `${n}/browse/${c == null ? void 0 : c.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (b) => {
                          b.stopPropagation(), c != null && c.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: c.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ fe.jsxs(_, { alignItems: "center", gap: "200", children: [
                          c == null ? void 0 : c.key,
                          /* @__PURE__ */ fe.jsx(ye, { name: "external-link", size: 16 })
                        ] })
                      },
                      c == null ? void 0 : c.key
                    )
                  ] }),
                  /* @__PURE__ */ fe.jsx("span", { className: hr.collapseHeaderStatus, children: (p == null ? void 0 : p.name) && /* @__PURE__ */ fe.jsx(Dn, { className: hr.collapseContentStatusTag, children: p.name }) })
                ] }),
                /* @__PURE__ */ fe.jsx("div", { className: hr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ fe.jsx(lr.Content, { className: hr.collapseContent, children: /* @__PURE__ */ fe.jsxs(_, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ fe.jsx("div", { className: hr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ fe.jsx(Wn, { className: hr.collapseContentDescription, children: d ? zh(d, J1) : "" }),
            /* @__PURE__ */ fe.jsx(
              Qn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: hr.collapseContentButtonSpacer,
                onClick: () => (c == null ? void 0 : c.key) && t(c.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ fe.jsx(
              Ct,
              {
                slotEnd: /* @__PURE__ */ fe.jsx(ye, { name: "external-link" }),
                variant: "tertiary",
                className: hr.collapseContentButtonLink,
                navigate: () => {
                  var b;
                  c != null && c.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: c.key,
                    jiraInstanceUrl: n
                  }), (b = window.open(
                    `${n}/browse/${c.key}`,
                    "_blank"
                  )) == null || b.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      c == null ? void 0 : c.id
    );
  }) : /* @__PURE__ */ fe.jsx(fe.Fragment, {}) });
}, r5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, i5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, a5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, o5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, s5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, l5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchForIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchForIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, u5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, c5 = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': r5,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": i5,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": a5,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": o5,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': s5,
  '\n  query searchForIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchForIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': l5,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": u5
};
function Hi(e) {
  return c5[e] ?? {};
}
const X1 = Hi(
  /* GraphQL */
  `
  query searchForIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchForIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), d5 = Hi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), m5 = Hi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), f5 = Hi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), p5 = Hi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), v5 = Hi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), h5 = Hi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Mh = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), y5 = new RegExp(`^${Mh.source}$`), g5 = new RegExp(`/${Mh.source}$`), Pb = new RegExp(
  `.+?[&?]selectedIssue=(${Mh.source})[&?]?.*`
);
function Z1(e, n) {
  var t, i, a;
  const o = { jira: { issues: [] } }, [s, l] = me([]), [c, m] = me([]), [d, p] = me(), { track: v } = bn(), { showNotification: y, showModal: S, useLazyQuery: b, useMutation: j } = pn(), {
    loading: x,
    data: h,
    error: P,
    store: N
  } = Lv(e ?? null), [
    $,
    { loading: O, error: B, data: Z }
  ] = b(X1, {
    notifyOnNetworkStatusChange: !0
  });
  Ge(() => {
    var le, he;
    const M = ((he = (le = Z == null ? void 0 : Z.Jira) == null ? void 0 : le.searchForIssuesUsingJql) == null ? void 0 : he.issues) || [];
    M != null && M.length && (m(M), l(M.map((Ae) => Ae == null ? void 0 : Ae.key).filter(Boolean)));
  }, [Z]), Ge(
    () => p(P || B || void 0),
    [P, B]
  ), Ge(
    () => {
      x || ne();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [(t = h == null ? void 0 : h.jira) == null ? void 0 : t.issues, x]
  );
  const Y = async (le, he) => {
    await N(le).then(() => {
      y({
        icon: "check-circle-filled",
        severity: "success",
        title: he.success.title,
        text: he.success.text
      });
    }).catch((M) => {
      y({
        title: he.error.title,
        text: `${he.error.text} ${M.message && " (" + M.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [ee] = j(d5, {
    onError: (le) => {
      y({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), J = (le) => {
    const he = window.location.href;
    ee({
      variables: {
        issueKey: le,
        title: `# ${e}`,
        url: he,
        globalId: `system=${he}`
      }
    });
  }, [K] = j(m5, {
    onError: (le) => {
      y({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), V = (le) => {
    const he = window.location.href;
    K({
      variables: {
        issueKey: le,
        globalId: `system=${he}`
      }
    });
  }, Q = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), ne = () => {
    var le, he, M;
    h && ((he = (le = h.jira) == null ? void 0 : le.issues) == null ? void 0 : he.length) > 0 ? $({
      variables: {
        jql: `key in (${(M = h == null ? void 0 : h.jira) == null ? void 0 : M.issues.join(",")})`,
        maxResults: 15
      }
    }) : m([]);
  }, ce = async (le) => {
    var he;
    v("jira:issue:link:clicked", Q(le));
    const M = (he = h == null ? void 0 : h.jira) != null && he.issues ? h : o;
    M.jira.issues = Array.from(
      new Set(M.jira.issues).add(le)
    ), await N(M).then(() => J(le)).catch((Ae) => {
      y({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${Ae.message && " (" + Ae.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ae = (le) => {
    var he;
    v("jira:issue:link:clicked", Q(le));
    const M = (he = h == null ? void 0 : h.jira) != null && he.issues ? h : o;
    M.jira.issues = Array.from(
      new Set(M.jira.issues).add(le)
    ), Y(M, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => J(le));
  }, ve = (le) => {
    v("jira:issue:unlink:clicked", Q(le)), S({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        var he;
        v("jira:issue:unlink:confirmed", Q(le));
        const M = {
          ...h,
          jira: {
            ...h == null ? void 0 : h.jira,
            issues: ((he = h == null ? void 0 : h.jira) == null ? void 0 : he.issues.filter((Ae) => Ae !== le)) || []
          }
        };
        Y(M, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => V(le));
      },
      onCancel: () => v("jira:issue:unlink:cancelled", Q(le))
    });
  }, je = () => {
    v("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), S({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        v("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), c == null || c.forEach((le) => (le == null ? void 0 : le.key) && V(le.key)), Y(o, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => v("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, G = ((a = (i = h == null ? void 0 : h.jira) == null ? void 0 : i.issues) == null ? void 0 : a.filter(
    (le) => !(s != null && s.includes(le))
  )) || [];
  return {
    linkIssue: ae,
    linkIssueQuietly: ce,
    unlinkIssue: ve,
    loadIssues: ne,
    removeDanglingIssueLinks: () => {
      var le;
      v("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const he = {
        ...h,
        jira: {
          ...h == null ? void 0 : h.jira,
          issues: ((le = h == null ? void 0 : h.jira) == null ? void 0 : le.issues.filter(
            (M) => !G.includes(M)
          )) || []
        }
      };
      N(he);
    },
    unlinkAllIssues: je,
    maybeExtractIssueKey: (le) => {
      var he;
      const M = le.replace(/\s/g, "");
      if (y5.test(M))
        return M;
      if (Pb.test(le))
        return (he = le.match(Pb)) == null ? void 0 : he[1];
      if (le.startsWith(n) && g5.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: x,
    danglingIssueLinks: G,
    isLoadingIssues: O,
    issues: c,
    error: d
  };
}
function k5(e = !1, n) {
  const [t, i] = me(e);
  return Ge(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const b5 = "_result_axxxc_48", _5 = "_resultName_axxxc_68", x5 = "_resultNameIcon_axxxc_76", S5 = "_resultDescription_axxxc_81", N5 = "_resultLinkIcon_axxxc_93", w5 = "_tooltip_axxxc_102", j5 = "_tooltipContent_axxxc_108", C5 = "_tooltipName_axxxc_115", F5 = "_tooltipNameIcon_axxxc_120", I5 = "_tooltipDescription_axxxc_125", $5 = "_tooltipSummary_axxxc_133", E5 = "_tooltipTag_axxxc_137", ar = {
  result: b5,
  resultName: _5,
  resultNameIcon: x5,
  resultDescription: S5,
  resultLinkIcon: N5,
  tooltip: w5,
  tooltipContent: j5,
  tooltipName: C5,
  tooltipNameIcon: F5,
  tooltipDescription: I5,
  tooltipSummary: $5,
  tooltipTag: E5
}, T5 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: t,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: c, description: m } = e, [d, p] = me(!1), v = Q1({
    avatarId: o == null ? void 0 : o.avatarId,
    iconUrl: o == null ? void 0 : o.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ fe.jsx(
    nn,
    {
      disabled: i,
      className: ar.tooltip,
      content: /* @__PURE__ */ fe.jsxs("div", { className: ar.tooltipContent, children: [
        /* @__PURE__ */ fe.jsxs(
          _,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ fe.jsxs("span", { className: ar.tooltipName, children: [
                /* @__PURE__ */ fe.jsx(
                  eu,
                  {
                    width: 16,
                    iconUrl: v,
                    className: ar.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ fe.jsx(Dn, { className: ar.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ fe.jsx("div", { className: ar.tooltipSummary, children: m }),
        c && /* @__PURE__ */ fe.jsx("div", { className: ar.tooltipDescription, children: c })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ fe.jsxs(
        "button",
        {
          ...a,
          className: ar.result,
          type: "button",
          onClick: () => {
            t(e);
          },
          onMouseEnter: () => p(!0),
          onMouseLeave: () => p(!1),
          children: [
            /* @__PURE__ */ fe.jsxs(
              _,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: d ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ fe.jsx(_, { flexDirection: "row", children: /* @__PURE__ */ fe.jsxs("span", { className: ar.resultName, children: [
                    /* @__PURE__ */ fe.jsx(
                      eu,
                      {
                        width: 16,
                        iconUrl: v,
                        className: ar.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ fe.jsx("div", { className: ar.resultDescription, children: m })
                ]
              }
            ),
            d && /* @__PURE__ */ fe.jsx(
              ye,
              {
                className: ar.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, O5 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: t
}) => /* @__PURE__ */ fe.jsx(
  Ct,
  {
    slotEnd: /* @__PURE__ */ fe.jsx(ye, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      var i;
      (i = window.open(
        `${t}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )) == null || i.focus();
    },
    children: "View matching issues in Jira"
  }
), R5 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: t,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = pn(), [o, s] = me([]), [l, c] = me(""), [m, { loading: d, error: p, data: v, networkStatus: y }] = a(X1, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: S } = Z1(null, n);
  Va(
    () => {
      !d && l && y === cr.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Ge(() => {
    var N, $;
    const O = (($ = (N = v == null ? void 0 : v.Jira) == null ? void 0 : N.searchForIssuesUsingJql) == null ? void 0 : $.issues) || [];
    s(
      O.map((B) => ({
        id: (B == null ? void 0 : B.key) ?? "",
        name: (B == null ? void 0 : B.key) ?? "",
        description: B == null ? void 0 : B.fields.summary,
        status: B == null ? void 0 : B.fields.status,
        issuetype: B == null ? void 0 : B.fields.issuetype,
        text: B != null && B.fields.description ? zh(B == null ? void 0 : B.fields.description, J1) : /* @__PURE__ */ fe.jsx(fe.Fragment, {})
      }))
    );
  }, [v]);
  const b = (N) => {
    e(N.id), c("");
  }, j = (N) => {
    const $ = N.trim(), O = S($);
    if (O) {
      const B = O.replaceAll("[-_|]", "\\\\$0");
      c(`key = '${B}'`);
    } else $ !== "" && c(
      `text ~ '${$}'${t ? " and project = " + t : ""}`
    );
  }, x = () => {
    c("");
  }, h = (N) => /* @__PURE__ */ fe.jsx(O5, { ...N, jiraInstanceUrl: n }), P = (N) => /* @__PURE__ */ fe.jsx(
    T5,
    {
      ...N,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !d && p ? /* @__PURE__ */ fe.jsx(Fn, { error: p }) : /* @__PURE__ */ fe.jsx(
    Fr,
    {
      items: o,
      loading: d,
      onSearch: j,
      onSelect: b,
      onClear: x,
      emptyMessage: l ? d ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: h,
      itemComponent: P,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, D5 = ({
  field: e,
  value: n,
  onChange: t
}) => {
  var i;
  const [a, o] = me(n ? [n] : []), s = (l, c) => {
    o(
      c ? [...a, l] : a.filter(({ id: m }) => m !== l.id)
    );
  };
  return Ge(() => {
    t(a);
  }, [a]), /* @__PURE__ */ fe.jsx(
    Fr,
    {
      multiple: !0,
      onChange: s,
      selectedItems: a,
      items: (i = e == null ? void 0 : e.allowedValues) == null ? void 0 : i.map(
        ({ id: l, name: c, value: m }) => ({
          id: l,
          name: c || m
        })
      )
    }
  );
}, P5 = "_itemButton_1hl53_1", A5 = "_result_1hl53_6", L5 = "_resultIcon_1hl53_26", V5 = "_resultName_1hl53_30", z5 = "_resultCheckIcon_1hl53_38", oo = {
  itemButton: P5,
  result: A5,
  resultIcon: L5,
  resultName: V5,
  resultCheckIcon: z5
}, vv = ({
  item: e,
  checked: n = !1,
  onSelectItem: t,
  jiraInstanceUrl: i
}) => {
  var a;
  const o = (l) => {
    const c = l.indexOf("/rest/api/");
    return c >= 0 ? `${i}${l == null ? void 0 : l.substring(c)}` : l;
  };
  let s = (e == null ? void 0 : e.iconUrl) || ((a = e == null ? void 0 : e.avatarUrls) == null ? void 0 : a._24x24) || null;
  return s && (s = s != null && s.startsWith("https://api.atlassian.com/ex/") ? o(s) : s), /* @__PURE__ */ fe.jsx(
    _,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ fe.jsx(
        "button",
        {
          onClick: () => {
            t(e);
          },
          className: oo.itemButton,
          children: /* @__PURE__ */ fe.jsxs(_, { className: oo.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ fe.jsx(
              eu,
              {
                width: 36,
                iconUrl: s || "",
                className: oo.resultIcon
              }
            ),
            /* @__PURE__ */ fe.jsx(Wn, { className: oo.resultName, children: e.name }),
            n && /* @__PURE__ */ fe.jsx(Wn, { className: oo.resultCheckIcon, children: /* @__PURE__ */ fe.jsx(ye, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, M5 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: t,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = pn(), [o, s] = me([]), [l, c] = me(), m = 2, [d, { loading: p, error: v, data: y, networkStatus: S }] = a(h5, {
    notifyOnNetworkStatusChange: !0
  });
  return Va(
    () => {
      !p && l && l.length >= m && S === cr.ready ? d({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Ge(() => {
    n && d({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((b) => {
      var j, x, h, P;
      if (((x = (j = b == null ? void 0 : b.data) == null ? void 0 : j.Jira.findUsers) == null ? void 0 : x.length) === 1) {
        const N = (P = (h = b == null ? void 0 : b.data) == null ? void 0 : h.Jira) == null ? void 0 : P.findUsers[0];
        t(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), Ge(() => {
    var b;
    const j = ((b = y == null ? void 0 : y.Jira) == null ? void 0 : b.findUsers) || [];
    s(
      j.filter(({ active: x }) => x).map(({ accountId: x, displayName: h, avatarUrls: P, active: N }) => ({
        id: x,
        name: h,
        avatarUrls: P,
        active: N
      }))
    );
  }, [y]), !p && v ? /* @__PURE__ */ fe.jsx(Fn, { error: v }) : /* @__PURE__ */ fe.jsx(
    Fr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: p,
      onSearch: (b) => c(b),
      onSelect: t,
      onClear: () => c(void 0),
      selectedItems: e,
      emptyMessage: l ? p ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: b, onSelect: j, checked: x }) => /* @__PURE__ */ fe.jsx(
        vv,
        {
          item: b,
          checked: x,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Ab = ({
  field: e
}) => {
  const [n, t] = me(!1), [i, a] = O1();
  return Ge(() => {
    const o = n ? window.setTimeout(() => t(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ fe.jsxs(_, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ fe.jsx(_, { children: /* @__PURE__ */ fe.jsx(ye, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ fe.jsx(q.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ fe.jsx(nn, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ fe.jsx(
      qr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), t(!0);
        }
      }
    ) })
  ] });
}, U5 = ({
  field: e,
  onChange: n,
  value: t,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  var o, s;
  const { type: l, system: c } = e.schema;
  if (["array", "option", "priority"].includes(l) && (!(e != null && e.allowedValues) || e.allowedValues.length === 0))
    return /* @__PURE__ */ fe.jsx(Ab, { field: e });
  switch (l) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ fe.jsx(Cr, { onChange: n, value: t });
    case "string":
      return c === "description" ? /* @__PURE__ */ fe.jsx(Tp, { onChange: n, value: t }) : /* @__PURE__ */ fe.jsx(Cr, { onChange: n, value: t });
    case "textarea":
      return /* @__PURE__ */ fe.jsx(Tp, { onChange: n, value: t });
    case "number":
      return /* @__PURE__ */ fe.jsx(Cr, { type: "number", onChange: n, value: t });
    case "user":
      return /* @__PURE__ */ fe.jsx(
        M5,
        {
          onSelect: n,
          selectedItems: t ? [t] : [],
          agentEmail: e.key === "reporter" && ((o = i == null ? void 0 : i.agent) == null ? void 0 : o.email) || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ fe.jsx(
        Fr,
        {
          onSelect: n,
          selectedItems: t ? [t] : [],
          items: ((s = e == null ? void 0 : e.allowedValues) == null ? void 0 : s.map(
            ({ id: m, name: d, value: p }) => ({
              id: m,
              name: d || p
            })
          )) || []
        }
      );
    case "array":
      return /* @__PURE__ */ fe.jsx(D5, { field: e, value: t, onChange: n });
    default:
      return /* @__PURE__ */ fe.jsx(Ab, { field: e });
  }
}, B5 = ["description", "reporter", "summary"], q5 = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: t,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ fe.jsx(fe.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || B5.includes(o)
).map((o) => /* @__PURE__ */ fe.jsx(
  Ut,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ fe.jsx(
      Vn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: U5({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: t
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), H5 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: t,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ fe.jsxs(
  _,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ fe.jsxs(q.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ fe.jsxs(
          q.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ fe.jsx(ye, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ fe.jsx(Vn, { label: "Jira issue link", children: /* @__PURE__ */ fe.jsx(
        Cr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: t ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), K5 = "_modalBody_1hk1o_1", W5 = "_modalBodyFormFields_1hk1o_4", Lb = {
  modalBody: K5,
  modalBodyFormFields: W5
}, G5 = (e) => {
  var n;
  return {
    version: 1,
    type: "doc",
    content: (n = e == null ? void 0 : e.trim()) == null ? void 0 : n.split(`
`).filter((t) => t !== "").map((t) => ({
      type: "paragraph",
      content: [
        {
          type: "text",
          text: t
        }
      ]
    }))
  };
}, Y5 = (e) => {
  var n, t;
  return ((t = (n = e == null ? void 0 : e.custom) == null ? void 0 : n.split(":")) == null ? void 0 : t[1]) || null;
}, J5 = (e, n) => {
  if (e.startsWith("customfield_")) {
    const t = n.find((a) => a.key === e), i = t == null ? void 0 : t.schema;
    if (i)
      return i;
  }
  return null;
}, Q5 = (e, n) => {
  var t, i;
  const a = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((o, [s, l]) => {
        if (!l || l === "")
          return delete e[s], o;
        const c = J5(s, n), m = Y5(c) ?? s;
        return a.includes(m) ? o[s] = G5(l) : (c == null ? void 0 : c.type) === "number" ? o[s] = parseInt(l) : o[s] = l, o;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...(e == null ? void 0 : e.parent) && { parent: { key: e.parent } },
      ...(e == null ? void 0 : e.reporter) && {
        reporter: { id: ((t = e.reporter) == null ? void 0 : t.id) ?? e.reporter }
      },
      ...(e == null ? void 0 : e.assignee) && {
        assignee: { id: ((i = e.assignee) == null ? void 0 : i.id) ?? e.assignee }
      }
    }
  };
}, X5 = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: t,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, c] = me([]), [m, d] = me(), [p, v] = me(0), [y, S] = me([]), [b, j] = me([]), [x, h] = me(!1), [P, N] = me(!1), [$, O] = me({}), { track: B } = bn(), { isCopied: Z, copyToClipboard: Y } = k5(), { useMutation: ee, useLazyQuery: J, showNotification: K } = pn(), {
    control: V,
    handleSubmit: Q,
    formState: { errors: ne },
    reset: ce,
    setValue: ae,
    getValues: ve
  } = xi({
    defaultValues: s
  }), je = b.length > 0, G = `${a}/browse`, le = Object.keys($).length > 0, [he, { loading: M, error: Ae }] = J(f5, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (re) => {
      c(re.Jira.getAllProjects);
    },
    onError: (re) => {
      K({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", re), c([]);
    }
  }), [
    Ve,
    { loading: Te, error: ze }
  ] = J(p5, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (re) => {
      var be, Ne;
      v(0);
      const Pe = (Ne = (be = re == null ? void 0 : re.Jira) == null ? void 0 : be.getCreateIssueMeta) == null ? void 0 : Ne.projects[0];
      if (Pe) {
        const Ie = Pe == null ? void 0 : Pe.issuetypes.filter(
          ({ subtask: on }) => !on
        );
        S(Ie || []), ae(
          "issuetype",
          Ie.length > 0 ? Ie[0] : void 0
        );
      } else
        K({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), S([]), j([]);
    },
    onError: (re) => {
      K({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", re), S([]), j([]), v(0);
    }
  }), [ge, { error: Oe }] = ee(
    v5,
    {
      onError: () => {
        h(!1), K({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), B("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (re) => {
        var be, Ne, Pe;
        if (h(!1), re != null && re.Jira && "key" in re.Jira.createIssue)
          d((be = re == null ? void 0 : re.Jira) == null ? void 0 : be.createIssue), K({
            title: "Success",
            text: `Jira issue '${re.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), B("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: re.Jira.createIssue.key
          }), t(re.Jira.createIssue.key);
        else if ("errorMessages" in re.Jira.createIssue || "errors" in re.Jira.createIssue) {
          const Ie = (Pe = (Ne = re == null ? void 0 : re.Jira) == null ? void 0 : Ne.createIssue) == null ? void 0 : Pe.errors;
          console.warn("There was a problem creating a Jira issue.", Ie), K({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), $e = (re) => {
    h(!0), O({}), ge({
      variables: {
        input: Q5(re, b)
      }
    });
  };
  Ge(() => {
    if (e)
      try {
        he();
      } catch (re) {
        console.warn("Error when fetching initial projects", re);
      }
  }, [e]), Ge(() => {
    const re = P ? window.setTimeout(() => N(!1), 2e3) : void 0;
    return () => window.clearTimeout(re);
  }, [P]), Ge(() => {
    var re, be;
    if ((y == null ? void 0 : y.length) > 0) {
      ae("issuetype", y[p]);
      const Ne = (be = (re = y[p]) == null ? void 0 : re.fields) == null ? void 0 : be.additionalProperties;
      if ((Ne == null ? void 0 : Ne.length) > 0) {
        const Pe = Ne.map(
          ({ value: k }) => k
        ), Ie = (o ? Pe.sort(({ name: k }, { name: F }) => k.localeCompare(F)) : Pe).sort(
          ({ required: k }, { required: F }) => Number(F) - Number(k)
        ), { project: on, issuetype: C } = ve();
        ce({ project: on, issuetype: C }), j(Ie);
      }
    } else
      j([]), ae("issuetype", void 0);
  }, [y, ae, p]), Ge(() => {
    var re, be, Ne;
    if (Oe && XN(Oe)) {
      if (((re = Oe == null ? void 0 : Oe.graphQLErrors) == null ? void 0 : re.length) > 0) {
        const { graphQLErrors: Pe } = Oe, Ie = (Ne = (be = Pe[0].extensions) == null ? void 0 : be.integration) == null ? void 0 : Ne.responseBody;
        try {
          const on = JSON.parse(Ie);
          if (on != null && on.errors) {
            const C = Object.keys(on.errors).reduce(
              (k, F) => ({
                ...k,
                [F]: {
                  type: "required",
                  message: on.errors[F],
                  ref: {
                    name: F
                  }
                }
              }),
              {}
            );
            O(C);
          }
        } catch {
        }
      }
    } else
      O({});
  }, [Oe]);
  const Ye = () => {
    c([]), j([]), S([]), d(void 0), v(0), h(!1), O({});
  }, xe = () => {
    Ye(), ce(s), n();
  }, Ue = (re) => {
    re && Ve({
      variables: {
        projectKey: re
      }
    });
  }, Be = (re) => {
    const be = y.map((Ne) => Ne.id).indexOf(re);
    v(be ?? 0);
  };
  return /* @__PURE__ */ fe.jsxs(
    Ht,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: xe,
      children: [
        /* @__PURE__ */ fe.jsx(
          Kt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: xe
          }
        ),
        /* @__PURE__ */ fe.jsxs(Wt, { className: Lb.modalBody, children: [
          !M && Ae && /* @__PURE__ */ fe.jsx(Fn, { error: Ae, retry: he }),
          !Te && ze && /* @__PURE__ */ fe.jsx(
            Fn,
            {
              error: ze,
              retry: Ve
            }
          ),
          !x && le && /* @__PURE__ */ fe.jsx(_, { margin: "0 0 400", children: /* @__PURE__ */ fe.jsx(
            hu,
            {
              variant: "warning",
              description: /* @__PURE__ */ fe.jsxs(
                _,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ fe.jsx(q.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ fe.jsx(
                      Qn,
                      {
                        icon: Z ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Y(JSON.stringify(b, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ fe.jsx(
            H5,
            {
              createdIssue: m,
              issueBaseLink: G,
              issueLinkCopied: P,
              setIssueLinkCopied: N,
              copyToClipboard: Y
            }
          ) : /* @__PURE__ */ fe.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: Q($e),
              children: /* @__PURE__ */ fe.jsxs(Ir, { children: [
                /* @__PURE__ */ fe.jsx(ln, { span: 3, children: /* @__PURE__ */ fe.jsx(Vn, { label: "Project", required: !0, children: /* @__PURE__ */ fe.jsx(
                  Ut,
                  {
                    control: V,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: re, value: be } }) => /* @__PURE__ */ fe.jsx(
                      Fr,
                      {
                        searchable: !0,
                        loading: M,
                        onSelect: (Ne) => {
                          Ue(Ne.key), re(Ne);
                        },
                        selectedItems: [be],
                        placeholder: "Select Jira project",
                        emptyMessage: Ae ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ne, onSelect: Pe, checked: Ie }) => /* @__PURE__ */ fe.jsx(
                          vv,
                          {
                            item: Ne,
                            checked: Ie,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ fe.jsx(ln, { span: 3, children: /* @__PURE__ */ fe.jsx(Vn, { label: "Issue type", required: !0, children: /* @__PURE__ */ fe.jsx(
                  Ut,
                  {
                    control: V,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: re, value: be } }) => /* @__PURE__ */ fe.jsx(
                      Fr,
                      {
                        disabled: y.length === 0,
                        loading: Te,
                        onSelect: (Ne) => {
                          Be(Ne.id), re(Ne);
                        },
                        selectedItems: [be],
                        placeholder: y.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: ze ? "No issues found" : "No issues available",
                        items: y,
                        itemComponent: ({ item: Ne, onSelect: Pe, checked: Ie }) => /* @__PURE__ */ fe.jsx(
                          vv,
                          {
                            item: Ne,
                            checked: Ie,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                je && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ fe.jsx(ln, { className: Lb.modalBodyFormFields, children: /* @__PURE__ */ fe.jsx(
                  q5,
                  {
                    control: V,
                    errors: { ...ne, ...$ },
                    getValues: ve,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: b
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ fe.jsx(
          rr,
          {
            confirmOnClick: m ? xe : Q($e),
            confirmProps: {
              disabled: !je,
              isLoading: x,
              loadingIndicator: /* @__PURE__ */ fe.jsx(fn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : xe
          }
        )
      ]
    }
  );
}, Z5 = (e) => {
  if (!e) return "";
  const n = "https://", t = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${t}`;
}, eq = (e) => {
  if (!(e != null && e.trim()))
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const t = e.startsWith(n);
  if (t) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = t ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else {
    const i = "://";
    return e.includes(i) ? `The protocol \`${e.substring(
      0,
      e.indexOf(i) + i.length
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
  }
}, nq = "_wrapper_1bylq_1", tq = "_inputWrapper_1bylq_6", rq = "_inputSeparator_1bylq_18", iq = "_buttonLink_1bylq_23", aq = "_noIssuesFound_1bylq_27", so = {
  wrapper: nq,
  inputWrapper: tq,
  inputSeparator: rq,
  buttonLink: iq,
  noIssuesFound: aq
}, oq = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: t } = bn(), i = Z5(n == null ? void 0 : n.jiraSiteUrl), [a, o] = me(!1), s = !!(e != null && e.conversationId), {
    linkIssue: l,
    linkIssueQuietly: c,
    unlinkIssue: m,
    unlinkAllIssues: d,
    loadIssues: p,
    removeDanglingIssueLinks: v,
    danglingIssueLinks: y,
    isLoadingIssueLinks: S,
    isLoadingIssues: b,
    issues: j,
    error: x
  } = Z1(
    s ? e.conversationId : null,
    i
  ), h = !!(n != null && n.enableCreateIssue), P = !!(n != null && n.enableSortIssueTypeByLabel), N = !!(j != null && j.length || y != null && y.length), $ = !!(n != null && n.enableRemoveAllLinks) && N, O = !S && !b && (y == null ? void 0 : y.length) > 0 && !!(n != null && n.showDanglingLinks);
  return !b && x ? /* @__PURE__ */ fe.jsx(Fn, { error: x, retry: () => p() }) : /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
    /* @__PURE__ */ fe.jsxs(_, { className: so.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ fe.jsxs(_, { className: so.inputWrapper, flexDirection: "column", children: [
        h && /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
          /* @__PURE__ */ fe.jsx(
            Qn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ fe.jsx("div", { className: so.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ fe.jsx(
          R5,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      b ? /* @__PURE__ */ fe.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ fe.jsx(fn, { "data-testid": "jira-widget-issue-spinner" }) }) : j != null && j.length ? /* @__PURE__ */ fe.jsx(
        t5,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ fe.jsx(q.Paragraph, { align: "center", className: so.noIssuesFound, children: "No linked issues found" }),
      $ && (j == null ? void 0 : j.length) > 0 && /* @__PURE__ */ fe.jsx(
        Qn,
        {
          variant: "secondary",
          disabled: !(j != null && j.length) && !(y != null && y.length),
          onClick: d,
          children: "Unlink all issues"
        }
      ),
      O && /* @__PURE__ */ fe.jsxs(
        _,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ fe.jsx(q.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ fe.jsx(_, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: y.map((B) => /* @__PURE__ */ fe.jsx(Dn, { onDelete: () => m(B), children: B }, B)) }),
            /* @__PURE__ */ fe.jsx(
              Qn,
              {
                variant: "secondary",
                onClick: () => v(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ fe.jsx(
        Ct,
        {
          slotEnd: /* @__PURE__ */ fe.jsx(ye, { name: "external-link" }),
          variant: "tertiary",
          className: so.buttonLink,
          navigate: () => {
            var B;
            t("jira:view:jira:clicked", { jiraInstanceUrl: i }), (B = window.open(i, "_blank")) == null || B.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    /* @__PURE__ */ fe.jsx(
      X5,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: c,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: P
      }
    )
  ] });
}, Vb = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => eq(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vu
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ud = { exports: {} }, lo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zb;
function sq() {
  if (zb) return lo;
  zb = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return lo.Fragment = t, lo.jsx = s, lo.jsxs = s, lo;
}
var Ys = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mb;
function lq() {
  return Mb || (Mb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    Ys.Fragment = i, Ys.jsx = Mn, Ys.jsxs = Un;
  }()), Ys;
}
var Ub;
function uq() {
  return Ub || (Ub = 1, process.env.NODE_ENV === "production" ? ud.exports = sq() : ud.exports = lq()), ud.exports;
}
var Re = uq();
function cq({
  query: e,
  options: n,
  delayMs: t
}) {
  const { useLazyQuery: i } = pn(), [a, o] = me([]), [s] = i(e, n), [l, c] = me(
    []
  );
  return Ge(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const d = [];
    for (const [p, v] of m.entries()) {
      p !== 0 && await new Promise((S) => {
        const b = setTimeout(S, t);
        c([...l, b]);
      });
      const y = await s({
        variables: v
      });
      d.push(y);
    }
    o(d);
  }, a];
}
const dq = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, mq = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, fq = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, pq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, vq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, hq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, yq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, gq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, kq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, bq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "EnumValue", value: "subscriptions" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, _q = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_lists" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, xq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Sq = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": dq,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": mq,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": pq,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": vq,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": fq,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": hq,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": yq,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": gq,
  "\n  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": kq,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": bq,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_lists(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": _q,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_segments(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": xq
};
function li(e) {
  return Sq[e] ?? {};
}
const Nq = li(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), wq = li(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), jq = li(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Cq = li(
  /* GraphQL */
  `
  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Fq = li(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Iq = li(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_lists(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), $q = li(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_segments(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Eq = li(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Tq = li(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function hv(e) {
  var n, t;
  return ((t = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.event_properties) == null ? void 0 : t.$flow) !== void 0;
}
function Bb(e) {
  var n, t;
  return hv(e) && ((t = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.event_properties) == null ? void 0 : t.$message);
}
function Oq(e) {
  var n, t;
  return ((t = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.event_properties) == null ? void 0 : t["Bounce Type"]) !== void 0;
}
function qb(e) {
  var n;
  const t = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.timestamp;
  if (t)
    return t;
}
function Rq(e) {
  var n, t;
  return ((t = (n = e.Klaviyo) == null ? void 0 : n.get_metrics) == null ? void 0 : t.__typename) === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function Dq(e) {
  var n, t, i;
  return (i = ((t = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.receivedEmail) == null ? void 0 : t.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || []) == null ? void 0 : i.map((a) => ({
    ...a,
    eventType: "EMAIL"
  }));
}
function Pq(e) {
  var n, t, i;
  return (i = ((t = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.receivedSms) == null ? void 0 : t.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || []) == null ? void 0 : i.map((a) => ({
    ...a,
    eventType: "SMS"
  }));
}
function Aq(e) {
  var n, t, i;
  return (i = ((t = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.openedEmail) == null ? void 0 : t.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || []) == null ? void 0 : i.map((a) => ({
    ...a,
    eventType: "EMAIL"
  }));
}
function Lq(e) {
  var n, t, i;
  return (i = ((t = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.clickedEmail) == null ? void 0 : t.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || []) == null ? void 0 : i.map((a) => ({
    ...a,
    eventType: "EMAIL"
  }));
}
function Vq(e) {
  var n, t, i;
  return (i = ((t = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.bouncedEmail) == null ? void 0 : t.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || []) == null ? void 0 : i.map((a) => ({
    ...a,
    eventType: "EMAIL"
  }));
}
function Hb(e) {
  var n, t;
  return ((t = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.get_flow_message) == null ? void 0 : t.__typename) === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function zq(e) {
  var n, t;
  return ((t = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.content) == null ? void 0 : t.__typename) === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function Mq(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const Uq = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function Bq(e) {
  var n, t, i, a, o;
  return ((o = (a = (i = (t = (n = e == null ? void 0 : e.data) == null ? void 0 : n.attributes) == null ? void 0 : t.subscriptions) == null ? void 0 : i.email) == null ? void 0 : a.marketing) == null ? void 0 : o.consent) === "SUBSCRIBED";
}
function qq(e) {
  var n, t, i, a, o;
  return ((o = (a = (i = (t = (n = e == null ? void 0 : e.data) == null ? void 0 : n.attributes) == null ? void 0 : t.subscriptions) == null ? void 0 : i.sms) == null ? void 0 : a.marketing) == null ? void 0 : o.consent) === "SUBSCRIBED";
}
function Hq({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: t, useQuery: i } = pn(), { track: a } = bn(), [o, s] = me(null), [l, c] = me(
    null
  ), [m, d] = me(null), [p, v] = me(null), [y, S] = me(
    null
  ), [b, j] = me([]), {
    data: x,
    error: h,
    loading: P,
    networkStatus: N
  } = i(jq, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    $,
    {
      data: O,
      error: B,
      loading: Z,
      networkStatus: Y
    }
  ] = t(Nq, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Ge(() => {
    var ee, J, K, V, Q;
    if (x && !P && N === cr.ready) {
      const ne = Rq(x);
      s(
        ((ee = ne.find((ce) => {
          var ae;
          return ((ae = ce == null ? void 0 : ce.attributes) == null ? void 0 : ae.name) === "Received Email";
        })) == null ? void 0 : ee.id) || null
      ), c(
        ((J = ne.find((ce) => {
          var ae;
          return ((ae = ce == null ? void 0 : ce.attributes) == null ? void 0 : ae.name) === "Opened Email";
        })) == null ? void 0 : J.id) || null
      ), d(
        ((K = ne.find((ce) => {
          var ae;
          return ((ae = ce == null ? void 0 : ce.attributes) == null ? void 0 : ae.name) === "Clicked Email";
        })) == null ? void 0 : K.id) || null
      ), v(
        ((V = ne.find((ce) => {
          var ae;
          return ((ae = ce == null ? void 0 : ce.attributes) == null ? void 0 : ae.name) === "Bounced Email";
        })) == null ? void 0 : V.id) || null
      ), S(
        ((Q = ne.find((ce) => {
          var ae;
          return ((ae = ce == null ? void 0 : ce.attributes) == null ? void 0 : ae.name) === "Received SMS";
        })) == null ? void 0 : Q.id) || null
      );
    } else
      s(null), c(null), d(null), v(null), S(null);
  }, [x]), Ge(() => {
    o && l && m && p && y && !Z && Y === cr.ready ? $({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${p}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${y}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    m,
    p,
    y
  ]), Ge(() => {
    if (!Z && O) {
      const ee = Dq(O), J = Aq(
        O
      ).map(
        (ae) => {
          var ve;
          return (ve = ae == null ? void 0 : ae.attributes) == null ? void 0 : ve.event_properties.$message;
        }
      ), K = Lq(
        O
      ).map(
        (ae) => {
          var ve;
          return (ve = ae == null ? void 0 : ae.attributes) == null ? void 0 : ve.event_properties.$message;
        }
      );
      ee.forEach((ae) => {
        var ve;
        const je = (ve = ae.attributes) == null ? void 0 : ve.event_properties.$message;
        ae.opened = J.includes(je), ae.clicked = K.includes(je);
      });
      const V = Pq(O), Q = Vq(O), ne = [
        ...ee,
        ...Q,
        ...V
      ].sort((ae, ve) => {
        const je = qb(ae), G = qb(ve);
        return je == null && G == null ? 0 : je == null ? 1 : G == null ? -1 : G - je;
      }).slice(0, n);
      j(ne);
      const ce = ne.map((ae) => ae.id);
      a("klaviyo:messages:received", {
        emailsReceived: ee.filter(
          (ae) => ce.includes(ae.id)
        ).length,
        emailsBounced: Q.filter(
          (ae) => ce.includes(ae.id)
        ).length,
        smsReceived: V.filter(
          (ae) => ce.includes(ae.id)
        ).length,
        total: ce.length
      });
    } else
      j([]);
  }, [Z, O]), At(
    () => ({
      receivedMessages: b,
      isLoading: P || Z,
      error: h || B
    }),
    [
      b,
      P,
      Z,
      h,
      B
    ]
  );
}
function Kq({ profileId: e }) {
  const { useQuery: n } = pn(), [t, i] = me(), [a, o] = me(), {
    data: s,
    error: l,
    loading: c,
    refetch: m
  } = n(Fq, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Ge(() => {
    l && o(l);
  }, [l]), Ge(() => {
    !c && s && i(s.Klaviyo.get_profile);
  }, [c, s]);
  const d = async () => {
    const p = await m();
    p.error ? o(p.error) : p.data && i(
      p.data.Klaviyo.get_profile
    );
  };
  return At(
    () => ({
      profile: t,
      refetchProfile: d,
      isLoading: c,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, c, a]
  );
}
function Wq({
  email: e,
  phoneNumber: n
}) {
  const { track: t } = bn(), { useLazyQuery: i } = pn(), [a, o] = me(), [s, l] = me(), [
    c,
    { data: m, error: d, loading: p }
  ] = i(Cq, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Ge(() => {
    var y, S, b, j;
    if (!p && m) {
      const x = ((S = (y = m.Klaviyo) == null ? void 0 : y.profileByEmail) == null ? void 0 : S.__typename) === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, h = ((j = (b = m.Klaviyo) == null ? void 0 : b.profileByPhoneNumber) == null ? void 0 : j.__typename) === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      v(x, h);
    }
  }, [p, m]);
  const v = (y, S) => {
    var b, j, x, h;
    const P = ((b = y == null ? void 0 : y.data) == null ? void 0 : b.length) === 1 && ((j = y.data[0]) == null ? void 0 : j.id) || void 0, N = ((x = S == null ? void 0 : S.data) == null ? void 0 : x.length) === 1 && ((h = S.data[0]) == null ? void 0 : h.id) || void 0, $ = P || N, O = !P || !N || P === N;
    if ($ && O) {
      o(P || N), t("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), t("klaviyo:profile:received", { hasProfile: !1 }), O || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${P}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return At(
    () => ({
      profileId: a,
      getProfileId: c,
      isLoading: p,
      error: d || s
    }),
    [a, c, p, d, s]
  );
}
const Kb = 800, Gq = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, Yq = 3, Jq = 1.5, Qq = ({
  query: e,
  delay: n,
  delayRange: t,
  maxCount: i = Yq,
  useDelayRange: a = !1
}) => {
  const o = (B) => Math.floor(Math.random() * (B.max - B.min) + B.min), [s, l] = me(0), [c, m] = me(n || Kb), [d, p] = me(t || Gq), [v, y] = me(!1), [S, b] = me(!1), j = a || !!t, x = j ? o(d) : n || Kb, [h, P] = me(x);
  i4(
    async () => {
      const B = s + 1, Z = Jq ** B;
      l(B), P(
        (j ? o(d) : c) * Z
      ), await e().then(() => {
        b(!0), O();
      });
    },
    v ? h : null
  ), o4(() => O());
  const N = ut(() => {
    l(0), P(x);
  }, [x]), $ = ut(
    (B = {}) => {
      const { delay: Z, delayRange: Y } = B;
      b(!1), N(), Y && (p(Y), P(o(Y))), Z && (m(Z), P(Z)), y(!0);
    },
    [N]
  ), O = ut(() => {
    y(!1), N();
  }, [N]);
  return Ge(() => {
    s >= i && O();
  }, [s, i, O]), At(
    () => ({ isRunning: v, isSuccessful: S, start: $, stop: O }),
    [v, S, $, O]
  );
}, Xq = (e) => {
  var n, t, i;
  const a = (i = (t = (n = e.graphQLErrors[0]) == null ? void 0 : n.extensions.integration) == null ? void 0 : t.responseHeaders) == null ? void 0 : i["retry-after"];
  return a ? parseInt(a, 10) : void 0;
}, Zq = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function e6({
  profileId: e,
  query: n
}) {
  const { useQuery: t } = pn(), [i, a] = me(), [o, s] = me(), {
    data: l,
    error: c,
    loading: m,
    refetch: d,
    networkStatus: p
  } = t(
    n === "lists" ? Iq : $q,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: v,
    start: y,
    stop: S
  } = Qq({
    query: d,
    useDelayRange: !0
  }), b = m || v;
  return Ge(() => {
    if (c)
      if (nI({
        errors: c.graphQLErrors
      })) {
        if (!v) {
          const j = Xq(c);
          y({
            ...j && {
              delayRange: Zq(j)
            }
          });
        }
      } else
        s(c);
  }, [c]), Ge(() => {
    var j, x, h;
    if (!m && l != null && l.Klaviyo) {
      let P = {}, N = {};
      n === "lists" && (P = (j = l == null ? void 0 : l.Klaviyo) == null ? void 0 : j.get_profile_lists), n === "segments" && (N = (x = l == null ? void 0 : l.Klaviyo) == null ? void 0 : x.get_profile_segments), (P != null && P.data || N != null && N.data) && (S(), a(
        (h = n === "lists" ? P == null ? void 0 : P.data : N == null ? void 0 : N.data) == null ? void 0 : h.map(($) => ({
          ...$,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), At(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: y,
      isLoading: b,
      error: o,
      networkStatus: p
    }),
    [i, b, o, p, y]
  );
}
const n6 = "_notificationText_1polx_1", Uh = {
  notificationText: n6
}, qu = ({ error: e }) => {
  const { track: n } = bn();
  let t = e;
  if (XN(e)) {
    const { graphQLErrors: i } = e, a = i.length === 1 && ZF({ error: i[0] }), o = i.length === 1 && eI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), t = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), t = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Re.jsx(Fn, { error: e });
  }
  return /* @__PURE__ */ Re.jsx(_, { margin: "0 0 300", children: /* @__PURE__ */ Re.jsx(
    Je.Item,
    {
      contentLeft: /* @__PURE__ */ Re.jsx(ye, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: t.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, t6 = "_message_1vrar_48", r6 = "_messageIsOpen_1vrar_56", i6 = "_messageHeader_1vrar_59", a6 = "_messageLabel_1vrar_65", o6 = "_messageText_1vrar_68", ga = {
  message: t6,
  messageIsOpen: r6,
  messageHeader: i6,
  messageLabel: a6,
  messageText: o6
}, s6 = ({ event: e, isLoadingPreview: n }) => {
  var t;
  const i = (t = e == null ? void 0 : e.attributes) == null ? void 0 : t.event_properties, a = e.flowMessage && zq(e.flowMessage);
  return /* @__PURE__ */ Re.jsxs(Re.Fragment, { children: [
    /* @__PURE__ */ Re.jsxs(_, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Re.jsx(q.Paragraph, { variant: "4", className: ga.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Re.jsx(q.Paragraph, { children: i["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Re.jsx(_, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Re.jsx(fn, { size: 22 }) }) : a && a.length > 0 && /* @__PURE__ */ Re.jsxs(
      _,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Re.jsx(_, { children: /* @__PURE__ */ Re.jsx(
            q.Paragraph,
            {
              variant: "4",
              className: ga.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Re.jsx(q.Paragraph, { variant: "4", className: ga.messageText, children: a })
        ]
      }
    )
  ] });
}, l6 = ({ event: e }) => {
  var n, t;
  const i = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.event_properties;
  return /* @__PURE__ */ Re.jsx(Re.Fragment, { children: /* @__PURE__ */ Re.jsxs(_, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Re.jsx(_, { children: /* @__PURE__ */ Re.jsx(q.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Re.jsx(_, { children: (t = i == null ? void 0 : i.extra) == null ? void 0 : t["Message Body"] })
  ] }) });
}, u6 = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: t
}) => {
  const [i, a] = me(t), { attributes: o, eventType: s } = e, l = o == null ? void 0 : o.datetime, c = o == null ? void 0 : o.timestamp, m = "DD MMM YYYY @ HH:mm", d = At(
    () => () => l ? An(l).format(m) : c ? An.unix(c).format(m) : null,
    [c, l]
  )(), p = s === "EMAIL", v = s === "SMS", y = p && e.opened, S = p && e.clicked, b = p && (o == null ? void 0 : o.event_properties.Subject), j = v && (o == null ? void 0 : o.event_properties["Message Name"]), x = p ? "mail" : "sms";
  return /* @__PURE__ */ Re.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      className: ct(ga.message, {
        [ga.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Re.jsxs(
          _,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: ga.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Re.jsxs(_, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Re.jsxs(_, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Re.jsx(ye, { size: 16, name: x }),
                  " ",
                  Uq(s),
                  d && /* @__PURE__ */ Re.jsx(Jn, { size: "small", variant: "info", children: d })
                ] }),
                b && b,
                j && j
              ] }),
              /* @__PURE__ */ Re.jsx(
                qr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Re.jsxs(_, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Re.jsx(zv, {}),
          Oq(e) && /* @__PURE__ */ Re.jsx(_, { children: /* @__PURE__ */ Re.jsx(Jn, { size: "medium", variant: "error", children: "Bounced" }) }),
          p && /* @__PURE__ */ Re.jsxs(Re.Fragment, { children: [
            /* @__PURE__ */ Re.jsxs(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Re.jsx(Dn, { children: /* @__PURE__ */ Re.jsxs(_, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Re.jsx(
                  ye,
                  {
                    size: 16,
                    color: y ? "green.400" : "red.400",
                    name: y ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Re.jsx(Dn, { children: /* @__PURE__ */ Re.jsxs(_, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Re.jsx(
                  ye,
                  {
                    size: 16,
                    color: S ? "green.400" : "red.400",
                    name: S ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Re.jsx(s6, { event: e, isLoadingPreview: n })
          ] }),
          v && /* @__PURE__ */ Re.jsx(l6, { event: e })
        ] })
      ]
    }
  );
}, c6 = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, d6 = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [t, i] = me(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = Hq({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, c] = cq({
    query: wq,
    options: c6,
    delayMs: 1e3
  }), [m, d] = me([]);
  Ge(() => {
    if (a.length > 0) {
      d(a);
      const v = a.filter((y) => hv(y)).map((y) => Bb(y));
      v.length > 0 && (i(!0), l(
        v.map((y) => ({
          messageId: y
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Ge(() => {
    c.length > 0 && d(
      a == null ? void 0 : a.map((v) => {
        if (v.eventType === "EMAIL" && hv(v) && !v.flowMessage) {
          const y = Bb(v), S = c.find((j) => {
            const x = j.data && Hb(j.data);
            return (x == null ? void 0 : x.id) === y;
          }), b = (S == null ? void 0 : S.data) && Hb(S.data);
          if (b)
            return {
              ...Mq(v),
              flowMessage: b
            };
        }
        return v;
      })
    );
  }, [c]);
  const p = [];
  return s && p.push(s), c.length > 0 && p.push(
    ...c.map((v) => v.error).filter((v) => v)
  ), p && p.length > 0 ? /* @__PURE__ */ Re.jsx(Re.Fragment, { children: p.map((v, y) => v.graphQLErrors ? /* @__PURE__ */ Re.jsx(
    Fn,
    {
      error: v
    },
    `lastMessagesError${y}`
  ) : /* @__PURE__ */ Re.jsx(
    qu,
    {
      error: v
    },
    `lastMessagesError${y}`
  )) }) : /* @__PURE__ */ Re.jsxs(Re.Fragment, { children: [
    /* @__PURE__ */ Re.jsx(q.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Re.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Re.jsx(fn, {}) }) : /* @__PURE__ */ Re.jsx(Re.Fragment, { children: (m == null ? void 0 : m.length) > 0 ? /* @__PURE__ */ Re.jsx(_, { gap: "200", flexDirection: "column", children: m.map((v, y) => /* @__PURE__ */ Re.jsx(
      u6,
      {
        event: v,
        isLoadingPreview: t,
        openByDefault: y === 0
      },
      v.id
    )) }) : /* @__PURE__ */ Re.jsx(
      _,
      {
        justifyContent: "center",
        margin: "200",
        className: Uh.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, m6 = "_list_ld0hf_1", f6 = "_listItem_ld0hf_4", Ro = {
  list: m6,
  listItem: f6
}, Wb = ({
  profileId: e,
  type: n
}) => {
  const [t, i] = me(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: c
  } = e6({ profileId: e, query: n });
  Ge(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || c();
  }, d = a || [];
  return o ? /* @__PURE__ */ Re.jsx(qu, { error: o }) : s ? /* @__PURE__ */ Re.jsx(Je.Text, { variant: "dense", className: Ro.listItem, children: /* @__PURE__ */ Re.jsx(fn, { size: 14 }) }, "loading") : d.length > 0 ? /* @__PURE__ */ Re.jsx(Re.Fragment, { children: d.map(
    ({ attributes: p, type: v }, y) => /* @__PURE__ */ Re.jsx(Je.Text, { variant: "dense", className: Ro.listItem, children: /* @__PURE__ */ Re.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(q.Paragraph, { variant: "4", children: p == null ? void 0 : p.name }),
      !!v && /* @__PURE__ */ Re.jsx(Dn, { children: Vv(v) })
    ] }) }, y)
  ) }) : t && !a ? /* @__PURE__ */ Re.jsx(Je.Text, { variant: "dense", className: Ro.listItem, children: /* @__PURE__ */ Re.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Re.jsxs(_, { gap: "200", children: [
      /* @__PURE__ */ Re.jsx(ye, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Re.jsxs(q.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Re.jsx(nn, { content: "Refresh lists and segments", children: /* @__PURE__ */ Re.jsx(Qn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Re.jsx(Je.Text, { variant: "dense", className: Ro.listItem, children: /* @__PURE__ */ Re.jsx(_, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Re.jsx(q.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Re.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, p6 = "_tagHover_kzbzk_1", v6 = "_channelUnsubscribed_kzbzk_6", Gb = {
  tagHover: p6,
  channelUnsubscribed: v6
}, Yb = ({
  isSubscribed: e,
  isLoading: n,
  channelName: t,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Re.jsx(
    nn,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Re.jsx(
        Dn,
        {
          className: Gb.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Re.jsxs(
            _,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ct({
                [Gb.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Re.jsx(fn, { size: 16 }) : /* @__PURE__ */ Re.jsx(ye, { size: 16, name: i }),
                t
              ]
            }
          )
        }
      )
    }
  );
}, h6 = "_subscriptionError_1qhhx_1", y6 = {
  subscriptionError: h6
}, g6 = ({
  subscriptionListId: e,
  profile: n,
  email: t,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  var s, l, c, m, d, p, v, y, S, b;
  const [j, x] = me(!1), [h, P] = me(!1), [N, $] = me(), { track: O } = bn(), [B, Z] = a4({
    channel: null,
    request: null
  }), Y = Bq(n), ee = qq(n), J = !!e, { useMutation: K } = pn(), [V] = K(
    Eq
  ), [Q] = K(
    Tq
  ), ne = (ve) => {
    O("klaviyo:profile:subscribe:clicked", { channel: ve }), Z.setAll({
      channel: ve,
      request: "subscribed"
    }), ((je) => V({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: "profile",
                id: a,
                attributes: {
                  email: t,
                  // eslint-disable-next-line camelcase
                  phone_number: i,
                  subscriptions: {
                    ...je === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    },
                    ...je === "SMS" && {
                      sms: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: e
            }
          }
        }
      }
    }))(ve).then(
      (je) => ae({
        channel: ve,
        mutationResponse: je,
        isSubscriptionRequest: !0
      })
    ).catch(
      (je) => ae({
        channel: ve,
        mutationErrorResponse: je,
        isSubscriptionRequest: !0
      })
    );
  }, ce = (ve) => {
    O("klaviyo:profile:unsubscribe:clicked", { channel: ve }), Z.setAll({
      channel: ve,
      request: "unsubscribed"
    }), Q({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: "profile",
                attributes: {
                  ...ve === "EMAIL" ? { email: t } : {},
                  // eslint-disable-next-line camelcase
                  ...ve === "SMS" ? { phone_number: i } : {}
                }
              }
            ]
          }
        }
      }
    }).then(
      (je) => ae({
        channel: ve,
        mutationResponse: je,
        isSubscriptionRequest: !1
      })
    ).catch(
      (je) => ae({
        channel: ve,
        mutationErrorResponse: je,
        isSubscriptionRequest: !1
      })
    );
  }, ae = async ({
    channel: ve,
    mutationResponse: je,
    mutationErrorResponse: G,
    isSubscriptionRequest: le
  }) => {
    const he = G == null ? void 0 : G.networkError, M = he ? he == null ? void 0 : he.statusCode : NaN, Ae = je == null ? void 0 : je.errors, Ve = !!Ae && KN({
      errors: Ae
    });
    M === 202 ? (O(
      le ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: ve }
    ), await o()) : Ve ? (O(
      le ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: ve,
        reason: "Insufficient permissions"
      }
    ), $(
      `Request failed with a permission error. Could not ${le ? "opt-in" : "opt-out"}.`
    )) : (O(
      le ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: ve,
        reason: (he == null ? void 0 : he.message) || "Unexpected error"
      }
    ), $(
      `Request failed. Could not ${le ? "opt-in" : "opt-out"}.`
    )), P(!1), x(!1);
  };
  return Ge(() => {
    var ve, je, G, le, he, M, Ae, Ve, Te, ze;
    if (B.request === "subscribed") {
      const ge = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${B.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      B.channel === "EMAIL" && !j && ((he = (le = (G = (je = (ve = n == null ? void 0 : n.data) == null ? void 0 : ve.attributes) == null ? void 0 : je.subscriptions) == null ? void 0 : G.email) == null ? void 0 : le.marketing) == null ? void 0 : he.consent) !== "SUBSCRIBED" && ($(ge), Z.reset()), B.channel === "SMS" && !h && ((ze = (Te = (Ve = (Ae = (M = n == null ? void 0 : n.data) == null ? void 0 : M.attributes) == null ? void 0 : Ae.subscriptions) == null ? void 0 : Ve.sms) == null ? void 0 : Te.marketing) == null ? void 0 : ze.consent) !== "SUBSCRIBED" && ($(ge), Z.reset());
    }
  }, [
    (d = (m = (c = (l = (s = n == null ? void 0 : n.data) == null ? void 0 : s.attributes) == null ? void 0 : l.subscriptions) == null ? void 0 : c.email) == null ? void 0 : m.marketing) == null ? void 0 : d.consent,
    (b = (S = (y = (v = (p = n == null ? void 0 : n.data) == null ? void 0 : p.attributes) == null ? void 0 : v.subscriptions) == null ? void 0 : y.sms) == null ? void 0 : S.marketing) == null ? void 0 : b.consent,
    j,
    h
  ]), /* @__PURE__ */ Re.jsx(
    _,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Re.jsxs(_, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Re.jsx(q.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Re.jsxs(_, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Re.jsx(
            Yb,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: j,
              isSubscribed: Y,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: J,
              handleAction: () => {
                x(!0), $(void 0), Y ? ce("EMAIL") : ne("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Re.jsx(
            Yb,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: h,
              isSubscribed: ee,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: J,
              handleAction: () => {
                P(!0), $(void 0), ee ? ce("SMS") : ne("SMS");
              }
            }
          )
        ] }),
        N && /* @__PURE__ */ Re.jsx(_, { className: y6.subscriptionError, children: N })
      ] })
    }
  );
}, k6 = ({
  profileId: e,
  email: n,
  phoneNumber: t,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  noOfMessagesToShow: s,
  subscriptionListId: l
}) => {
  const {
    profile: c,
    error: m,
    isLoading: d,
    refetchProfile: p
  } = Kq({ profileId: e });
  return m ? /* @__PURE__ */ Re.jsx(qu, { error: m }) : d ? /* @__PURE__ */ Re.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Re.jsx(fn, {}) }) : !c && !d ? /* @__PURE__ */ Re.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200",
      className: Uh.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Re.jsxs(_, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Re.jsxs(_, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Re.jsx(q.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Re.jsxs(Je, { className: Ro.list, children: [
        i && /* @__PURE__ */ Re.jsx(Wb, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Re.jsx(
          Wb,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    c && e && o && /* @__PURE__ */ Re.jsx(
      g6,
      {
        profile: c,
        profileId: e,
        subscriptionListId: l,
        refetchProfile: p,
        email: n,
        phoneNumber: t
      }
    ),
    /* @__PURE__ */ Re.jsx(
      d6,
      {
        profileId: e,
        noOfMessagesToShow: s
      }
    )
  ] });
}, b6 = ({
  conversationContext: e,
  settings: n
}) => {
  var t, i;
  const a = ((t = e.customer) == null ? void 0 : t.email) || void 0, o = ((i = e.customer) == null ? void 0 : i.phone_number) || void 0, s = n == null ? void 0 : n.showProfileLists, l = n == null ? void 0 : n.showProfileSegments, c = n == null ? void 0 : n.showSubscriptions, m = Number(n == null ? void 0 : n.noOfMessagesToShow), d = n == null ? void 0 : n.subscriptionListId, {
    profileId: p,
    getProfileId: v,
    isLoading: y,
    error: S
  } = Wq({ email: a, phoneNumber: o });
  return rI(() => {
    (a || o) && v({
      variables: {
        emailFilter: `equals(email,"${a}")`,
        phoneNumberFilter: `equals(phone_number,"${o}")`
      }
    });
  }, [a, o]), !a && !o ? /* @__PURE__ */ Re.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : y ? /* @__PURE__ */ Re.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Re.jsx(fn, {}) }) : S ? /* @__PURE__ */ Re.jsx(qu, { error: S }) : p ? /* @__PURE__ */ Re.jsx(
    k6,
    {
      profileId: p,
      email: a,
      phoneNumber: o,
      showProfileLists: s,
      showProfileSegments: l,
      showSubscriptions: c,
      noOfMessagesToShow: m,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ Re.jsx(
    _,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Uh.notificationText,
      children: "No profile ID found"
    }
  );
}, _6 = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: XF
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
];
function x6(e, n) {
  const t = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const S6 = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, N6 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, w6 = {};
function Jb(e, n) {
  return (w6.jsx ? N6 : S6).test(e);
}
const j6 = /[ \t\n\f\r]/g;
function C6(e) {
  return typeof e == "object" ? e.type === "text" ? Qb(e.value) : !1 : Qb(e);
}
function Qb(e) {
  return e.replace(j6, "") === "";
}
class bs {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, t, i) {
    this.property = n, this.normal = t, i && (this.space = i);
  }
}
bs.prototype.property = {};
bs.prototype.normal = {};
bs.prototype.space = null;
function eC(e, n) {
  const t = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(t, e[a].property), Object.assign(i, e[a].normal);
  return new bs(t, i, n);
}
function yv(e) {
  return e.toLowerCase();
}
class vr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, t) {
    this.property = n, this.attribute = t;
  }
}
vr.prototype.space = null;
vr.prototype.boolean = !1;
vr.prototype.booleanish = !1;
vr.prototype.overloadedBoolean = !1;
vr.prototype.number = !1;
vr.prototype.commaSeparated = !1;
vr.prototype.spaceSeparated = !1;
vr.prototype.commaOrSpaceSeparated = !1;
vr.prototype.mustUseProperty = !1;
vr.prototype.defined = !1;
let F6 = 0;
const gn = Ki(), lt = Ki(), nC = Ki(), Me = Ki(), Gn = Ki(), ka = Ki(), Jt = Ki();
function Ki() {
  return 2 ** ++F6;
}
const gv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: gn,
  booleanish: lt,
  commaOrSpaceSeparated: Jt,
  commaSeparated: ka,
  number: Me,
  overloadedBoolean: nC,
  spaceSeparated: Gn
}, Symbol.toStringTag, { value: "Module" })), cd = Object.keys(gv);
class Bh extends vr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, t, i, a) {
    let o = -1;
    if (super(n, t), Xb(this, "space", a), typeof i == "number")
      for (; ++o < cd.length; ) {
        const s = cd[o];
        Xb(this, cd[o], (i & gv[s]) === gv[s]);
      }
  }
}
Bh.prototype.defined = !0;
function Xb(e, n, t) {
  t && (e[n] = t);
}
const I6 = {}.hasOwnProperty;
function Ma(e) {
  const n = {}, t = {};
  let i;
  for (i in e.properties)
    if (I6.call(e.properties, i)) {
      const a = e.properties[i], o = new Bh(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, t[yv(i)] = i, t[yv(o.attribute)] = i;
    }
  return new bs(n, t, e.space);
}
const tC = Ma({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), rC = Ma({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function iC(e, n) {
  return n in e ? e[n] : n;
}
function aC(e, n) {
  return iC(e, n.toLowerCase());
}
const oC = Ma({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: aC,
  properties: { xmlns: null, xmlnsXLink: null }
}), sC = Ma({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: lt,
    ariaAutoComplete: null,
    ariaBusy: lt,
    ariaChecked: lt,
    ariaColCount: Me,
    ariaColIndex: Me,
    ariaColSpan: Me,
    ariaControls: Gn,
    ariaCurrent: null,
    ariaDescribedBy: Gn,
    ariaDetails: null,
    ariaDisabled: lt,
    ariaDropEffect: Gn,
    ariaErrorMessage: null,
    ariaExpanded: lt,
    ariaFlowTo: Gn,
    ariaGrabbed: lt,
    ariaHasPopup: null,
    ariaHidden: lt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Gn,
    ariaLevel: Me,
    ariaLive: null,
    ariaModal: lt,
    ariaMultiLine: lt,
    ariaMultiSelectable: lt,
    ariaOrientation: null,
    ariaOwns: Gn,
    ariaPlaceholder: null,
    ariaPosInSet: Me,
    ariaPressed: lt,
    ariaReadOnly: lt,
    ariaRelevant: null,
    ariaRequired: lt,
    ariaRoleDescription: Gn,
    ariaRowCount: Me,
    ariaRowIndex: Me,
    ariaRowSpan: Me,
    ariaSelected: lt,
    ariaSetSize: Me,
    ariaSort: null,
    ariaValueMax: Me,
    ariaValueMin: Me,
    ariaValueNow: Me,
    ariaValueText: null,
    role: null
  }
}), $6 = Ma({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: aC,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ka,
    acceptCharset: Gn,
    accessKey: Gn,
    action: null,
    allow: null,
    allowFullScreen: gn,
    allowPaymentRequest: gn,
    allowUserMedia: gn,
    alt: null,
    as: null,
    async: gn,
    autoCapitalize: null,
    autoComplete: Gn,
    autoFocus: gn,
    autoPlay: gn,
    blocking: Gn,
    capture: null,
    charSet: null,
    checked: gn,
    cite: null,
    className: Gn,
    cols: Me,
    colSpan: null,
    content: null,
    contentEditable: lt,
    controls: gn,
    controlsList: Gn,
    coords: Me | ka,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: gn,
    defer: gn,
    dir: null,
    dirName: null,
    disabled: gn,
    download: nC,
    draggable: lt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: gn,
    formTarget: null,
    headers: Gn,
    height: Me,
    hidden: gn,
    high: Me,
    href: null,
    hrefLang: null,
    htmlFor: Gn,
    httpEquiv: Gn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: gn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: gn,
    itemId: null,
    itemProp: Gn,
    itemRef: Gn,
    itemScope: gn,
    itemType: Gn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: gn,
    low: Me,
    manifest: null,
    max: null,
    maxLength: Me,
    media: null,
    method: null,
    min: null,
    minLength: Me,
    multiple: gn,
    muted: gn,
    name: null,
    nonce: null,
    noModule: gn,
    noValidate: gn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: gn,
    optimum: Me,
    pattern: null,
    ping: Gn,
    placeholder: null,
    playsInline: gn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: gn,
    referrerPolicy: null,
    rel: Gn,
    required: gn,
    reversed: gn,
    rows: Me,
    rowSpan: Me,
    sandbox: Gn,
    scope: null,
    scoped: gn,
    seamless: gn,
    selected: gn,
    shadowRootClonable: gn,
    shadowRootDelegatesFocus: gn,
    shadowRootMode: null,
    shape: null,
    size: Me,
    sizes: null,
    slot: null,
    span: Me,
    spellCheck: lt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Me,
    step: null,
    style: null,
    tabIndex: Me,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: gn,
    useMap: null,
    value: lt,
    width: Me,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Gn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Me,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Me,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: gn,
    // Lists. Use CSS to reduce space between items instead
    declare: gn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Me,
    // `<img>` and `<object>`
    leftMargin: Me,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Me,
    // `<body>`
    marginWidth: Me,
    // `<body>`
    noResize: gn,
    // `<frame>`
    noHref: gn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: gn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: gn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Me,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: lt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Me,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Me,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: gn,
    disableRemotePlayback: gn,
    prefix: null,
    property: null,
    results: Me,
    security: null,
    unselectable: null
  }
}), E6 = Ma({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: iC,
  properties: {
    about: Jt,
    accentHeight: Me,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Me,
    amplitude: Me,
    arabicForm: null,
    ascent: Me,
    attributeName: null,
    attributeType: null,
    azimuth: Me,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Me,
    by: null,
    calcMode: null,
    capHeight: Me,
    className: Gn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Me,
    diffuseConstant: Me,
    direction: null,
    display: null,
    dur: null,
    divisor: Me,
    dominantBaseline: null,
    download: gn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Me,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Me,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Me,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ka,
    g2: ka,
    glyphName: ka,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Me,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Me,
    horizOriginX: Me,
    horizOriginY: Me,
    id: null,
    ideographic: Me,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Me,
    k: Me,
    k1: Me,
    k2: Me,
    k3: Me,
    k4: Me,
    kernelMatrix: Jt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Me,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Me,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Me,
    overlineThickness: Me,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Me,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Gn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Me,
    pointsAtY: Me,
    pointsAtZ: Me,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Jt,
    rev: Jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Jt,
    requiredFeatures: Jt,
    requiredFonts: Jt,
    requiredFormats: Jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Me,
    specularExponent: Me,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Me,
    strikethroughThickness: Me,
    string: null,
    stroke: null,
    strokeDashArray: Jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Me,
    strokeOpacity: Me,
    strokeWidth: null,
    style: null,
    surfaceScale: Me,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Jt,
    tabIndex: Me,
    tableValues: null,
    target: null,
    targetX: Me,
    targetY: Me,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Jt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Me,
    underlineThickness: Me,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Me,
    values: null,
    vAlphabetic: Me,
    vMathematical: Me,
    vectorEffect: null,
    vHanging: Me,
    vIdeographic: Me,
    version: null,
    vertAdvY: Me,
    vertOriginX: Me,
    vertOriginY: Me,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Me,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), T6 = /^data[-\w.:]+$/i, Zb = /-[a-z]/g, O6 = /[A-Z]/g;
function R6(e, n) {
  const t = yv(n);
  let i = n, a = vr;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && T6.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(Zb, P6);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!Zb.test(o)) {
        let s = o.replace(O6, D6);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Bh;
  }
  return new a(i, n);
}
function D6(e) {
  return "-" + e.toLowerCase();
}
function P6(e) {
  return e.charAt(1).toUpperCase();
}
const A6 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, L6 = eC([rC, tC, oC, sC, $6], "html"), qh = eC([rC, tC, oC, sC, E6], "svg");
function V6(e) {
  return e.join(" ").trim();
}
var ra = {}, dd, e_;
function z6() {
  if (e_) return dd;
  e_ = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, t = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, c = `
`, m = "/", d = "*", p = "", v = "comment", y = "declaration";
  dd = function(b, j) {
    if (typeof b != "string")
      throw new TypeError("First argument must be a string");
    if (!b) return [];
    j = j || {};
    var x = 1, h = 1;
    function P(V) {
      var Q = V.match(n);
      Q && (x += Q.length);
      var ne = V.lastIndexOf(c);
      h = ~ne ? V.length - ne : h + V.length;
    }
    function N() {
      var V = { line: x, column: h };
      return function(Q) {
        return Q.position = new $(V), Z(), Q;
      };
    }
    function $(V) {
      this.start = V, this.end = { line: x, column: h }, this.source = j.source;
    }
    $.prototype.content = b;
    function O(V) {
      var Q = new Error(
        j.source + ":" + x + ":" + h + ": " + V
      );
      if (Q.reason = V, Q.filename = j.source, Q.line = x, Q.column = h, Q.source = b, !j.silent) throw Q;
    }
    function B(V) {
      var Q = V.exec(b);
      if (Q) {
        var ne = Q[0];
        return P(ne), b = b.slice(ne.length), Q;
      }
    }
    function Z() {
      B(t);
    }
    function Y(V) {
      var Q;
      for (V = V || []; Q = ee(); )
        Q !== !1 && V.push(Q);
      return V;
    }
    function ee() {
      var V = N();
      if (!(m != b.charAt(0) || d != b.charAt(1))) {
        for (var Q = 2; p != b.charAt(Q) && (d != b.charAt(Q) || m != b.charAt(Q + 1)); )
          ++Q;
        if (Q += 2, p === b.charAt(Q - 1))
          return O("End of comment missing");
        var ne = b.slice(2, Q - 2);
        return h += 2, P(ne), b = b.slice(Q), h += 2, V({
          type: v,
          comment: ne
        });
      }
    }
    function J() {
      var V = N(), Q = B(i);
      if (Q) {
        if (ee(), !B(a)) return O("property missing ':'");
        var ne = B(o), ce = V({
          type: y,
          property: S(Q[0].replace(e, p)),
          value: ne ? S(ne[0].replace(e, p)) : p
        });
        return B(s), ce;
      }
    }
    function K() {
      var V = [];
      Y(V);
      for (var Q; Q = J(); )
        Q !== !1 && (V.push(Q), Y(V));
      return V;
    }
    return Z(), K();
  };
  function S(b) {
    return b ? b.replace(l, p) : p;
  }
  return dd;
}
var n_;
function M6() {
  if (n_) return ra;
  n_ = 1;
  var e = ra && ra.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(ra, "__esModule", { value: !0 }), ra.default = t;
  var n = e(z6());
  function t(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(c) {
      if (c.type === "declaration") {
        var m = c.property, d = c.value;
        l ? a(m, d, c) : d && (o = o || {}, o[m] = d);
      }
    }), o;
  }
  return ra;
}
var U6 = M6();
const t_ = /* @__PURE__ */ Uv(U6), B6 = t_.default || t_, lC = uC("end"), Hh = uC("start");
function uC(e) {
  return n;
  function n(t) {
    const i = t && t.position && t.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function q6(e) {
  const n = Hh(e), t = lC(e);
  if (n && t)
    return { start: n, end: t };
}
function H6(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? r_(e.position) : "start" in e || "end" in e ? r_(e) : "line" in e || "column" in e ? kv(e) : "";
}
function kv(e) {
  return i_(e && e.line) + ":" + i_(e && e.column);
}
function r_(e) {
  return kv(e && e.start) + "-" + kv(e && e.end);
}
function i_(e) {
  return e && typeof e == "number" ? e : 1;
}
class Ft extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, i) {
    super(), typeof t == "string" && (i = t, t = void 0);
    let a = "", o = {}, s = !1;
    if (t && ("line" in t && "column" in t ? o = { place: t } : "start" in t && "end" in t ? o = { place: t } : "type" in t ? o = {
      ancestors: [t],
      place: t.position
    } : o = { ...t }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const c = i.indexOf(":");
      c === -1 ? o.ruleId = i : (o.source = i.slice(0, c), o.ruleId = i.slice(c + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const c = o.ancestors[o.ancestors.length - 1];
      c && (o.place = c.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = H6(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Ft.prototype.file = "";
Ft.prototype.name = "";
Ft.prototype.reason = "";
Ft.prototype.message = "";
Ft.prototype.stack = "";
Ft.prototype.column = void 0;
Ft.prototype.line = void 0;
Ft.prototype.ancestors = void 0;
Ft.prototype.cause = void 0;
Ft.prototype.fatal = void 0;
Ft.prototype.place = void 0;
Ft.prototype.ruleId = void 0;
Ft.prototype.source = void 0;
const Kh = {}.hasOwnProperty, K6 = /* @__PURE__ */ new Map(), W6 = /[A-Z]/g, G6 = /-([a-z])/g, Y6 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), J6 = /* @__PURE__ */ new Set(["td", "th"]), cC = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function Q6(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = aH(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = iH(t, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? qh : L6,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = dC(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function dC(e, n, t) {
  if (n.type === "element")
    return X6(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return Z6(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return nH(e, n, t);
  if (n.type === "mdxjsEsm")
    return eH(e, n);
  if (n.type === "root")
    return tH(e, n, t);
  if (n.type === "text")
    return rH(e, n);
}
function X6(e, n, t) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = qh, e.schema = a), e.ancestors.push(n);
  const o = fC(e, n.tagName, !1), s = oH(e, n);
  let l = Gh(e, n);
  return Y6.has(n.tagName) && (l = l.filter(function(c) {
    return typeof c == "string" ? !C6(c) : !0;
  })), mC(e, s, o, n), Wh(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, t);
}
function Z6(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Xo(e, n.position);
}
function eH(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Xo(e, n.position);
}
function nH(e, n, t) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = qh, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : fC(e, n.name, !0), s = sH(e, n), l = Gh(e, n);
  return mC(e, s, o, n), Wh(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, t);
}
function tH(e, n, t) {
  const i = {};
  return Wh(i, Gh(e, n)), e.create(n, e.Fragment, i, t);
}
function rH(e, n) {
  return n.value;
}
function mC(e, n, t, i) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = i);
}
function Wh(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function iH(e, n, t) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? t : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function aH(e, n) {
  return t;
  function t(i, a, o, s) {
    const l = Array.isArray(o.children), c = Hh(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function oH(e, n) {
  const t = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Kh.call(n.properties, a)) {
      const o = lH(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && J6.has(n.tagName) ? i = l : t[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return t;
}
function sH(e, n) {
  const t = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Xo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Xo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      t[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return t;
}
function Gh(e, n) {
  const t = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : K6;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const c = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (c) {
        const m = a.get(c) || 0;
        s = c + "-" + m, a.set(c, m + 1);
      }
    }
    const l = dC(e, o, s);
    l !== void 0 && t.push(l);
  }
  return t;
}
function lH(e, n, t) {
  const i = R6(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = i.commaSeparated ? x6(t) : V6(t)), i.property === "style") {
      let a = typeof t == "object" ? t : uH(e, String(t));
      return e.stylePropertyNameCase === "css" && (a = cH(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? A6[i.property] || i.property : i.attribute,
      t
    ];
  }
}
function uH(e, n) {
  const t = {};
  try {
    B6(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Ft("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = cC + "#cannot-parse-style-attribute", s;
    }
  }
  return t;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(G6, mH)), t[s] = o;
  }
}
function fC(e, n, t) {
  let i;
  if (!t)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = Jb(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = Jb(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Kh.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Xo(e);
}
function Xo(e, n) {
  const t = new Ft(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = cC + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function cH(e) {
  const n = {};
  let t;
  for (t in e)
    Kh.call(e, t) && (n[dH(t)] = e[t]);
  return n;
}
function dH(e) {
  let n = e.replace(W6, fH);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function mH(e, n) {
  return n.toUpperCase();
}
function fH(e) {
  return "-" + e.toLowerCase();
}
const md = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, pH = {};
function vH(e, n) {
  const t = pH, i = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, a = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return pC(e, i, a);
}
function pC(e, n, t) {
  if (hH(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return a_(e.children, n, t);
  }
  return Array.isArray(e) ? a_(e, n, t) : "";
}
function a_(e, n, t) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = pC(e[a], n, t);
  return i.join("");
}
function hH(e) {
  return !!(e && typeof e == "object");
}
const o_ = document.createElement("i");
function Yh(e) {
  const n = "&" + e + ";";
  o_.innerHTML = n;
  const t = o_.textContent;
  return t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t;
}
function Br(e, n, t, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, t = t > 0 ? t : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, t), e.splice(...s);
  else
    for (t && e.splice(n, t); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function sr(e, n) {
  return e.length > 0 ? (Br(e, e.length, 0, n), e) : n;
}
const s_ = {}.hasOwnProperty;
function yH(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    gH(n, e[t]);
  return n;
}
function gH(e, n) {
  let t;
  for (t in n) {
    const a = (s_.call(e, t) ? e[t] : void 0) || (e[t] = {}), o = n[t];
    let s;
    if (o)
      for (s in o) {
        s_.call(a, s) || (a[s] = []);
        const l = o[s];
        kH(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function kH(e, n) {
  let t = -1;
  const i = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : i).push(n[t]);
  Br(e, 0, 0, i);
}
function vC(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function ba(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const l_ = bH(/[\dA-Za-z]/);
function bH(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function Ua(e) {
  const n = [];
  let t = -1, i = 0, a = 0;
  for (; ++t < e.length; ) {
    const o = e.charCodeAt(t);
    let s = "";
    if (o === 37 && l_(e.charCodeAt(t + 1)) && l_(e.charCodeAt(t + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(t + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, t), encodeURIComponent(s)), i = t + a + 1, s = ""), a && (t += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
const Lr = Ba(/[A-Za-z]/), jr = Ba(/[\dA-Za-z]/), _H = Ba(/[#-'*+\--9=?A-Z^-~]/);
function bv(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const _v = Ba(/\d/), xH = Ba(/[\dA-Fa-f]/), SH = Ba(/[!-/:-@[-`{-~]/);
function dn(e) {
  return e !== null && e < -2;
}
function tr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Rn(e) {
  return e === -2 || e === -1 || e === 32;
}
function Ba(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function Yn(e, n, t, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(c) {
    return Rn(c) ? (e.enter(t), l(c)) : n(c);
  }
  function l(c) {
    return Rn(c) && o++ < a ? (e.consume(c), l) : (e.exit(t), n(c));
  }
}
const NH = {
  tokenize: wH
};
function wH(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let t;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Yn(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = c), t = c, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return dn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const jH = {
  tokenize: CH
}, u_ = {
  tokenize: FH
};
function CH(e) {
  const n = this, t = [];
  let i = 0, a, o, s;
  return l;
  function l(P) {
    if (i < t.length) {
      const N = t[i];
      return n.containerState = N[1], e.attempt(N[0].continuation, c, m)(P);
    }
    return m(P);
  }
  function c(P) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && h();
      const N = n.events.length;
      let $ = N, O;
      for (; $--; )
        if (n.events[$][0] === "exit" && n.events[$][1].type === "chunkFlow") {
          O = n.events[$][1].end;
          break;
        }
      x(i);
      let B = N;
      for (; B < n.events.length; )
        n.events[B][1].end = {
          ...O
        }, B++;
      return Br(n.events, $ + 1, 0, n.events.slice(N)), n.events.length = B, m(P);
    }
    return l(P);
  }
  function m(P) {
    if (i === t.length) {
      if (!a)
        return v(P);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return S(P);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(u_, d, p)(P);
  }
  function d(P) {
    return a && h(), x(i), v(P);
  }
  function p(P) {
    return n.parser.lazy[n.now().line] = i !== t.length, s = n.now().offset, S(P);
  }
  function v(P) {
    return n.containerState = {}, e.attempt(u_, y, S)(P);
  }
  function y(P) {
    return i++, t.push([n.currentConstruct, n.containerState]), v(P);
  }
  function S(P) {
    if (P === null) {
      a && h(), x(0), e.consume(P);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), b(P);
  }
  function b(P) {
    if (P === null) {
      j(e.exit("chunkFlow"), !0), x(0), e.consume(P);
      return;
    }
    return dn(P) ? (e.consume(P), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(P), b);
  }
  function j(P, N) {
    const $ = n.sliceStream(P);
    if (N && $.push(null), P.previous = o, o && (o.next = P), o = P, a.defineSkip(P.start), a.write($), n.parser.lazy[P.start.line]) {
      let O = a.events.length;
      for (; O--; )
        if (
          // The token starts before the line ending…
          a.events[O][1].start.offset < s && // …and either is not ended yet…
          (!a.events[O][1].end || // …or ends after it.
          a.events[O][1].end.offset > s)
        )
          return;
      const B = n.events.length;
      let Z = B, Y, ee;
      for (; Z--; )
        if (n.events[Z][0] === "exit" && n.events[Z][1].type === "chunkFlow") {
          if (Y) {
            ee = n.events[Z][1].end;
            break;
          }
          Y = !0;
        }
      for (x(i), O = B; O < n.events.length; )
        n.events[O][1].end = {
          ...ee
        }, O++;
      Br(n.events, Z + 1, 0, n.events.slice(B)), n.events.length = O;
    }
  }
  function x(P) {
    let N = t.length;
    for (; N-- > P; ) {
      const $ = t[N];
      n.containerState = $[1], $[0].exit.call(n, e);
    }
    t.length = P;
  }
  function h() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function FH(e, n, t) {
  return Yn(e, e.attempt(this.parser.constructs.document, n, t), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function IH(e) {
  return e !== null && (e < 0 || e === 32);
}
const $H = hC(new RegExp("\\p{P}|\\p{S}", "u")), EH = hC(/\s/);
function hC(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function c_(e) {
  if (e === null || IH(e) || EH(e))
    return 1;
  if ($H(e))
    return 2;
}
function Jh(e, n, t) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, t), i.push(o));
  }
  return n;
}
const xv = {
  name: "attention",
  resolveAll: TH,
  tokenize: OH
};
function TH(e, n) {
  let t = -1, i, a, o, s, l, c, m, d;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (i = t; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          c = e[i][1].end.offset - e[i][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const p = {
            ...e[i][1].end
          }, v = {
            ...e[t][1].start
          };
          d_(p, -c), d_(v, c), s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: p,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[t][1].start
            },
            end: v
          }, o = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[t][1].start
            }
          }, a = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[t][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = sr(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = sr(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = sr(m, Jh(n.parser.constructs.insideSpan.null, e.slice(i + 1, t), n)), m = sr(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[t][1].end.offset - e[t][1].start.offset ? (d = 2, m = sr(m, [["enter", e[t][1], n], ["exit", e[t][1], n]])) : d = 0, Br(e, i - 1, t - i + 3, m), t = i + m.length - d - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function OH(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, i = this.previous, a = c_(i);
  let o;
  return s;
  function s(c) {
    return o = c, e.enter("attentionSequence"), l(c);
  }
  function l(c) {
    if (c === o)
      return e.consume(c), l;
    const m = e.exit("attentionSequence"), d = c_(c), p = !d || d === 2 && a || t.includes(c), v = !a || a === 2 && d || t.includes(i);
    return m._open = !!(o === 42 ? p : p && (a || !v)), m._close = !!(o === 42 ? v : v && (d || !p)), n(c);
  }
}
function d_(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const RH = {
  name: "autolink",
  tokenize: DH
};
function DH(e, n, t) {
  let i = 0;
  return a;
  function a(y) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(y), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(y) {
    return Lr(y) ? (e.consume(y), s) : y === 64 ? t(y) : m(y);
  }
  function s(y) {
    return y === 43 || y === 45 || y === 46 || jr(y) ? (i = 1, l(y)) : m(y);
  }
  function l(y) {
    return y === 58 ? (e.consume(y), i = 0, c) : (y === 43 || y === 45 || y === 46 || jr(y)) && i++ < 32 ? (e.consume(y), l) : (i = 0, m(y));
  }
  function c(y) {
    return y === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(y), e.exit("autolinkMarker"), e.exit("autolink"), n) : y === null || y === 32 || y === 60 || bv(y) ? t(y) : (e.consume(y), c);
  }
  function m(y) {
    return y === 64 ? (e.consume(y), d) : _H(y) ? (e.consume(y), m) : t(y);
  }
  function d(y) {
    return jr(y) ? p(y) : t(y);
  }
  function p(y) {
    return y === 46 ? (e.consume(y), i = 0, d) : y === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(y), e.exit("autolinkMarker"), e.exit("autolink"), n) : v(y);
  }
  function v(y) {
    if ((y === 45 || jr(y)) && i++ < 63) {
      const S = y === 45 ? v : p;
      return e.consume(y), S;
    }
    return t(y);
  }
}
const Hu = {
  partial: !0,
  tokenize: PH
};
function PH(e, n, t) {
  return i;
  function i(o) {
    return Rn(o) ? Yn(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || dn(o) ? n(o) : t(o);
  }
}
const yC = {
  continuation: {
    tokenize: LH
  },
  exit: VH,
  name: "blockQuote",
  tokenize: AH
};
function AH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return t(s);
  }
  function o(s) {
    return Rn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function LH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return Rn(s) ? Yn(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(yC, n, t)(s);
  }
}
function VH(e) {
  e.exit("blockQuote");
}
const gC = {
  name: "characterEscape",
  tokenize: zH
};
function zH(e, n, t) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return SH(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(o);
  }
}
const kC = {
  name: "characterReference",
  tokenize: MH
};
function MH(e, n, t) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(p) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), c;
  }
  function c(p) {
    return p === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(p), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = jr, d(p));
  }
  function m(p) {
    return p === 88 || p === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(p), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = xH, d) : (e.enter("characterReferenceValue"), o = 7, s = _v, d(p));
  }
  function d(p) {
    if (p === 59 && a) {
      const v = e.exit("characterReferenceValue");
      return s === jr && !Yh(i.sliceSerialize(v)) ? t(p) : (e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(p) && a++ < o ? (e.consume(p), d) : t(p);
  }
}
const m_ = {
  partial: !0,
  tokenize: BH
}, f_ = {
  concrete: !0,
  name: "codeFenced",
  tokenize: UH
};
function UH(e, n, t) {
  const i = this, a = {
    partial: !0,
    tokenize: $
  };
  let o = 0, s = 0, l;
  return c;
  function c(O) {
    return m(O);
  }
  function m(O) {
    const B = i.events[i.events.length - 1];
    return o = B && B[1].type === "linePrefix" ? B[2].sliceSerialize(B[1], !0).length : 0, l = O, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(O);
  }
  function d(O) {
    return O === l ? (s++, e.consume(O), d) : s < 3 ? t(O) : (e.exit("codeFencedFenceSequence"), Rn(O) ? Yn(e, p, "whitespace")(O) : p(O));
  }
  function p(O) {
    return O === null || dn(O) ? (e.exit("codeFencedFence"), i.interrupt ? n(O) : e.check(m_, b, N)(O)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), v(O));
  }
  function v(O) {
    return O === null || dn(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), p(O)) : Rn(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Yn(e, y, "whitespace")(O)) : O === 96 && O === l ? t(O) : (e.consume(O), v);
  }
  function y(O) {
    return O === null || dn(O) ? p(O) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), S(O));
  }
  function S(O) {
    return O === null || dn(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), p(O)) : O === 96 && O === l ? t(O) : (e.consume(O), S);
  }
  function b(O) {
    return e.attempt(a, N, j)(O);
  }
  function j(O) {
    return e.enter("lineEnding"), e.consume(O), e.exit("lineEnding"), x;
  }
  function x(O) {
    return o > 0 && Rn(O) ? Yn(e, h, "linePrefix", o + 1)(O) : h(O);
  }
  function h(O) {
    return O === null || dn(O) ? e.check(m_, b, N)(O) : (e.enter("codeFlowValue"), P(O));
  }
  function P(O) {
    return O === null || dn(O) ? (e.exit("codeFlowValue"), h(O)) : (e.consume(O), P);
  }
  function N(O) {
    return e.exit("codeFenced"), n(O);
  }
  function $(O, B, Z) {
    let Y = 0;
    return ee;
    function ee(ne) {
      return O.enter("lineEnding"), O.consume(ne), O.exit("lineEnding"), J;
    }
    function J(ne) {
      return O.enter("codeFencedFence"), Rn(ne) ? Yn(O, K, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ne) : K(ne);
    }
    function K(ne) {
      return ne === l ? (O.enter("codeFencedFenceSequence"), V(ne)) : Z(ne);
    }
    function V(ne) {
      return ne === l ? (Y++, O.consume(ne), V) : Y >= s ? (O.exit("codeFencedFenceSequence"), Rn(ne) ? Yn(O, Q, "whitespace")(ne) : Q(ne)) : Z(ne);
    }
    function Q(ne) {
      return ne === null || dn(ne) ? (O.exit("codeFencedFence"), B(ne)) : Z(ne);
    }
  }
}
function BH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? t(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? t(s) : n(s);
  }
}
const fd = {
  name: "codeIndented",
  tokenize: HH
}, qH = {
  partial: !0,
  tokenize: KH
};
function HH(e, n, t) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), Yn(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? s(m) : t(m);
  }
  function s(m) {
    return m === null ? c(m) : dn(m) ? e.attempt(qH, s, c)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || dn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function c(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function KH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? t(s) : dn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : Yn(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : dn(s) ? a(s) : t(s);
  }
}
const WH = {
  name: "codeText",
  previous: YH,
  resolve: GH,
  tokenize: JH
};
function GH(e) {
  let n = e.length - 4, t = 3, i, a;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = t; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (i = t - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function YH(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function JH(e, n, t) {
  let i = 0, a, o;
  return s;
  function s(p) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(p);
  }
  function l(p) {
    return p === 96 ? (e.consume(p), i++, l) : (e.exit("codeTextSequence"), c(p));
  }
  function c(p) {
    return p === null ? t(p) : p === 32 ? (e.enter("space"), e.consume(p), e.exit("space"), c) : p === 96 ? (o = e.enter("codeTextSequence"), a = 0, d(p)) : dn(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), c) : (e.enter("codeTextData"), m(p));
  }
  function m(p) {
    return p === null || p === 32 || p === 96 || dn(p) ? (e.exit("codeTextData"), c(p)) : (e.consume(p), m);
  }
  function d(p) {
    return p === 96 ? (e.consume(p), a++, d) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(p)) : (o.type = "codeTextData", m(p));
  }
}
class QH {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, t) {
    const i = t ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, t, i) {
    const a = t || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && uo(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), uo(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), uo(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const t = this.left.splice(n, Number.POSITIVE_INFINITY);
        uo(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        uo(this.left, t.reverse());
      }
  }
}
function uo(e, n) {
  let t = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; t < n.length; )
      e.push(...n.slice(t, t + 1e4)), t += 1e4;
}
function bC(e) {
  const n = {};
  let t = -1, i, a, o, s, l, c, m;
  const d = new QH(e);
  for (; ++t < d.length; ) {
    for (; t in n; )
      t = n[t];
    if (i = d.get(t), t && i[1].type === "chunkFlow" && d.get(t - 1)[1].type === "listItemPrefix" && (c = i[1]._tokenizer.events, o = 0, o < c.length && c[o][1].type === "lineEndingBlank" && (o += 2), o < c.length && c[o][1].type === "content"))
      for (; ++o < c.length && c[o][1].type !== "content"; )
        c[o][1].type === "chunkText" && (c[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, XH(d, t)), t = n[t], m = !0);
    else if (i[1]._container) {
      for (o = t, a = void 0; o-- && (s = d.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (d.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...d.get(a)[1].start
      }, l = d.slice(a, t), l.unshift(i), d.splice(a, t - a + 1, l));
    }
  }
  return Br(e, 0, Number.POSITIVE_INFINITY, d.slice(0)), !m;
}
function XH(e, n) {
  const t = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = t._tokenizer || i.parser[t.contentType](t.start), l = s.events, c = [], m = {};
  let d, p, v = -1, y = t, S = 0, b = 0;
  const j = [b];
  for (; y; ) {
    for (; e.get(++a)[1] !== y; )
      ;
    o.push(a), y._tokenizer || (d = i.sliceStream(y), y.next || d.push(null), p && s.defineSkip(y.start), y._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(d), y._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), p = y, y = y.next;
  }
  for (y = t; ++v < l.length; )
    // Find a void token that includes a break.
    l[v][0] === "exit" && l[v - 1][0] === "enter" && l[v][1].type === l[v - 1][1].type && l[v][1].start.line !== l[v][1].end.line && (b = v + 1, j.push(b), y._tokenizer = void 0, y.previous = void 0, y = y.next);
  for (s.events = [], y ? (y._tokenizer = void 0, y.previous = void 0) : j.pop(), v = j.length; v--; ) {
    const x = l.slice(j[v], j[v + 1]), h = o.pop();
    c.push([h, h + x.length - 1]), e.splice(h, 2, x);
  }
  for (c.reverse(), v = -1; ++v < c.length; )
    m[S + c[v][0]] = S + c[v][1], S += c[v][1] - c[v][0] - 1;
  return m;
}
const ZH = {
  resolve: nK,
  tokenize: tK
}, eK = {
  partial: !0,
  tokenize: rK
};
function nK(e) {
  return bC(e), e;
}
function tK(e, n) {
  let t;
  return i;
  function i(l) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : dn(l) ? e.check(eK, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, a;
  }
}
function rK(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Yn(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || dn(s))
      return t(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, t, n)(s);
  }
}
function _C(e, n, t, i, a, o, s, l, c) {
  const m = c || Number.POSITIVE_INFINITY;
  let d = 0;
  return p;
  function p(x) {
    return x === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(x), e.exit(o), v) : x === null || x === 32 || x === 41 || bv(x) ? t(x) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), b(x));
  }
  function v(x) {
    return x === 62 ? (e.enter(o), e.consume(x), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), y(x));
  }
  function y(x) {
    return x === 62 ? (e.exit("chunkString"), e.exit(l), v(x)) : x === null || x === 60 || dn(x) ? t(x) : (e.consume(x), x === 92 ? S : y);
  }
  function S(x) {
    return x === 60 || x === 62 || x === 92 ? (e.consume(x), y) : y(x);
  }
  function b(x) {
    return !d && (x === null || x === 41 || tr(x)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(x)) : d < m && x === 40 ? (e.consume(x), d++, b) : x === 41 ? (e.consume(x), d--, b) : x === null || x === 32 || x === 40 || bv(x) ? t(x) : (e.consume(x), x === 92 ? j : b);
  }
  function j(x) {
    return x === 40 || x === 41 || x === 92 ? (e.consume(x), b) : b(x);
  }
}
function xC(e, n, t, i, a, o) {
  const s = this;
  let l = 0, c;
  return m;
  function m(y) {
    return e.enter(i), e.enter(a), e.consume(y), e.exit(a), e.enter(o), d;
  }
  function d(y) {
    return l > 999 || y === null || y === 91 || y === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    y === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? t(y) : y === 93 ? (e.exit(o), e.enter(a), e.consume(y), e.exit(a), e.exit(i), n) : dn(y) ? (e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), p(y));
  }
  function p(y) {
    return y === null || y === 91 || y === 93 || dn(y) || l++ > 999 ? (e.exit("chunkString"), d(y)) : (e.consume(y), c || (c = !Rn(y)), y === 92 ? v : p);
  }
  function v(y) {
    return y === 91 || y === 92 || y === 93 ? (e.consume(y), l++, p) : p(y);
  }
}
function SC(e, n, t, i, a, o) {
  let s;
  return l;
  function l(v) {
    return v === 34 || v === 39 || v === 40 ? (e.enter(i), e.enter(a), e.consume(v), e.exit(a), s = v === 40 ? 41 : v, c) : t(v);
  }
  function c(v) {
    return v === s ? (e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : (e.enter(o), m(v));
  }
  function m(v) {
    return v === s ? (e.exit(o), c(s)) : v === null ? t(v) : dn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), Yn(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(v));
  }
  function d(v) {
    return v === s || v === null || dn(v) ? (e.exit("chunkString"), m(v)) : (e.consume(v), v === 92 ? p : d);
  }
  function p(v) {
    return v === s || v === 92 ? (e.consume(v), d) : d(v);
  }
}
function zo(e, n) {
  let t;
  return i;
  function i(a) {
    return dn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t = !0, i) : Rn(a) ? Yn(e, i, t ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const iK = {
  name: "definition",
  tokenize: oK
}, aK = {
  partial: !0,
  tokenize: sK
};
function oK(e, n, t) {
  const i = this;
  let a;
  return o;
  function o(y) {
    return e.enter("definition"), s(y);
  }
  function s(y) {
    return xC.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(y);
  }
  function l(y) {
    return a = ba(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), y === 58 ? (e.enter("definitionMarker"), e.consume(y), e.exit("definitionMarker"), c) : t(y);
  }
  function c(y) {
    return tr(y) ? zo(e, m)(y) : m(y);
  }
  function m(y) {
    return _C(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(y);
  }
  function d(y) {
    return e.attempt(aK, p, p)(y);
  }
  function p(y) {
    return Rn(y) ? Yn(e, v, "whitespace")(y) : v(y);
  }
  function v(y) {
    return y === null || dn(y) ? (e.exit("definition"), i.parser.defined.push(a), n(y)) : t(y);
  }
}
function sK(e, n, t) {
  return i;
  function i(l) {
    return tr(l) ? zo(e, a)(l) : t(l);
  }
  function a(l) {
    return SC(e, o, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Rn(l) ? Yn(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || dn(l) ? n(l) : t(l);
  }
}
const lK = {
  name: "hardBreakEscape",
  tokenize: uK
};
function uK(e, n, t) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return dn(o) ? (e.exit("hardBreakEscape"), n(o)) : t(o);
  }
}
const cK = {
  name: "headingAtx",
  resolve: dK,
  tokenize: mK
};
function dK(e, n) {
  let t = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), t - 2 > i && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (i === t - 1 || t - 4 > i && e[t - 2][1].type === "whitespace") && (t -= i + 1 === t ? 2 : 4), t > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[t][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, Br(e, i, t - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function mK(e, n, t) {
  let i = 0;
  return a;
  function a(d) {
    return e.enter("atxHeading"), o(d);
  }
  function o(d) {
    return e.enter("atxHeadingSequence"), s(d);
  }
  function s(d) {
    return d === 35 && i++ < 6 ? (e.consume(d), s) : d === null || tr(d) ? (e.exit("atxHeadingSequence"), l(d)) : t(d);
  }
  function l(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), c(d)) : d === null || dn(d) ? (e.exit("atxHeading"), n(d)) : Rn(d) ? Yn(e, l, "whitespace")(d) : (e.enter("atxHeadingText"), m(d));
  }
  function c(d) {
    return d === 35 ? (e.consume(d), c) : (e.exit("atxHeadingSequence"), l(d));
  }
  function m(d) {
    return d === null || d === 35 || tr(d) ? (e.exit("atxHeadingText"), l(d)) : (e.consume(d), m);
  }
}
const fK = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], p_ = ["pre", "script", "style", "textarea"], pK = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: yK,
  tokenize: gK
}, vK = {
  partial: !0,
  tokenize: bK
}, hK = {
  partial: !0,
  tokenize: kK
};
function yK(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function gK(e, n, t) {
  const i = this;
  let a, o, s, l, c;
  return m;
  function m(M) {
    return d(M);
  }
  function d(M) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(M), p;
  }
  function p(M) {
    return M === 33 ? (e.consume(M), v) : M === 47 ? (e.consume(M), o = !0, b) : M === 63 ? (e.consume(M), a = 3, i.interrupt ? n : G) : Lr(M) ? (e.consume(M), s = String.fromCharCode(M), j) : t(M);
  }
  function v(M) {
    return M === 45 ? (e.consume(M), a = 2, y) : M === 91 ? (e.consume(M), a = 5, l = 0, S) : Lr(M) ? (e.consume(M), a = 4, i.interrupt ? n : G) : t(M);
  }
  function y(M) {
    return M === 45 ? (e.consume(M), i.interrupt ? n : G) : t(M);
  }
  function S(M) {
    const Ae = "CDATA[";
    return M === Ae.charCodeAt(l++) ? (e.consume(M), l === Ae.length ? i.interrupt ? n : K : S) : t(M);
  }
  function b(M) {
    return Lr(M) ? (e.consume(M), s = String.fromCharCode(M), j) : t(M);
  }
  function j(M) {
    if (M === null || M === 47 || M === 62 || tr(M)) {
      const Ae = M === 47, Ve = s.toLowerCase();
      return !Ae && !o && p_.includes(Ve) ? (a = 1, i.interrupt ? n(M) : K(M)) : fK.includes(s.toLowerCase()) ? (a = 6, Ae ? (e.consume(M), x) : i.interrupt ? n(M) : K(M)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? t(M) : o ? h(M) : P(M));
    }
    return M === 45 || jr(M) ? (e.consume(M), s += String.fromCharCode(M), j) : t(M);
  }
  function x(M) {
    return M === 62 ? (e.consume(M), i.interrupt ? n : K) : t(M);
  }
  function h(M) {
    return Rn(M) ? (e.consume(M), h) : ee(M);
  }
  function P(M) {
    return M === 47 ? (e.consume(M), ee) : M === 58 || M === 95 || Lr(M) ? (e.consume(M), N) : Rn(M) ? (e.consume(M), P) : ee(M);
  }
  function N(M) {
    return M === 45 || M === 46 || M === 58 || M === 95 || jr(M) ? (e.consume(M), N) : $(M);
  }
  function $(M) {
    return M === 61 ? (e.consume(M), O) : Rn(M) ? (e.consume(M), $) : P(M);
  }
  function O(M) {
    return M === null || M === 60 || M === 61 || M === 62 || M === 96 ? t(M) : M === 34 || M === 39 ? (e.consume(M), c = M, B) : Rn(M) ? (e.consume(M), O) : Z(M);
  }
  function B(M) {
    return M === c ? (e.consume(M), c = null, Y) : M === null || dn(M) ? t(M) : (e.consume(M), B);
  }
  function Z(M) {
    return M === null || M === 34 || M === 39 || M === 47 || M === 60 || M === 61 || M === 62 || M === 96 || tr(M) ? $(M) : (e.consume(M), Z);
  }
  function Y(M) {
    return M === 47 || M === 62 || Rn(M) ? P(M) : t(M);
  }
  function ee(M) {
    return M === 62 ? (e.consume(M), J) : t(M);
  }
  function J(M) {
    return M === null || dn(M) ? K(M) : Rn(M) ? (e.consume(M), J) : t(M);
  }
  function K(M) {
    return M === 45 && a === 2 ? (e.consume(M), ce) : M === 60 && a === 1 ? (e.consume(M), ae) : M === 62 && a === 4 ? (e.consume(M), le) : M === 63 && a === 3 ? (e.consume(M), G) : M === 93 && a === 5 ? (e.consume(M), je) : dn(M) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(vK, he, V)(M)) : M === null || dn(M) ? (e.exit("htmlFlowData"), V(M)) : (e.consume(M), K);
  }
  function V(M) {
    return e.check(hK, Q, he)(M);
  }
  function Q(M) {
    return e.enter("lineEnding"), e.consume(M), e.exit("lineEnding"), ne;
  }
  function ne(M) {
    return M === null || dn(M) ? V(M) : (e.enter("htmlFlowData"), K(M));
  }
  function ce(M) {
    return M === 45 ? (e.consume(M), G) : K(M);
  }
  function ae(M) {
    return M === 47 ? (e.consume(M), s = "", ve) : K(M);
  }
  function ve(M) {
    if (M === 62) {
      const Ae = s.toLowerCase();
      return p_.includes(Ae) ? (e.consume(M), le) : K(M);
    }
    return Lr(M) && s.length < 8 ? (e.consume(M), s += String.fromCharCode(M), ve) : K(M);
  }
  function je(M) {
    return M === 93 ? (e.consume(M), G) : K(M);
  }
  function G(M) {
    return M === 62 ? (e.consume(M), le) : M === 45 && a === 2 ? (e.consume(M), G) : K(M);
  }
  function le(M) {
    return M === null || dn(M) ? (e.exit("htmlFlowData"), he(M)) : (e.consume(M), le);
  }
  function he(M) {
    return e.exit("htmlFlow"), n(M);
  }
}
function kK(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return dn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : t(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? t(s) : n(s);
  }
}
function bK(e, n, t) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Hu, n, t);
  }
}
const _K = {
  name: "htmlText",
  tokenize: xK
};
function xK(e, n, t) {
  const i = this;
  let a, o, s;
  return l;
  function l(G) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(G), c;
  }
  function c(G) {
    return G === 33 ? (e.consume(G), m) : G === 47 ? (e.consume(G), $) : G === 63 ? (e.consume(G), P) : Lr(G) ? (e.consume(G), Z) : t(G);
  }
  function m(G) {
    return G === 45 ? (e.consume(G), d) : G === 91 ? (e.consume(G), o = 0, S) : Lr(G) ? (e.consume(G), h) : t(G);
  }
  function d(G) {
    return G === 45 ? (e.consume(G), y) : t(G);
  }
  function p(G) {
    return G === null ? t(G) : G === 45 ? (e.consume(G), v) : dn(G) ? (s = p, ae(G)) : (e.consume(G), p);
  }
  function v(G) {
    return G === 45 ? (e.consume(G), y) : p(G);
  }
  function y(G) {
    return G === 62 ? ce(G) : G === 45 ? v(G) : p(G);
  }
  function S(G) {
    const le = "CDATA[";
    return G === le.charCodeAt(o++) ? (e.consume(G), o === le.length ? b : S) : t(G);
  }
  function b(G) {
    return G === null ? t(G) : G === 93 ? (e.consume(G), j) : dn(G) ? (s = b, ae(G)) : (e.consume(G), b);
  }
  function j(G) {
    return G === 93 ? (e.consume(G), x) : b(G);
  }
  function x(G) {
    return G === 62 ? ce(G) : G === 93 ? (e.consume(G), x) : b(G);
  }
  function h(G) {
    return G === null || G === 62 ? ce(G) : dn(G) ? (s = h, ae(G)) : (e.consume(G), h);
  }
  function P(G) {
    return G === null ? t(G) : G === 63 ? (e.consume(G), N) : dn(G) ? (s = P, ae(G)) : (e.consume(G), P);
  }
  function N(G) {
    return G === 62 ? ce(G) : P(G);
  }
  function $(G) {
    return Lr(G) ? (e.consume(G), O) : t(G);
  }
  function O(G) {
    return G === 45 || jr(G) ? (e.consume(G), O) : B(G);
  }
  function B(G) {
    return dn(G) ? (s = B, ae(G)) : Rn(G) ? (e.consume(G), B) : ce(G);
  }
  function Z(G) {
    return G === 45 || jr(G) ? (e.consume(G), Z) : G === 47 || G === 62 || tr(G) ? Y(G) : t(G);
  }
  function Y(G) {
    return G === 47 ? (e.consume(G), ce) : G === 58 || G === 95 || Lr(G) ? (e.consume(G), ee) : dn(G) ? (s = Y, ae(G)) : Rn(G) ? (e.consume(G), Y) : ce(G);
  }
  function ee(G) {
    return G === 45 || G === 46 || G === 58 || G === 95 || jr(G) ? (e.consume(G), ee) : J(G);
  }
  function J(G) {
    return G === 61 ? (e.consume(G), K) : dn(G) ? (s = J, ae(G)) : Rn(G) ? (e.consume(G), J) : Y(G);
  }
  function K(G) {
    return G === null || G === 60 || G === 61 || G === 62 || G === 96 ? t(G) : G === 34 || G === 39 ? (e.consume(G), a = G, V) : dn(G) ? (s = K, ae(G)) : Rn(G) ? (e.consume(G), K) : (e.consume(G), Q);
  }
  function V(G) {
    return G === a ? (e.consume(G), a = void 0, ne) : G === null ? t(G) : dn(G) ? (s = V, ae(G)) : (e.consume(G), V);
  }
  function Q(G) {
    return G === null || G === 34 || G === 39 || G === 60 || G === 61 || G === 96 ? t(G) : G === 47 || G === 62 || tr(G) ? Y(G) : (e.consume(G), Q);
  }
  function ne(G) {
    return G === 47 || G === 62 || tr(G) ? Y(G) : t(G);
  }
  function ce(G) {
    return G === 62 ? (e.consume(G), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(G);
  }
  function ae(G) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(G), e.exit("lineEnding"), ve;
  }
  function ve(G) {
    return Rn(G) ? Yn(e, je, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(G) : je(G);
  }
  function je(G) {
    return e.enter("htmlTextData"), s(G);
  }
}
const Qh = {
  name: "labelEnd",
  resolveAll: jK,
  resolveTo: CK,
  tokenize: FK
}, SK = {
  tokenize: IK
}, NK = {
  tokenize: $K
}, wK = {
  tokenize: EK
};
function jK(e) {
  let n = -1;
  const t = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (t.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== t.length && Br(e, 0, e.length, t), e;
}
function CK(e, n) {
  let t = e.length, i = 0, a, o, s, l;
  for (; t--; )
    if (a = e[t][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[t][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[t][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = t, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = t);
  const c = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, d = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", c, n], ["enter", m, n]], l = sr(l, e.slice(o + 1, o + i + 3)), l = sr(l, [["enter", d, n]]), l = sr(l, Jh(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = sr(l, [["exit", d, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = sr(l, e.slice(s + 1)), l = sr(l, [["exit", c, n]]), Br(e, o, e.length, l), e;
}
function FK(e, n, t) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(v) {
    return o ? o._inactive ? p(v) : (s = i.parser.defined.includes(ba(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(v), e.exit("labelMarker"), e.exit("labelEnd"), c) : t(v);
  }
  function c(v) {
    return v === 40 ? e.attempt(SK, d, s ? d : p)(v) : v === 91 ? e.attempt(NK, d, s ? m : p)(v) : s ? d(v) : p(v);
  }
  function m(v) {
    return e.attempt(wK, d, p)(v);
  }
  function d(v) {
    return n(v);
  }
  function p(v) {
    return o._balanced = !0, t(v);
  }
}
function IK(e, n, t) {
  return i;
  function i(p) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(p), e.exit("resourceMarker"), a;
  }
  function a(p) {
    return tr(p) ? zo(e, o)(p) : o(p);
  }
  function o(p) {
    return p === 41 ? d(p) : _C(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(p);
  }
  function s(p) {
    return tr(p) ? zo(e, c)(p) : d(p);
  }
  function l(p) {
    return t(p);
  }
  function c(p) {
    return p === 34 || p === 39 || p === 40 ? SC(e, m, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(p) : d(p);
  }
  function m(p) {
    return tr(p) ? zo(e, d)(p) : d(p);
  }
  function d(p) {
    return p === 41 ? (e.enter("resourceMarker"), e.consume(p), e.exit("resourceMarker"), e.exit("resource"), n) : t(p);
  }
}
function $K(e, n, t) {
  const i = this;
  return a;
  function a(l) {
    return xC.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ba(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : t(l);
  }
  function s(l) {
    return t(l);
  }
}
function EK(e, n, t) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : t(o);
  }
}
const TK = {
  name: "labelStartImage",
  resolveAll: Qh.resolveAll,
  tokenize: OK
};
function OK(e, n, t) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : t(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(l) : n(l);
  }
}
const RK = {
  name: "labelStartLink",
  resolveAll: Qh.resolveAll,
  tokenize: DK
};
function DK(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(s) : n(s);
  }
}
const pd = {
  name: "lineEnding",
  tokenize: PK
};
function PK(e, n) {
  return t;
  function t(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), Yn(e, n, "linePrefix");
  }
}
const Il = {
  name: "thematicBreak",
  tokenize: AK
};
function AK(e, n, t) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), c(m)) : i >= 3 && (m === null || dn(m)) ? (e.exit("thematicBreak"), n(m)) : t(m);
  }
  function c(m) {
    return m === a ? (e.consume(m), i++, c) : (e.exit("thematicBreakSequence"), Rn(m) ? Yn(e, l, "whitespace")(m) : l(m));
  }
}
const zt = {
  continuation: {
    tokenize: MK
  },
  exit: BK,
  name: "list",
  tokenize: zK
}, LK = {
  partial: !0,
  tokenize: qK
}, VK = {
  partial: !0,
  tokenize: UK
};
function zK(e, n, t) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(y) {
    const S = i.containerState.type || (y === 42 || y === 43 || y === 45 ? "listUnordered" : "listOrdered");
    if (S === "listUnordered" ? !i.containerState.marker || y === i.containerState.marker : _v(y)) {
      if (i.containerState.type || (i.containerState.type = S, e.enter(S, {
        _container: !0
      })), S === "listUnordered")
        return e.enter("listItemPrefix"), y === 42 || y === 45 ? e.check(Il, t, m)(y) : m(y);
      if (!i.interrupt || y === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(y);
    }
    return t(y);
  }
  function c(y) {
    return _v(y) && ++s < 10 ? (e.consume(y), c) : (!i.interrupt || s < 2) && (i.containerState.marker ? y === i.containerState.marker : y === 41 || y === 46) ? (e.exit("listItemValue"), m(y)) : t(y);
  }
  function m(y) {
    return e.enter("listItemMarker"), e.consume(y), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || y, e.check(
      Hu,
      // Can’t be empty when interrupting.
      i.interrupt ? t : d,
      e.attempt(LK, v, p)
    );
  }
  function d(y) {
    return i.containerState.initialBlankLine = !0, o++, v(y);
  }
  function p(y) {
    return Rn(y) ? (e.enter("listItemPrefixWhitespace"), e.consume(y), e.exit("listItemPrefixWhitespace"), v) : t(y);
  }
  function v(y) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(y);
  }
}
function MK(e, n, t) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Hu, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, Yn(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Rn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(VK, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, Yn(e, e.attempt(zt, n, t), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function UK(e, n, t) {
  const i = this;
  return Yn(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : t(o);
  }
}
function BK(e) {
  e.exit(this.containerState.type);
}
function qK(e, n, t) {
  const i = this;
  return Yn(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Rn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : t(o);
  }
}
const v_ = {
  name: "setextUnderline",
  resolveTo: HK,
  tokenize: KK
};
function HK(e, n) {
  let t = e.length, i, a, o;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        i = t;
        break;
      }
      e[t][1].type === "paragraph" && (a = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !o && e[t][1].type === "definition" && (o = t);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function KK(e, n, t) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let d = i.events.length, p;
    for (; d--; )
      if (i.events[d][1].type !== "lineEnding" && i.events[d][1].type !== "linePrefix" && i.events[d][1].type !== "content") {
        p = i.events[d][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || p) ? (e.enter("setextHeadingLine"), a = m, s(m)) : t(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), Rn(m) ? Yn(e, c, "lineSuffix")(m) : c(m));
  }
  function c(m) {
    return m === null || dn(m) ? (e.exit("setextHeadingLine"), n(m)) : t(m);
  }
}
const WK = {
  tokenize: GK
};
function GK(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    Hu,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, Yn(e, e.attempt(this.parser.constructs.flow, a, e.attempt(ZH, a)), "linePrefix"))
  );
  return t;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const YK = {
  resolveAll: wC()
}, JK = NC("string"), QK = NC("text");
function NC(e) {
  return {
    resolveAll: wC(e === "text" ? XK : void 0),
    tokenize: n
  };
  function n(t) {
    const i = this, a = this.parser.constructs[e], o = t.attempt(a, s, l);
    return s;
    function s(d) {
      return m(d) ? o(d) : l(d);
    }
    function l(d) {
      if (d === null) {
        t.consume(d);
        return;
      }
      return t.enter("data"), t.consume(d), c;
    }
    function c(d) {
      return m(d) ? (t.exit("data"), o(d)) : (t.consume(d), c);
    }
    function m(d) {
      if (d === null)
        return !0;
      const p = a[d];
      let v = -1;
      if (p)
        for (; ++v < p.length; ) {
          const y = p[v];
          if (!y.previous || y.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function wC(e) {
  return n;
  function n(t, i) {
    let a = -1, o;
    for (; ++a <= t.length; )
      o === void 0 ? t[a] && t[a][1].type === "data" && (o = a, a++) : (!t[a] || t[a][1].type !== "data") && (a !== o + 2 && (t[o][1].end = t[a - 1][1].end, t.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(t, i) : t;
  }
}
function XK(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const i = e[t - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, c;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          c = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: t === e.length || c || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(t, 0, ["enter", m, n], ["exit", m, n]), t += 2);
      }
      t++;
    }
  return e;
}
const ZK = {
  42: zt,
  43: zt,
  45: zt,
  48: zt,
  49: zt,
  50: zt,
  51: zt,
  52: zt,
  53: zt,
  54: zt,
  55: zt,
  56: zt,
  57: zt,
  62: yC
}, e9 = {
  91: iK
}, n9 = {
  [-2]: fd,
  [-1]: fd,
  32: fd
}, t9 = {
  35: cK,
  42: Il,
  45: [v_, Il],
  60: pK,
  61: v_,
  95: Il,
  96: f_,
  126: f_
}, r9 = {
  38: kC,
  92: gC
}, i9 = {
  [-5]: pd,
  [-4]: pd,
  [-3]: pd,
  33: TK,
  38: kC,
  42: xv,
  60: [RH, _K],
  91: RK,
  92: [lK, gC],
  93: Qh,
  95: xv,
  96: WH
}, a9 = {
  null: [xv, YK]
}, o9 = {
  null: [42, 95]
}, s9 = {
  null: []
}, l9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: o9,
  contentInitial: e9,
  disable: s9,
  document: ZK,
  flow: t9,
  flowInitial: n9,
  insideSpan: a9,
  string: r9,
  text: i9
}, Symbol.toStringTag, { value: "Module" }));
function u9(e, n, t) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: t && t.line || 1,
    column: t && t.column || 1,
    offset: t && t.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const c = {
    attempt: B($),
    check: B(O),
    consume: h,
    enter: P,
    exit: N,
    interrupt: B(O, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: b,
    events: [],
    now: S,
    parser: e,
    previous: null,
    sliceSerialize: v,
    sliceStream: y,
    write: p
  };
  let d = n.tokenize.call(m, c);
  return n.resolveAll && o.push(n), m;
  function p(J) {
    return s = sr(s, J), j(), s[s.length - 1] !== null ? [] : (Z(n, 0), m.events = Jh(o, m.events, m), m.events);
  }
  function v(J, K) {
    return d9(y(J), K);
  }
  function y(J) {
    return c9(s, J);
  }
  function S() {
    const {
      _bufferIndex: J,
      _index: K,
      line: V,
      column: Q,
      offset: ne
    } = i;
    return {
      _bufferIndex: J,
      _index: K,
      line: V,
      column: Q,
      offset: ne
    };
  }
  function b(J) {
    a[J.line] = J.column, ee();
  }
  function j() {
    let J;
    for (; i._index < s.length; ) {
      const K = s[i._index];
      if (typeof K == "string")
        for (J = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === J && i._bufferIndex < K.length; )
          x(K.charCodeAt(i._bufferIndex));
      else
        x(K);
    }
  }
  function x(J) {
    d = d(J);
  }
  function h(J) {
    dn(J) ? (i.line++, i.column = 1, i.offset += J === -3 ? 2 : 1, ee()) : J !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = J;
  }
  function P(J, K) {
    const V = K || {};
    return V.type = J, V.start = S(), m.events.push(["enter", V, m]), l.push(V), V;
  }
  function N(J) {
    const K = l.pop();
    return K.end = S(), m.events.push(["exit", K, m]), K;
  }
  function $(J, K) {
    Z(J, K.from);
  }
  function O(J, K) {
    K.restore();
  }
  function B(J, K) {
    return V;
    function V(Q, ne, ce) {
      let ae, ve, je, G;
      return Array.isArray(Q) ? (
        /* c8 ignore next 1 */
        he(Q)
      ) : "tokenize" in Q ? (
        // Looks like a construct.
        he([
          /** @type {Construct} */
          Q
        ])
      ) : le(Q);
      function le(Te) {
        return ze;
        function ze(ge) {
          const Oe = ge !== null && Te[ge], $e = ge !== null && Te.null, Ye = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Oe) ? Oe : Oe ? [Oe] : [],
            ...Array.isArray($e) ? $e : $e ? [$e] : []
          ];
          return he(Ye)(ge);
        }
      }
      function he(Te) {
        return ae = Te, ve = 0, Te.length === 0 ? ce : M(Te[ve]);
      }
      function M(Te) {
        return ze;
        function ze(ge) {
          return G = Y(), je = Te, Te.partial || (m.currentConstruct = Te), Te.name && m.parser.constructs.disable.null.includes(Te.name) ? Ve() : Te.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            K ? Object.assign(Object.create(m), K) : m,
            c,
            Ae,
            Ve
          )(ge);
        }
      }
      function Ae(Te) {
        return J(je, G), ne;
      }
      function Ve(Te) {
        return G.restore(), ++ve < ae.length ? M(ae[ve]) : ce;
      }
    }
  }
  function Z(J, K) {
    J.resolveAll && !o.includes(J) && o.push(J), J.resolve && Br(m.events, K, m.events.length - K, J.resolve(m.events.slice(K), m)), J.resolveTo && (m.events = J.resolveTo(m.events, m));
  }
  function Y() {
    const J = S(), K = m.previous, V = m.currentConstruct, Q = m.events.length, ne = Array.from(l);
    return {
      from: Q,
      restore: ce
    };
    function ce() {
      i = J, m.previous = K, m.currentConstruct = V, m.events.length = Q, l = ne, ee();
    }
  }
  function ee() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function c9(e, n) {
  const t = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (t === a)
    s = [e[t].slice(i, o)];
  else {
    if (s = e.slice(t, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function d9(e, n) {
  let t = -1;
  const i = [];
  let a;
  for (; ++t < e.length; ) {
    const o = e[t];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function m9(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      yH([l9, ...(e || {}).extensions || []])
    ),
    content: a(NH),
    defined: [],
    document: a(jH),
    flow: a(WK),
    lazy: {},
    string: a(JK),
    text: a(QK)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return u9(i, o, l);
    }
  }
}
function f9(e) {
  for (; !bC(e); )
    ;
  return e;
}
const h_ = /[\0\t\n\r]/g;
function p9() {
  let e = 1, n = "", t = !0, i;
  return a;
  function a(o, s, l) {
    const c = [];
    let m, d, p, v, y;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), p = 0, n = "", t && (o.charCodeAt(0) === 65279 && p++, t = void 0); p < o.length; ) {
      if (h_.lastIndex = p, m = h_.exec(o), v = m && m.index !== void 0 ? m.index : o.length, y = o.charCodeAt(v), !m) {
        n = o.slice(p);
        break;
      }
      if (y === 10 && p === v && i)
        c.push(-3), i = void 0;
      else
        switch (i && (c.push(-5), i = void 0), p < v && (c.push(o.slice(p, v)), e += v - p), y) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, c.push(-2); e++ < d; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      p = v + 1;
    }
    return l && (i && c.push(-5), n && c.push(n), c.push(null)), c;
  }
}
const v9 = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function h9(e) {
  return e.replace(v9, y9);
}
function y9(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const a = t.charCodeAt(1), o = a === 120 || a === 88;
    return vC(t.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Yh(t) || e;
}
function $l(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? y_(e.position) : "start" in e || "end" in e ? y_(e) : "line" in e || "column" in e ? Sv(e) : "";
}
function Sv(e) {
  return g_(e && e.line) + ":" + g_(e && e.column);
}
function y_(e) {
  return Sv(e && e.start) + "-" + Sv(e && e.end);
}
function g_(e) {
  return e && typeof e == "number" ? e : 1;
}
const jC = {}.hasOwnProperty;
function g9(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), k9(t)(f9(m9(t).document().write(p9()(e, n, !0))));
}
function k9(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Ie),
      autolinkProtocol: Y,
      autolinkEmail: Y,
      atxHeading: o(re),
      blockQuote: o($e),
      characterEscape: Y,
      characterReference: Y,
      codeFenced: o(Ye),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Ye, s),
      codeText: o(xe, s),
      codeTextData: Y,
      data: Y,
      codeFlowValue: Y,
      definition: o(Ue),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Be),
      hardBreakEscape: o(be),
      hardBreakTrailing: o(be),
      htmlFlow: o(Ne, s),
      htmlFlowData: Y,
      htmlText: o(Ne, s),
      htmlTextData: Y,
      image: o(Pe),
      label: s,
      link: o(Ie),
      listItem: o(C),
      listItemValue: v,
      listOrdered: o(on, p),
      listUnordered: o(on),
      paragraph: o(k),
      reference: M,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(re),
      strong: o(F),
      thematicBreak: o(X)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: $,
      autolink: c(),
      autolinkEmail: Oe,
      autolinkProtocol: ge,
      blockQuote: c(),
      characterEscapeValue: ee,
      characterReferenceMarkerHexadecimal: Ve,
      characterReferenceMarkerNumeric: Ve,
      characterReferenceValue: Te,
      characterReference: ze,
      codeFenced: c(j),
      codeFencedFence: b,
      codeFencedFenceInfo: y,
      codeFencedFenceMeta: S,
      codeFlowValue: ee,
      codeIndented: c(x),
      codeText: c(ne),
      codeTextData: ee,
      data: ee,
      definition: c(),
      definitionDestinationString: N,
      definitionLabelString: h,
      definitionTitleString: P,
      emphasis: c(),
      hardBreakEscape: c(K),
      hardBreakTrailing: c(K),
      htmlFlow: c(V),
      htmlFlowData: ee,
      htmlText: c(Q),
      htmlTextData: ee,
      image: c(ae),
      label: je,
      labelText: ve,
      lineEnding: J,
      link: c(ce),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: Ae,
      resourceDestinationString: G,
      resourceTitleString: le,
      resource: he,
      setextHeading: c(Z),
      setextHeadingLineSequence: B,
      setextHeadingText: O,
      strong: c(),
      thematicBreak: c()
    }
  };
  CC(n, (e || {}).mdastExtensions || []);
  const t = {};
  return i;
  function i(T) {
    let U = {
      type: "root",
      children: []
    };
    const te = {
      stack: [U],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: d,
      data: t
    }, pe = [];
    let Se = -1;
    for (; ++Se < T.length; )
      if (T[Se][1].type === "listOrdered" || T[Se][1].type === "listUnordered")
        if (T[Se][0] === "enter")
          pe.push(Se);
        else {
          const Ze = pe.pop();
          Se = a(T, Ze, Se);
        }
    for (Se = -1; ++Se < T.length; ) {
      const Ze = n[T[Se][0]];
      jC.call(Ze, T[Se][1].type) && Ze[T[Se][1].type].call(Object.assign({
        sliceSerialize: T[Se][2].sliceSerialize
      }, te), T[Se][1]);
    }
    if (te.tokenStack.length > 0) {
      const Ze = te.tokenStack[te.tokenStack.length - 1];
      (Ze[1] || k_).call(te, void 0, Ze[0]);
    }
    for (U.position = {
      start: ui(T.length > 0 ? T[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: ui(T.length > 0 ? T[T.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Se = -1; ++Se < n.transforms.length; )
      U = n.transforms[Se](U) || U;
    return U;
  }
  function a(T, U, te) {
    let pe = U - 1, Se = -1, Ze = !1, un, en, tn, mn;
    for (; ++pe <= te; ) {
      const cn = T[pe];
      switch (cn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          cn[0] === "enter" ? Se++ : Se--, mn = void 0;
          break;
        }
        case "lineEndingBlank": {
          cn[0] === "enter" && (un && !mn && !Se && !tn && (tn = pe), mn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          mn = void 0;
      }
      if (!Se && cn[0] === "enter" && cn[1].type === "listItemPrefix" || Se === -1 && cn[0] === "exit" && (cn[1].type === "listUnordered" || cn[1].type === "listOrdered")) {
        if (un) {
          let vn = pe;
          for (en = void 0; vn--; ) {
            const Qe = T[vn];
            if (Qe[1].type === "lineEnding" || Qe[1].type === "lineEndingBlank") {
              if (Qe[0] === "exit") continue;
              en && (T[en][1].type = "lineEndingBlank", Ze = !0), Qe[1].type = "lineEnding", en = vn;
            } else if (!(Qe[1].type === "linePrefix" || Qe[1].type === "blockQuotePrefix" || Qe[1].type === "blockQuotePrefixWhitespace" || Qe[1].type === "blockQuoteMarker" || Qe[1].type === "listItemIndent")) break;
          }
          tn && (!en || tn < en) && (un._spread = !0), un.end = Object.assign({}, en ? T[en][1].start : cn[1].end), T.splice(en || pe, 0, ["exit", un, cn[2]]), pe++, te++;
        }
        if (cn[1].type === "listItemPrefix") {
          const vn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, cn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          un = vn, T.splice(pe, 0, ["enter", vn, cn[2]]), pe++, te++, tn = void 0, mn = !0;
        }
      }
    }
    return T[U][1]._spread = Ze, te;
  }
  function o(T, U) {
    return te;
    function te(pe) {
      l.call(this, T(pe), pe), U && U.call(this, pe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(T, U, te) {
    this.stack[this.stack.length - 1].children.push(T), this.stack.push(T), this.tokenStack.push([U, te || void 0]), T.position = {
      start: ui(U.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(T) {
    return U;
    function U(te) {
      T && T.call(this, te), m.call(this, te);
    }
  }
  function m(T, U) {
    const te = this.stack.pop(), pe = this.tokenStack.pop();
    if (pe)
      pe[0].type !== T.type && (U ? U.call(this, T, pe[0]) : (pe[1] || k_).call(this, T, pe[0]));
    else throw new Error("Cannot close `" + T.type + "` (" + $l({
      start: T.start,
      end: T.end
    }) + "): it’s not open");
    te.position.end = ui(T.end);
  }
  function d() {
    return vH(this.stack.pop());
  }
  function p() {
    this.data.expectingFirstListItemValue = !0;
  }
  function v(T) {
    if (this.data.expectingFirstListItemValue) {
      const U = this.stack[this.stack.length - 2];
      U.start = Number.parseInt(this.sliceSerialize(T), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function y() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.lang = T;
  }
  function S() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.meta = T;
  }
  function b() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = T.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function x() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = T.replace(/(\r?\n|\r)$/g, "");
  }
  function h(T) {
    const U = this.resume(), te = this.stack[this.stack.length - 1];
    te.label = U, te.identifier = ba(this.sliceSerialize(T)).toLowerCase();
  }
  function P() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.title = T;
  }
  function N() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.url = T;
  }
  function $(T) {
    const U = this.stack[this.stack.length - 1];
    if (!U.depth) {
      const te = this.sliceSerialize(T).length;
      U.depth = te;
    }
  }
  function O() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function B(T) {
    const U = this.stack[this.stack.length - 1];
    U.depth = this.sliceSerialize(T).codePointAt(0) === 61 ? 1 : 2;
  }
  function Z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Y(T) {
    const te = this.stack[this.stack.length - 1].children;
    let pe = te[te.length - 1];
    (!pe || pe.type !== "text") && (pe = W(), pe.position = {
      start: ui(T.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, te.push(pe)), this.stack.push(pe);
  }
  function ee(T) {
    const U = this.stack.pop();
    U.value += this.sliceSerialize(T), U.position.end = ui(T.end);
  }
  function J(T) {
    const U = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const te = U.children[U.children.length - 1];
      te.position.end = ui(T.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(U.type) && (Y.call(this, T), ee.call(this, T));
  }
  function K() {
    this.data.atHardBreak = !0;
  }
  function V() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = T;
  }
  function Q() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = T;
  }
  function ne() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = T;
  }
  function ce() {
    const T = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const U = this.data.referenceType || "shortcut";
      T.type += "Reference", T.referenceType = U, delete T.url, delete T.title;
    } else
      delete T.identifier, delete T.label;
    this.data.referenceType = void 0;
  }
  function ae() {
    const T = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const U = this.data.referenceType || "shortcut";
      T.type += "Reference", T.referenceType = U, delete T.url, delete T.title;
    } else
      delete T.identifier, delete T.label;
    this.data.referenceType = void 0;
  }
  function ve(T) {
    const U = this.sliceSerialize(T), te = this.stack[this.stack.length - 2];
    te.label = h9(U), te.identifier = ba(U).toLowerCase();
  }
  function je() {
    const T = this.stack[this.stack.length - 1], U = this.resume(), te = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, te.type === "link") {
      const pe = T.children;
      te.children = pe;
    } else
      te.alt = U;
  }
  function G() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.url = T;
  }
  function le() {
    const T = this.resume(), U = this.stack[this.stack.length - 1];
    U.title = T;
  }
  function he() {
    this.data.inReference = void 0;
  }
  function M() {
    this.data.referenceType = "collapsed";
  }
  function Ae(T) {
    const U = this.resume(), te = this.stack[this.stack.length - 1];
    te.label = U, te.identifier = ba(this.sliceSerialize(T)).toLowerCase(), this.data.referenceType = "full";
  }
  function Ve(T) {
    this.data.characterReferenceType = T.type;
  }
  function Te(T) {
    const U = this.sliceSerialize(T), te = this.data.characterReferenceType;
    let pe;
    te ? (pe = vC(U, te === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : pe = Yh(U);
    const Se = this.stack[this.stack.length - 1];
    Se.value += pe;
  }
  function ze(T) {
    const U = this.stack.pop();
    U.position.end = ui(T.end);
  }
  function ge(T) {
    ee.call(this, T);
    const U = this.stack[this.stack.length - 1];
    U.url = this.sliceSerialize(T);
  }
  function Oe(T) {
    ee.call(this, T);
    const U = this.stack[this.stack.length - 1];
    U.url = "mailto:" + this.sliceSerialize(T);
  }
  function $e() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Ye() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function xe() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ue() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Be() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function re() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function be() {
    return {
      type: "break"
    };
  }
  function Ne() {
    return {
      type: "html",
      value: ""
    };
  }
  function Pe() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Ie() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function on(T) {
    return {
      type: "list",
      ordered: T.type === "listOrdered",
      start: null,
      spread: T._spread,
      children: []
    };
  }
  function C(T) {
    return {
      type: "listItem",
      spread: T._spread,
      checked: null,
      children: []
    };
  }
  function k() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function F() {
    return {
      type: "strong",
      children: []
    };
  }
  function W() {
    return {
      type: "text",
      value: ""
    };
  }
  function X() {
    return {
      type: "thematicBreak"
    };
  }
}
function ui(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function CC(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const i = n[t];
    Array.isArray(i) ? CC(e, i) : b9(e, i);
  }
}
function b9(e, n) {
  let t;
  for (t in n)
    if (jC.call(n, t))
      switch (t) {
        case "canContainEols": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "transforms": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[t];
          i && Object.assign(e[t], i);
          break;
        }
      }
}
function k_(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + $l({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + $l({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + $l({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function _9(e) {
  const n = this;
  n.parser = t;
  function t(i) {
    return g9(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function x9(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function S9(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function N9(e, n) {
  const t = n.value ? n.value + `
` : "", i = {};
  n.lang && (i.className = ["language-" + n.lang]);
  let a = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (a.data = { meta: n.meta }), e.patch(n, a), a = e.applyData(n, a), a = { type: "element", tagName: "pre", properties: {}, children: [a] }, e.patch(n, a), a;
}
function w9(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function j9(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function C9(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Ua(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + a,
      id: t + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, c);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function F9(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function I9(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function FC(e, n) {
  const t = n.referenceType;
  let i = "]";
  if (t === "collapsed" ? i += "[]" : t === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function $9(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return FC(e, n);
  const a = { src: Ua(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function E9(e, n) {
  const t = { src: Ua(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function T9(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function O9(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return FC(e, n);
  const a = { href: Ua(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function R9(e, n) {
  const t = { href: Ua(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function D9(e, n, t) {
  const i = e.all(n), a = t ? P9(t) : IC(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const d = i[0];
    let p;
    d && d.type === "element" && d.tagName === "p" ? p = d : (p = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(p)), p.children.length > 0 && p.children.unshift({ type: "text", value: " " }), p.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const d = i[l];
    (a || l !== 0 || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !a ? s.push(...d.children) : s.push(d);
  }
  const c = i[i.length - 1];
  c && (a || c.type !== "element" || c.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function P9(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let i = -1;
    for (; !n && ++i < t.length; )
      n = IC(t[i]);
  }
  return n;
}
function IC(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function A9(e, n) {
  const t = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function L9(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function V9(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function z9(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function M9(e, n) {
  const t = e.all(n), i = t.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (t.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, l = Hh(n.children[1]), c = lC(n.children[n.children.length - 1]);
    l && c && (s.position = { start: l, end: c }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function U9(e, n, t) {
  const i = t ? t.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = t && t.type === "table" ? t.align : void 0, l = s ? s.length : n.children.length;
  let c = -1;
  const m = [];
  for (; ++c < l; ) {
    const p = n.children[c], v = {}, y = s ? s[c] : void 0;
    y && (v.align = y);
    let S = { type: "element", tagName: o, properties: v, children: [] };
    p && (S.children = e.all(p), e.patch(p, S), S = e.applyData(p, S)), m.push(S);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, d), e.applyData(n, d);
}
function B9(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const b_ = 9, __ = 32;
function q9(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let i = t.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      x_(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = t.exec(n);
  return o.push(x_(n.slice(a), a > 0, !1)), o.join("");
}
function x_(e, n, t) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === b_ || o === __; )
      i++, o = e.codePointAt(i);
  }
  if (t) {
    let o = e.codePointAt(a - 1);
    for (; o === b_ || o === __; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function H9(e, n) {
  const t = { type: "text", value: q9(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function K9(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const W9 = {
  blockquote: x9,
  break: S9,
  code: N9,
  delete: w9,
  emphasis: j9,
  footnoteReference: C9,
  heading: F9,
  html: I9,
  imageReference: $9,
  image: E9,
  inlineCode: T9,
  linkReference: O9,
  link: R9,
  listItem: D9,
  list: A9,
  paragraph: L9,
  // @ts-expect-error: root is different, but hard to type.
  root: V9,
  strong: z9,
  table: M9,
  tableCell: B9,
  tableRow: U9,
  text: H9,
  thematicBreak: K9,
  toml: Js,
  yaml: Js,
  definition: Js,
  footnoteDefinition: Js
};
function Js() {
}
const $C = -1, Ku = 0, nu = 1, tu = 2, Xh = 3, Zh = 4, ey = 5, ny = 6, EC = 7, TC = 8, S_ = typeof self == "object" ? self : globalThis, G9 = (e, n) => {
  const t = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Ku:
      case $C:
        return t(s, a);
      case nu: {
        const l = t([], a);
        for (const c of s)
          l.push(i(c));
        return l;
      }
      case tu: {
        const l = t({}, a);
        for (const [c, m] of s)
          l[i(c)] = i(m);
        return l;
      }
      case Xh:
        return t(new Date(s), a);
      case Zh: {
        const { source: l, flags: c } = s;
        return t(new RegExp(l, c), a);
      }
      case ey: {
        const l = t(/* @__PURE__ */ new Map(), a);
        for (const [c, m] of s)
          l.set(i(c), i(m));
        return l;
      }
      case ny: {
        const l = t(/* @__PURE__ */ new Set(), a);
        for (const c of s)
          l.add(i(c));
        return l;
      }
      case EC: {
        const { name: l, message: c } = s;
        return t(new S_[l](c), a);
      }
      case TC:
        return t(BigInt(s), a);
      case "BigInt":
        return t(Object(BigInt(s)), a);
    }
    return t(new S_[o](s), a);
  };
  return i;
}, N_ = (e) => G9(/* @__PURE__ */ new Map(), e)(0), ia = "", { toString: Y9 } = {}, { keys: J9 } = Object, co = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Ku, n];
  const t = Y9.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [nu, ia];
    case "Object":
      return [tu, ia];
    case "Date":
      return [Xh, ia];
    case "RegExp":
      return [Zh, ia];
    case "Map":
      return [ey, ia];
    case "Set":
      return [ny, ia];
  }
  return t.includes("Array") ? [nu, t] : t.includes("Error") ? [EC, t] : [tu, t];
}, Qs = ([e, n]) => e === Ku && (n === "function" || n === "symbol"), Q9 = (e, n, t, i) => {
  const a = (s, l) => {
    const c = i.push(s) - 1;
    return t.set(l, c), c;
  }, o = (s) => {
    if (t.has(s))
      return t.get(s);
    let [l, c] = co(s);
    switch (l) {
      case Ku: {
        let d = s;
        switch (c) {
          case "bigint":
            l = TC, d = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            d = null;
            break;
          case "undefined":
            return a([$C], s);
        }
        return a([l, d], s);
      }
      case nu: {
        if (c)
          return a([c, [...s]], s);
        const d = [], p = a([l, d], s);
        for (const v of s)
          d.push(o(v));
        return p;
      }
      case tu: {
        if (c)
          switch (c) {
            case "BigInt":
              return a([c, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([c, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const d = [], p = a([l, d], s);
        for (const v of J9(s))
          (e || !Qs(co(s[v]))) && d.push([o(v), o(s[v])]);
        return p;
      }
      case Xh:
        return a([l, s.toISOString()], s);
      case Zh: {
        const { source: d, flags: p } = s;
        return a([l, { source: d, flags: p }], s);
      }
      case ey: {
        const d = [], p = a([l, d], s);
        for (const [v, y] of s)
          (e || !(Qs(co(v)) || Qs(co(y)))) && d.push([o(v), o(y)]);
        return p;
      }
      case ny: {
        const d = [], p = a([l, d], s);
        for (const v of s)
          (e || !Qs(co(v))) && d.push(o(v));
        return p;
      }
    }
    const { message: m } = s;
    return a([l, { name: c, message: m }], s);
  };
  return o;
}, w_ = (e, { json: n, lossy: t } = {}) => {
  const i = [];
  return Q9(!(n || t), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, ru = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? N_(w_(e, n)) : structuredClone(e)
) : (e, n) => N_(w_(e, n));
function X9(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function Z9(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function e7(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || X9, i = e.options.footnoteBackLabel || Z9, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!m)
      continue;
    const d = e.all(m), p = String(m.identifier).toUpperCase(), v = Ua(p.toLowerCase());
    let y = 0;
    const S = [], b = e.footnoteCounts.get(p);
    for (; b !== void 0 && ++y <= b; ) {
      S.length > 0 && S.push({ type: "text", value: " " });
      let h = typeof t == "string" ? t : t(c, y);
      typeof h == "string" && (h = { type: "text", value: h }), S.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + v + (y > 1 ? "-" + y : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(c, y),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(h) ? h : [h]
      });
    }
    const j = d[d.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const h = j.children[j.children.length - 1];
      h && h.type === "text" ? h.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...S);
    } else
      d.push(...S);
    const x = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + v },
      children: e.wrap(d, !0)
    };
    e.patch(m, x), l.push(x);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...ru(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const OC = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return i7;
    if (typeof e == "function")
      return Wu(e);
    if (typeof e == "object")
      return Array.isArray(e) ? n7(e) : t7(e);
    if (typeof e == "string")
      return r7(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function n7(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = OC(e[t]);
  return Wu(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function t7(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Wu(t);
  function t(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function r7(e) {
  return Wu(n);
  function n(t) {
    return t && t.type === e;
  }
}
function Wu(e) {
  return n;
  function n(t, i, a) {
    return !!(a7(t) && e.call(
      this,
      t,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function i7() {
  return !0;
}
function a7(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const RC = [], o7 = !0, j_ = !1, s7 = "skip";
function l7(e, n, t, i) {
  let a;
  typeof n == "function" && typeof t != "function" ? (i = t, t = n) : a = n;
  const o = OC(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(c, m, d) {
    const p = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof p.type == "string") {
      const y = (
        // `hast`
        typeof p.tagName == "string" ? p.tagName : (
          // `xast`
          typeof p.name == "string" ? p.name : void 0
        )
      );
      Object.defineProperty(v, "name", {
        value: "node (" + (c.type + (y ? "<" + y + ">" : "")) + ")"
      });
    }
    return v;
    function v() {
      let y = RC, S, b, j;
      if ((!n || o(c, m, d[d.length - 1] || void 0)) && (y = u7(t(c, d)), y[0] === j_))
        return y;
      if ("children" in c && c.children) {
        const x = (
          /** @type {UnistParent} */
          c
        );
        if (x.children && y[0] !== s7)
          for (b = (i ? x.children.length : -1) + s, j = d.concat(x); b > -1 && b < x.children.length; ) {
            const h = x.children[b];
            if (S = l(h, b, j)(), S[0] === j_)
              return S;
            b = typeof S[1] == "number" ? S[1] : b + s;
          }
      }
      return y;
    }
  }
}
function u7(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [o7, e] : e == null ? RC : [e];
}
function DC(e, n, t, i) {
  let a, o, s;
  typeof n == "function" ? (o = void 0, s = n, a = t) : (o = n, s = t, a = i), l7(e, o, l, a);
  function l(c, m) {
    const d = m[m.length - 1], p = d ? d.children.indexOf(c) : void 0;
    return s(c, p, d);
  }
}
const Nv = {}.hasOwnProperty, c7 = {};
function d7(e, n) {
  const t = n || c7, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...W9, ...t.handlers }, l = {
    all: m,
    applyData: f7,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: c,
    options: t,
    patch: m7,
    wrap: v7
  };
  return DC(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const p = d.type === "definition" ? i : a, v = String(d.identifier).toUpperCase();
      p.has(v) || p.set(v, d);
    }
  }), l;
  function c(d, p) {
    const v = d.type, y = l.handlers[v];
    if (Nv.call(l.handlers, v) && y)
      return y(l, d, p);
    if (l.options.passThrough && l.options.passThrough.includes(v)) {
      if ("children" in d) {
        const { children: b, ...j } = d, x = ru(j);
        return x.children = l.all(d), x;
      }
      return ru(d);
    }
    return (l.options.unknownHandler || p7)(l, d, p);
  }
  function m(d) {
    const p = [];
    if ("children" in d) {
      const v = d.children;
      let y = -1;
      for (; ++y < v.length; ) {
        const S = l.one(v[y], d);
        if (S) {
          if (y && v[y - 1].type === "break" && (!Array.isArray(S) && S.type === "text" && (S.value = C_(S.value)), !Array.isArray(S) && S.type === "element")) {
            const b = S.children[0];
            b && b.type === "text" && (b.value = C_(b.value));
          }
          Array.isArray(S) ? p.push(...S) : p.push(S);
        }
      }
    }
    return p;
  }
}
function m7(e, n) {
  e.position && (n.position = q6(e));
}
function f7(e, n) {
  let t = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (t.type === "element")
        t.tagName = i;
      else {
        const s = "children" in t ? t.children : [t];
        t = { type: "element", tagName: i, properties: {}, children: s };
      }
    t.type === "element" && o && Object.assign(t.properties, ru(o)), "children" in t && t.children && a !== null && a !== void 0 && (t.children = a);
  }
  return t;
}
function p7(e, n) {
  const t = n.data || {}, i = "value" in n && !(Nv.call(t, "hProperties") || Nv.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function v7(e, n) {
  const t = [];
  let i = -1;
  for (n && t.push({ type: "text", value: `
` }); ++i < e.length; )
    i && t.push({ type: "text", value: `
` }), t.push(e[i]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function C_(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function F_(e, n) {
  const t = d7(e, n), i = t.one(e, void 0), a = e7(t), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function h7(e, n) {
  return e && "run" in e ? async function(t, i) {
    const a = (
      /** @type {HastRoot} */
      F_(t, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(t, i) {
    return (
      /** @type {HastRoot} */
      F_(t, { file: i, ...e || n })
    );
  };
}
function I_(e) {
  if (e)
    throw e;
}
var vd, $_;
function y7() {
  if ($_) return vd;
  $_ = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, t = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var d = e.call(m, "constructor"), p = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !d && !p)
      return !1;
    var v;
    for (v in m)
      ;
    return typeof v > "u" || e.call(m, v);
  }, s = function(m, d) {
    t && d.name === "__proto__" ? t(m, d.name, {
      enumerable: !0,
      configurable: !0,
      value: d.newValue,
      writable: !0
    }) : m[d.name] = d.newValue;
  }, l = function(m, d) {
    if (d === "__proto__")
      if (e.call(m, d)) {
        if (i)
          return i(m, d).value;
      } else return;
    return m[d];
  };
  return vd = function c() {
    var m, d, p, v, y, S, b = arguments[0], j = 1, x = arguments.length, h = !1;
    for (typeof b == "boolean" && (h = b, b = arguments[1] || {}, j = 2), (b == null || typeof b != "object" && typeof b != "function") && (b = {}); j < x; ++j)
      if (m = arguments[j], m != null)
        for (d in m)
          p = l(b, d), v = l(m, d), b !== v && (h && v && (o(v) || (y = a(v))) ? (y ? (y = !1, S = p && a(p) ? p : []) : S = p && o(p) ? p : {}, s(b, { name: d, newValue: c(h, S, v) })) : typeof v < "u" && s(b, { name: d, newValue: v }));
    return b;
  }, vd;
}
var g7 = y7();
const hd = /* @__PURE__ */ Uv(g7);
function wv(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function k7() {
  const e = [], n = { run: t, use: i };
  return n;
  function t(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(c, ...m) {
      const d = e[++o];
      let p = -1;
      if (c) {
        s(c);
        return;
      }
      for (; ++p < a.length; )
        (m[p] === null || m[p] === void 0) && (m[p] = a[p]);
      a = m, d ? b7(d, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function b7(e, n) {
  let t;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let c;
    l && s.push(a);
    try {
      c = e.apply(this, s);
    } catch (m) {
      const d = (
        /** @type {Error} */
        m
      );
      if (l && t)
        throw d;
      return a(d);
    }
    l || (c instanceof Promise ? c.then(o, a) : c instanceof Error ? a(c) : o(c));
  }
  function a(s, ...l) {
    t || (t = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Pr = { basename: _7, dirname: x7, extname: S7, join: N7, sep: "/" };
function _7(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  _s(e);
  let t = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          t = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(t, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        t = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return t === i ? i = s : i < 0 && (i = e.length), e.slice(t, i);
}
function x7(e) {
  if (_s(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, i;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (i) {
        n = t;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function S7(e) {
  _s(e);
  let n = e.length, t = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (s = !0, t = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === t - 1 && a === i + 1 ? "" : e.slice(a, t);
}
function N7(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    _s(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : w7(t);
}
function w7(e) {
  _s(e);
  const n = e.codePointAt(0) === 47;
  let t = j7(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function j7(e, n) {
  let t = "", i = 0, a = -1, o = 0, s = -1, l, c;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (t.length < 2 || i !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (c = t.lastIndexOf("/"), c !== t.length - 1) {
              c < 0 ? (t = "", i = 0) : (t = t.slice(0, c), i = t.length - 1 - t.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", i = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(a + 1, s) : t = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return t;
}
function _s(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const C7 = { cwd: F7 };
function F7() {
  return "/";
}
function jv(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function I7(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!jv(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return $7(e);
}
function $7(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const i = n.codePointAt(t + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const yd = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class PC {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? jv(n) ? t = { path: n } : typeof n == "string" || E7(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : C7.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < yd.length; ) {
      const o = yd[i];
      o in t && t[o] !== void 0 && t[o] !== null && (this[o] = o === "history" ? [...t[o]] : t[o]);
    }
    let a;
    for (a in t)
      yd.includes(a) || (this[a] = t[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Pr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    kd(n, "basename"), gd(n, "basename"), this.path = Pr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Pr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    E_(this.basename, "dirname"), this.path = Pr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Pr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (gd(n, "extname"), E_(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Pr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    jv(n) && (n = I7(n)), kd(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Pr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    kd(n, "stem"), gd(n, "stem"), this.path = Pr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, i) {
    const a = this.message(n, t, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, i) {
    const a = this.message(n, t, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, i) {
    const a = new Ft(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function gd(e, n) {
  if (e && e.includes(Pr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Pr.sep + "`"
    );
}
function kd(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function E_(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function E7(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const T7 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  }
), O7 = {}.hasOwnProperty;
class ty extends T7 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = k7();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new ty()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const i = this.attachers[t];
      n.use(...i);
    }
    return n.data(hd(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (xd("data", this.frozen), this.namespace[n] = t, this) : O7.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (xd("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = t.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = Xs(n), i = this.parser || this.Parser;
    return bd("parse", i), i(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const i = this;
    return this.freeze(), bd("process", this.parser || this.Parser), _d("process", this.compiler || this.Compiler), t ? a(void 0, t) : new Promise(a);
    function a(o, s) {
      const l = Xs(n), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(c, l, function(d, p, v) {
        if (d || !p || !v)
          return m(d);
        const y = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          p
        ), S = i.stringify(y, v);
        P7(S) ? v.value = S : v.result = S, m(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          v
        );
      });
      function m(d, p) {
        d || !p ? s(d) : o ? o(p) : t(void 0, p);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, i;
    return this.freeze(), bd("processSync", this.parser || this.Parser), _d("processSync", this.compiler || this.Compiler), this.process(n, a), O_("processSync", "process", t), i;
    function a(o, s) {
      t = !0, I_(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, i) {
    T_(n), this.freeze();
    const a = this.transformers;
    return !i && typeof t == "function" && (i = t, t = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const c = Xs(t);
      a.run(n, c, m);
      function m(d, p, v) {
        const y = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          p || n
        );
        d ? l(d) : s ? s(y) : i(void 0, y, v);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let i = !1, a;
    return this.run(n, t, o), O_("runSync", "run", i), a;
    function o(s, l) {
      I_(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const i = Xs(t), a = this.compiler || this.Compiler;
    return _d("stringify", a), T_(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const i = this.attachers, a = this.namespace;
    if (xd("use", this.frozen), n != null) if (typeof n == "function")
      c(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        c(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [d, ...p] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          c(d, p);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = hd(!0, a.settings, m.settings));
    }
    function l(m) {
      let d = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++d < m.length; ) {
          const p = m[d];
          o(p);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function c(m, d) {
      let p = -1, v = -1;
      for (; ++p < i.length; )
        if (i[p][0] === m) {
          v = p;
          break;
        }
      if (v === -1)
        i.push([m, ...d]);
      else if (d.length > 0) {
        let [y, ...S] = d;
        const b = i[v][1];
        wv(b) && wv(y) && (y = hd(!0, b, y)), i[v] = [m, y, ...S];
      }
    }
  }
}
const R7 = new ty().freeze();
function bd(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function _d(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function xd(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function T_(e) {
  if (!wv(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function O_(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Xs(e) {
  return D7(e) ? e : new PC(e);
}
function D7(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function P7(e) {
  return typeof e == "string" || A7(e);
}
function A7(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const L7 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", R_ = [], D_ = { allowDangerousHtml: !0 }, V7 = /^(https?|ircs?|mailto|xmpp)$/i, z7 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function M7(e) {
  const n = e.allowedElements, t = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || R_, c = e.remarkPlugins || R_, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...D_ } : D_, d = e.skipHtml, p = e.unwrapDisallowed, v = e.urlTransform || U7, y = R7().use(_9).use(c).use(h7, m).use(l), S = new PC();
  typeof i == "string" && (S.value = i);
  for (const h of z7)
    Object.hasOwn(e, h.from) && ("" + h.from + (h.to ? "use `" + h.to + "` instead" : "remove it") + L7 + h.id, void 0);
  const b = y.parse(S);
  let j = y.runSync(b, S);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), DC(j, x), Q6(j, {
    Fragment: qe.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: qe.jsx,
    jsxs: qe.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function x(h, P, N) {
    if (h.type === "raw" && N && typeof P == "number")
      return d ? N.children.splice(P, 1) : N.children[P] = { type: "text", value: h.value }, P;
    if (h.type === "element") {
      let $;
      for ($ in md)
        if (Object.hasOwn(md, $) && Object.hasOwn(h.properties, $)) {
          const O = h.properties[$], B = md[$];
          (B === null || B.includes(h.tagName)) && (h.properties[$] = v(String(O || ""), $, h));
        }
    }
    if (h.type === "element") {
      let $ = n ? !n.includes(h.tagName) : s ? s.includes(h.tagName) : !1;
      if (!$ && t && typeof P == "number" && ($ = !t(h, P, N)), $ && N && typeof P == "number")
        return p && h.children ? N.children.splice(P, 1, ...h.children) : N.children.splice(P, 1), P;
    }
  }
}
function U7(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || t > -1 && n > t || i > -1 && n > i || // It is a protocol, it should be allowed.
    V7.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Sd = { exports: {} }, mo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var P_;
function B7() {
  if (P_) return mo;
  P_ = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return mo.Fragment = t, mo.jsx = s, mo.jsxs = s, mo;
}
var Zs = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var A_;
function q7() {
  return A_ || (A_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    Zs.Fragment = i, Zs.jsx = Mn, Zs.jsxs = Un;
  }()), Zs;
}
var L_;
function H7() {
  return L_ || (L_ = 1, process.env.NODE_ENV === "production" ? Sd.exports = B7() : Sd.exports = q7()), Sd.exports;
}
var oe = H7();
const K7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, W7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, G7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, Y7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "or" }, value: { kind: "ListValue", values: [{ kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "containsIgnoreCase" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }] } }] }, { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "containsIgnoreCase" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }] } }] }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, J7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, Q7 = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": K7,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": W7,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": G7,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      issues(\n        first:$first\n        after:$after\n        filter: {\n          or: [\n            { title: { containsIgnoreCase: $issueQuery } }\n            { description: { containsIgnoreCase: $issueQuery } }\n          ]\n        }\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": Y7,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": J7
};
function xs(e) {
  return Q7[e] ?? {};
}
const X7 = xs(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      issues(
        first:$first
        after:$after
        filter: {
          or: [
            { title: { containsIgnoreCase: $issueQuery } }
            { description: { containsIgnoreCase: $issueQuery } }
          ]
        }
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), Z7 = xs(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), el = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(_, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(q.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), eW = "_issueAvatar_kc0sw_1", nW = "_issueField_kc0sw_9", tW = "_issueDescription_kc0sw_12", nl = {
  issueAvatar: eW,
  issueField: nW,
  issueDescription: tW
}, AC = ({ issue: e }) => {
  var n, t;
  return /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
    /* @__PURE__ */ oe.jsx(el, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
      _,
      {
        gap: "200",
        flexDirection: "row",
        alignContent: "center",
        className: nl.issueAvatar,
        children: [
          /* @__PURE__ */ oe.jsx(
            Mv,
            {
              size: "24",
              user: e.assignee ? {
                name: e.assignee.name || null,
                // eslint-disable-next-line camelcase
                avatar_url: e.assignee.avatarUrl || null,
                email: e.assignee.email
              } : void 0
            }
          ),
          /* @__PURE__ */ oe.jsx(q.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
        ]
      }
    ) }),
    ((n = e.team) == null ? void 0 : n.name) && /* @__PURE__ */ oe.jsx(el, { title: "Team", children: /* @__PURE__ */ oe.jsx(
      q.Paragraph,
      {
        variant: "3",
        color: "neutral.800",
        className: nl.issueField,
        children: e.team.name
      }
    ) }),
    ((t = e.project) == null ? void 0 : t.name) && /* @__PURE__ */ oe.jsx(el, { title: "Project", children: /* @__PURE__ */ oe.jsx(
      q.Paragraph,
      {
        variant: "3",
        color: "neutral.800",
        className: nl.issueField,
        children: e.project.name
      }
    ) }),
    /* @__PURE__ */ oe.jsx(el, { title: "Description", children: /* @__PURE__ */ oe.jsx(M7, { className: nl.issueDescription, children: e.description }) })
  ] });
}, rW = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), iW = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), aW = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), oW = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), sW = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), LC = {
  0: rW,
  1: sW,
  2: oW,
  3: aW,
  4: iW
}, lW = (e) => e in LC, iu = ({ priority: e }) => lW(e) ? LC[e] : /* @__PURE__ */ oe.jsx(Dn, { "data-testid": "defaultPriorityTag", children: e }), uW = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), cW = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), dW = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), mW = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), fW = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), pW = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Cv = {
  backlog: (e, n) => uW(e, n),
  unstarted: (e, n) => cW(e, n),
  started: (e, n) => dW(e, n),
  done: (e, n) => mW(e, n),
  canceled: (e, n) => fW(e, n),
  completed: (e, n) => pW(e, n)
}, vW = (e) => e in Cv, au = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: t = "linear-backlog-icon"
}) => vW(e) ? Cv[e](n, t) : Cv.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), hW = "_wrapper_e0qj3_1", yW = "_resultTitle_e0qj3_21", gW = "_resultTooltipTitle_e0qj3_28", kW = "_resultLinkIcon_e0qj3_31", fo = {
  wrapper: hW,
  resultTitle: yW,
  resultTooltipTitle: gW,
  resultLinkIcon: kW
}, bW = ({
  issue: e
}) => {
  const [n, t] = me(!1);
  return /* @__PURE__ */ oe.jsx(
    nn,
    {
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(_, { flexDirection: "column", gap: "300", className: fo.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(_, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(_, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              au,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(q.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(iu, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(Dn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(_, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            q.Heading,
            {
              variant: "heading-3",
              className: fo.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(AC, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        Bt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: fo.result,
          onMouseEnter: () => t(!0),
          onMouseLeave: () => t(!1),
          "data-testid": "selectionListItemWrapper",
          children: /* @__PURE__ */ oe.jsxs(
            _,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(_, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    au,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(q.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(iu, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(q.Paragraph, { variant: "4", className: fo.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  ye,
                  {
                    className: fo.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, _W = "_loader_13xpk_1", xW = "_dropdown_13xpk_8", SW = "_loadMore_13xpk_13", Nd = {
  loader: _W,
  dropdown: xW,
  loadMore: SW
}, NW = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [t, i] = me(), [a, o] = me([]), [s, l] = me(""), [c, m] = me(!1), { useLazyQuery: d } = pn(), [p, { data: v, loading: y, networkStatus: S }] = d(
    X7,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Va(
    () => {
      !y && s !== "" && S === cr.ready ? p({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Ge(() => {
    y || o([]);
  }, [s]), Ge(() => {
    var j, x, h;
    if (v && Object.keys(v).length > 0) {
      const P = v.Linear.issues.edges.map(
        ({ node: B }) => B
      ), N = a.filter(
        (B) => !n.find((Z) => Z.id === B.id)
      ), $ = N.filter(
        (B) => !P.find(
          (Z) => Z.id === B.id
        )
      ), O = P.filter(
        (B) => !n.find((Z) => Z.id === B.id)
      );
      n.length > 0 ? o(
        c ? [...$, ...O] : O
      ) : (x = (j = v == null ? void 0 : v.Linear) == null ? void 0 : j.issues) != null && x.edges && o(
        c ? [...N, ...P] : P
      ), v.Linear.issues.pageInfo.hasNextPage && m(!1), i((h = v.Linear.issues) == null ? void 0 : h.pageInfo);
    }
  }, [v, n]);
  const b = () => {
    !y && s !== "" && S === cr.ready ? (m(!0), p({
      variables: {
        issueQuery: s,
        first: 8,
        after: t == null ? void 0 : t.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(_, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    ni,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j == null ? void 0 : j.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: Nd.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const x = j.target.value;
          l(x);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a == null ? void 0 : a.map((j) => /* @__PURE__ */ oe.jsx(bW, { issue: j }, j.id)),
        (t == null ? void 0 : t.hasNextPage) && !y && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          _,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => b(),
            className: Nd.loadMore,
            children: /* @__PURE__ */ oe.jsx(q.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        y && s !== "" && /* @__PURE__ */ oe.jsx(_, { justifyContent: "center", className: Nd.loader, children: /* @__PURE__ */ oe.jsx(fn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          _,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(q.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !y && /* @__PURE__ */ oe.jsx(
          _,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(q.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, wW = "_collapse_su0f9_1", jW = "_collapseHeader_su0f9_8", CW = "_collapseContent_su0f9_31", FW = "_url_su0f9_35", IW = "_externalLink_su0f9_51", $W = "_emptyState_su0f9_55", ci = {
  collapse: wW,
  collapseHeader: jW,
  collapseContent: CW,
  url: FW,
  externalLink: IW,
  emptyState: $W
}, EW = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: t,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (d, p) => ({ ...d, [p.id]: !1 }),
    {}
  ), [l, c] = me(s), { track: m } = bn();
  return n ? /* @__PURE__ */ oe.jsx(
    _,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(fn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    _,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          q.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: ci.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Ct,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ye, { name: "external-link" }),
            variant: "tertiary",
            className: ci.externalLink,
            navigate: () => {
              var d, p, v;
              return (v = window.open(
                `https://linear.app/${((p = (d = e[0]) == null ? void 0 : d.team) == null ? void 0 : p.organization.urlKey) ?? ""}`,
                "_blank"
              )) == null ? void 0 : v.focus();
            },
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    _,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((d) => {
          var p, v, y;
          const S = l[d.id];
          return /* @__PURE__ */ oe.jsxs(
            lr,
            {
              "data-testid": "collapseCard",
              onToggle: () => c({ ...l, [d.id]: !l[d.id] }),
              isOpen: S,
              className: ci.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(lr.Header, { className: ci.collapseHeader, children: /* @__PURE__ */ oe.jsxs(_, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(_, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(_, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(nn, { content: /* @__PURE__ */ oe.jsx(_, { children: d.state.name }), children: /* @__PURE__ */ oe.jsx(_, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        au,
                        {
                          type: d.state.type,
                          color: d.state.color,
                          name: d.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        q.ExternalLink,
                        {
                          className: ci.url,
                          href: d.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            d.identifier,
                            /* @__PURE__ */ oe.jsx(ye, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(nn, { content: /* @__PURE__ */ oe.jsx(_, { children: d.priorityLabel }), children: /* @__PURE__ */ oe.jsx(_, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(iu, { priority: d.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(Dn, { children: d.state.name })
                  ] }),
                  d.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(lr.Content, { className: ci.collapseContent, children: /* @__PURE__ */ oe.jsxs(_, { flexDirection: "column", gap: "300", children: [
                  (d == null ? void 0 : d.labels) && ((v = (p = d == null ? void 0 : d.labels) == null ? void 0 : p.edges) == null ? void 0 : v.length) > 0 && /* @__PURE__ */ oe.jsx(
                    _,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: (y = d.labels) == null ? void 0 : y.edges.map((b) => /* @__PURE__ */ oe.jsx(Dn, { color: b.node.color, children: b.node.name }, b.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(AC, { issue: d }),
                  /* @__PURE__ */ oe.jsx(
                    Qn,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(ye, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => t(d.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    Ct,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(ye, { name: "external-link" }),
                      variant: "tertiary",
                      className: ci.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: d.id
                        });
                      },
                      navigate: () => {
                        var b;
                        return (b = window.open(d.url, "_blank")) == null ? void 0 : b.focus();
                      },
                      children: [
                        "View ",
                        d.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            d.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          Qn,
          {
            slotStart: /* @__PURE__ */ oe.jsx(ye, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Ct,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ye, { name: "external-link" }),
            variant: "tertiary",
            className: ci.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => {
              var d;
              return (d = window.open(o, "_blank")) == null ? void 0 : d.focus();
            },
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, TW = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => {
      var t;
      return `
${"#".repeat(
        parseInt((t = e.attrs) == null ? void 0 : t.level) || 1
      )} ${n()}

`;
    },
    bullet_list: (e, n) => `
` + n().map((t) => `- ${t}`).join(""),
    ordered_list: (e, n) => `
` + n().map((t) => `1. ${t}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => {
      var t;
      return "\n```" + (((t = e.attrs) == null ? void 0 : t.language) || "") + `
` + n() + "\n```\n";
    }
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        var t;
        switch ((t = e.attrs) == null ? void 0 : t.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => {
        var t;
        return `[${n()}](${(t = e.attrs) == null ? void 0 : t.href})`;
      },
      code: (e, n) => `\`${n()}\``
    }
  }
}, VC = (e, n) => {
  const t = (o) => (e.marks || []).map((s) => {
    var l;
    return {
      formatterFunction: (l = n.marks[e.type]) == null ? void 0 : l[s.type],
      mark: s
    };
  }).reduce(
    (s, l) => () => {
      var c;
      return ((c = l.formatterFunction) == null ? void 0 : c.call(l, l.mark, s)) || o;
    },
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => VC(l, s)) : [], a = n.nodes[e.type] || n.default;
  return t(
    a(e, i(e, n))
  );
}, OW = "_modalBody_iv3ua_1", RW = "_error_iv3ua_5", DW = "_dropdown_iv3ua_16", aa = {
  modalBody: OW,
  error: RW,
  dropdown: DW
}, PW = xs(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), AW = xs(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), LW = xs(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), VW = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: t,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: c } = pn(), { control: m, handleSubmit: d, reset: p } = xi(), [v, y] = me([]), [S, b] = me(), [j, x] = me([]), [h, P] = me(), [N, $] = me([]), [O, B] = me(), [Z, Y] = me([]), [ee, J] = me(), [K, V] = me([]), [Q, ne] = me(), [ce, ae] = me(!1), { useMutation: ve } = pn(), { track: je } = bn(), [G, { loading: le }] = ve(
    PW,
    {
      onError: () => c({
        title: "Creation was not successful",
        text: "Please try again later or contact your admin.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }),
      onCompleted: (xe) => {
        var Ue, Be, re, be, Ne, Pe, Ie, on, C, k, F, W;
        const X = {
          identifier: (re = (Be = (Ue = xe.Linear) == null ? void 0 : Ue.issueCreate) == null ? void 0 : Be.issue) == null ? void 0 : re.identifier,
          url: (Pe = (Ne = (be = xe.Linear) == null ? void 0 : be.issueCreate) == null ? void 0 : Ne.issue) == null ? void 0 : Pe.url
        };
        xe.Linear && !le && (C = (on = (Ie = xe.Linear) == null ? void 0 : Ie.issueCreate) == null ? void 0 : on.issue) != null && C.id && (a((W = (F = (k = xe.Linear) == null ? void 0 : k.issueCreate) == null ? void 0 : F.issue) == null ? void 0 : W.id), Oe(X), ae(!1), c({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${xe.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), je("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    he,
    { data: M, loading: Ae, error: Ve }
  ] = l(AW, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => c({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (xe) => {
      const Ue = xe.Linear.teams.edges.map(
        ({ node: Be }) => Be
      );
      y(Ue), Y(xe.Linear.issuePriorityValues), s(`${GW}${xe.Linear.organization.urlKey}`);
    }
  }), [Te, { data: ze, loading: ge }] = l(LW, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => c({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (xe) => {
      var Ue, Be, re, be, Ne, Pe, Ie, on, C, k, F, W;
      const X = (be = (re = (Be = (Ue = xe == null ? void 0 : xe.Linear) == null ? void 0 : Ue.team) == null ? void 0 : Be.projects) == null ? void 0 : re.edges) == null ? void 0 : be.map(
        ({ node: te }) => te
      );
      x(X);
      const T = (on = (Ie = (Pe = (Ne = xe == null ? void 0 : xe.Linear) == null ? void 0 : Ne.team) == null ? void 0 : Pe.states) == null ? void 0 : Ie.edges) == null ? void 0 : on.map(
        ({ node: te }) => te
      );
      $(T);
      const U = (W = (F = (k = (C = xe == null ? void 0 : xe.Linear) == null ? void 0 : C.team) == null ? void 0 : k.templates) == null ? void 0 : F.edges) == null ? void 0 : W.map(
        ({ node: te }) => te
      );
      V(
        U.filter(
          (te) => te.type === "issue"
        )
      );
    }
  }), Oe = (xe) => {
    t(!1), P(void 0), b(void 0), B(void 0), J(void 0), ne(void 0), xe && (e(xe), i(!0)), p({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, $e = (xe) => {
    var Ue, Be, re;
    M && !Ae && (G({
      variables: {
        issueTitle: xe.title,
        issueDescription: xe == null ? void 0 : xe.description,
        teamId: xe.team.id,
        projectId: (Ue = xe == null ? void 0 : xe.project) == null ? void 0 : Ue.id,
        statusId: (Be = xe == null ? void 0 : xe.status) == null ? void 0 : Be.id,
        priority: (re = xe == null ? void 0 : xe.priority) == null ? void 0 : re.priority
      }
    }), ae(!0));
  };
  Ge(() => {
    n && he();
  }, [n]);
  const Ye = () => {
    je("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    Ht,
    {
      isOpen: n,
      onClose: () => {
        Ye(), Oe();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          Kt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Ye(), Oe();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Wt,
          {
            className: aa.modalBody,
            "data-testid": "createIssueModalBody",
            children: Ve ? /* @__PURE__ */ oe.jsx(Fn, { error: Ve }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: d($e), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(Ir, { children: [
              /* @__PURE__ */ oe.jsx(ln, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Ut,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: xe, onChange: Ue },
                    fieldState: { error: Be }
                  }) => /* @__PURE__ */ oe.jsx(
                    Vn,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: (Be == null ? void 0 : Be.message) ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        ni,
                        {
                          dropdownProps: { className: aa.dropdown },
                          placeholder: "Select Linear team",
                          className: ct({ [aa.error]: Be }),
                          getItemTitleByValue: (re) => re == null ? void 0 : re.name,
                          onChange: (re) => {
                            P(void 0), B(void 0), J(void 0), ne(void 0), b(re.selectedValues[0]), Te({
                              variables: { teamId: re.selectedValues[0].id }
                            }), Ue(re.selectedValues[0]);
                          },
                          value: S ? [xe] : void 0,
                          children: v == null ? void 0 : v.map((re) => /* @__PURE__ */ oe.jsx(
                            Bt.Item,
                            {
                              value: re,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(q.Paragraph, { children: re.name })
                            },
                            re.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ln, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Ut,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: xe, onChange: Ue } }) => {
                    const Be = ge ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(Vn, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      ni,
                      {
                        dropdownProps: { className: aa.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (re) => re == null ? void 0 : re.name,
                        disabled: S === void 0,
                        placeholder: S ? "Select Linear project" : "Select a Team first",
                        onChange: (re) => {
                          P(re.selectedValues[0]), Ue(re.selectedValues[0]);
                        },
                        value: h ? [xe] : Be,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          ge && /* @__PURE__ */ oe.jsx(
                            _,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(fn, { size: 24 })
                            }
                          ),
                          ze && !ge && j.map((re) => /* @__PURE__ */ oe.jsx(
                            Bt.Item,
                            {
                              value: re,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(q.Paragraph, { children: re.name })
                            },
                            re.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ln, { span: 6, children: /* @__PURE__ */ oe.jsx(Vn, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                ni,
                {
                  clearable: !0,
                  dropdownProps: { className: aa.dropdown },
                  disabled: !S || ge,
                  placeholder: S ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (xe) => xe == null ? void 0 : xe.name,
                  onChange: (xe) => {
                    if (xe.selectedValues.length > 0) {
                      ne(xe.selectedValues[0]);
                      const Ue = JSON.parse(
                        xe.selectedValues[0].templateData
                      ), Be = Z.filter(
                        (Pe) => Pe.priority === Ue.priority
                      );
                      J(
                        Be ? Be[0] : void 0
                      );
                      const re = N.filter(
                        (Pe) => Pe.id === Ue.stateId
                      );
                      B(
                        re ? re[0] : void 0
                      );
                      const be = j.filter(
                        (Pe) => Pe.id === Ue.projectId
                      );
                      P(
                        be ? be[0] : void 0
                      );
                      const Ne = Ue.description;
                      p({
                        title: Ue == null ? void 0 : Ue.title,
                        priority: Be[0],
                        status: re[0],
                        project: be[0],
                        description: Ne ? VC(Ne, TW) : "",
                        team: S
                      });
                    } else
                      p({
                        title: "",
                        description: "",
                        team: S
                      }), P(void 0), J(void 0), B(void 0), ne(void 0);
                  },
                  value: Q ? [Q] : void 0,
                  children: K == null ? void 0 : K.map((xe) => /* @__PURE__ */ oe.jsx(
                    Bt.Item,
                    {
                      value: xe,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(q.Paragraph, { children: xe.name })
                    },
                    xe.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(ln, { span: 6, children: /* @__PURE__ */ oe.jsx(
                Ut,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: xe, value: Ue },
                    fieldState: { error: Be }
                  }) => /* @__PURE__ */ oe.jsx(
                    ur,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Ue || "",
                        onChange: xe
                      },
                      meta: {
                        error: (Be == null ? void 0 : Be.message) ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ln, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Ut,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: xe, onChange: Ue } }) => {
                    const Be = ge ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Vn, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      ni,
                      {
                        dropdownProps: { className: aa.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (re) => re == null ? void 0 : re.name,
                        disabled: S === void 0,
                        placeholder: S ? "Select Issue status" : "Select a Team first",
                        onChange: (re) => {
                          B(re.selectedValues[0]), Ue(re.selectedValues[0]);
                        },
                        value: O ? [xe] : Be,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          ge && /* @__PURE__ */ oe.jsx(
                            _,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(fn, { size: 24 })
                            }
                          ),
                          ze && !ge && N.map((re) => /* @__PURE__ */ oe.jsx(
                            Bt.Item,
                            {
                              value: re,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                _,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      au,
                                      {
                                        type: re.type,
                                        color: re.color,
                                        name: re.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(q.Paragraph, { children: re.name })
                                  ]
                                }
                              )
                            },
                            re.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ln, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Ut,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: xe, onChange: Ue } }) => {
                    const Be = Ae ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Vn, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      ni,
                      {
                        clearable: !0,
                        getItemTitleByValue: (re) => re == null ? void 0 : re.label,
                        disabled: S === void 0,
                        placeholder: S ? "Select Issue priority" : "Select a Team first",
                        onChange: (re) => {
                          J(re.selectedValues[0]), Ue(re.selectedValues[0]);
                        },
                        value: ee ? [xe] : Be,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          ge && /* @__PURE__ */ oe.jsx(
                            _,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(fn, { size: 24 })
                            }
                          ),
                          M && !Ae && Z.map((re) => /* @__PURE__ */ oe.jsx(
                            Bt.Item,
                            {
                              value: re,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                _,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      iu,
                                      {
                                        priority: re.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(q.Paragraph, { children: re.label })
                                  ]
                                }
                              )
                            },
                            re.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ln, { children: /* @__PURE__ */ oe.jsx(
                Ut,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: xe, value: Ue },
                    fieldState: { error: Be }
                  }) => /* @__PURE__ */ oe.jsx(
                    sI,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Ue || "",
                        onChange: xe
                      },
                      meta: {
                        error: (Be == null ? void 0 : Be.message) ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          rr,
          {
            confirmOnClick: d($e),
            confirmProps: {
              disabled: le || !M,
              isLoading: ce || Ae || ge,
              loadingIndicator: /* @__PURE__ */ oe.jsx(fn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Ye(), Oe();
            }
          }
        )
      ]
    }
  );
}, zW = "_modalWrapper_4kh9u_1", MW = "_copyButton_4kh9u_6", UW = "_copyWrapper_4kh9u_15", BW = "_copyField_4kh9u_24", qW = "_externalLink_4kh9u_47", HW = "_externalLinkIcon_4kh9u_52", KW = "_textWrapper_4kh9u_56", ji = {
  modalWrapper: zW,
  copyButton: MW,
  copyWrapper: UW,
  copyField: BW,
  externalLink: qW,
  externalLinkIcon: HW,
  textWrapper: KW
}, WW = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: t
}) => /* @__PURE__ */ oe.jsxs(
  Ht,
  {
    isOpen: !!n && e,
    className: ji.modalWrapper,
    onClose: () => t(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        Kt,
        {
          title: "Issue creation successful",
          onClose: () => t(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(Wt, { children: /* @__PURE__ */ oe.jsxs(
        _,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(q.Paragraph, { className: ji.textWrapper, children: [
              `You can visit issue ${n == null ? void 0 : n.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                q.ExternalLink,
                {
                  href: n == null ? void 0 : n.url,
                  target: "_blank",
                  className: ji.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(ye, { name: "external-link", className: ji.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(Vn, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              _,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ji.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    Cr,
                    {
                      readOnly: !0,
                      value: n == null ? void 0 : n.url,
                      className: ji.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    lI,
                    {
                      className: ji.copyButton,
                      textToCopy: (n == null ? void 0 : n.url) || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        rr,
        {
          cancelOnClick: () => t(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), GW = "https://linear.app/", YW = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = me([]), [a, o] = me([]), [s, l] = me(!1), [c, m] = me(!1), [d, p] = me(!1), [v, y] = me(), { useLazyQuery: S } = pn(), [b, j] = me(""), x = n == null ? void 0 : n.enableCreateIssue, h = !!(n != null && n.enableUnlinkAll), { track: P } = bn(), {
    loading: N,
    data: $,
    error: O,
    store: B
  } = Lv((e == null ? void 0 : e.conversationId) ?? null), [
    Z,
    {
      data: Y,
      loading: ee,
      networkStatus: J,
      error: K
    }
  ] = S(Z7, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Ge(() => {
    var ce, ae;
    !N && !O && $ && ((ae = (ce = $ == null ? void 0 : $.linear) == null ? void 0 : ce.issues) == null ? void 0 : ae.length) > 0 && (o($.linear.issues), Z({
      variables: {
        linkedIssues: $.linear.issues
      }
    }));
  }, [$, N, O]), Ge(() => {
    var ce, ae;
    Y && Y != null && Y.Linear && !ee && J === cr.ready && Object.keys(Y).length > 0 && i((ae = (ce = Y.Linear.issues) == null ? void 0 : ce.edges) == null ? void 0 : ae.map(({ node: ve }) => ve));
  }, [Y, ee, J]);
  const V = (ce) => {
    var ae, ve;
    ce && (ve = (ae = ce == null ? void 0 : ce.team) == null ? void 0 : ae.organization) != null && ve.urlKey && P("linear:link:issue:clicked", {
      linearInstanceUrl: b,
      linearIssueKey: ce.id
    });
    const je = (G) => G.id === (ce == null ? void 0 : ce.id);
    t.some((G) => G && je(G)) || ($ && a.length === 0 && o([]), B({
      linear: {
        issues: [...a, ce.id]
      }
    }));
  }, Q = (ce) => {
    const ae = ($ == null ? void 0 : $.linear.issues.filter((ve) => ve !== ce)) || [];
    P("linear:unlink:issue:clicked", {
      linearInstanceUrl: b,
      linearIssueKey: ce
    }), i(t.filter(({ id: ve }) => ve !== ce)), o(ae), B({
      linear: {
        issues: ae
      }
    });
  }, ne = () => {
    l(!1), i([]), o([]), B({
      linear: {
        issues: []
      }
    });
  };
  return !N && !ee && (K || O) ? /* @__PURE__ */ oe.jsx(Fn, { error: K || O }) : /* @__PURE__ */ oe.jsxs(_, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      Ht,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            Kt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(Wt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            rr,
            {
              confirmOnClick: () => ne(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      VW,
      {
        isCreateIssueModalOpen: c,
        setIsCreateIssueModalOpen: (ce) => m(ce),
        setIsCreationSuccessfulModalOpen: (ce) => p(ce),
        addToLinkedIssueIds: (ce) => {
          B({
            linear: {
              issues: [...a, ce]
            }
          });
        },
        setCreatedIssue: (ce) => y(ce),
        organizationUrl: b,
        setOrganizationUrl: (ce) => j(ce)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      WW,
      {
        isCreationSuccessfulModalOpen: d,
        setIsCreationSuccessfulModalOpen: (ce) => p(ce),
        createdIssueData: v
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      _,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          x && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              Qn,
              {
                variant: "primary",
                onClick: () => {
                  P("linear:create:new:issue:clicked", {
                    linearInstanceUrl: b
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(q.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(NW, { handleSelect: V, linkedIssues: t })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      EW,
      {
        linkedIssues: t,
        isLoading: ee,
        handleUnlinkIssue: Q,
        showUnlinkAllModal: (ce) => l(ce),
        showUnlinkAllButton: h,
        organizationUrl: b
      }
    )
  ] });
}, JW = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vu
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var wd = { exports: {} }, po = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V_;
function QW() {
  if (V_) return po;
  V_ = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return po.Fragment = t, po.jsx = s, po.jsxs = s, po;
}
var tl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var z_;
function XW() {
  return z_ || (z_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    tl.Fragment = i, tl.jsx = Mn, tl.jsxs = Un;
  }()), tl;
}
var M_;
function ZW() {
  return M_ || (M_ = 1, process.env.NODE_ENV === "production" ? wd.exports = QW() : wd.exports = XW()), wd.exports;
}
var De = ZW();
const eG = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, nG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, tG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, rG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, iG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, aG = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": eG,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": nG,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": tG,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": rG,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": iG
};
function Gu(e) {
  return aG[e] ?? {};
}
const oG = Gu(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), sG = Gu(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), lG = Gu(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), uG = Gu(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function jd(e = !1, n) {
  const [t, i] = me(e);
  return Ge(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const cG = "_wrapper_27vny_1", dG = "_copyIcon_27vny_12", vo = {
  wrapper: cG,
  copyIcon: dG
}, mG = ({
  customer: e
}) => {
  const { isCopied: n, copy: t } = jd(), { isCopied: i, copy: a } = jd(), { isCopied: o, copy: s } = jd();
  if (!e)
    return null;
  const l = 14, {
    email: c,
    properties: m,
    metadata: d,
    birthday: p,
    created_at: v,
    enrolled: y,
    enrolled_at: S,
    referral_url: b
  } = e, j = p ? An(p).isSame(Date.now(), "day") : !1, { name: x, first_name: h, last_name: P } = m ?? {}, N = x ?? `${h} ${P}` ?? "A customer has no name", $ = d != null && d.shopify_source_url ? d.shopify_source_url.startsWith("https://") ? d.shopify_source_url : `https://${d.shopify_source_url}` : "";
  return /* @__PURE__ */ De.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ De.jsxs(_, { className: vo.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(
      _,
      {
        justifyContent: "space-between",
        className: vo.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ De.jsx(q.Heading, { variant: "heading-2", children: N }),
          j && /* @__PURE__ */ De.jsx(q.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    v && /* @__PURE__ */ De.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ De.jsx(q.Paragraph, { variant: "4", color: "secondary", children: An(v).format("DD MMM YYYY @ HH:mm") })
    ] }),
    y && /* @__PURE__ */ De.jsx(_, { gap: "200", children: /* @__PURE__ */ De.jsxs(q.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      An(S).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ De.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(_, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ye, { size: l, name: "mail" }),
        /* @__PURE__ */ De.jsx(q.ExternalLink, { href: `mailto:${c}`, children: c })
      ] }),
      /* @__PURE__ */ De.jsx(nn, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ye,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => t(c),
          className: vo.copyIcon
        }
      ) })
    ] }),
    $ && /* @__PURE__ */ De.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(_, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ye, { size: l, name: "link" }),
        /* @__PURE__ */ De.jsx(nn, { content: "Shopify shop", children: /* @__PURE__ */ De.jsx(
          q.ExternalLink,
          {
            href: $,
            target: "_blank",
            rel: "noreferrer",
            children: $.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(nn, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ye,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a($),
          className: vo.copyIcon
        }
      ) })
    ] }),
    b && /* @__PURE__ */ De.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(_, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ye, { size: l, name: "external-link" }),
        /* @__PURE__ */ De.jsx(nn, { content: "Referral link", children: /* @__PURE__ */ De.jsx(
          q.ExternalLink,
          {
            href: b,
            target: "_blank",
            rel: "noreferrer",
            children: b.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(nn, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ye,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(b),
          className: vo.copyIcon
        }
      ) })
    ] })
  ] }) });
}, fG = "_list_1q5b5_5", pG = "_listItem_1q5b5_8", vG = "_listItemEdit_1q5b5_15", hG = "_notificationText_1q5b5_19", Fa = {
  list: fG,
  listItem: pG,
  listItemEdit: vG,
  notificationText: hG
}, yG = "_modalBody_1clhs_1", gG = {
  modalBody: yG
}, kG = ({
  isOpen: e,
  points: n,
  merchantId: t,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = pn(), { track: l } = bn(), [c, m] = me(n), [d, p] = me(""), [v, y] = me(), [S, { loading: b }] = o(
    lG,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), J();
      }
    }
  ), [j, { loading: x }] = o(uG), h = b || x, P = !!v, N = n === c ? "Change the value to update the points" : "", $ = isNaN(c), O = $ ? "Points can not be empty" : "", B = c > n && c - n > 1e6, Z = B ? "Points can not exceed 1,000,000" : "", Y = () => {
    c > n && S({
      variables: {
        input: {
          points: c - n,
          reason: d
        },
        merchantId: t
      }
    }).catch((K) => {
      const V = K == null ? void 0 : K.networkError;
      (V ? V == null ? void 0 : V.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : (l("loyaltylion:add:points:failed"), y(["Failed to add points, try again later."]));
    }), c < n && j({
      variables: {
        input: {
          points: n - c,
          reason: d
        },
        merchantId: t
      }
    }).then((K) => {
      var V, Q, ne, ce;
      ((ne = (Q = (V = K.data) == null ? void 0 : V.LoyaltyLion) == null ? void 0 : Q.removeCustomersPoints) == null ? void 0 : ne.__typename) === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : "errors" in K && (l("loyaltylion:remove:points:failed"), y(
        ((ce = K.errors) == null ? void 0 : ce.map((ae) => ae.message)) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), y(["Failed to remove points, try again later."]);
    });
  }, ee = () => {
    $ && m(n), p(""), i();
  }, J = () => {
    a(), ee();
  };
  return /* @__PURE__ */ De.jsxs(
    Ht,
    {
      isOpen: e,
      onClose: ee,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ De.jsx(Kt, { title: "Change points", onClose: ee }),
        /* @__PURE__ */ De.jsxs(Wt, { className: gG.modalBody, children: [
          /* @__PURE__ */ De.jsxs(Ir, { children: [
            /* @__PURE__ */ De.jsx(ln, { span: 6, children: /* @__PURE__ */ De.jsx(
              ur,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Z || O,
                  warning: N
                },
                input: {
                  name: "points",
                  value: c.toString(),
                  onChange: (K) => m((K == null ? void 0 : K.target.valueAsNumber) ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ De.jsx(ln, { span: 6, children: /* @__PURE__ */ De.jsx(
              ur,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: d,
                  onChange: (K) => p((K == null ? void 0 : K.target.value) ?? "")
                }
              }
            ) })
          ] }),
          !h && P && /* @__PURE__ */ De.jsx(_, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ De.jsx(Je, { children: v == null ? void 0 : v.map((K, V) => /* @__PURE__ */ De.jsx(
            Je.Item,
            {
              variant: "dense",
              title: K,
              contentLeft: /* @__PURE__ */ De.jsx(
                ye,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            V
          )) }) })
        ] }),
        /* @__PURE__ */ De.jsx(
          rr,
          {
            confirmName: "Save",
            confirmOnClick: () => Y(),
            confirmProps: {
              isLoading: h,
              disabled: $ || B || n === c,
              loadingIndicator: /* @__PURE__ */ De.jsx(fn, { size: 16 })
            },
            cancelOnClick: ee
          }
        )
      ]
    }
  );
}, bG = ({
  label: e,
  points: n,
  setIsModalOpen: t
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ De.jsx(Je.Text, { variant: "dense", className: Fa.listItem, children: /* @__PURE__ */ De.jsxs(_, { justifyContent: "space-between", children: [
    /* @__PURE__ */ De.jsxs(_, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ye, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ De.jsx(q.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ De.jsxs(_, { gap: "200", alignItems: "center", children: [
      t && /* @__PURE__ */ De.jsx(nn, { content: "Edit points", children: /* @__PURE__ */ De.jsx(
        ye,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Fa.listItemEdit,
          onClick: () => t(!0)
        }
      ) }),
      /* @__PURE__ */ De.jsx(Jn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, _G = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [t, i] = me(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: c
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: c ?? 0
    }
  ];
  return /* @__PURE__ */ De.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(q.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ De.jsx(Je, { className: Fa.list, children: m.map(({ id: d, points: p, label: v, setIsModalOpen: y }) => /* @__PURE__ */ De.jsx(
      bG,
      {
        points: p,
        label: v,
        setIsModalOpen: y
      },
      d
    )) }),
    /* @__PURE__ */ De.jsx(
      kG,
      {
        isOpen: t,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, xG = "_reward_1wxia_1", SG = {
  reward: xG
}, NG = ({ reward: e }) => {
  const {
    title: n,
    point_cost: t,
    target_site: i,
    description: a
  } = e, o = i == null ? void 0 : i.name, s = i == null ? void 0 : i.url;
  return /* @__PURE__ */ De.jsx(_, { gap: "100", flexDirection: "column", className: SG.reward, children: /* @__PURE__ */ De.jsx(nn, { content: a ?? "No description", children: /* @__PURE__ */ De.jsxs(_, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(_, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ De.jsx(ye, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ De.jsxs(Jn, { size: "small", variant: "info", children: [
        t ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ De.jsxs(_, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ye, { size: 14, name: "external-link" }),
      /* @__PURE__ */ De.jsx(
        q.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, wG = ({ customer: e }) => {
  const { useQuery: n } = pn(), [t, i] = me(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(sG, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  return Ge(() => {
    var c, m;
    if (l != null && l.LoyaltyLion) {
      const d = (m = (c = l.LoyaltyLion) == null ? void 0 : c.getAvailableRewards) == null ? void 0 : m.rewards;
      d && i(d);
    }
  }, [l]), s ? Zo({ errors: s.graphQLErrors }) ? /* @__PURE__ */ De.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Fa.notificationText,
      children: "No rewards found"
    }
  ) : KN({ errors: s.graphQLErrors }) ? /* @__PURE__ */ De.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Fa.notificationText,
      children: "You don't have permissions to view rewards"
    }
  ) : /* @__PURE__ */ De.jsx(Fn, { error: s }) : /* @__PURE__ */ De.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(q.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ De.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(fn, {}) }) : /* @__PURE__ */ De.jsx(_, { gap: "200", flexDirection: "column", children: t == null ? void 0 : t.map((c) => /* @__PURE__ */ De.jsx(NG, { reward: c }, c.id)) })
  ] });
}, jG = ({ customer: e }) => {
  const { blocked: n, guest: t, insights_segment: i } = e ?? {}, a = n || t || i, o = 14;
  return a ? /* @__PURE__ */ De.jsxs(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ De.jsx(_, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Dn, { children: /* @__PURE__ */ De.jsxs(_, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(
        ye,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    t && /* @__PURE__ */ De.jsx(_, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Dn, { children: /* @__PURE__ */ De.jsxs(_, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ye, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ De.jsx(_, { alignItems: "start", children: /* @__PURE__ */ De.jsx(nn, { content: "Insights segment", children: /* @__PURE__ */ De.jsx(Dn, { children: /* @__PURE__ */ De.jsxs(_, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ye, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, CG = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = pn(), { track: i } = bn(), [a, o] = me(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: c,
    showPointsBalance: m,
    showAvailableRewards: d
  } = n, p = !l && !c && !m && !d, {
    loading: v,
    error: y,
    data: S,
    refetch: b
  } = t(oG, {
    skip: !(s != null && s.email),
    variables: {
      email: (s == null ? void 0 : s.email) ?? ""
    }
  });
  return Ge(() => {
    var j;
    if (S && !v) {
      const x = ((j = S == null ? void 0 : S.LoyaltyLion) == null ? void 0 : j.getCustomers).customers;
      x && x.length > 0 && (o(x[0]), i("loyaltylion:customer:received"));
    }
  }, [S, v]), s != null && s.email ? y ? Zo({
    errors: y.graphQLErrors
  }) ? /* @__PURE__ */ De.jsxs(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Fa.notificationText,
      children: [
        "No user found for email: ",
        s == null ? void 0 : s.email
      ]
    }
  ) : /* @__PURE__ */ De.jsx(Fn, { error: y }) : v ? /* @__PURE__ */ De.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(fn, {}) }) : p ? /* @__PURE__ */ De.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ De.jsx(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ De.jsxs(De.Fragment, { children: [
        l && /* @__PURE__ */ De.jsx(mG, { customer: a }),
        c && /* @__PURE__ */ De.jsx(jG, { customer: a }),
        m && /* @__PURE__ */ De.jsx(
          _G,
          {
            customer: a,
            refetchCustomerData: b
          }
        ),
        d && /* @__PURE__ */ De.jsx(wG, { customer: a })
      ] }) : /* @__PURE__ */ De.jsx(_, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ De.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, FG = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Cd = { exports: {} }, ho = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U_;
function IG() {
  if (U_) return ho;
  U_ = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return ho.Fragment = t, ho.jsx = s, ho.jsxs = s, ho;
}
var rl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var B_;
function $G() {
  return B_ || (B_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    rl.Fragment = i, rl.jsx = Mn, rl.jsxs = Un;
  }()), rl;
}
var q_;
function EG() {
  return q_ || (q_ = 1, process.env.NODE_ENV === "production" ? Cd.exports = IG() : Cd.exports = $G()), Cd.exports;
}
var yn = EG();
const TG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, OG = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": TG
};
function RG(e) {
  return OG[e] ?? {};
}
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */
const {
  entries: zC,
  setPrototypeOf: H_,
  isFrozen: DG,
  getPrototypeOf: PG,
  getOwnPropertyDescriptor: AG
} = Object;
let {
  freeze: Lt,
  seal: dr,
  create: MC
} = Object, {
  apply: Fv,
  construct: Iv
} = typeof Reflect < "u" && Reflect;
Lt || (Lt = function(e) {
  return e;
});
dr || (dr = function(e) {
  return e;
});
Fv || (Fv = function(e, n, t) {
  return e.apply(n, t);
});
Iv || (Iv = function(e, n) {
  return new e(...n);
});
const il = Vt(Array.prototype.forEach), LG = Vt(Array.prototype.lastIndexOf), K_ = Vt(Array.prototype.pop), yo = Vt(Array.prototype.push), VG = Vt(Array.prototype.splice), El = Vt(String.prototype.toLowerCase), Fd = Vt(String.prototype.toString), W_ = Vt(String.prototype.match), go = Vt(String.prototype.replace), zG = Vt(String.prototype.indexOf), MG = Vt(String.prototype.trim), yr = Vt(Object.prototype.hasOwnProperty), It = Vt(RegExp.prototype.test), ko = UG(TypeError);
function Vt(e) {
  return function(n) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
      i[a - 1] = arguments[a];
    return Fv(e, n, i);
  };
}
function UG(e) {
  return function() {
    for (var n = arguments.length, t = new Array(n), i = 0; i < n; i++)
      t[i] = arguments[i];
    return Iv(e, t);
  };
}
function In(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : El;
  H_ && H_(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = t(a);
      o !== a && (DG(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function BG(e) {
  for (let n = 0; n < e.length; n++)
    yr(e, n) || (e[n] = null);
  return e;
}
function Fi(e) {
  const n = MC(null);
  for (const [t, i] of zC(e))
    yr(e, t) && (Array.isArray(i) ? n[t] = BG(i) : i && typeof i == "object" && i.constructor === Object ? n[t] = Fi(i) : n[t] = i);
  return n;
}
function bo(e, n) {
  for (; e !== null; ) {
    const i = AG(e, n);
    if (i) {
      if (i.get)
        return Vt(i.get);
      if (typeof i.value == "function")
        return Vt(i.value);
    }
    e = PG(e);
  }
  function t() {
    return null;
  }
  return t;
}
const G_ = Lt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Id = Lt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), $d = Lt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), qG = Lt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ed = Lt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), HG = Lt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Y_ = Lt(["#text"]), J_ = Lt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Td = Lt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Q_ = Lt(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), al = Lt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), KG = dr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), WG = dr(/<%[\w\W]*|[\w\W]*%>/gm), GG = dr(/\$\{[\w\W]*/gm), YG = dr(/^data-[\-\w.\u00B7-\uFFFF]+$/), JG = dr(/^aria-[\-\w]+$/), UC = dr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), QG = dr(/^(?:\w+script|data):/i), XG = dr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), BC = dr(/^html$/i), ZG = dr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var X_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: JG,
  ATTR_WHITESPACE: XG,
  CUSTOM_ELEMENT: ZG,
  DATA_ATTR: YG,
  DOCTYPE_NAME: BC,
  ERB_EXPR: WG,
  IS_ALLOWED_URI: UC,
  IS_SCRIPT_OR_DATA: QG,
  MUSTACHE_EXPR: KG,
  TMPLIT_EXPR: GG
});
const _o = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, e8 = function() {
  return typeof window > "u" ? null : window;
}, n8 = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let t = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (t = n.getAttribute(i));
  const a = "dompurify" + (t ? "#" + t : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, Z_ = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function qC() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e8();
  const n = (E) => qC(E);
  if (n.version = "3.2.4", n.removed = [], !e || !e.document || e.document.nodeType !== _o.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: t
  } = e;
  const i = t, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: c,
    NodeFilter: m,
    NamedNodeMap: d = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: p,
    DOMParser: v,
    trustedTypes: y
  } = e, S = c.prototype, b = bo(S, "cloneNode"), j = bo(S, "remove"), x = bo(S, "nextSibling"), h = bo(S, "childNodes"), P = bo(S, "parentNode");
  if (typeof s == "function") {
    const E = t.createElement("template");
    E.content && E.content.ownerDocument && (t = E.content.ownerDocument);
  }
  let N, $ = "";
  const {
    implementation: O,
    createNodeIterator: B,
    createDocumentFragment: Z,
    getElementsByTagName: Y
  } = t, {
    importNode: ee
  } = i;
  let J = Z_();
  n.isSupported = typeof zC == "function" && typeof P == "function" && O && O.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: K,
    ERB_EXPR: V,
    TMPLIT_EXPR: Q,
    DATA_ATTR: ne,
    ARIA_ATTR: ce,
    IS_SCRIPT_OR_DATA: ae,
    ATTR_WHITESPACE: ve,
    CUSTOM_ELEMENT: je
  } = X_;
  let {
    IS_ALLOWED_URI: G
  } = X_, le = null;
  const he = In({}, [...G_, ...Id, ...$d, ...Ed, ...Y_]);
  let M = null;
  const Ae = In({}, [...J_, ...Td, ...Q_, ...al]);
  let Ve = Object.seal(MC(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Te = null, ze = null, ge = !0, Oe = !0, $e = !1, Ye = !0, xe = !1, Ue = !0, Be = !1, re = !1, be = !1, Ne = !1, Pe = !1, Ie = !1, on = !0, C = !1;
  const k = "user-content-";
  let F = !0, W = !1, X = {}, T = null;
  const U = In({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let te = null;
  const pe = In({}, ["audio", "video", "img", "source", "image", "track"]);
  let Se = null;
  const Ze = In({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), un = "http://www.w3.org/1998/Math/MathML", en = "http://www.w3.org/2000/svg", tn = "http://www.w3.org/1999/xhtml";
  let mn = tn, cn = !1, vn = null;
  const Qe = In({}, [un, en, tn], Fd);
  let hn = In({}, ["mi", "mo", "mn", "ms", "mtext"]), Le = In({}, ["annotation-xml"]);
  const sn = In({}, ["title", "style", "font", "a", "script"]);
  let rn = null;
  const Nn = ["application/xhtml+xml", "text/html"], Bn = "text/html";
  let an = null, On = null;
  const wn = t.createElement("form"), _n = function(E) {
    return E instanceof RegExp || E instanceof Function;
  }, Ln = function() {
    let E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(On && On === E)) {
      if ((!E || typeof E != "object") && (E = {}), E = Fi(E), rn = // eslint-disable-next-line unicorn/prefer-includes
      Nn.indexOf(E.PARSER_MEDIA_TYPE) === -1 ? Bn : E.PARSER_MEDIA_TYPE, an = rn === "application/xhtml+xml" ? Fd : El, le = yr(E, "ALLOWED_TAGS") ? In({}, E.ALLOWED_TAGS, an) : he, M = yr(E, "ALLOWED_ATTR") ? In({}, E.ALLOWED_ATTR, an) : Ae, vn = yr(E, "ALLOWED_NAMESPACES") ? In({}, E.ALLOWED_NAMESPACES, Fd) : Qe, Se = yr(E, "ADD_URI_SAFE_ATTR") ? In(Fi(Ze), E.ADD_URI_SAFE_ATTR, an) : Ze, te = yr(E, "ADD_DATA_URI_TAGS") ? In(Fi(pe), E.ADD_DATA_URI_TAGS, an) : pe, T = yr(E, "FORBID_CONTENTS") ? In({}, E.FORBID_CONTENTS, an) : U, Te = yr(E, "FORBID_TAGS") ? In({}, E.FORBID_TAGS, an) : {}, ze = yr(E, "FORBID_ATTR") ? In({}, E.FORBID_ATTR, an) : {}, X = yr(E, "USE_PROFILES") ? E.USE_PROFILES : !1, ge = E.ALLOW_ARIA_ATTR !== !1, Oe = E.ALLOW_DATA_ATTR !== !1, $e = E.ALLOW_UNKNOWN_PROTOCOLS || !1, Ye = E.ALLOW_SELF_CLOSE_IN_ATTR !== !1, xe = E.SAFE_FOR_TEMPLATES || !1, Ue = E.SAFE_FOR_XML !== !1, Be = E.WHOLE_DOCUMENT || !1, Ne = E.RETURN_DOM || !1, Pe = E.RETURN_DOM_FRAGMENT || !1, Ie = E.RETURN_TRUSTED_TYPE || !1, be = E.FORCE_BODY || !1, on = E.SANITIZE_DOM !== !1, C = E.SANITIZE_NAMED_PROPS || !1, F = E.KEEP_CONTENT !== !1, W = E.IN_PLACE || !1, G = E.ALLOWED_URI_REGEXP || UC, mn = E.NAMESPACE || tn, hn = E.MATHML_TEXT_INTEGRATION_POINTS || hn, Le = E.HTML_INTEGRATION_POINTS || Le, Ve = E.CUSTOM_ELEMENT_HANDLING || {}, E.CUSTOM_ELEMENT_HANDLING && _n(E.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Ve.tagNameCheck = E.CUSTOM_ELEMENT_HANDLING.tagNameCheck), E.CUSTOM_ELEMENT_HANDLING && _n(E.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Ve.attributeNameCheck = E.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), E.CUSTOM_ELEMENT_HANDLING && typeof E.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Ve.allowCustomizedBuiltInElements = E.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), xe && (Oe = !1), Pe && (Ne = !0), X && (le = In({}, Y_), M = [], X.html === !0 && (In(le, G_), In(M, J_)), X.svg === !0 && (In(le, Id), In(M, Td), In(M, al)), X.svgFilters === !0 && (In(le, $d), In(M, Td), In(M, al)), X.mathMl === !0 && (In(le, Ed), In(M, Q_), In(M, al))), E.ADD_TAGS && (le === he && (le = Fi(le)), In(le, E.ADD_TAGS, an)), E.ADD_ATTR && (M === Ae && (M = Fi(M)), In(M, E.ADD_ATTR, an)), E.ADD_URI_SAFE_ATTR && In(Se, E.ADD_URI_SAFE_ATTR, an), E.FORBID_CONTENTS && (T === U && (T = Fi(T)), In(T, E.FORBID_CONTENTS, an)), F && (le["#text"] = !0), Be && In(le, ["html", "head", "body"]), le.table && (In(le, ["tbody"]), delete Te.tbody), E.TRUSTED_TYPES_POLICY) {
        if (typeof E.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ko('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof E.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ko('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        N = E.TRUSTED_TYPES_POLICY, $ = N.createHTML("");
      } else
        N === void 0 && (N = n8(y, a)), N !== null && typeof $ == "string" && ($ = N.createHTML(""));
      Lt && Lt(E), On = E;
    }
  }, zn = In({}, [...Id, ...$d, ...qG]), xn = In({}, [...Ed, ...HG]), jn = function(E) {
    let L = P(E);
    (!L || !L.tagName) && (L = {
      namespaceURI: mn,
      tagName: "template"
    });
    const z = El(E.tagName), se = El(L.tagName);
    return vn[E.namespaceURI] ? E.namespaceURI === en ? L.namespaceURI === tn ? z === "svg" : L.namespaceURI === un ? z === "svg" && (se === "annotation-xml" || hn[se]) : !!zn[z] : E.namespaceURI === un ? L.namespaceURI === tn ? z === "math" : L.namespaceURI === en ? z === "math" && Le[se] : !!xn[z] : E.namespaceURI === tn ? L.namespaceURI === en && !Le[se] || L.namespaceURI === un && !hn[se] ? !1 : !xn[z] && (sn[z] || !zn[z]) : !!(rn === "application/xhtml+xml" && vn[E.namespaceURI]) : !1;
  }, En = function(E) {
    yo(n.removed, {
      element: E
    });
    try {
      P(E).removeChild(E);
    } catch {
      j(E);
    }
  }, Pn = function(E, L) {
    try {
      yo(n.removed, {
        attribute: L.getAttributeNode(E),
        from: L
      });
    } catch {
      yo(n.removed, {
        attribute: null,
        from: L
      });
    }
    if (L.removeAttribute(E), E === "is")
      if (Ne || Pe)
        try {
          En(L);
        } catch {
        }
      else
        try {
          L.setAttribute(E, "");
        } catch {
        }
  }, Mn = function(E) {
    let L = null, z = null;
    if (be)
      E = "<remove></remove>" + E;
    else {
      const Ce = W_(E, /^[\r\n\t ]+/);
      z = Ce && Ce[0];
    }
    rn === "application/xhtml+xml" && mn === tn && (E = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + E + "</body></html>");
    const se = N ? N.createHTML(E) : E;
    if (mn === tn)
      try {
        L = new v().parseFromString(se, rn);
      } catch {
      }
    if (!L || !L.documentElement) {
      L = O.createDocument(mn, "template", null);
      try {
        L.documentElement.innerHTML = cn ? $ : se;
      } catch {
      }
    }
    const Ee = L.body || L.documentElement;
    return E && z && Ee.insertBefore(t.createTextNode(z), Ee.childNodes[0] || null), mn === tn ? Y.call(L, Be ? "html" : "body")[0] : Be ? L.documentElement : Ee;
  }, Un = function(E) {
    return B.call(
      E.ownerDocument || E,
      E,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, r = function(E) {
    return E instanceof p && (typeof E.nodeName != "string" || typeof E.textContent != "string" || typeof E.removeChild != "function" || !(E.attributes instanceof d) || typeof E.removeAttribute != "function" || typeof E.setAttribute != "function" || typeof E.namespaceURI != "string" || typeof E.insertBefore != "function" || typeof E.hasChildNodes != "function");
  }, u = function(E) {
    return typeof l == "function" && E instanceof l;
  };
  function f(E, L, z) {
    il(E, (se) => {
      se.call(n, L, z, On);
    });
  }
  const g = function(E) {
    let L = null;
    if (f(J.beforeSanitizeElements, E, null), r(E))
      return En(E), !0;
    const z = an(E.nodeName);
    if (f(J.uponSanitizeElement, E, {
      tagName: z,
      allowedTags: le
    }), E.hasChildNodes() && !u(E.firstElementChild) && It(/<[/\w]/g, E.innerHTML) && It(/<[/\w]/g, E.textContent) || E.nodeType === _o.progressingInstruction || Ue && E.nodeType === _o.comment && It(/<[/\w]/g, E.data))
      return En(E), !0;
    if (!le[z] || Te[z]) {
      if (!Te[z] && A(z) && (Ve.tagNameCheck instanceof RegExp && It(Ve.tagNameCheck, z) || Ve.tagNameCheck instanceof Function && Ve.tagNameCheck(z)))
        return !1;
      if (F && !T[z]) {
        const se = P(E) || E.parentNode, Ee = h(E) || E.childNodes;
        if (Ee && se) {
          const Ce = Ee.length;
          for (let ie = Ce - 1; ie >= 0; --ie) {
            const Xe = b(Ee[ie], !0);
            Xe.__removalCount = (E.__removalCount || 0) + 1, se.insertBefore(Xe, x(E));
          }
        }
      }
      return En(E), !0;
    }
    return E instanceof c && !jn(E) || (z === "noscript" || z === "noembed" || z === "noframes") && It(/<\/no(script|embed|frames)/i, E.innerHTML) ? (En(E), !0) : (xe && E.nodeType === _o.text && (L = E.textContent, il([K, V, Q], (se) => {
      L = go(L, se, " ");
    }), E.textContent !== L && (yo(n.removed, {
      element: E.cloneNode()
    }), E.textContent = L)), f(J.afterSanitizeElements, E, null), !1);
  }, R = function(E, L, z) {
    if (on && (L === "id" || L === "name") && (z in t || z in wn))
      return !1;
    if (!(Oe && !ze[L] && It(ne, L)) && !(ge && It(ce, L))) {
      if (!M[L] || ze[L]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(A(E) && (Ve.tagNameCheck instanceof RegExp && It(Ve.tagNameCheck, E) || Ve.tagNameCheck instanceof Function && Ve.tagNameCheck(E)) && (Ve.attributeNameCheck instanceof RegExp && It(Ve.attributeNameCheck, L) || Ve.attributeNameCheck instanceof Function && Ve.attributeNameCheck(L)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          L === "is" && Ve.allowCustomizedBuiltInElements && (Ve.tagNameCheck instanceof RegExp && It(Ve.tagNameCheck, z) || Ve.tagNameCheck instanceof Function && Ve.tagNameCheck(z)))
        ) return !1;
      } else if (!Se[L] && !It(G, go(z, ve, "")) && !((L === "src" || L === "xlink:href" || L === "href") && E !== "script" && zG(z, "data:") === 0 && te[E]) && !($e && !It(ae, go(z, ve, ""))) && z)
        return !1;
    }
    return !0;
  }, A = function(E) {
    return E !== "annotation-xml" && W_(E, je);
  }, I = function(E) {
    f(J.beforeSanitizeAttributes, E, null);
    const {
      attributes: L
    } = E;
    if (!L || r(E))
      return;
    const z = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: M,
      forceKeepAttr: void 0
    };
    let se = L.length;
    for (; se--; ) {
      const Ee = L[se], {
        name: Ce,
        namespaceURI: ie,
        value: Xe
      } = Ee, $n = an(Ce);
      let Sn = Ce === "value" ? Xe : MG(Xe);
      if (z.attrName = $n, z.attrValue = Sn, z.keepAttr = !0, z.forceKeepAttr = void 0, f(J.uponSanitizeAttribute, E, z), Sn = z.attrValue, C && ($n === "id" || $n === "name") && (Pn(Ce, E), Sn = k + Sn), Ue && It(/((--!?|])>)|<\/(style|title)/i, Sn)) {
        Pn(Ce, E);
        continue;
      }
      if (z.forceKeepAttr || (Pn(Ce, E), !z.keepAttr))
        continue;
      if (!Ye && It(/\/>/i, Sn)) {
        Pn(Ce, E);
        continue;
      }
      xe && il([K, V, Q], (KF) => {
        Sn = go(Sn, KF, " ");
      });
      const Ty = an(E.nodeName);
      if (R(Ty, $n, Sn)) {
        if (N && typeof y == "object" && typeof y.getAttributeType == "function" && !ie)
          switch (y.getAttributeType(Ty, $n)) {
            case "TrustedHTML": {
              Sn = N.createHTML(Sn);
              break;
            }
            case "TrustedScriptURL": {
              Sn = N.createScriptURL(Sn);
              break;
            }
          }
        try {
          ie ? E.setAttributeNS(ie, Ce, Sn) : E.setAttribute(Ce, Sn), r(E) ? En(E) : K_(n.removed);
        } catch {
        }
      }
    }
    f(J.afterSanitizeAttributes, E, null);
  }, w = function E(L) {
    let z = null;
    const se = Un(L);
    for (f(J.beforeSanitizeShadowDOM, L, null); z = se.nextNode(); )
      f(J.uponSanitizeShadowNode, z, null), g(z), I(z), z.content instanceof o && E(z.content);
    f(J.afterSanitizeShadowDOM, L, null);
  };
  return n.sanitize = function(E) {
    let L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, z = null, se = null, Ee = null, Ce = null;
    if (cn = !E, cn && (E = "<!-->"), typeof E != "string" && !u(E))
      if (typeof E.toString == "function") {
        if (E = E.toString(), typeof E != "string")
          throw ko("dirty is not a string, aborting");
      } else
        throw ko("toString is not a function");
    if (!n.isSupported)
      return E;
    if (re || Ln(L), n.removed = [], typeof E == "string" && (W = !1), W) {
      if (E.nodeName) {
        const $n = an(E.nodeName);
        if (!le[$n] || Te[$n])
          throw ko("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (E instanceof l)
      z = Mn("<!---->"), se = z.ownerDocument.importNode(E, !0), se.nodeType === _o.element && se.nodeName === "BODY" || se.nodeName === "HTML" ? z = se : z.appendChild(se);
    else {
      if (!Ne && !xe && !Be && // eslint-disable-next-line unicorn/prefer-includes
      E.indexOf("<") === -1)
        return N && Ie ? N.createHTML(E) : E;
      if (z = Mn(E), !z)
        return Ne ? null : Ie ? $ : "";
    }
    z && be && En(z.firstChild);
    const ie = Un(W ? E : z);
    for (; Ee = ie.nextNode(); )
      g(Ee), I(Ee), Ee.content instanceof o && w(Ee.content);
    if (W)
      return E;
    if (Ne) {
      if (Pe)
        for (Ce = Z.call(z.ownerDocument); z.firstChild; )
          Ce.appendChild(z.firstChild);
      else
        Ce = z;
      return (M.shadowroot || M.shadowrootmode) && (Ce = ee.call(i, Ce, !0)), Ce;
    }
    let Xe = Be ? z.outerHTML : z.innerHTML;
    return Be && le["!doctype"] && z.ownerDocument && z.ownerDocument.doctype && z.ownerDocument.doctype.name && It(BC, z.ownerDocument.doctype.name) && (Xe = "<!DOCTYPE " + z.ownerDocument.doctype.name + `>
` + Xe), xe && il([K, V, Q], ($n) => {
      Xe = go(Xe, $n, " ");
    }), N && Ie ? N.createHTML(Xe) : Xe;
  }, n.setConfig = function() {
    let E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Ln(E), re = !0;
  }, n.clearConfig = function() {
    On = null, re = !1;
  }, n.isValidAttribute = function(E, L, z) {
    On || Ln({});
    const se = an(E), Ee = an(L);
    return R(se, Ee, z);
  }, n.addHook = function(E, L) {
    typeof L == "function" && yo(J[E], L);
  }, n.removeHook = function(E, L) {
    if (L !== void 0) {
      const z = LG(J[E], L);
      return z === -1 ? void 0 : VG(J[E], z, 1)[0];
    }
    return K_(J[E]);
  }, n.removeHooks = function(E) {
    J[E] = [];
  }, n.removeAllHooks = function() {
    J = Z_();
  }, n;
}
var t8 = qC();
const r8 = "_messageContainer_1rxr4_1", i8 = "_chip_1rxr4_7", a8 = "_chipLabel_1rxr4_10", o8 = "_chipValue_1rxr4_13", ol = {
  messageContainer: r8,
  chip: i8,
  chipLabel: a8,
  chipValue: o8
}, ex = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, s8 = ({
  messages: e,
  customFields: n,
  attachments: t,
  conversationContext: i
}) => {
  Ge(() => {
    var o;
    document.getElementById("endOfConversationAnchor") && ((o = document.getElementById("endOfConversationAnchor")) == null || o.scrollIntoView({ behavior: "smooth" }));
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!(i != null && i.customer))
      return o;
    const {
      name: s,
      given_name: l,
      family_name: c,
      email: m,
      phone_number: d
    } = i.customer;
    return s ?? l ?? c ?? m ?? d ?? o;
  };
  return /* @__PURE__ */ yn.jsxs(_, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ yn.jsx(_, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!(n != null && n.length) && /* @__PURE__ */ yn.jsxs(_, { gap: "100", children: [
      /* @__PURE__ */ yn.jsx(nn, { content: "Conversation Attributes", children: /* @__PURE__ */ yn.jsx(
        Mv,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ yn.jsx(_, { alignItems: "center", children: /* @__PURE__ */ yn.jsx(Dn, { className: ol.chip, children: /* @__PURE__ */ yn.jsxs(_, { gap: "100", children: [
        /* @__PURE__ */ yn.jsxs(Wn, { className: ol.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ yn.jsx(Wn, { className: ol.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e == null ? void 0 : e.map((o) => {
      var s, l;
      return /* @__PURE__ */ yn.jsx(
        _,
        {
          className: ol.messageContainer,
          gap: "200",
          style: {
            backgroundColor: o != null && o.direction ? ex[o.direction].background : "var(--dixa-color-neutral-000)",
            borderColor: o != null && o.direction ? ex[o.direction].borderColor : "var(--dixa-color-neutral-100)"
          },
          children: /* @__PURE__ */ yn.jsxs(_, { flexDirection: "column", gap: "200", width: "100%", children: [
            /* @__PURE__ */ yn.jsxs(_, { flexDirection: "row", justifyContent: "space-between", children: [
              /* @__PURE__ */ yn.jsx(q.Heading, { variant: "heading-3", children: (o == null ? void 0 : o.direction) == "INBOUND" ? a() : (s = o == null ? void 0 : o.agent) == null ? void 0 : s.name }),
              /* @__PURE__ */ yn.jsx(q.Paragraph, { variant: "4", children: /* @__PURE__ */ yn.jsx(uI, { relative: !0, time: o == null ? void 0 : o.created_at }) })
            ] }),
            /* @__PURE__ */ yn.jsx(
              "div",
              {
                dangerouslySetInnerHTML: {
                  __html: t8.sanitize(
                    ((l = o == null ? void 0 : o.body) == null ? void 0 : l.replaceAll(/\r\n?|\n/g, "<br />")) || ""
                  )
                }
              }
            )
          ] })
        },
        o == null ? void 0 : o.created_at
      );
    }),
    t && /* @__PURE__ */ yn.jsx(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: t.map((o, s) => /* @__PURE__ */ yn.jsx(
      cI,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          var l;
          (l = window.open(o.url, "_blank")) == null || l.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ yn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, l8 = "_conversation_1draa_1", u8 = "_conversationSubLine_1draa_9", c8 = "_modal_1draa_14", Od = {
  conversation: l8,
  conversationSubLine: u8,
  modal: c8
}, d8 = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), m8 = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, t]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: t != null && t.value ? t.value.toString() : ""
})), f8 = ({
  conversation: e,
  conversationContext: n
}) => {
  var t, i;
  const [a, o] = me(!1), s = e == null ? void 0 : e.created_at, l = e == null ? void 0 : e.custom_fields, c = l && "attachments" in l;
  return /* @__PURE__ */ yn.jsxs(_, { className: Od.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ yn.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ yn.jsxs(_, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ yn.jsxs(_, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ yn.jsx(q.Heading, { variant: "heading-4", children: e == null ? void 0 : e.id }),
          s && /* @__PURE__ */ yn.jsx(Jn, { size: "small", variant: "info", children: An(e == null ? void 0 : e.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ yn.jsx(
          q.Heading,
          {
            variant: "heading-4",
            className: Od.conversationSubLine,
            children: e == null ? void 0 : e.subject
          }
        ),
        !!((t = e == null ? void 0 : e.labels) != null && t.length) && /* @__PURE__ */ yn.jsx(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((m) => /* @__PURE__ */ yn.jsx(Dn, { children: m }, `${e.id}-${m}`)) })
      ] }),
      /* @__PURE__ */ yn.jsx(nn, { content: "Show conversation preview", children: /* @__PURE__ */ yn.jsx(
        qr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => o(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ yn.jsxs(
      Ht,
      {
        isOpen: a,
        allowEscClose: !0,
        onClose: () => o(!1),
        className: Od.modal,
        children: [
          /* @__PURE__ */ yn.jsx(
            Kt,
            {
              title: "Conversation preview",
              onClose: () => o(!1)
            }
          ),
          /* @__PURE__ */ yn.jsx(Wt, { children: /* @__PURE__ */ yn.jsx(
            s8,
            {
              messages: (e == null ? void 0 : e.messages) || [],
              ...c && {
                attachments: d8(
                  (i = l == null ? void 0 : l.attachments) == null ? void 0 : i.value
                )
              },
              conversationContext: n,
              customFields: m8(
                e == null ? void 0 : e.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, p8 = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: t
}) => {
  const [i, a] = me(!1), o = t > 0 ? t : 1, s = (e == null ? void 0 : e.length) > o, l = At(
    () => e == null ? void 0 : e.sort((c, m) => m == null ? void 0 : m.created_at.localeCompare(c == null ? void 0 : c.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ yn.jsxs(_, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((c, m) => /* @__PURE__ */ yn.jsx(
      f8,
      {
        conversation: c,
        conversationContext: n
      },
      `${m}-${c == null ? void 0 : c.id}`
    )),
    s && /* @__PURE__ */ yn.jsxs(
      Qn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, v8 = RG(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), h8 = ({
  conversationContext: e,
  settings: n
}) => {
  var t, i;
  const [a, o] = me([]), s = Number.parseInt(n == null ? void 0 : n.amountOfConversationsToShow) || 1, l = [
    (t = e.customer) == null ? void 0 : t.email,
    (i = e.customer) == null ? void 0 : i.phone_number
  ].filter((v) => !!v).map((v) => `'${v}'`).join(","), { useQuery: c } = pn(), { data: m, loading: d, error: p } = c(v8, {
    skip: l.length === 0,
    variables: {
      query: `requester_id=in=(${l})`
    }
  });
  return Ge(() => {
    var v, y;
    if (m != null && m.Miuros) {
      const S = (y = (v = m == null ? void 0 : m.Miuros) == null ? void 0 : v.findTickets) == null ? void 0 : y.data;
      S && o(S);
    }
  }, [m]), p ? /* @__PURE__ */ yn.jsx(Fn, { error: p }) : d ? /* @__PURE__ */ yn.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ yn.jsx(fn, {}) }) : (a == null ? void 0 : a.length) === 0 ? /* @__PURE__ */ yn.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ yn.jsx(
    p8,
    {
      "data-testid": "conversation-list",
      conversationsToShow: s,
      conversations: a,
      conversationContext: e
    }
  );
}, y8 = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vu
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Rd = { exports: {} }, xo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nx;
function g8() {
  if (nx) return xo;
  nx = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return xo.Fragment = t, xo.jsx = s, xo.jsxs = s, xo;
}
var sl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tx;
function k8() {
  return tx || (tx = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    sl.Fragment = i, sl.jsx = Mn, sl.jsxs = Un;
  }()), sl;
}
var rx;
function b8() {
  return rx || (rx = 1, process.env.NODE_ENV === "production" ? Rd.exports = g8() : Rd.exports = k8()), Rd.exports;
}
var Fe = b8();
const _8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, x8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, S8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, N8 = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": _8,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": x8,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": S8
};
function ry(e) {
  return N8[e] ?? {};
}
const w8 = ry(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), j8 = ry(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), C8 = ry(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function $v(e = !1, n) {
  const [t, i] = me(e);
  return Ge(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const F8 = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, HC = "DD MMM YYYY @ HH:mm", I8 = "_list_2c4dq_1", $8 = "_listItem_2c4dq_4", E8 = "_copyIcon_2c4dq_12", Vi = {
  list: I8,
  listItem: $8,
  copyIcon: E8
}, Ev = ({
  address: e,
  icon: n,
  title: t,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = $v(), l = 14, {
    first_name: c,
    last_name: m,
    address1: d,
    address2: p,
    city: v,
    zip: y,
    country_code: S
  } = e ?? {}, b = `${c} ${m}`.trim() || void 0, j = `${v} ${y}`.trim() || void 0, x = [b, d, p, j, S].filter(
    Boolean
  );
  return /* @__PURE__ */ Fe.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(_, { gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ye, { size: l, name: n }),
      i ? /* @__PURE__ */ Fe.jsx(fn, { size: l }) : /* @__PURE__ */ Fe.jsxs(_, { gap: "200", flexDirection: "column", children: [
        t && /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "3", children: t }),
        /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: x.map((h, P) => /* @__PURE__ */ Fe.jsx(Wn, { children: h }, P)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Fe.jsxs(_, { gap: "100", children: [
      a && /* @__PURE__ */ Fe.jsx(nn, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Fe.jsx(
        ye,
        {
          size: l,
          name: "exclamation",
          className: Vi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(nn, { content: `Copy ${t ? t.toLowerCase() : "address"}`, children: /* @__PURE__ */ Fe.jsx(
        ye,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(x.join(", ")),
          className: Vi.copyIcon
        }
      ) })
    ] })
  ] });
}, T8 = "_wrapper_1nher_1", O8 = {
  wrapper: T8
}, R8 = ({
  customer: e,
  store: n
}) => {
  const { track: t } = bn(), { isCopied: i, copy: a } = $v(), { isCopied: o, copy: s } = $v(), { useQuery: l } = pn(), [c, m] = me(!1), [d, p] = me(), v = e == null ? void 0 : e.id, { loading: y, error: S } = l(j8, {
    skip: !v,
    variables: {
      customerId: v == null ? void 0 : v.toString()
    },
    onCompleted(Y) {
      var ee;
      const J = (ee = Y == null ? void 0 : Y.Recharge) == null ? void 0 : ee.getAddresses;
      J != null && J.addresses && (J == null ? void 0 : J.addresses.length) > 0 && !y ? (p(J.addresses[0]), t("recharge:profile:received"), J.addresses.length > 1 ? m(!0) : m(!1)) : p(void 0);
    }
  });
  if (S)
    return /* @__PURE__ */ Fe.jsx(Fn, { error: S });
  if (!e)
    return null;
  const {
    id: b,
    phone: j,
    email: x,
    first_name: h,
    last_name: P,
    created_at: N,
    has_valid_payment_method: $
  } = e, O = 14, B = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${b}` : null, Z = `${h || ""} ${P || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Fe.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(_, { className: O8.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(q.Heading, { variant: "heading-2", children: Z }),
    N && /* @__PURE__ */ Fe.jsxs(_, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: An(N).format(HC) })
    ] }),
    x && /* @__PURE__ */ Fe.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ye, { size: O, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(q.ExternalLink, { href: `mailto:${x}`, children: x })
      ] }),
      /* @__PURE__ */ Fe.jsx(nn, { content: "Copy email", children: /* @__PURE__ */ Fe.jsx(
        ye,
        {
          size: O,
          name: i ? "done" : "copy",
          onClick: () => a(x),
          className: Vi.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Fe.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ye, { size: O, name: "phone" }),
        /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ Fe.jsx(nn, { content: "Copy phone number", children: /* @__PURE__ */ Fe.jsx(
        ye,
        {
          size: O,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: Vi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Fe.jsx(
      Ev,
      {
        address: d,
        icon: "home",
        isLoading: y,
        hasMultipleAddresses: c
      }
    ),
    /* @__PURE__ */ Fe.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ye, { size: O, name: "credit-card" }),
        /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Fe.jsx(
        ye,
        {
          size: O,
          name: $ ? "check-circle" : "close-circle-filled",
          color: $ ? "green.500" : "red.500"
        }
      )
    ] }),
    B && /* @__PURE__ */ Fe.jsxs(_, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ye, { size: O, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        q.ExternalLink,
        {
          href: B,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => t("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, D8 = "_order_1dlaa_1", P8 = "_orderIsOpen_1dlaa_9", A8 = "_orderHeader_1dlaa_12", L8 = "_note_1dlaa_16", ll = {
  order: D8,
  orderIsOpen: P8,
  orderHeader: A8,
  note: L8
}, V8 = ({
  order: e,
  isOpenByDefault: n,
  store: t
}) => {
  var i;
  const { track: a } = bn(), [o, s] = me(n), {
    id: l,
    status: c,
    charge: m,
    currency: d,
    note: p,
    created_at: v,
    billing_address: y,
    shipping_address: S,
    total_price: b,
    is_prepaid: j
  } = e, x = 14, h = t ? `https://${t.identifier}.admin.rechargeapps.com/merchant/orders/${l}` : null, P = ((i = m == null ? void 0 : m.external_transaction_id) == null ? void 0 : i.payment_processor) || void 0;
  return /* @__PURE__ */ Fe.jsxs(
    _,
    {
      className: ct(ll.order, {
        [ll.orderIsOpen]: o
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Fe.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ll.orderHeader,
            onClick: () => s(!o),
            children: [
              /* @__PURE__ */ Fe.jsxs(_, { gap: "100", flexDirection: "column", children: [
                v && /* @__PURE__ */ Fe.jsx(_, { alignItems: "center", children: /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: An(v).format(HC) }) }),
                /* @__PURE__ */ Fe.jsxs(q.Paragraph, { variant: "1", children: [
                  "Order #",
                  l
                ] })
              ] }),
              /* @__PURE__ */ Fe.jsx(
                qr,
                {
                  variant: "tertiary",
                  icon: o ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        o && /* @__PURE__ */ Fe.jsxs(_, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          p && /* @__PURE__ */ Fe.jsx(nn, { content: "Note", children: /* @__PURE__ */ Fe.jsx(
            q.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: ll.note,
              children: p
            }
          ) }),
          c && /* @__PURE__ */ Fe.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ye, { size: x, name: "activity" }),
            /* @__PURE__ */ Fe.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: F8(c) })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ye, { size: x, name: "credit-card" }),
            /* @__PURE__ */ Fe.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: j ? "Yes" : "No" })
            ] })
          ] }),
          P && /* @__PURE__ */ Fe.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ye, { size: x, name: "cog" }),
            /* @__PURE__ */ Fe.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: P })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ye, { size: x, name: "chart-bar" }),
            /* @__PURE__ */ Fe.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Fe.jsxs(q.Paragraph, { variant: "4", children: [
                b,
                " ",
                d
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsx(
            Ev,
            {
              address: y,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Fe.jsx(
            Ev,
            {
              address: S,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          h && /* @__PURE__ */ Fe.jsx(
            Ct,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => {
                var N;
                return (N = window.open(h, "_blank")) == null ? void 0 : N.focus();
              },
              slotStart: /* @__PURE__ */ Fe.jsx(ye, { name: "external-link" }),
              onClick: () => a("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, z8 = ({
  customerId: e,
  store: n
}) => {
  const { track: t } = bn(), { useQuery: i } = pn(), [a, o] = me([]), { loading: s, error: l } = i(C8, {
    skip: !e,
    variables: {
      customerId: e == null ? void 0 : e.toString(),
      limit: "5"
    },
    onCompleted(m) {
      var d;
      const p = (d = m == null ? void 0 : m.Recharge) == null ? void 0 : d.getOrders;
      p != null && p.orders && (p == null ? void 0 : p.orders.length) > 0 && !s ? o(p.orders) : o([]);
    }
  });
  if (!e)
    return null;
  if (l)
    return /* @__PURE__ */ Fe.jsx(Fn, { error: l });
  const c = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Fe.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(q.Heading, { variant: "heading-3", children: "Customer orders" }),
      !s && /* @__PURE__ */ Fe.jsx(Jn, { variant: "success", size: "small", children: a.length })
    ] }),
    /* @__PURE__ */ Fe.jsxs(_, { gap: "200", flexDirection: "column", children: [
      s && /* @__PURE__ */ Fe.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(fn, {}) }),
      !s && a.length === 0 && /* @__PURE__ */ Fe.jsx(
        _,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Fe.jsx(q.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !s && a.length > 0 && /* @__PURE__ */ Fe.jsx(_, { gap: "200", flexDirection: "column", children: a.map((m, d) => /* @__PURE__ */ Fe.jsx(
        V8,
        {
          order: m,
          isOpenByDefault: d === 0,
          store: n
        },
        `${d}-${m.id}`
      )) }),
      c && /* @__PURE__ */ Fe.jsx(
        Ct,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => {
            var m;
            return (m = window.open(c, "_blank")) == null ? void 0 : m.focus();
          },
          slotStart: /* @__PURE__ */ Fe.jsx(ye, { name: "external-link" }),
          onClick: () => t("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, M8 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: t
  } = e, i = t ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Fe.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(q.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Fe.jsxs(Je, { className: Vi.list, children: [
      /* @__PURE__ */ Fe.jsx(Je.Text, { variant: "dense", className: Vi.listItem, children: /* @__PURE__ */ Fe.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Fe.jsx(Je.Text, { variant: "dense", className: Vi.listItem, children: /* @__PURE__ */ Fe.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Fe.jsx(q.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, U8 = ({
  conversationContext: e,
  settings: n
}) => {
  var t;
  const { useQuery: i } = pn(), [a, o] = me(), [s, l] = me(), c = (t = e == null ? void 0 : e.customer) == null ? void 0 : t.email, m = n.displayCustomerDetails ?? !1, d = n.displaysubscriptionOverview ?? !1, p = n.displayOrders ?? !1, v = !m && !d && !p, { loading: y, error: S } = i(w8, {
    skip: !c,
    variables: {
      email: c
    },
    onCompleted(b) {
      var j, x, h;
      const P = (j = b == null ? void 0 : b.Recharge) == null ? void 0 : j.getCustomers, N = (x = b == null ? void 0 : b.Recharge) == null ? void 0 : x.getStore;
      P != null && P.customers && ((h = P == null ? void 0 : P.customers) == null ? void 0 : h.length) > 0 && !y ? o(P.customers[0]) : o(void 0), N != null && N.store && !y ? l(N.store) : l(void 0);
    }
  });
  return S ? Pv({ errors: S.graphQLErrors }) ? /* @__PURE__ */ Fe.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-forbidden-error",
      children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
    }
  ) : Av({ errors: S.graphQLErrors }) ? /* @__PURE__ */ Fe.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-authorization-error",
      children: "The integration could not authorize against Recharge. Please contact your administrator."
    }
  ) : /* @__PURE__ */ Fe.jsx(Fn, { error: S }) : y ? /* @__PURE__ */ Fe.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(fn, {}) }) : a ? v ? /* @__PURE__ */ Fe.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Fe.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        m && /* @__PURE__ */ Fe.jsx(R8, { customer: a, store: s }),
        d && /* @__PURE__ */ Fe.jsx(M8, { customer: a }),
        p && /* @__PURE__ */ Fe.jsx(z8, { customerId: a.id, store: s })
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, B8 = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var ul = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function KC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Dd = { exports: {} }, So = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ix;
function q8() {
  if (ix) return So;
  ix = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return So.Fragment = t, So.jsx = s, So.jsxs = s, So;
}
var cl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ax;
function H8() {
  return ax || (ax = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    cl.Fragment = i, cl.jsx = Mn, cl.jsxs = Un;
  }()), cl;
}
var ox;
function K8() {
  return ox || (ox = 1, process.env.NODE_ENV === "production" ? Dd.exports = q8() : Dd.exports = H8()), Dd.exports;
}
var zi = K8();
function W8(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Pd, sx;
function Si() {
  if (sx) return Pd;
  sx = 1;
  var e = Array.isArray;
  return Pd = e, Pd;
}
var Ad, lx;
function WC() {
  if (lx) return Ad;
  lx = 1;
  var e = typeof ul == "object" && ul && ul.Object === Object && ul;
  return Ad = e, Ad;
}
var Ld, ux;
function Kr() {
  if (ux) return Ld;
  ux = 1;
  var e = WC(), n = typeof self == "object" && self && self.Object === Object && self, t = e || n || Function("return this")();
  return Ld = t, Ld;
}
var Vd, cx;
function Ss() {
  if (cx) return Vd;
  cx = 1;
  var e = Kr(), n = e.Symbol;
  return Vd = n, Vd;
}
var zd, dx;
function G8() {
  if (dx) return zd;
  dx = 1;
  var e = Ss(), n = Object.prototype, t = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = t.call(s, a), c = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var d = i.call(s);
    return m && (l ? s[a] = c : delete s[a]), d;
  }
  return zd = o, zd;
}
var Md, mx;
function Y8() {
  if (mx) return Md;
  mx = 1;
  var e = Object.prototype, n = e.toString;
  function t(i) {
    return n.call(i);
  }
  return Md = t, Md;
}
var Ud, fx;
function qa() {
  if (fx) return Ud;
  fx = 1;
  var e = Ss(), n = G8(), t = Y8(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : t(l);
  }
  return Ud = s, Ud;
}
var Bd, px;
function Wi() {
  if (px) return Bd;
  px = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Bd = e, Bd;
}
var qd, vx;
function iy() {
  if (vx) return qd;
  vx = 1;
  var e = qa(), n = Wi(), t = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == t;
  }
  return qd = i, qd;
}
var Hd, hx;
function J8() {
  if (hx) return Hd;
  hx = 1;
  var e = Si(), n = iy(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !t.test(o) || s != null && o in Object(s);
  }
  return Hd = a, Hd;
}
var Kd, yx;
function Ha() {
  if (yx) return Kd;
  yx = 1;
  function e(n) {
    var t = typeof n;
    return n != null && (t == "object" || t == "function");
  }
  return Kd = e, Kd;
}
var Wd, gx;
function GC() {
  if (gx) return Wd;
  gx = 1;
  var e = qa(), n = Ha(), t = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var c = e(l);
    return c == i || c == a || c == t || c == o;
  }
  return Wd = s, Wd;
}
var Gd, kx;
function Q8() {
  if (kx) return Gd;
  kx = 1;
  var e = Kr(), n = e["__core-js_shared__"];
  return Gd = n, Gd;
}
var Yd, bx;
function X8() {
  if (bx) return Yd;
  bx = 1;
  var e = Q8(), n = function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  }();
  function t(i) {
    return !!n && n in i;
  }
  return Yd = t, Yd;
}
var Jd, _x;
function YC() {
  if (_x) return Jd;
  _x = 1;
  var e = Function.prototype, n = e.toString;
  function t(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Jd = t, Jd;
}
var Qd, xx;
function Z8() {
  if (xx) return Qd;
  xx = 1;
  var e = GC(), n = X8(), t = Ha(), i = YC(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, c = s.toString, m = l.hasOwnProperty, d = RegExp(
    "^" + c.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function p(v) {
    if (!t(v) || n(v))
      return !1;
    var y = e(v) ? d : o;
    return y.test(i(v));
  }
  return Qd = p, Qd;
}
var Xd, Sx;
function eY() {
  if (Sx) return Xd;
  Sx = 1;
  function e(n, t) {
    return n == null ? void 0 : n[t];
  }
  return Xd = e, Xd;
}
var Zd, Nx;
function Gi() {
  if (Nx) return Zd;
  Nx = 1;
  var e = Z8(), n = eY();
  function t(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Zd = t, Zd;
}
var em, wx;
function Yu() {
  if (wx) return em;
  wx = 1;
  var e = Gi(), n = e(Object, "create");
  return em = n, em;
}
var nm, jx;
function nY() {
  if (jx) return nm;
  jx = 1;
  var e = Yu();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return nm = n, nm;
}
var tm, Cx;
function tY() {
  if (Cx) return tm;
  Cx = 1;
  function e(n) {
    var t = this.has(n) && delete this.__data__[n];
    return this.size -= t ? 1 : 0, t;
  }
  return tm = e, tm;
}
var rm, Fx;
function rY() {
  if (Fx) return rm;
  Fx = 1;
  var e = Yu(), n = "__lodash_hash_undefined__", t = Object.prototype, i = t.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return rm = a, rm;
}
var im, Ix;
function iY() {
  if (Ix) return im;
  Ix = 1;
  var e = Yu(), n = Object.prototype, t = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : t.call(o, a);
  }
  return im = i, im;
}
var am, $x;
function aY() {
  if ($x) return am;
  $x = 1;
  var e = Yu(), n = "__lodash_hash_undefined__";
  function t(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return am = t, am;
}
var om, Ex;
function oY() {
  if (Ex) return om;
  Ex = 1;
  var e = nY(), n = tY(), t = rY(), i = iY(), a = aY();
  function o(s) {
    var l = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++l < c; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, om = o, om;
}
var sm, Tx;
function sY() {
  if (Tx) return sm;
  Tx = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return sm = e, sm;
}
var lm, Ox;
function JC() {
  if (Ox) return lm;
  Ox = 1;
  function e(n, t) {
    return n === t || n !== n && t !== t;
  }
  return lm = e, lm;
}
var um, Rx;
function Ju() {
  if (Rx) return um;
  Rx = 1;
  var e = JC();
  function n(t, i) {
    for (var a = t.length; a--; )
      if (e(t[a][0], i))
        return a;
    return -1;
  }
  return um = n, um;
}
var cm, Dx;
function lY() {
  if (Dx) return cm;
  Dx = 1;
  var e = Ju(), n = Array.prototype, t = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : t.call(o, s, 1), --this.size, !0;
  }
  return cm = i, cm;
}
var dm, Px;
function uY() {
  if (Px) return dm;
  Px = 1;
  var e = Ju();
  function n(t) {
    var i = this.__data__, a = e(i, t);
    return a < 0 ? void 0 : i[a][1];
  }
  return dm = n, dm;
}
var mm, Ax;
function cY() {
  if (Ax) return mm;
  Ax = 1;
  var e = Ju();
  function n(t) {
    return e(this.__data__, t) > -1;
  }
  return mm = n, mm;
}
var fm, Lx;
function dY() {
  if (Lx) return fm;
  Lx = 1;
  var e = Ju();
  function n(t, i) {
    var a = this.__data__, o = e(a, t);
    return o < 0 ? (++this.size, a.push([t, i])) : a[o][1] = i, this;
  }
  return fm = n, fm;
}
var pm, Vx;
function Qu() {
  if (Vx) return pm;
  Vx = 1;
  var e = sY(), n = lY(), t = uY(), i = cY(), a = dY();
  function o(s) {
    var l = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++l < c; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, pm = o, pm;
}
var vm, zx;
function ay() {
  if (zx) return vm;
  zx = 1;
  var e = Gi(), n = Kr(), t = e(n, "Map");
  return vm = t, vm;
}
var hm, Mx;
function mY() {
  if (Mx) return hm;
  Mx = 1;
  var e = oY(), n = Qu(), t = ay();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || n)(),
      string: new e()
    };
  }
  return hm = i, hm;
}
var ym, Ux;
function fY() {
  if (Ux) return ym;
  Ux = 1;
  function e(n) {
    var t = typeof n;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
  }
  return ym = e, ym;
}
var gm, Bx;
function Xu() {
  if (Bx) return gm;
  Bx = 1;
  var e = fY();
  function n(t, i) {
    var a = t.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return gm = n, gm;
}
var km, qx;
function pY() {
  if (qx) return km;
  qx = 1;
  var e = Xu();
  function n(t) {
    var i = e(this, t).delete(t);
    return this.size -= i ? 1 : 0, i;
  }
  return km = n, km;
}
var bm, Hx;
function vY() {
  if (Hx) return bm;
  Hx = 1;
  var e = Xu();
  function n(t) {
    return e(this, t).get(t);
  }
  return bm = n, bm;
}
var _m, Kx;
function hY() {
  if (Kx) return _m;
  Kx = 1;
  var e = Xu();
  function n(t) {
    return e(this, t).has(t);
  }
  return _m = n, _m;
}
var xm, Wx;
function yY() {
  if (Wx) return xm;
  Wx = 1;
  var e = Xu();
  function n(t, i) {
    var a = e(this, t), o = a.size;
    return a.set(t, i), this.size += a.size == o ? 0 : 1, this;
  }
  return xm = n, xm;
}
var Sm, Gx;
function QC() {
  if (Gx) return Sm;
  Gx = 1;
  var e = mY(), n = pY(), t = vY(), i = hY(), a = yY();
  function o(s) {
    var l = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++l < c; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, Sm = o, Sm;
}
var Nm, Yx;
function gY() {
  if (Yx) return Nm;
  Yx = 1;
  var e = QC(), n = "Expected a function";
  function t(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], c = o.cache;
      if (c.has(l))
        return c.get(l);
      var m = i.apply(this, s);
      return o.cache = c.set(l, m) || c, m;
    };
    return o.cache = new (t.Cache || e)(), o;
  }
  return t.Cache = e, Nm = t, Nm;
}
var wm, Jx;
function kY() {
  if (Jx) return wm;
  Jx = 1;
  var e = gY(), n = 500;
  function t(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return wm = t, wm;
}
var jm, Qx;
function bY() {
  if (Qx) return jm;
  Qx = 1;
  var e = kY(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, c, m) {
      o.push(c ? m.replace(t, "$1") : l || s);
    }), o;
  });
  return jm = i, jm;
}
var Cm, Xx;
function XC() {
  if (Xx) return Cm;
  Xx = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = t(n[i], i, n);
    return o;
  }
  return Cm = e, Cm;
}
var Fm, Zx;
function _Y() {
  if (Zx) return Fm;
  Zx = 1;
  var e = Ss(), n = XC(), t = Si(), i = iy(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (t(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var c = l + "";
    return c == "0" && 1 / l == -1 / 0 ? "-0" : c;
  }
  return Fm = s, Fm;
}
var Im, e0;
function xY() {
  if (e0) return Im;
  e0 = 1;
  var e = _Y();
  function n(t) {
    return t == null ? "" : e(t);
  }
  return Im = n, Im;
}
var $m, n0;
function Ka() {
  if (n0) return $m;
  n0 = 1;
  var e = Si(), n = J8(), t = bY(), i = xY();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : t(i(o));
  }
  return $m = a, $m;
}
var Em, t0;
function Zu() {
  if (t0) return Em;
  t0 = 1;
  var e = iy();
  function n(t) {
    if (typeof t == "string" || e(t))
      return t;
    var i = t + "";
    return i == "0" && 1 / t == -1 / 0 ? "-0" : i;
  }
  return Em = n, Em;
}
var Tm, r0;
function ZC() {
  if (r0) return Tm;
  r0 = 1;
  var e = Ka(), n = Zu();
  function t(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Tm = t, Tm;
}
var Om, i0;
function eF() {
  if (i0) return Om;
  i0 = 1;
  var e = Gi(), n = function() {
    try {
      var t = e(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  }();
  return Om = n, Om;
}
var Rm, a0;
function nF() {
  if (a0) return Rm;
  a0 = 1;
  var e = eF();
  function n(t, i, a) {
    i == "__proto__" && e ? e(t, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : t[i] = a;
  }
  return Rm = n, Rm;
}
var Dm, o0;
function oy() {
  if (o0) return Dm;
  o0 = 1;
  var e = nF(), n = JC(), t = Object.prototype, i = t.hasOwnProperty;
  function a(o, s, l) {
    var c = o[s];
    (!(i.call(o, s) && n(c, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Dm = a, Dm;
}
var Pm, s0;
function sy() {
  if (s0) return Pm;
  s0 = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function t(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Pm = t, Pm;
}
var Am, l0;
function SY() {
  if (l0) return Am;
  l0 = 1;
  var e = oy(), n = Ka(), t = sy(), i = Ha(), a = Zu();
  function o(s, l, c, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, p = l.length, v = p - 1, y = s; y != null && ++d < p; ) {
      var S = a(l[d]), b = c;
      if (S === "__proto__" || S === "constructor" || S === "prototype")
        return s;
      if (d != v) {
        var j = y[S];
        b = m ? m(j, S, y) : void 0, b === void 0 && (b = i(j) ? j : t(l[d + 1]) ? [] : {});
      }
      e(y, S, b), y = y[S];
    }
    return s;
  }
  return Am = o, Am;
}
var Lm, u0;
function NY() {
  if (u0) return Lm;
  u0 = 1;
  var e = ZC(), n = SY(), t = Ka();
  function i(a, o, s) {
    for (var l = -1, c = o.length, m = {}; ++l < c; ) {
      var d = o[l], p = e(a, d);
      s(p, d) && n(m, t(d, a), p);
    }
    return m;
  }
  return Lm = i, Lm;
}
var Vm, c0;
function wY() {
  if (c0) return Vm;
  c0 = 1;
  function e(n, t) {
    return n != null && t in Object(n);
  }
  return Vm = e, Vm;
}
var zm, d0;
function jY() {
  if (d0) return zm;
  d0 = 1;
  var e = qa(), n = Wi(), t = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return zm = i, zm;
}
var Mm, m0;
function ly() {
  if (m0) return Mm;
  m0 = 1;
  var e = jY(), n = Wi(), t = Object.prototype, i = t.hasOwnProperty, a = t.propertyIsEnumerable, o = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Mm = o, Mm;
}
var Um, f0;
function uy() {
  if (f0) return Um;
  f0 = 1;
  var e = 9007199254740991;
  function n(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
  }
  return Um = n, Um;
}
var Bm, p0;
function CY() {
  if (p0) return Bm;
  p0 = 1;
  var e = Ka(), n = ly(), t = Si(), i = sy(), a = uy(), o = Zu();
  function s(l, c, m) {
    c = e(c, l);
    for (var d = -1, p = c.length, v = !1; ++d < p; ) {
      var y = o(c[d]);
      if (!(v = l != null && m(l, y)))
        break;
      l = l[y];
    }
    return v || ++d != p ? v : (p = l == null ? 0 : l.length, !!p && a(p) && i(y, p) && (t(l) || n(l)));
  }
  return Bm = s, Bm;
}
var qm, v0;
function FY() {
  if (v0) return qm;
  v0 = 1;
  var e = wY(), n = CY();
  function t(i, a) {
    return i != null && n(i, a, e);
  }
  return qm = t, qm;
}
var Hm, h0;
function IY() {
  if (h0) return Hm;
  h0 = 1;
  var e = NY(), n = FY();
  function t(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Hm = t, Hm;
}
var Km, y0;
function cy() {
  if (y0) return Km;
  y0 = 1;
  function e(n, t) {
    for (var i = -1, a = t.length, o = n.length; ++i < a; )
      n[o + i] = t[i];
    return n;
  }
  return Km = e, Km;
}
var Wm, g0;
function $Y() {
  if (g0) return Wm;
  g0 = 1;
  var e = Ss(), n = ly(), t = Si(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return t(o) || n(o) || !!(i && o && o[i]);
  }
  return Wm = a, Wm;
}
var Gm, k0;
function EY() {
  if (k0) return Gm;
  k0 = 1;
  var e = cy(), n = $Y();
  function t(i, a, o, s, l) {
    var c = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++c < m; ) {
      var d = i[c];
      a > 0 && o(d) ? a > 1 ? t(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return Gm = t, Gm;
}
var Ym, b0;
function TY() {
  if (b0) return Ym;
  b0 = 1;
  var e = EY();
  function n(t) {
    var i = t == null ? 0 : t.length;
    return i ? e(t, 1) : [];
  }
  return Ym = n, Ym;
}
var Jm, _0;
function OY() {
  if (_0) return Jm;
  _0 = 1;
  function e(n, t, i) {
    switch (i.length) {
      case 0:
        return n.call(t);
      case 1:
        return n.call(t, i[0]);
      case 2:
        return n.call(t, i[0], i[1]);
      case 3:
        return n.call(t, i[0], i[1], i[2]);
    }
    return n.apply(t, i);
  }
  return Jm = e, Jm;
}
var Qm, x0;
function RY() {
  if (x0) return Qm;
  x0 = 1;
  var e = OY(), n = Math.max;
  function t(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, c = n(s.length - a, 0), m = Array(c); ++l < c; )
        m[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(m), e(i, this, d);
    };
  }
  return Qm = t, Qm;
}
var Xm, S0;
function DY() {
  if (S0) return Xm;
  S0 = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Xm = e, Xm;
}
var Zm, N0;
function tF() {
  if (N0) return Zm;
  N0 = 1;
  function e(n) {
    return n;
  }
  return Zm = e, Zm;
}
var ef, w0;
function PY() {
  if (w0) return ef;
  w0 = 1;
  var e = DY(), n = eF(), t = tF(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : t;
  return ef = i, ef;
}
var nf, j0;
function AY() {
  if (j0) return nf;
  j0 = 1;
  var e = 800, n = 16, t = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = t(), c = n - (l - s);
      if (s = l, c > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return nf = i, nf;
}
var tf, C0;
function LY() {
  if (C0) return tf;
  C0 = 1;
  var e = PY(), n = AY(), t = n(e);
  return tf = t, tf;
}
var rf, F0;
function rF() {
  if (F0) return rf;
  F0 = 1;
  var e = TY(), n = RY(), t = LY();
  function i(a) {
    return t(n(a, void 0, e), a + "");
  }
  return rf = i, rf;
}
var af, I0;
function VY() {
  if (I0) return af;
  I0 = 1;
  var e = IY(), n = rF(), t = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return af = t, af;
}
var zY = VY();
const iF = /* @__PURE__ */ KC(zY), MY = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function aF(e) {
  const n = iF(e, MY);
  return {
    controller: z1(n),
    controllerProps: n
  };
}
const UY = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function oF(e) {
  var n, t, i, a;
  const { controller: o, controllerProps: s } = aF(e), l = {
    ...iF(e, UY),
    required: W8((n = s.rules) == null ? void 0 : n.required),
    meta: {
      touched: o.fieldState.isTouched,
      error: (t = o.fieldState.error) == null ? void 0 : t.message,
      success: (i = e.meta) == null ? void 0 : i.success,
      warning: (a = e.meta) == null ? void 0 : a.warning
    },
    labelFor: s.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: o,
    controllerProps: s,
    fieldWrapperProps: l
  };
}
var of, $0;
function BY() {
  if ($0) return of;
  $0 = 1;
  var e = Qu();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return of = n, of;
}
var sf, E0;
function qY() {
  if (E0) return sf;
  E0 = 1;
  function e(n) {
    var t = this.__data__, i = t.delete(n);
    return this.size = t.size, i;
  }
  return sf = e, sf;
}
var lf, T0;
function HY() {
  if (T0) return lf;
  T0 = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return lf = e, lf;
}
var uf, O0;
function KY() {
  if (O0) return uf;
  O0 = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return uf = e, uf;
}
var cf, R0;
function WY() {
  if (R0) return cf;
  R0 = 1;
  var e = Qu(), n = ay(), t = QC(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var c = l.__data__;
      if (!n || c.length < i - 1)
        return c.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new t(c);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return cf = a, cf;
}
var df, D0;
function GY() {
  if (D0) return df;
  D0 = 1;
  var e = Qu(), n = BY(), t = qY(), i = HY(), a = KY(), o = WY();
  function s(l) {
    var c = this.__data__ = new e(l);
    this.size = c.size;
  }
  return s.prototype.clear = n, s.prototype.delete = t, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, df = s, df;
}
var mf, P0;
function YY() {
  if (P0) return mf;
  P0 = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && t(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return mf = e, mf;
}
var ff, A0;
function Ns() {
  if (A0) return ff;
  A0 = 1;
  var e = oy(), n = nF();
  function t(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var c = -1, m = a.length; ++c < m; ) {
      var d = a[c], p = s ? s(o[d], i[d], d, o, i) : void 0;
      p === void 0 && (p = i[d]), l ? n(o, d, p) : e(o, d, p);
    }
    return o;
  }
  return ff = t, ff;
}
var pf, L0;
function JY() {
  if (L0) return pf;
  L0 = 1;
  function e(n, t) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = t(i);
    return a;
  }
  return pf = e, pf;
}
var Tl = { exports: {} }, vf, V0;
function QY() {
  if (V0) return vf;
  V0 = 1;
  function e() {
    return !1;
  }
  return vf = e, vf;
}
Tl.exports;
var z0;
function sF() {
  return z0 || (z0 = 1, function(e, n) {
    var t = Kr(), i = QY(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? t.Buffer : void 0, c = l ? l.isBuffer : void 0, m = c || i;
    e.exports = m;
  }(Tl, Tl.exports)), Tl.exports;
}
var hf, M0;
function XY() {
  if (M0) return hf;
  M0 = 1;
  var e = qa(), n = uy(), t = Wi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", c = "[object Function]", m = "[object Map]", d = "[object Number]", p = "[object Object]", v = "[object RegExp]", y = "[object Set]", S = "[object String]", b = "[object WeakMap]", j = "[object ArrayBuffer]", x = "[object DataView]", h = "[object Float32Array]", P = "[object Float64Array]", N = "[object Int8Array]", $ = "[object Int16Array]", O = "[object Int32Array]", B = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", Y = "[object Uint16Array]", ee = "[object Uint32Array]", J = {};
  J[h] = J[P] = J[N] = J[$] = J[O] = J[B] = J[Z] = J[Y] = J[ee] = !0, J[i] = J[a] = J[j] = J[o] = J[x] = J[s] = J[l] = J[c] = J[m] = J[d] = J[p] = J[v] = J[y] = J[S] = J[b] = !1;
  function K(V) {
    return t(V) && n(V.length) && !!J[e(V)];
  }
  return hf = K, hf;
}
var yf, U0;
function dy() {
  if (U0) return yf;
  U0 = 1;
  function e(n) {
    return function(t) {
      return n(t);
    };
  }
  return yf = e, yf;
}
var Ol = { exports: {} };
Ol.exports;
var B0;
function my() {
  return B0 || (B0 = 1, function(e, n) {
    var t = WC(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && t.process, l = function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || s && s.binding && s.binding("util");
      } catch {
      }
    }();
    e.exports = l;
  }(Ol, Ol.exports)), Ol.exports;
}
var gf, q0;
function ZY() {
  if (q0) return gf;
  q0 = 1;
  var e = XY(), n = dy(), t = my(), i = t && t.isTypedArray, a = i ? n(i) : e;
  return gf = a, gf;
}
var kf, H0;
function lF() {
  if (H0) return kf;
  H0 = 1;
  var e = JY(), n = ly(), t = Si(), i = sF(), a = sy(), o = ZY(), s = Object.prototype, l = s.hasOwnProperty;
  function c(m, d) {
    var p = t(m), v = !p && n(m), y = !p && !v && i(m), S = !p && !v && !y && o(m), b = p || v || y || S, j = b ? e(m.length, String) : [], x = j.length;
    for (var h in m)
      (d || l.call(m, h)) && !(b && // Safari 9 has enumerable `arguments.length` in strict mode.
      (h == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      y && (h == "offset" || h == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      S && (h == "buffer" || h == "byteLength" || h == "byteOffset") || // Skip index properties.
      a(h, x))) && j.push(h);
    return j;
  }
  return kf = c, kf;
}
var bf, K0;
function fy() {
  if (K0) return bf;
  K0 = 1;
  var e = Object.prototype;
  function n(t) {
    var i = t && t.constructor, a = typeof i == "function" && i.prototype || e;
    return t === a;
  }
  return bf = n, bf;
}
var _f, W0;
function uF() {
  if (W0) return _f;
  W0 = 1;
  function e(n, t) {
    return function(i) {
      return n(t(i));
    };
  }
  return _f = e, _f;
}
var xf, G0;
function eJ() {
  if (G0) return xf;
  G0 = 1;
  var e = uF(), n = e(Object.keys, Object);
  return xf = n, xf;
}
var Sf, Y0;
function nJ() {
  if (Y0) return Sf;
  Y0 = 1;
  var e = fy(), n = eJ(), t = Object.prototype, i = t.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Sf = a, Sf;
}
var Nf, J0;
function cF() {
  if (J0) return Nf;
  J0 = 1;
  var e = GC(), n = uy();
  function t(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Nf = t, Nf;
}
var wf, Q0;
function py() {
  if (Q0) return wf;
  Q0 = 1;
  var e = lF(), n = nJ(), t = cF();
  function i(a) {
    return t(a) ? e(a) : n(a);
  }
  return wf = i, wf;
}
var jf, X0;
function tJ() {
  if (X0) return jf;
  X0 = 1;
  var e = Ns(), n = py();
  function t(i, a) {
    return i && e(a, n(a), i);
  }
  return jf = t, jf;
}
var Cf, Z0;
function rJ() {
  if (Z0) return Cf;
  Z0 = 1;
  function e(n) {
    var t = [];
    if (n != null)
      for (var i in Object(n))
        t.push(i);
    return t;
  }
  return Cf = e, Cf;
}
var Ff, eS;
function iJ() {
  if (eS) return Ff;
  eS = 1;
  var e = Ha(), n = fy(), t = rJ(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return t(s);
    var l = n(s), c = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || c.push(m);
    return c;
  }
  return Ff = o, Ff;
}
var If, nS;
function vy() {
  if (nS) return If;
  nS = 1;
  var e = lF(), n = iJ(), t = cF();
  function i(a) {
    return t(a) ? e(a, !0) : n(a);
  }
  return If = i, If;
}
var $f, tS;
function aJ() {
  if (tS) return $f;
  tS = 1;
  var e = Ns(), n = vy();
  function t(i, a) {
    return i && e(a, n(a), i);
  }
  return $f = t, $f;
}
var Rl = { exports: {} };
Rl.exports;
var rS;
function oJ() {
  return rS || (rS = 1, function(e, n) {
    var t = Kr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? t.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function c(m, d) {
      if (d)
        return m.slice();
      var p = m.length, v = l ? l(p) : new m.constructor(p);
      return m.copy(v), v;
    }
    e.exports = c;
  }(Rl, Rl.exports)), Rl.exports;
}
var Ef, iS;
function sJ() {
  if (iS) return Ef;
  iS = 1;
  function e(n, t) {
    var i = -1, a = n.length;
    for (t || (t = Array(a)); ++i < a; )
      t[i] = n[i];
    return t;
  }
  return Ef = e, Ef;
}
var Tf, aS;
function lJ() {
  if (aS) return Tf;
  aS = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      t(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Tf = e, Tf;
}
var Of, oS;
function dF() {
  if (oS) return Of;
  oS = 1;
  function e() {
    return [];
  }
  return Of = e, Of;
}
var Rf, sS;
function hy() {
  if (sS) return Rf;
  sS = 1;
  var e = lJ(), n = dF(), t = Object.prototype, i = t.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Rf = o, Rf;
}
var Df, lS;
function uJ() {
  if (lS) return Df;
  lS = 1;
  var e = Ns(), n = hy();
  function t(i, a) {
    return e(i, n(i), a);
  }
  return Df = t, Df;
}
var Pf, uS;
function yy() {
  if (uS) return Pf;
  uS = 1;
  var e = uF(), n = e(Object.getPrototypeOf, Object);
  return Pf = n, Pf;
}
var Af, cS;
function mF() {
  if (cS) return Af;
  cS = 1;
  var e = cy(), n = yy(), t = hy(), i = dF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, t(s)), s = n(s);
    return l;
  } : i;
  return Af = o, Af;
}
var Lf, dS;
function cJ() {
  if (dS) return Lf;
  dS = 1;
  var e = Ns(), n = mF();
  function t(i, a) {
    return e(i, n(i), a);
  }
  return Lf = t, Lf;
}
var Vf, mS;
function fF() {
  if (mS) return Vf;
  mS = 1;
  var e = cy(), n = Si();
  function t(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Vf = t, Vf;
}
var zf, fS;
function dJ() {
  if (fS) return zf;
  fS = 1;
  var e = fF(), n = hy(), t = py();
  function i(a) {
    return e(a, t, n);
  }
  return zf = i, zf;
}
var Mf, pS;
function pF() {
  if (pS) return Mf;
  pS = 1;
  var e = fF(), n = mF(), t = vy();
  function i(a) {
    return e(a, t, n);
  }
  return Mf = i, Mf;
}
var Uf, vS;
function mJ() {
  if (vS) return Uf;
  vS = 1;
  var e = Gi(), n = Kr(), t = e(n, "DataView");
  return Uf = t, Uf;
}
var Bf, hS;
function fJ() {
  if (hS) return Bf;
  hS = 1;
  var e = Gi(), n = Kr(), t = e(n, "Promise");
  return Bf = t, Bf;
}
var qf, yS;
function pJ() {
  if (yS) return qf;
  yS = 1;
  var e = Gi(), n = Kr(), t = e(n, "Set");
  return qf = t, qf;
}
var Hf, gS;
function vJ() {
  if (gS) return Hf;
  gS = 1;
  var e = Gi(), n = Kr(), t = e(n, "WeakMap");
  return Hf = t, Hf;
}
var Kf, kS;
function gy() {
  if (kS) return Kf;
  kS = 1;
  var e = mJ(), n = ay(), t = fJ(), i = pJ(), a = vJ(), o = qa(), s = YC(), l = "[object Map]", c = "[object Object]", m = "[object Promise]", d = "[object Set]", p = "[object WeakMap]", v = "[object DataView]", y = s(e), S = s(n), b = s(t), j = s(i), x = s(a), h = o;
  return (e && h(new e(new ArrayBuffer(1))) != v || n && h(new n()) != l || t && h(t.resolve()) != m || i && h(new i()) != d || a && h(new a()) != p) && (h = function(P) {
    var N = o(P), $ = N == c ? P.constructor : void 0, O = $ ? s($) : "";
    if (O)
      switch (O) {
        case y:
          return v;
        case S:
          return l;
        case b:
          return m;
        case j:
          return d;
        case x:
          return p;
      }
    return N;
  }), Kf = h, Kf;
}
var Wf, bS;
function hJ() {
  if (bS) return Wf;
  bS = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function t(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Wf = t, Wf;
}
var Gf, _S;
function yJ() {
  if (_S) return Gf;
  _S = 1;
  var e = Kr(), n = e.Uint8Array;
  return Gf = n, Gf;
}
var Yf, xS;
function ky() {
  if (xS) return Yf;
  xS = 1;
  var e = yJ();
  function n(t) {
    var i = new t.constructor(t.byteLength);
    return new e(i).set(new e(t)), i;
  }
  return Yf = n, Yf;
}
var Jf, SS;
function gJ() {
  if (SS) return Jf;
  SS = 1;
  var e = ky();
  function n(t, i) {
    var a = i ? e(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.byteLength);
  }
  return Jf = n, Jf;
}
var Qf, NS;
function kJ() {
  if (NS) return Qf;
  NS = 1;
  var e = /\w*$/;
  function n(t) {
    var i = new t.constructor(t.source, e.exec(t));
    return i.lastIndex = t.lastIndex, i;
  }
  return Qf = n, Qf;
}
var Xf, wS;
function bJ() {
  if (wS) return Xf;
  wS = 1;
  var e = Ss(), n = e ? e.prototype : void 0, t = n ? n.valueOf : void 0;
  function i(a) {
    return t ? Object(t.call(a)) : {};
  }
  return Xf = i, Xf;
}
var Zf, jS;
function _J() {
  if (jS) return Zf;
  jS = 1;
  var e = ky();
  function n(t, i) {
    var a = i ? e(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.length);
  }
  return Zf = n, Zf;
}
var ep, CS;
function xJ() {
  if (CS) return ep;
  CS = 1;
  var e = ky(), n = gJ(), t = kJ(), i = bJ(), a = _J(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", c = "[object Number]", m = "[object RegExp]", d = "[object Set]", p = "[object String]", v = "[object Symbol]", y = "[object ArrayBuffer]", S = "[object DataView]", b = "[object Float32Array]", j = "[object Float64Array]", x = "[object Int8Array]", h = "[object Int16Array]", P = "[object Int32Array]", N = "[object Uint8Array]", $ = "[object Uint8ClampedArray]", O = "[object Uint16Array]", B = "[object Uint32Array]";
  function Z(Y, ee, J) {
    var K = Y.constructor;
    switch (ee) {
      case y:
        return e(Y);
      case o:
      case s:
        return new K(+Y);
      case S:
        return n(Y, J);
      case b:
      case j:
      case x:
      case h:
      case P:
      case N:
      case $:
      case O:
      case B:
        return a(Y, J);
      case l:
        return new K();
      case c:
      case p:
        return new K(Y);
      case m:
        return t(Y);
      case d:
        return new K();
      case v:
        return i(Y);
    }
  }
  return ep = Z, ep;
}
var np, FS;
function SJ() {
  if (FS) return np;
  FS = 1;
  var e = Ha(), n = Object.create, t = /* @__PURE__ */ function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  }();
  return np = t, np;
}
var tp, IS;
function NJ() {
  if (IS) return tp;
  IS = 1;
  var e = SJ(), n = yy(), t = fy();
  function i(a) {
    return typeof a.constructor == "function" && !t(a) ? e(n(a)) : {};
  }
  return tp = i, tp;
}
var rp, $S;
function wJ() {
  if ($S) return rp;
  $S = 1;
  var e = gy(), n = Wi(), t = "[object Map]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return rp = i, rp;
}
var ip, ES;
function jJ() {
  if (ES) return ip;
  ES = 1;
  var e = wJ(), n = dy(), t = my(), i = t && t.isMap, a = i ? n(i) : e;
  return ip = a, ip;
}
var ap, TS;
function CJ() {
  if (TS) return ap;
  TS = 1;
  var e = gy(), n = Wi(), t = "[object Set]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return ap = i, ap;
}
var op, OS;
function FJ() {
  if (OS) return op;
  OS = 1;
  var e = CJ(), n = dy(), t = my(), i = t && t.isSet, a = i ? n(i) : e;
  return op = a, op;
}
var sp, RS;
function IJ() {
  if (RS) return sp;
  RS = 1;
  var e = GY(), n = YY(), t = oy(), i = tJ(), a = aJ(), o = oJ(), s = sJ(), l = uJ(), c = cJ(), m = dJ(), d = pF(), p = gy(), v = hJ(), y = xJ(), S = NJ(), b = Si(), j = sF(), x = jJ(), h = Ha(), P = FJ(), N = py(), $ = vy(), O = 1, B = 2, Z = 4, Y = "[object Arguments]", ee = "[object Array]", J = "[object Boolean]", K = "[object Date]", V = "[object Error]", Q = "[object Function]", ne = "[object GeneratorFunction]", ce = "[object Map]", ae = "[object Number]", ve = "[object Object]", je = "[object RegExp]", G = "[object Set]", le = "[object String]", he = "[object Symbol]", M = "[object WeakMap]", Ae = "[object ArrayBuffer]", Ve = "[object DataView]", Te = "[object Float32Array]", ze = "[object Float64Array]", ge = "[object Int8Array]", Oe = "[object Int16Array]", $e = "[object Int32Array]", Ye = "[object Uint8Array]", xe = "[object Uint8ClampedArray]", Ue = "[object Uint16Array]", Be = "[object Uint32Array]", re = {};
  re[Y] = re[ee] = re[Ae] = re[Ve] = re[J] = re[K] = re[Te] = re[ze] = re[ge] = re[Oe] = re[$e] = re[ce] = re[ae] = re[ve] = re[je] = re[G] = re[le] = re[he] = re[Ye] = re[xe] = re[Ue] = re[Be] = !0, re[V] = re[Q] = re[M] = !1;
  function be(Ne, Pe, Ie, on, C, k) {
    var F, W = Pe & O, X = Pe & B, T = Pe & Z;
    if (Ie && (F = C ? Ie(Ne, on, C, k) : Ie(Ne)), F !== void 0)
      return F;
    if (!h(Ne))
      return Ne;
    var U = b(Ne);
    if (U) {
      if (F = v(Ne), !W)
        return s(Ne, F);
    } else {
      var te = p(Ne), pe = te == Q || te == ne;
      if (j(Ne))
        return o(Ne, W);
      if (te == ve || te == Y || pe && !C) {
        if (F = X || pe ? {} : S(Ne), !W)
          return X ? c(Ne, a(F, Ne)) : l(Ne, i(F, Ne));
      } else {
        if (!re[te])
          return C ? Ne : {};
        F = y(Ne, te, W);
      }
    }
    k || (k = new e());
    var Se = k.get(Ne);
    if (Se)
      return Se;
    k.set(Ne, F), P(Ne) ? Ne.forEach(function(en) {
      F.add(be(en, Pe, Ie, en, Ne, k));
    }) : x(Ne) && Ne.forEach(function(en, tn) {
      F.set(tn, be(en, Pe, Ie, tn, Ne, k));
    });
    var Ze = T ? X ? d : m : X ? $ : N, un = U ? void 0 : Ze(Ne);
    return n(un || Ne, function(en, tn) {
      un && (tn = en, en = Ne[tn]), t(F, tn, be(en, Pe, Ie, tn, Ne, k));
    }), F;
  }
  return sp = be, sp;
}
var lp, DS;
function $J() {
  if (DS) return lp;
  DS = 1;
  function e(n) {
    var t = n == null ? 0 : n.length;
    return t ? n[t - 1] : void 0;
  }
  return lp = e, lp;
}
var up, PS;
function EJ() {
  if (PS) return up;
  PS = 1;
  function e(n, t, i) {
    var a = -1, o = n.length;
    t < 0 && (t = -t > o ? 0 : o + t), i = i > o ? o : i, i < 0 && (i += o), o = t > i ? 0 : i - t >>> 0, t >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + t];
    return s;
  }
  return up = e, up;
}
var cp, AS;
function TJ() {
  if (AS) return cp;
  AS = 1;
  var e = ZC(), n = EJ();
  function t(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return cp = t, cp;
}
var dp, LS;
function OJ() {
  if (LS) return dp;
  LS = 1;
  var e = Ka(), n = $J(), t = TJ(), i = Zu();
  function a(o, s) {
    return s = e(s, o), o = t(o, s), o == null || delete o[i(n(s))];
  }
  return dp = a, dp;
}
var mp, VS;
function RJ() {
  if (VS) return mp;
  VS = 1;
  var e = qa(), n = yy(), t = Wi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, c = s.call(Object);
  function m(d) {
    if (!t(d) || e(d) != i)
      return !1;
    var p = n(d);
    if (p === null)
      return !0;
    var v = l.call(p, "constructor") && p.constructor;
    return typeof v == "function" && v instanceof v && s.call(v) == c;
  }
  return mp = m, mp;
}
var fp, zS;
function DJ() {
  if (zS) return fp;
  zS = 1;
  var e = RJ();
  function n(t) {
    return e(t) ? void 0 : t;
  }
  return fp = n, fp;
}
var pp, MS;
function PJ() {
  if (MS) return pp;
  MS = 1;
  var e = XC(), n = IJ(), t = OJ(), i = Ka(), a = Ns(), o = DJ(), s = rF(), l = pF(), c = 1, m = 2, d = 4, p = s(function(v, y) {
    var S = {};
    if (v == null)
      return S;
    var b = !1;
    y = e(y, function(x) {
      return x = i(x, v), b || (b = x.length > 1), x;
    }), a(v, l(v), S), b && (S = n(S, c | m | d, o));
    for (var j = y.length; j--; )
      t(S, y[j]);
    return S;
  });
  return pp = p, pp;
}
PJ();
const _a = ({
  children: e,
  ...n
}) => {
  const { controller: t, controllerProps: i, fieldWrapperProps: a } = oF(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...c
  } = t.field;
  return /* @__PURE__ */ zi.jsx(Vn, { ...a, children: /* @__PURE__ */ zi.jsx(
    ni,
    {
      ...n.componentProps,
      ...c,
      multiple: !1,
      value: c.value ? [c.value] : [],
      onBlur: (m) => {
        var d, p;
        (p = (d = n.componentProps) == null ? void 0 : d.onBlur) == null || p.call(d, m), s();
      },
      onChange: (m) => {
        var d, p;
        (p = (d = n.componentProps) == null ? void 0 : d.onChange) == null || p.call(d, m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: Vn.getStatus(a.meta),
      children: e
    }
  ) });
};
var AJ = tF();
const LJ = /* @__PURE__ */ KC(AJ), vp = ({
  transformValue: e = LJ,
  label: n,
  className: t,
  ...i
}) => {
  var a;
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = aF(i);
  return /* @__PURE__ */ zi.jsxs(_, { gap: "200", alignItems: "center", className: t, children: [
    n && /* @__PURE__ */ zi.jsx(dI, { htmlFor: s, children: n }),
    /* @__PURE__ */ zi.jsx(
      Op,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: (a = i.componentProps) == null ? void 0 : a.disabled,
        onChange: (l) => {
          var c, m;
          (m = (c = i.componentProps) == null ? void 0 : c.onChange) == null || m.call(c, l), o.onChange(e(l.target.checked));
        }
      }
    )
  ] });
}, ti = (e) => {
  var n;
  const { controller: t, controllerProps: i, fieldWrapperProps: a } = oF(e);
  return /* @__PURE__ */ zi.jsx(Vn, { ...a, children: /* @__PURE__ */ zi.jsx(
    Cr,
    {
      ...e.componentProps,
      ...t.field,
      value: ((n = e.componentProps) == null ? void 0 : n.type) === "number" && isNaN(t.field.value) ? "" : t.field.value ?? "",
      onBlur: (o) => {
        var s, l;
        (l = (s = e.componentProps) == null ? void 0 : s.onBlur) == null || l.call(s, o), t.field.onBlur();
      },
      onChange: (o) => {
        var s, l, c;
        (l = (s = e.componentProps) == null ? void 0 : s.onChange) == null || l.call(s, o), t.field.onChange(
          ((c = e.componentProps) == null ? void 0 : c.type) === "number" ? o.target.valueAsNumber : o
        );
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: Vn.getStatus(a.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_1j1cn_1{padding:0}._listItem_1j1cn_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1j1cn_4:last-child{border-bottom:none}._listItemEdit_1j1cn_11{cursor:pointer}._fullWidth_1j1cn_15{width:100%}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
const US = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayEmailMarketingConsent",
    label: "Displays the email marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var hp = { exports: {} }, No = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var BS;
function VJ() {
  if (BS) return No;
  BS = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return No.Fragment = t, No.jsx = s, No.jsxs = s, No;
}
var dl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qS;
function zJ() {
  return qS || (qS = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    dl.Fragment = i, dl.jsx = Mn, dl.jsxs = Un;
  }()), dl;
}
var HS;
function MJ() {
  return HS || (HS = 1, process.env.NODE_ENV === "production" ? hp.exports = VJ() : hp.exports = zJ()), hp.exports;
}
var D = MJ(), Ii = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ii || {}), hi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(hi || {}), ca = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(ca || {}), $i = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))($i || {});
const UJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, BJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, qJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, HJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, KJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refund" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refund" }, value: { kind: "Variable", name: { kind: "Name", value: "refund" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, WJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "smsMarketingConsent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "consentUpdatedAt" } }] } }] } }] } }] } }] } }] }, GJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "emailMarketingConsent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consentUpdatedAt" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] }, YJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, JJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, QJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, XJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, ZJ = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": UJ,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": BJ,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": qJ,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": HJ,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refund: Boolean!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refund: $refund\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": KJ,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          email\n          phone\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n          smsMarketingConsent {\n            marketingState\n            marketingOptInLevel\n            consentUpdatedAt\n          }\n        }\n      }\n    }\n  }\n": WJ,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            email\n            phone\n            numberOfOrders\n            tags\n            verifiedEmail\n            emailMarketingConsent {\n              consentUpdatedAt\n              marketingOptInLevel\n              marketingState\n            }\n            amountSpent {\n              amount\n              currencyCode\n            }\n          }\n        }\n      }\n    }\n  }\n": GJ,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  image {\n                    url\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": YJ,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": JJ,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": QJ,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": XJ
};
function Wr(e) {
  return ZJ[e] ?? {};
}
const eQ = Wr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            email
            phone
            numberOfOrders
            tags
            verifiedEmail
            emailMarketingConsent {
              consentUpdatedAt
              marketingOptInLevel
              marketingState
            }
            amountSpent {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`
), nQ = Wr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), tQ = Wr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  image {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), rQ = Wr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), iQ = Wr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), aQ = Wr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), oQ = Wr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refund: Boolean!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refund: $refund
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), sQ = Wr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), lQ = Wr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          email
          phone
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
          smsMarketingConsent {
            marketingState
            marketingOptInLevel
            consentUpdatedAt
          }
        }
      }
    }
  }
`
), uQ = Wr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), cQ = ({
  conversationContext: e
}) => {
  var n, t;
  const { useQuery: i } = pn(), a = (n = e.customer) == null ? void 0 : n.email, o = (t = e.customer) == null ? void 0 : t.phone_number, s = a ? `email:"${a}"` : null, l = o ? `phone:"${o}"` : null, c = s ?? l ?? null, {
    loading: m,
    error: d,
    data: p,
    refetch: v,
    networkStatus: y
  } = i(eQ, {
    skip: !c,
    variables: {
      query: c
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: m,
    customerError: d,
    customerData: p,
    refetchCustomer: v,
    customerNetworkStatus: y
  };
}, dQ = () => {
  const { useLazyQuery: e } = pn(), [
    n,
    {
      loading: t,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(tQ);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: t,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function ou(e = !1, n) {
  const [t, i] = me(e);
  return Ge(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const mQ = "_list_1j1cn_1", fQ = "_listItem_1j1cn_4", pQ = "_fullWidth_1j1cn_15", gi = {
  list: mQ,
  listItem: fQ,
  fullWidth: pQ
}, vQ = "_modal_1vkwz_1", hQ = "_disabled_1vkwz_5", yp = {
  modal: vQ,
  disabled: hQ
}, KS = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: hi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: hi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: hi.Unknown
  }
], WS = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: ca.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: ca.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: ca.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: ca.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: ca.Unsubscribed
  }
], yQ = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: t,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  var s, l, c, m;
  const { track: d } = bn(), { useMutation: p, showNotification: v } = pn(), [y, S] = me(), [b, j] = me(), [x, h] = mb(!0), [P, N] = mb(!0), $ = !!y, O = (s = e.customer) == null ? void 0 : s.email, B = (l = e.customer) == null ? void 0 : l.phone_number, Z = (c = e.customer) == null ? void 0 : c.given_name, Y = (m = e.customer) == null ? void 0 : m.family_name, ee = {
    email: O ?? "",
    phone: B ?? "",
    firstName: Z ?? "",
    lastName: Y ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, J = xi({
    defaultValues: ee
  });
  Ge(() => {
    b == null || b.forEach((ae) => {
      var ve;
      const je = (ve = ae == null ? void 0 : ae.field) == null ? void 0 : ve[0];
      je && (J.setError(je, {
        type: "server",
        message: ae.message
      }), J.setFocus(je));
    });
  }, [b, J]);
  const [K, { error: V, reset: Q }] = p(lQ, {
    onError: (ae) => {
      S(ae.message), a(!1), v({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (ae) => {
      var ve, je;
      const G = ((je = (ve = ae == null ? void 0 : ae.Shopify) == null ? void 0 : ve.customerCreate) == null ? void 0 : je.userErrors) || [];
      G.length > 0 ? (j(G), a(!1), v({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), v({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), d("shopify:profile:created"), t(!1));
    }
  }), ne = ut(
    (ae) => {
      a(!0), S(void 0), K({
        variables: {
          input: {
            ...x && { email: ae.email },
            ...P && { phone: ae.phone },
            firstName: ae.firstName,
            lastName: ae.lastName,
            smsMarketingConsent: {
              marketingState: ae.smsMarketingState,
              marketingOptInLevel: ae.smsMarketingOptInLevel
            }
          }
        }
      });
    },
    [K, a, P, x]
  ), ce = () => {
    t(!1), Q(), S(void 0), J.reset(ee);
  };
  return /* @__PURE__ */ D.jsxs(Ht, { isOpen: n, onClose: ce, className: yp.modal, children: [
    /* @__PURE__ */ D.jsx(Kt, { title: "Create new customer", onClose: ce }),
    /* @__PURE__ */ D.jsx(Wt, { children: /* @__PURE__ */ D.jsxs(Ir, { children: [
      /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
        ti,
        {
          label: "First name",
          name: "firstName",
          control: J.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
        ti,
        {
          label: "Last name",
          name: "lastName",
          control: J.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
        ti,
        {
          label: "Email",
          name: "email",
          control: J.control,
          rules: {
            required: x ? "Email is required" : void 0
          },
          componentProps: {
            className: ct({
              [yp.disabled]: !x
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ D.jsx(
                Op,
                {
                  disabled: !P,
                  name: "hasEmail",
                  value: "email",
                  checked: x,
                  onChange: () => h()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
        ti,
        {
          label: "Phone",
          name: "phone",
          control: J.control,
          rules: {
            required: P ? "Phone is required" : void 0
          },
          componentProps: {
            className: ct({
              [yp.disabled]: !P
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ D.jsx(
                Op,
                {
                  disabled: !x,
                  name: "hasPhone",
                  value: "phone",
                  checked: P,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
        _a,
        {
          control: J.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (ae, ve) => ae === ve,
            getItemTitleByValue: (ae) => {
              const ve = WS.find(
                (je) => je.value === ae
              );
              return /* @__PURE__ */ D.jsxs(
                _,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: ve.label }),
                    /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: ve.description })
                  ]
                }
              );
            }
          },
          children: WS.map((ae) => /* @__PURE__ */ D.jsx(Bt.Item, { value: ae.value, children: /* @__PURE__ */ D.jsxs(_, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: ae.label }),
            /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: ae.description })
          ] }) }, ae.value))
        }
      ) }),
      /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
        _a,
        {
          control: J.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (ae, ve) => ae === ve,
            getItemTitleByValue: (ae) => {
              const ve = KS.find(
                (je) => je.value === ae
              );
              return /* @__PURE__ */ D.jsxs(
                _,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: ve.label }),
                    /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: ve.description })
                  ]
                }
              );
            }
          },
          children: KS.map((ae) => /* @__PURE__ */ D.jsx(Bt.Item, { value: ae.value, children: /* @__PURE__ */ D.jsxs(_, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: ae.label }),
            /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: ae.description })
          ] }) }, ae.value))
        }
      ) }),
      $ && /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsxs(_, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx(ye, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ D.jsx(q.Paragraph, { children: y })
      ] }) })
    ] }) }),
    /* @__PURE__ */ D.jsx(
      rr,
      {
        confirmProps: {
          disabled: !(J.formState.isValid && J.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ D.jsx(fn, { size: 16 })
        },
        confirmOnClick: J.handleSubmit(ne),
        cancelOnClick: ce,
        confirmName: V ? "Close" : "Save",
        cancelName: V ? void 0 : "Cancel"
      }
    )
  ] });
}, gQ = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [t, i] = me(!1), [a, o] = me(!1);
  return /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    /* @__PURE__ */ D.jsx(
      Qn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ D.jsx(fn, { size: 16 }),
        slotStart: /* @__PURE__ */ D.jsx(ye, { size: 14, name: "user-plus", color: "green.500" }),
        className: gi.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ D.jsx(
      yQ,
      {
        isOpen: t,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, by = (e) => {
  const n = e == null ? void 0 : e.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, vF = "DD MMM YYYY @ HH:mm", kQ = "_wrapper_10fld_1", bQ = "_copyIcon_10fld_7", ml = {
  wrapper: kQ,
  copyIcon: bQ
}, _Q = ({
  customer: e,
  shopifyDomain: n,
  refresh: t,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = ou(), { isCopied: l, copy: c } = ou(), { track: m } = bn();
  if (!e)
    return null;
  const {
    id: d,
    displayName: p,
    email: v = "",
    phone: y = "",
    tags: S = [],
    verifiedEmail: b
  } = e, j = by(d), x = `https://${n}/admin/customers/${j ?? ""}`, h = i && a === cr.refetch, P = 14;
  return /* @__PURE__ */ D.jsxs(_, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(_, { className: ml.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: p }),
        h ? /* @__PURE__ */ D.jsx(fn, { size: P }) : /* @__PURE__ */ D.jsx(nn, { content: "Reload customer", children: /* @__PURE__ */ D.jsx(
          ye,
          {
            size: P,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: d }), t();
            },
            className: ml.copyIcon
          }
        ) })
      ] }),
      v && /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsxs(_, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ D.jsx(ye, { size: P, name: "mail" }),
          /* @__PURE__ */ D.jsx(q.ExternalLink, { href: `mailto:${v}`, children: v }),
          /* @__PURE__ */ D.jsx(
            nn,
            {
              content: b ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ D.jsx(_, { alignItems: "center", children: /* @__PURE__ */ D.jsx(
                ye,
                {
                  size: P,
                  color: b ? "green.500" : "red.500",
                  name: b ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ D.jsx(nn, { content: "Copy Email", children: /* @__PURE__ */ D.jsx(
          ye,
          {
            size: P,
            name: o ? "done" : "copy",
            onClick: () => s(v),
            className: ml.copyIcon
          }
        ) })
      ] }),
      y && /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsxs(_, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ D.jsx(ye, { size: P, name: "phone" }),
          /* @__PURE__ */ D.jsx(q.ExternalLink, { href: `tel:${y}`, children: y })
        ] }),
        /* @__PURE__ */ D.jsx(nn, { content: "Copy phone number", children: /* @__PURE__ */ D.jsx(
          ye,
          {
            size: P,
            name: l ? "done" : "copy",
            onClick: () => c(y),
            className: ml.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ D.jsxs(_, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ D.jsx(ye, { size: P, name: "external-link" }),
        /* @__PURE__ */ D.jsx(
          q.ExternalLink,
          {
            href: x,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    S.length > 0 && /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
      /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ D.jsx(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: S.map((N) => /* @__PURE__ */ D.jsx(Dn, { children: N }, `${d}-${N}`)) })
    ] })
  ] });
}, xQ = ({
  emailMarketingConsent: e
}) => {
  if (!e)
    return null;
  const n = (l) => l.charAt(0).toUpperCase() + l.slice(1).replace(/_/g, " ").toLowerCase(), t = (l) => {
    switch (l) {
      case Ii.Invalid:
      case Ii.NotSubscribed:
      case Ii.Redacted:
        return "red.500";
      case Ii.Pending:
      case Ii.Unsubscribed:
        return "orange.500";
      case Ii.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, i = (l) => {
    switch (l) {
      case hi.SingleOptIn:
      case hi.ConfirmedOptIn:
        return "green.500";
      case hi.Unknown:
      default:
        return "neutral.200";
    }
  }, { marketingState: a, consentUpdatedAt: o } = e, s = e.marketingOptInLevel ?? hi.Unknown;
  return /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(_, { gap: "200", alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: "Email marketing consent" }),
      o && /* @__PURE__ */ D.jsx(nn, { content: "Last updated at", children: /* @__PURE__ */ D.jsx(Jn, { size: "small", variant: "info", children: An(o).format(vF) }) })
    ] }),
    /* @__PURE__ */ D.jsxs(_, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(nn, { content: "Opt-In state", children: /* @__PURE__ */ D.jsx(Dn, { color: i(s), children: n(s) }) }),
      /* @__PURE__ */ D.jsx(nn, { content: "Marketing state", children: /* @__PURE__ */ D.jsx(Dn, { color: t(a), children: n(a) }) })
    ] })
  ] });
}, SQ = "_creationModal_pbe64_1", NQ = "_detailsModal_pbe64_5", wQ = "_percentageSuffix_pbe64_9", gp = {
  creationModal: SQ,
  detailsModal: NQ,
  percentageSuffix: wQ
}, jQ = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, CQ = (e) => {
  var n;
  const t = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, i = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), a = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: a === "only-once" ? 1 : null,
    appliesOncePerCustomer: a === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: t } : t
      },
      items: {
        all: !0
      }
    },
    customerSelection: {
      all: !0
    },
    ...i && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [i]: e.minimumRequirementOption === "quantity" ? (n = e.minimumRequirementValue) == null ? void 0 : n.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, GS = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], YS = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], JS = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], FQ = ({
  codeDiscount: e
}) => {
  var n, t, i;
  const a = (i = (t = (n = e == null ? void 0 : e.codes) == null ? void 0 : n.nodes) == null ? void 0 : t[0]) == null ? void 0 : i.code, { isCopied: o, copy: s } = ri(), l = e != null && e.usageLimit ? `${e == null ? void 0 : e.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ D.jsxs(_, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ D.jsxs(Je, { children: [
      /* @__PURE__ */ D.jsx(Je.Text, { children: /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "2", color: "secondary", children: e == null ? void 0 : e.title })
      ] }) }),
      /* @__PURE__ */ D.jsx(Je.Text, { children: /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ D.jsxs(_, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ D.jsx(
            ye,
            {
              name: (e == null ? void 0 : e.status) === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: (e == null ? void 0 : e.status) === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "2", color: "secondary", children: e == null ? void 0 : e.status })
        ] })
      ] }) }),
      /* @__PURE__ */ D.jsx(Je.Text, { children: /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "2", color: "secondary", children: l })
      ] }) }),
      /* @__PURE__ */ D.jsx(Je.Text, { children: /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "2", color: "secondary", children: e != null && e.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ D.jsx(Je.Text, { children: /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "2", color: "secondary", children: An(e == null ? void 0 : e.startsAt).format(vt) })
      ] }) })
    ] }),
    /* @__PURE__ */ D.jsx(Vn, { label: "Discount code", children: /* @__PURE__ */ D.jsx(
      Cr,
      {
        readOnly: !0,
        value: a,
        suffix: {
          type: "button",
          button: {
            icon: o ? "done" : "copy",
            onClick: () => {
              s(a);
            }
          }
        }
      }
    ) })
  ] });
}, IQ = "shopify-discount-code-form", QS = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, $Q = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: t } = bn(), { useMutation: i, showNotification: a } = pn(), [o, s] = me(
    []
  ), [l, c] = me(), m = xi({
    mode: "all",
    defaultValues: QS
  });
  Ge(() => {
    o == null || o.forEach(($) => {
      var O;
      const B = (O = $ == null ? void 0 : $.field) == null ? void 0 : O[1];
      B && m.setError(B, {
        type: "server",
        message: $.message
      });
    });
  }, [o, m]);
  const d = !!l, p = m.watch("minimumRequirementOption"), v = m.watch("customerGetsOption"), y = At(() => {
    switch (p) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [p]), [
    S,
    {
      loading: b,
      error: j,
      reset: x
    }
  ] = i(uQ, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: ($) => {
      var O, B, Z, Y, ee;
      const J = (B = (O = $ == null ? void 0 : $.Shopify) == null ? void 0 : O.discountCodeBasicCreate) == null ? void 0 : B.userErrors;
      if (J && J.length > 0)
        s(J);
      else {
        const K = (ee = (Y = (Z = $ == null ? void 0 : $.Shopify) == null ? void 0 : Z.discountCodeBasicCreate) == null ? void 0 : Y.codeDiscountNode) == null ? void 0 : ee.codeDiscount;
        K && "codes" in K && c(K), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), t("shopify:discount:code:created"), s([]);
      }
    }
  }), h = () => {
    m.setValue("code", jQ(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, P = ($) => {
    S({
      variables: {
        input: CQ($)
      }
    });
  }, N = () => {
    m.reset(QS), s([]), x(), c(void 0), n(!1);
  };
  return /* @__PURE__ */ D.jsxs(
    Ht,
    {
      isOpen: e,
      onClose: N,
      className: ct({
        [gp.creationModal]: !d,
        [gp.detailsModal]: d
      }),
      children: [
        /* @__PURE__ */ D.jsx(
          Kt,
          {
            title: d ? "Discount code details" : "Create new discount code",
            onClose: N
          }
        ),
        /* @__PURE__ */ D.jsxs(Wt, { children: [
          d && /* @__PURE__ */ D.jsx(FQ, { codeDiscount: l }),
          !d && /* @__PURE__ */ D.jsxs("form", { noValidate: !0, id: IQ, onSubmit: m.handleSubmit(P), children: [
            /* @__PURE__ */ D.jsx(_, { margin: "0 0 400", children: /* @__PURE__ */ D.jsx(
              hu,
              {
                variant: "info",
                description: /* @__PURE__ */ D.jsx(q.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ D.jsxs(Ir, { children: [
              /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
                ti,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
                _a,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: ($, O) => $ === O,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: ($) => {
                      const O = GS.find(
                        (B) => B.value === $
                      );
                      return /* @__PURE__ */ D.jsx(_, { margin: "0 0 100", children: /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: O == null ? void 0 : O.label }) });
                    }
                  },
                  children: GS.map(($) => /* @__PURE__ */ D.jsx(Bt.Item, { value: $.value, children: /* @__PURE__ */ D.jsxs(_, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: $.label }),
                    /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: $.description })
                  ] }) }, $.value))
                }
              ) }),
              /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
                ti,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: ($) => {
                      if (v === "percentage" && ($ < 0 || $ > 100))
                        return "Percentage must be between 0 and 100";
                      if (v === "discountAmount" && $ < 0)
                        return "Discount amount must be greater than 0";
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...v === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ D.jsx(
                          _,
                          {
                            alignItems: "center",
                            className: gp.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
                ti,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: h
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
                _a,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: ($, O) => $ === O,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: ($) => {
                      const O = YS.find(
                        (B) => B.value === $
                      );
                      return /* @__PURE__ */ D.jsx(_, { margin: "0 0 100", children: /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: O == null ? void 0 : O.label }) });
                    }
                  },
                  children: YS.map(($) => /* @__PURE__ */ D.jsx(Bt.Item, { value: $.value, children: /* @__PURE__ */ D.jsxs(_, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: $.label }),
                    /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: $.description })
                  ] }) }, $.value))
                }
              ) }),
              /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
                ti,
                {
                  name: "minimumRequirementValue",
                  label: y,
                  control: m.control,
                  disabled: p === "none",
                  rules: {
                    required: {
                      value: p !== "none",
                      message: "Please enter a value"
                    },
                    validate: ($) => {
                      if (p !== "none" && $ < 0)
                        return `Minimum ${p} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
                _a,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: ($, O) => $ === O,
                    getItemTitleByValue: ($) => {
                      const O = JS.find(
                        (B) => B.value === $
                      );
                      return /* @__PURE__ */ D.jsx(_, { margin: "0 0 100", children: /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: O == null ? void 0 : O.label }) });
                    }
                  },
                  children: JS.map(($) => /* @__PURE__ */ D.jsx(Bt.Item, { value: $.value, children: /* @__PURE__ */ D.jsxs(_, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: $.label }),
                    /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: $.description })
                  ] }) }, $.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ D.jsx(Fn, { error: j })
        ] }),
        /* @__PURE__ */ D.jsx(
          rr,
          {
            confirmProps: {
              disabled: !d && !(m.formState.isValid && m.formState.isDirty),
              isLoading: b,
              loadingIndicator: /* @__PURE__ */ D.jsx(fn, { size: 16 })
            },
            confirmName: d ? "Close" : "Save",
            confirmOnClick: d ? N : m.handleSubmit(P),
            cancelOnClick: d ? void 0 : N
          }
        )
      ]
    }
  );
}, di = ({
  control: e,
  name: n,
  label: t,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ D.jsx(
  Ut,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => {
      var c, m;
      return /* @__PURE__ */ D.jsx(
        ur,
        {
          required: a,
          label: t,
          input: s,
          placeholder: i,
          meta: {
            warning: (c = l == null ? void 0 : l.error) == null ? void 0 : c.message,
            error: ((m = l == null ? void 0 : l.error) == null ? void 0 : m.message) || (o == null ? void 0 : o[s.name])
          }
        }
      );
    }
  }
), EQ = "_modal_1wlra_1", TQ = {
  modal: EQ
};
function XS(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const ZS = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], eN = "shopify-shiping-address-form", OQ = ({
  title: e,
  address: n,
  isOpen: t,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  refetchOrders: l
}) => {
  const { useMutation: c, showNotification: m } = pn(), { track: d } = bn(), [p, v] = me(!1), [y, S] = me({}), [
    b,
    { error: j, reset: x }
  ] = c(nQ, {
    onError: () => {
      v(!1), m({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (Y) => {
      var ee, J;
      v(!1);
      const K = (J = (ee = Y == null ? void 0 : Y.Shopify) == null ? void 0 : ee.orderUpdate) == null ? void 0 : J.userErrors;
      if ((K == null ? void 0 : K.length) > 0) {
        const V = K.reduce((Q, ne) => (Q[ne.field[ne.field.length - 1]] = ne.message, Q), {});
        S(V);
      } else
        m({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), S({}), i(!1), l();
    }
  }), h = ut(
    () => ({
      firstName: (n == null ? void 0 : n.firstName) || "",
      lastName: (n == null ? void 0 : n.lastName) || "",
      company: (n == null ? void 0 : n.company) || "",
      address1: (n == null ? void 0 : n.address1) || "",
      address2: (n == null ? void 0 : n.address2) || "",
      city: (n == null ? void 0 : n.city) || "",
      countryCodeV2: ZS.reduce(
        (Y, ee) => ee === (n == null ? void 0 : n.countryCodeV2) ? {
          id: ee,
          name: XS(ee)
        } : Y,
        {}
      ),
      provinceCode: (n == null ? void 0 : n.province) || "",
      zip: (n == null ? void 0 : n.zip) || ""
    }),
    [n]
  ), { control: P, handleSubmit: N, formState: $, reset: O } = xi({
    mode: "all",
    defaultValues: h()
  }), B = N((Y) => {
    const { countryCodeV2: ee, ...J } = Y, K = { ...J, countryCode: ee.id };
    v(!0), o && d("shopify:order:edit:shipping:address:modal:submitted", {
      shopifyId: o,
      orderId: a
    }), b({
      variables: {
        input: {
          id: a,
          shippingAddress: K
        }
      }
    });
  }), Z = () => {
    O(h()), S({}), x(), i(!1);
  };
  return /* @__PURE__ */ D.jsxs(
    Ht,
    {
      isOpen: t,
      onClose: Z,
      className: TQ.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ D.jsx(Kt, { title: e, onClose: () => Z() }),
        /* @__PURE__ */ D.jsx(Wt, { children: /* @__PURE__ */ D.jsxs("form", { noValidate: !0, id: eN, onSubmit: B, children: [
          j && /* @__PURE__ */ D.jsx(Fn, { error: j }),
          /* @__PURE__ */ D.jsxs(Ir, { children: [
            /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
              di,
              {
                required: !0,
                control: P,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: y
              }
            ) }),
            /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
              di,
              {
                required: !0,
                control: P,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: y
              }
            ) }),
            /* @__PURE__ */ D.jsx(ln, { span: 6, children: /* @__PURE__ */ D.jsx(
              di,
              {
                control: P,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ D.jsx(ln, { span: 6, children: /* @__PURE__ */ D.jsx(
              di,
              {
                required: !0,
                control: P,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: y
              }
            ) }),
            /* @__PURE__ */ D.jsx(ln, { span: 6, children: /* @__PURE__ */ D.jsx(
              di,
              {
                control: P,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
              di,
              {
                required: !0,
                control: P,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: y
              }
            ) }),
            /* @__PURE__ */ D.jsx(ln, { span: 3, children: /* @__PURE__ */ D.jsx(
              di,
              {
                required: !0,
                control: P,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: y
              }
            ) }),
            /* @__PURE__ */ D.jsx(ln, { span: 6, children: /* @__PURE__ */ D.jsx(
              Ut,
              {
                name: "countryCodeV2",
                control: P,
                rules: {
                  required: {
                    value: !0,
                    message: "This field is required"
                  }
                },
                render: ({ field: Y, fieldState: ee }) => {
                  var J;
                  return /* @__PURE__ */ D.jsx(
                    Vn,
                    {
                      label: "Country",
                      meta: {
                        warning: (J = ee == null ? void 0 : ee.error) == null ? void 0 : J.message,
                        error: y[Y.name] ?? ""
                      },
                      children: /* @__PURE__ */ D.jsx(
                        ni,
                        {
                          required: !0,
                          placeholder: "Select your country",
                          getItemTitleByValue: (K) => K == null ? void 0 : K.name,
                          onBlur: Y.onBlur,
                          onChange: (K) => Y.onChange(K.selectedValues[0]),
                          value: [Y.value],
                          dropdownProps: {
                            style: { maxHeight: 300, overflowY: "scroll" }
                          },
                          children: ZS.filter(
                            (K) => s.includes(K)
                          ).map((K) => {
                            const V = XS(K);
                            return /* @__PURE__ */ D.jsx(
                              Bt.Item,
                              {
                                value: { id: K, name: V },
                                noFixedSelectionStateSpace: !0,
                                children: /* @__PURE__ */ D.jsx(q.Paragraph, { children: V })
                              },
                              K
                            );
                          })
                        }
                      )
                    }
                  );
                }
              }
            ) }),
            /* @__PURE__ */ D.jsx(ln, { span: 6, children: /* @__PURE__ */ D.jsx(
              di,
              {
                control: P,
                name: "provinceCode",
                label: "State / province",
                placeholder: "Insert your state / province"
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ D.jsx(
          rr,
          {
            confirmProps: {
              disabled: !($.isValid && $.isDirty),
              type: "submit",
              form: eN,
              isLoading: p,
              loadingIndicator: /* @__PURE__ */ D.jsx(fn, { size: 16 })
            },
            confirmOnClick: () => {
              j && Z();
            },
            cancelOnClick: () => {
              o && !j && d("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), Z();
            },
            confirmName: j ? "Close" : "Save",
            cancelName: j ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, RQ = "_clickableIcon_33mqm_1", kp = {
  clickableIcon: RQ
}, nN = ({
  labelText: e,
  address: n,
  orderId: t,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  refetchOrders: l,
  openByDefault: c = !1
}) => {
  const [m, d] = me(!1), [p, v] = me(c), { isCopied: y, copy: S } = ou(), { track: b } = bn(), j = ut(() => [
    N,
    n == null ? void 0 : n.company,
    n == null ? void 0 : n.address1,
    n == null ? void 0 : n.address2,
    P,
    n == null ? void 0 : n.province,
    n == null ? void 0 : n.country
  ].filter(Boolean).join(`
`), [n]);
  if (!n)
    return null;
  const x = 14, h = !!t && o, P = [(n == null ? void 0 : n.zip) || "", (n == null ? void 0 : n.city) || ""].filter(Boolean).join(" "), N = [(n == null ? void 0 : n.firstName) || "", (n == null ? void 0 : n.lastName) || ""].filter(Boolean).join(" "), $ = () => {
    i && t && b("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: t
    }), d(!0);
  };
  return /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ D.jsxs(_, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ D.jsx(ye, { size: x, name: s, color: "green.500" }),
        /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ D.jsxs(
            _,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!p),
              className: kp.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ D.jsx(
                  ye,
                  {
                    size: x,
                    name: p ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          p && /* @__PURE__ */ D.jsxs(_, { gap: "100", flexDirection: "column", children: [
            N && /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: N }),
            (n == null ? void 0 : n.company) && /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: n.company }),
            (n == null ? void 0 : n.address1) && /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: n.address1 }),
            (n == null ? void 0 : n.address2) && /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: n.address2 }),
            P && /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: P }),
            (n == null ? void 0 : n.province) && /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: n.province }),
            (n == null ? void 0 : n.country) && /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: n.country })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ D.jsxs(_, { gap: "250", flexDirection: "row", children: [
        h && /* @__PURE__ */ D.jsx(nn, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ D.jsx(
          ye,
          {
            size: x,
            name: "pen",
            onClick: () => $(),
            className: kp.clickableIcon
          }
        ) }),
        /* @__PURE__ */ D.jsx(nn, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ D.jsx(
          ye,
          {
            size: x,
            name: y ? "done" : "copy",
            onClick: () => S(j()),
            className: kp.clickableIcon
          }
        ) })
      ] })
    ] }),
    h && /* @__PURE__ */ D.jsx(
      OQ,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: m,
        setIsOpen: d,
        orderId: t,
        shopifyId: i,
        shippingCountryCodes: a,
        refetchOrders: l
      }
    )
  ] });
}, DQ = "_modal_al73g_1", PQ = {
  modal: DQ
}, tN = [
  {
    label: "Customer",
    value: $i.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: $i.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: $i.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: $i.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: $i.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: $i.Staff,
    description: "Staff made an error."
  }
], AQ = ({
  orderId: e,
  isOpen: n,
  orderName: t,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = bn(), { useMutation: c, showNotification: m } = pn(), [d, p] = me([]), v = d.length > 0, y = {
    orderId: e,
    reason: null,
    refund: !0,
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, S = xi({
    defaultValues: y
  }), [b, { error: j, reset: x }] = c(oQ, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (N) => {
      var $, O, B, Z, Y;
      const ee = ((O = ($ = N.Shopify) == null ? void 0 : $.orderCancel) == null ? void 0 : O.orderCancelUserErrors) || [];
      if (ee.length > 0)
        o(!1), p(ee), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const J = (Y = (Z = (B = N.Shopify) == null ? void 0 : B.orderCancel) == null ? void 0 : Z.job) == null ? void 0 : Y.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, J ? 0 : 4e3), m({
          title: "Success",
          text: `${J ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), h = ut(
    (N) => {
      o(!0), b({
        variables: N
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), P = () => {
    i(!1), x(), p([]), S.reset(y);
  };
  return /* @__PURE__ */ D.jsxs(Ht, { isOpen: n, onClose: P, className: PQ.modal, children: [
    /* @__PURE__ */ D.jsx(Kt, { title: `Cancel order ${t}`, onClose: P }),
    /* @__PURE__ */ D.jsx(Wt, { children: /* @__PURE__ */ D.jsxs(Ir, { children: [
      /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
        _a,
        {
          control: S.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (N, $) => N === $,
            getItemTitleByValue: (N) => {
              const $ = tN.find(
                (O) => O.value === N
              );
              return /* @__PURE__ */ D.jsxs(_, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: $.label }),
                /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: $.description })
              ] });
            }
          },
          children: tN.map((N) => /* @__PURE__ */ D.jsx(Bt.Item, { value: N.value, children: /* @__PURE__ */ D.jsxs(_, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: N.label }),
            /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: N.description })
          ] }) }, N.value))
        }
      ) }),
      /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(Vn, { required: !0, label: "Refund order", children: /* @__PURE__ */ D.jsx(vp, { control: S.control, name: "refund" }) }) }),
      /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(Vn, { required: !0, label: "Restock items", children: /* @__PURE__ */ D.jsx(vp, { control: S.control, name: "restock" }) }) }),
      /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(Vn, { required: !0, label: "Notify the customer", children: /* @__PURE__ */ D.jsx(vp, { control: S.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
        ti,
        {
          name: "staffNote",
          label: "Staff note",
          control: S.control
        }
      ) }),
      v && /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(_, { gap: "200", flexDirection: "column", children: d.map((N) => {
        var $;
        return /* @__PURE__ */ D.jsxs(
          _,
          {
            flexDirection: "row",
            gap: "200",
            alignItems: "center",
            children: [
              /* @__PURE__ */ D.jsx(ye, { name: "close-circle-filled", color: "red.500" }),
              /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: N.code }),
              /* @__PURE__ */ D.jsxs(q.Paragraph, { children: [
                "(",
                ($ = N.field) == null ? void 0 : $.join(","),
                ") ",
                N.message
              ] })
            ]
          },
          N.code
        );
      }) }) })
    ] }) }),
    /* @__PURE__ */ D.jsx(
      rr,
      {
        confirmProps: {
          disabled: !(S.formState.isValid && S.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ D.jsx(fn, { size: 16 })
        },
        confirmOnClick: S.handleSubmit(h),
        cancelOnClick: P,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, LQ = ({
  orderId: e,
  orderName: n,
  refetchOrders: t,
  disabled: i
}) => {
  const [a, o] = me(!1), [s, l] = me(!1);
  return /* @__PURE__ */ D.jsxs(_, { width: "100%", children: [
    /* @__PURE__ */ D.jsx(
      Qn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ D.jsx(fn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ D.jsx(
          ye,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: gi.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ D.jsx(
      AQ,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: t
      }
    )
  ] });
}, VQ = ({
  orderId: e,
  lineItems: n
}) => !n || (n == null ? void 0 : n.length) === 0 ? null : /* @__PURE__ */ D.jsxs(_, { gap: "100", flexDirection: "column", children: [
  /* @__PURE__ */ D.jsxs(_, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ D.jsx(ye, { size: 14, name: "shopify", color: "green.500" }),
    /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "3", children: "Line items" })
  ] }),
  /* @__PURE__ */ D.jsx(Je, { children: n.map(({ id: t, title: i, quantity: a, variantTitle: o, image: s }) => /* @__PURE__ */ D.jsx(
    Je.Item,
    {
      contentLeft: /* @__PURE__ */ D.jsxs(_, { gap: "200", children: [
        /* @__PURE__ */ D.jsx(q.Paragraph, { children: a }),
        /* @__PURE__ */ D.jsx(q.Paragraph, { children: "×" })
      ] }),
      title: /* @__PURE__ */ D.jsxs(q.Paragraph, { variant: "4", children: [
        i,
        " ",
        o && `(${o})`
      ] }),
      contentRight: (s == null ? void 0 : s.url) && /* @__PURE__ */ D.jsx(GN, { src: `${s == null ? void 0 : s.url}&height=48`, alt: i })
    },
    `list-${e}-${t}`
  )) })
] }), zQ = ({
  order: e,
  shopifyId: n,
  orderLink: t,
  refetchOrders: i
}) => {
  var a;
  const { useMutation: o, showNotification: s, showModal: l } = pn(), { track: c } = bn(), { suggestedRefund: m, currencyCode: d, id: p, name: v } = e, [y] = o(rQ, {
    onError: (j) => {
      setTimeout(() => b(j), 500);
    },
    onCompleted: (j) => {
      var x, h;
      const P = (h = (x = j.Shopify) == null ? void 0 : x.refundCreate) == null ? void 0 : h.userErrors;
      P && P.length > 0 ? b(
        new gI({
          graphQLErrors: P.map((N) => ({
            message: N.message
          }))
        })
      ) : (s({
        title: "Order refunded",
        text: `You refunded order ${v}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), S = ut(() => {
    c("shopify:order:refund:requested", { shopifyId: n, orderId: p });
    const { amount: j, ...x } = m;
    l({
      headline: `Refund Order ${v}?`,
      children: /* @__PURE__ */ D.jsxs(q.Paragraph, { children: [
        "You are about to refund ",
        j,
        " ",
        d,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        c("shopify:order:refund:confirmed", { shopifyId: n, orderId: p }), y({
          variables: {
            input: x
          }
        });
      },
      onCancel: () => c("shopify:order:refund:canceled", { shopifyId: n, orderId: p })
    });
  }, [n, p]), b = ut(
    (j) => {
      l({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ D.jsxs(_, { flexDirection: "column", children: [
          /* @__PURE__ */ D.jsx(Fn, { error: j }),
          /* @__PURE__ */ D.jsx(
            Ct,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => {
                var x;
                return (x = window.open(t, "_blank")) == null ? void 0 : x.focus();
              },
              slotStart: /* @__PURE__ */ D.jsx(ye, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [t]
  );
  return /* @__PURE__ */ D.jsx(_, { width: "100%", children: /* @__PURE__ */ D.jsx(
    Qn,
    {
      variant: "secondary",
      onClick: S,
      disabled: ((a = m == null ? void 0 : m.refundLineItems) == null ? void 0 : a.length) === 0,
      slotStart: /* @__PURE__ */ D.jsx(ye, { size: 14, name: "undo" }),
      className: gi.fullWidth,
      children: "Refund"
    }
  ) });
}, MQ = "_modal_al73g_1", UQ = {
  modal: MQ
}, BQ = ({
  orderId: e,
  tags: n,
  isOpen: t,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = bn(), { useMutation: s, showNotification: l } = pn(), [c, m] = me(n), [d, p] = me(!1), v = xi({
    defaultValues: {
      tags: n
    }
  });
  Ge(() => {
    c && v.setValue("tags", c, { shouldDirty: !0 });
  }, [c]);
  const [y, { error: S, reset: b }] = s(sQ, {
    onError: () => {
      p(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), p(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = ut(
    (h) => {
      p(!0), y({
        variables: {
          input: {
            id: e,
            tags: h.tags
          }
        }
      }).then((P) => {
        v.reset({ tags: P.data.Shopify.orderUpdate.order.tags });
      });
    },
    [e]
  ), x = () => {
    i(!1), b();
  };
  return /* @__PURE__ */ D.jsxs(Ht, { isOpen: t, onClose: x, className: UQ.modal, children: [
    /* @__PURE__ */ D.jsx(Kt, { title: "Manage tags for order", onClose: x }),
    /* @__PURE__ */ D.jsxs(Wt, { children: [
      /* @__PURE__ */ D.jsx(Ir, { children: /* @__PURE__ */ D.jsx(ln, { children: /* @__PURE__ */ D.jsx(
        Ut,
        {
          control: v.control,
          name: "tags",
          render: ({ fieldState: { error: h } }) => /* @__PURE__ */ D.jsx(
            Vn,
            {
              label: "Tags",
              meta: {
                error: h == null ? void 0 : h.message
              },
              children: /* @__PURE__ */ D.jsx(
                WN,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (P) => m(P)
                }
              )
            }
          )
        }
      ) }) }),
      S && /* @__PURE__ */ D.jsx(Fn, { error: S })
    ] }),
    /* @__PURE__ */ D.jsx(
      rr,
      {
        confirmProps: {
          disabled: !(v.formState.isValid && v.formState.isDirty),
          isLoading: d,
          loadingIndicator: /* @__PURE__ */ D.jsx(fn, { size: 16 })
        },
        confirmOnClick: v.handleSubmit(j),
        cancelOnClick: x,
        confirmName: S ? "Close" : "Save",
        cancelName: S ? void 0 : "Cancel"
      }
    )
  ] });
}, qQ = "_editIcon_1dntr_1", HQ = {
  editIcon: qQ
}, KQ = ({
  orderId: e,
  tags: n,
  refetchOrders: t
}) => {
  const [i, a] = me(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ D.jsxs(_, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ D.jsx(ye, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ D.jsxs(_, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, c) => /* @__PURE__ */ D.jsx(Jn, { size: "small", variant: "primary", children: l }, c))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ D.jsx(_, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ D.jsx(nn, { content: "Edit tags", children: /* @__PURE__ */ D.jsx(
        ye,
        {
          size: o,
          name: "pen",
          className: HQ.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ D.jsx(
      BQ,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: t
      }
    )
  ] });
}, WQ = "_icon_cddi1_1", GQ = "_link_cddi1_6", rN = {
  icon: WQ,
  link: GQ
}, YQ = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: t } = ou(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ D.jsx(
    Je.Item,
    {
      contentLeft: /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ D.jsx(
        q.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: rN.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ D.jsx(nn, { content: "Copy tracking code", children: /* @__PURE__ */ D.jsx(
        ye,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => t(a.toString()),
          className: rN.icon
        }
      ) })
    }
  );
}, JQ = ({
  trackingInfos: e
}) => !e || (e == null ? void 0 : e.length) === 0 ? null : /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ D.jsxs(_, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ D.jsx(ye, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ D.jsx(Je, { children: e.map((n) => /* @__PURE__ */ D.jsx(YQ, { trackingInfo: n }, n.number)) })
] }), QQ = "_order_135ze_1", XQ = "_orderIsOpen_135ze_9", ZQ = "_orderHeader_135ze_12", bp = {
  order: QQ,
  orderIsOpen: XQ,
  orderHeader: ZQ
}, eX = ({
  order: e,
  shopifyId: n,
  openByDefault: t,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  refetchOrders: c
}) => {
  const { track: m } = bn(), [d, p] = me(t), {
    id: v,
    name: y,
    createdAt: S,
    status: b,
    value: j,
    currencyCode: x,
    lineItems: h,
    billingAddress: P,
    shippingAddress: N,
    trackingInfos: $,
    tags: O
  } = e, B = !!N, Z = by(v), Y = `https://${l}/admin/orders/${Z ?? ""}`, ee = `${Number.parseFloat(j.toString()).toFixed(
    2
  )} ${x}`, J = b.includes("cancelled");
  return /* @__PURE__ */ D.jsxs(
    _,
    {
      className: ct(bp.order, {
        [bp.orderIsOpen]: d
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ D.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: bp.orderHeader,
            onClick: () => p(!d),
            children: [
              /* @__PURE__ */ D.jsxs(_, { gap: "100", flexDirection: "column", children: [
                S && /* @__PURE__ */ D.jsx(_, { alignItems: "center", children: /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: An(S).format(vF) }) }),
                /* @__PURE__ */ D.jsxs(q.Paragraph, { variant: "1", children: [
                  "Order ",
                  y
                ] })
              ] }),
              /* @__PURE__ */ D.jsx(
                qr,
                {
                  variant: "tertiary",
                  icon: d ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        d && /* @__PURE__ */ D.jsxs(_, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ D.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ D.jsx(ye, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: b })
            ] })
          ] }),
          /* @__PURE__ */ D.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ D.jsx(ye, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: ee })
            ] })
          ] }),
          /* @__PURE__ */ D.jsx(
            KQ,
            {
              orderId: v,
              tags: O,
              refetchOrders: c
            }
          ),
          /* @__PURE__ */ D.jsx(
            nN,
            {
              openByDefault: !B,
              labelText: "Billing address",
              address: P,
              shippingCountryCodes: i,
              refetchOrders: c
            }
          ),
          /* @__PURE__ */ D.jsx(
            nN,
            {
              openByDefault: B,
              shopifyId: n,
              orderId: v,
              icon: "map-pin",
              labelText: "Shipping address",
              address: N,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: c
            }
          ),
          /* @__PURE__ */ D.jsx(VQ, { orderId: v, lineItems: h }),
          /* @__PURE__ */ D.jsx(JQ, { trackingInfos: $ }),
          (o || s) && /* @__PURE__ */ D.jsxs(_, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ D.jsx(
              zQ,
              {
                order: e,
                shopifyId: n,
                refetchOrders: c,
                orderLink: Y
              }
            ),
            s && /* @__PURE__ */ D.jsx(
              LQ,
              {
                orderId: v,
                orderName: y,
                disabled: J,
                refetchOrders: c
              }
            )
          ] }),
          /* @__PURE__ */ D.jsx(
            Ct,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => {
                var K;
                return (K = window.open(Y, "_blank")) == null ? void 0 : K.focus();
              },
              slotStart: /* @__PURE__ */ D.jsx(ye, { name: "external-link" }),
              onClick: () => m("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: v
              }),
              children: "View order in Shopify"
            }
          )
        ] })
      ]
    }
  );
}, nX = ({
  ordersData: e
}) => {
  const n = (t) => {
    var i;
    return ((i = t == null ? void 0 : t.fulfillments) == null ? void 0 : i.length) > 0 ? t.fulfillments[0].trackingInfo : [];
  };
  return e.map(({ node: t }) => {
    var i, a, o, s, l, c, m, d, p, v, y, S, b, j, x, h, P;
    return {
      id: t.id,
      name: t.name,
      createdAt: new Date(t.createdAt),
      cancelledAt: t.cancelledAt ? new Date(t.cancelledAt) : void 0,
      status: `${(i = t.displayFulfillmentStatus) == null ? void 0 : i.toLowerCase()}, ${(a = t.displayFinancialStatus) == null ? void 0 : a.toLowerCase()}${t.cancelledAt ? ", cancelled" : ""}`,
      value: (s = (o = t.netPaymentSet) == null ? void 0 : o.presentmentMoney) == null ? void 0 : s.amount,
      currencyCode: (c = (l = t.netPaymentSet) == null ? void 0 : l.presentmentMoney) == null ? void 0 : c.currencyCode,
      shippingAddress: t.shippingAddress,
      billingAddress: t.billingAddress,
      lineItems: (d = (m = t.lineItems) == null ? void 0 : m.edges) == null ? void 0 : d.map(({ node: N }) => N),
      suggestedRefund: {
        orderId: t.id,
        amount: (y = (v = (p = t.suggestedRefund) == null ? void 0 : p.amountSet) == null ? void 0 : v.presentmentMoney) == null ? void 0 : y.amount,
        currency: (j = (b = (S = t.suggestedRefund) == null ? void 0 : S.amountSet) == null ? void 0 : b.presentmentMoney) == null ? void 0 : j.currencyCode,
        notify: !0,
        refundLineItems: (x = t.suggestedRefund) == null ? void 0 : x.refundLineItems.map(
          ({ lineItem: N }) => ({
            lineItemId: N.id,
            quantity: N.quantity
          })
        ),
        transactions: (P = (h = t.suggestedRefund) == null ? void 0 : h.suggestedTransactions) == null ? void 0 : P.map(
          ({ amountSet: N, gateway: $, parentTransaction: O }) => {
            var B;
            return {
              amount: ((B = N == null ? void 0 : N.presentmentMoney) == null ? void 0 : B.amount) || "0.00",
              gateway: $ || void 0,
              kind: "REFUND",
              orderId: t.id,
              parentId: O == null ? void 0 : O.id
            };
          }
        ),
        shipping: {
          fullRefund: !0
        }
      },
      trackingInfos: n(t),
      tags: t.tags
    };
  });
}, tX = ({
  shopifyId: e,
  customerCountryCodes: n,
  shopifyDomain: t,
  displayRefund: i,
  displayCancel: a,
  enableEditShippingAddress: o,
  displayDiscountCodeCreation: s
}) => {
  const { track: l } = bn(), [c, m] = me([]), [d, p] = me(!1), v = by(e), y = `https://${t}/admin/orders?customer_id=${v ?? ""}`, {
    getCustomerOrders: S,
    isCustomerOrdersLoading: b,
    customerOrdersError: j,
    customerOrders: x,
    refetchCustomerOrders: h
  } = dQ();
  return Ge(() => {
    !b && v && S({
      variables: {
        query: `customer_id:${v}`
      }
    });
  }, [v]), Ge(() => {
    var P, N;
    const $ = (N = (P = x == null ? void 0 : x.Shopify) == null ? void 0 : P.orders) == null ? void 0 : N.edges;
    $ && m(nX({ ordersData: $ }));
  }, [x]), e ? j ? /* @__PURE__ */ D.jsx(Fn, { error: j }) : /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: "Customer orders" }),
      !b && /* @__PURE__ */ D.jsx(Jn, { variant: "success", size: "small", children: c.length })
    ] }),
    s && /* @__PURE__ */ D.jsx(
      Qn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => p(!0),
        children: "Create discount code"
      }
    ),
    /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
      b && /* @__PURE__ */ D.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(fn, {}) }),
      !b && c.length === 0 && /* @__PURE__ */ D.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ D.jsx(q.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !b && c.length > 0 && /* @__PURE__ */ D.jsx(_, { gap: "200", flexDirection: "column", children: c.map((P, N) => /* @__PURE__ */ D.jsx(
        eX,
        {
          order: P,
          openByDefault: N === 0,
          shopifyId: e,
          displayRefund: i,
          displayCancel: a,
          enableEditShippingAddress: o,
          customerCountryCodes: n,
          refetchOrders: h,
          shopifyDomain: t
        },
        `${N}-${P.id}`
      )) }),
      /* @__PURE__ */ D.jsx(
        Ct,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => {
            var P;
            return (P = window.open(y, "_blank")) == null ? void 0 : P.focus();
          },
          slotStart: /* @__PURE__ */ D.jsx(ye, { name: "external-link" }),
          onClick: () => l("shopify:view:all:orders:clicked", {
            shopifyId: e
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    /* @__PURE__ */ D.jsx(
      $Q,
      {
        isOpen: d,
        setIsOpen: p
      }
    )
  ] }) : null;
}, rX = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const t = (n == null ? void 0 : n.amount) ?? 0, i = (n == null ? void 0 : n.currencyCode) ?? "", a = `${Number.parseFloat(t).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ D.jsx(D.Fragment, { children: /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ D.jsxs(Je, { className: gi.list, children: [
      /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: gi.listItem, children: /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ D.jsx(Je.Text, { variant: "dense", className: gi.listItem, children: /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, iX = "_segmentName_1dkhk_1", aX = {
  segmentName: iX
}, oX = 100, fl = 10, sX = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: t } = pn(), [i, a] = me([]), [o, s] = me(fl), [l, c] = me(!1), m = At(
    () => i.filter((b) => b.isMember).length,
    [i]
  ), { loading: d, error: p } = n(
    iQ,
    {
      skip: !e,
      variables: {
        first: oX
      },
      onCompleted: (b) => {
        var j, x;
        const h = (x = (j = b == null ? void 0 : b.Shopify) == null ? void 0 : j.segments) == null ? void 0 : x.edges;
        if (h && h.length > 0) {
          const P = h.map(({ node: N }) => ({
            ...N,
            isMember: !1
          })).sort((N, $) => N.name.localeCompare($.name));
          a(P), v({
            variables: {
              customerId: e,
              segmentIds: P.map((N) => N.id)
            }
          });
        }
      }
    }
  ), [
    v,
    { loading: y, error: S }
  ] = t(aQ, {
    onCompleted: (b) => {
      var j, x;
      const h = (x = (j = b == null ? void 0 : b.Shopify) == null ? void 0 : j.customerSegmentMembership) == null ? void 0 : x.memberships;
      if (h && h.length > 0) {
        const P = i.map((N) => {
          const $ = h.find(
            (O) => O.segmentId === N.id
          );
          return {
            ...N,
            ...($ == null ? void 0 : $.isMember) && { isMember: $.isMember }
          };
        }).sort(
          (N, $) => N.isMember === $.isMember ? 0 : N.isMember ? -1 : 1
        );
        a(P);
      }
    }
  });
  return Ge(() => {
    s(l ? i.length : fl);
  }, [l]), e ? /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ D.jsx(q.Heading, { variant: "heading-3", children: "Segment membership" }),
      !d && /* @__PURE__ */ D.jsx(Jn, { variant: "success", size: "small", children: m })
    ] }),
    d && /* @__PURE__ */ D.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(fn, {}) }),
    !d && i.length === 0 && /* @__PURE__ */ D.jsx(q.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    p && /* @__PURE__ */ D.jsx(Fn, { error: p }),
    S && /* @__PURE__ */ D.jsx(Fn, { error: S }),
    !d && i.length > 0 && /* @__PURE__ */ D.jsxs(Je, { className: gi.list, children: [
      i.slice(0, o).map(({ id: b, name: j, isMember: x }) => /* @__PURE__ */ D.jsx(Je.Text, { className: gi.listItem, children: /* @__PURE__ */ D.jsx(
        nn,
        {
          content: `${x ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ D.jsxs(_, { justifyContent: "space-between", children: [
            /* @__PURE__ */ D.jsx(q.Paragraph, { variant: "4", className: aX.segmentName, children: j }),
            y && /* @__PURE__ */ D.jsx(fn, { size: 12 }),
            !y && /* @__PURE__ */ D.jsx(_, { children: /* @__PURE__ */ D.jsx(
              ye,
              {
                color: x ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, b)),
      i.length > fl && /* @__PURE__ */ D.jsx(_, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ D.jsx(
        Qn,
        {
          variant: "secondary",
          onClick: () => c(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - fl} more`
        }
      ) })
    ] })
  ] }) : null;
}, lX = ({
  conversationContext: e,
  settings: n
}) => {
  var t;
  const {
    isCustomerLoading: i,
    customerError: a,
    customerData: o,
    refetchCustomer: s,
    customerNetworkStatus: l
  } = cQ({ conversationContext: e }), [c, m] = me(), [d, p] = me(
    []
  ), v = n.apiHostName, y = n.displayRefundOrder ?? !1, S = n.displayCancelOrder ?? !1, b = n.enableEditShippingAddress ?? !1, j = n.displayEmailMarketingConsent ?? !1, x = n.displayOrdersOverview ?? !1, h = n.displaySegmentMembership ?? !1, P = n.displayDiscountCodeCreation ?? !1;
  if (Ge(() => {
    var N, $, O, B, Z, Y;
    const ee = (O = ($ = (N = o == null ? void 0 : o.Shopify) == null ? void 0 : N.customers) == null ? void 0 : $.edges[0]) == null ? void 0 : O.node;
    ee && !i ? (p(
      ((Y = (Z = (B = o == null ? void 0 : o.Shopify) == null ? void 0 : B.shop) == null ? void 0 : Z.countriesInShippingZones) == null ? void 0 : Y.countryCodes) || []
    ), m(ee)) : m(void 0);
  }, [o]), !i && a)
    return /* @__PURE__ */ D.jsx(Fn, { error: a, retry: s });
  if (!i && !a && !c) {
    const N = `https://${v}/admin/customers?search=${((t = e.customer) == null ? void 0 : t.name) || ""}`;
    return /* @__PURE__ */ D.jsxs(
      _,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ D.jsx(q.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ D.jsxs(_, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ D.jsx(
              gQ,
              {
                refetchCustomer: s,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ D.jsx(
              Ct,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => {
                  var $;
                  return ($ = window.open(N, "_blank")) == null ? void 0 : $.focus();
                },
                slotStart: /* @__PURE__ */ D.jsx(ye, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return i && l !== cr.refetch ? /* @__PURE__ */ D.jsx(_, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ D.jsx(fn, {}) }) : /* @__PURE__ */ D.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ D.jsx(
          _Q,
          {
            customer: c,
            shopifyDomain: v,
            refresh: s,
            loading: i,
            networkStatus: l
          }
        ),
        x && /* @__PURE__ */ D.jsx(
          rX,
          {
            totalOrders: c == null ? void 0 : c.numberOfOrders,
            amountSpent: c == null ? void 0 : c.amountSpent
          }
        ),
        h && /* @__PURE__ */ D.jsx(sX, { shopifyId: c == null ? void 0 : c.id }),
        j && /* @__PURE__ */ D.jsx(
          xQ,
          {
            emailMarketingConsent: c == null ? void 0 : c.emailMarketingConsent
          }
        ),
        /* @__PURE__ */ D.jsx(
          tX,
          {
            shopifyId: c == null ? void 0 : c.id,
            shopifyDomain: v,
            displayRefund: y,
            displayCancel: S,
            enableEditShippingAddress: b,
            customerCountryCodes: d,
            displayDiscountCodeCreation: P
          }
        )
      ]
    }
  );
}, bt = [];
for (let e = 0; e < 256; ++e)
  bt.push((e + 256).toString(16).slice(1));
function uX(e, n = 0) {
  return (bt[e[n + 0]] + bt[e[n + 1]] + bt[e[n + 2]] + bt[e[n + 3]] + "-" + bt[e[n + 4]] + bt[e[n + 5]] + "-" + bt[e[n + 6]] + bt[e[n + 7]] + "-" + bt[e[n + 8]] + bt[e[n + 9]] + "-" + bt[e[n + 10]] + bt[e[n + 11]] + bt[e[n + 12]] + bt[e[n + 13]] + bt[e[n + 14]] + bt[e[n + 15]]).toLowerCase();
}
let _p;
const cX = new Uint8Array(16);
function dX() {
  if (!_p) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    _p = crypto.getRandomValues.bind(crypto);
  }
  return _p(cX);
}
const mX = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), iN = { randomUUID: mX };
function fX(e, n, t) {
  var a;
  if (iN.randomUUID && !e)
    return iN.randomUUID();
  e = e || {};
  const i = e.random ?? ((a = e.rng) == null ? void 0 : a.call(e)) ?? dX();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, uX(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_3pk5c_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_3pk5c_6{padding:0}._listItem_3pk5c_9{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemAlignRight_3pk5c_13 p{margin-left:auto}._listItem_3pk5c_9:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var xp = { exports: {} }, wo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aN;
function pX() {
  if (aN) return wo;
  aN = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return wo.Fragment = t, wo.jsx = s, wo.jsxs = s, wo;
}
var pl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oN;
function vX() {
  return oN || (oN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    pl.Fragment = i, pl.jsx = Mn, pl.jsxs = Un;
  }()), pl;
}
var sN;
function hX() {
  return sN || (sN = 1, process.env.NODE_ENV === "production" ? xp.exports = pX() : xp.exports = vX()), xp.exports;
}
var H = hX(), hF = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(hF || {}), Tv = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Tv || {});
const yX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, gX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, kX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, bX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, _X = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, xX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, SX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, NX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, wX = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": yX,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": gX,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": kX,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": bX,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": _X,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": xX,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SX,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": NX
};
function Ni(e) {
  return wX[e] ?? {};
}
const jX = Ni(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), CX = Ni(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), FX = Ni(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), IX = Ni(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), $X = Ni(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), EX = Ni(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), TX = Ni(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), OX = Ni(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), RX = ({
  contactId: e
}) => {
  const { useQuery: n } = pn(), { track: t } = bn(), [i, a] = me(), [o, s] = me(), [l, c] = me(), {
    loading: m,
    error: d,
    data: p,
    refetch: v
  } = n(jX, {
    skip: !e,
    variables: { contactId: e }
  });
  return Ge(() => {
    var y, S;
    const b = (y = p == null ? void 0 : p.Voyado) == null ? void 0 : y.ContactsV_GetContactById;
    !m && b && typeof b == "object" && ("id" in b && t("voyado:profile:received", { hasProfile: !0 }), "attributes" in b && a(b.attributes), "preferences" in b && s(b.preferences), "consents" in b && c(
      ((S = b == null ? void 0 : b.consents) == null ? void 0 : S.filter(
        (j) => j !== null
      )) || void 0
    )), !m && (!b || typeof b != "object") && t("voyado:profile:received", { hasProfile: !1 });
  }, [p == null ? void 0 : p.Voyado, m]), At(
    () => ({
      isLoading: m,
      error: d,
      refetch: v,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [d, i, o, l]
  );
};
function Dl(e = !1, n) {
  const [t, i] = me(e);
  return Ge(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const DX = {
  count: 0,
  items: []
}, PX = ({
  contactId: e
}) => {
  const { useQuery: n } = pn(), { track: t } = bn(), [i, a] = me(DX), {
    loading: o,
    error: s,
    data: l
  } = n(FX, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Ge(() => {
    var c, m, d, p, v, y;
    if (!o && ((c = l == null ? void 0 : l.Voyado) != null && c.ContactMessage_GetSmsMessagesByContactId || (m = l == null ? void 0 : l.Voyado) != null && m.ContactMessage_GetPostalMessagesByContactId || (d = l == null ? void 0 : l.Voyado) != null && d.ContactMessage_GetEmailMessagesByContactId)) {
      const S = (p = l == null ? void 0 : l.Voyado) == null ? void 0 : p.ContactMessage_GetEmailMessagesByContactId, b = (v = l == null ? void 0 : l.Voyado) == null ? void 0 : v.ContactMessage_GetSmsMessagesByContactId, j = (y = l == null ? void 0 : l.Voyado) == null ? void 0 : y.ContactMessage_GetPostalMessagesByContactId, x = {
        count: ((b == null ? void 0 : b.count) ?? 0) + ((j == null ? void 0 : j.count) ?? 0) + ((S == null ? void 0 : S.count) ?? 0),
        items: [
          ...b.items ?? [],
          ...S.items ?? [],
          ...j.items ?? []
        ]
      };
      a(x), t("voyado:messages:received", {
        emailsReceived: S.count ?? 0,
        smsReceived: b.count ?? 0,
        postalReceived: j.count ?? 0,
        total: x.count ?? 0
      });
    }
  }, [l == null ? void 0 : l.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, AX = {
  count: 0,
  totalCount: 0,
  items: []
}, LX = ({
  contactId: e
}) => {
  const { useQuery: n } = pn(), { track: t } = bn(), [i, a] = me(
    AX
  ), {
    loading: o,
    error: s,
    data: l
  } = n(IX, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Ge(() => {
    var c;
    const m = (c = l == null ? void 0 : l.Voyado) == null ? void 0 : c.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && m) {
      a(
        m
      );
      const { count: d } = m;
      d && t("voyado:transactions:received", { count: d });
    }
  }, [l == null ? void 0 : l.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, VX = ({
  conversationContext: e
}) => {
  const { useQuery: n } = pn(), [t, i] = me(void 0), [a, o] = me(!1), { customer: s } = e, l = !!(s != null && s.email) || !!(s != null && s.phone_number), {
    loading: c,
    error: m,
    data: d,
    refetch: p
  } = n(CX, {
    skip: !l,
    variables: {
      email: (s == null ? void 0 : s.email) ?? "",
      mobilePhone: (s == null ? void 0 : s.phone_number) ?? ""
    }
  });
  return Ge(() => {
    var v, y, S;
    const b = (v = d == null ? void 0 : d.Voyado) == null ? void 0 : v.ContactOverview_GetContactIdAsync;
    (b == null ? void 0 : b.__typename) === "Voyado_ApiExceptionMultipleMatchesResponse" && (y = b == null ? void 0 : b.messageDetails) != null && y.multipleMatchesFound && ((S = b == null ? void 0 : b.messageDetails) == null ? void 0 : S.multipleMatchesFound.length) > 0 && (o(!0), i(void 0)), (b == null ? void 0 : b.__typename) === "Voyado_String_container" && b != null && b.String && (o(!1), i(b.String));
  }, [d == null ? void 0 : d.Voyado, c]), {
    isLoading: c,
    contactId: t,
    hasMultipleContacts: a,
    error: m,
    refetch: p
  };
}, zX = "_pointer_3pk5c_1", MX = "_list_3pk5c_6", UX = "_listItem_3pk5c_9", BX = "_listItemAlignRight_3pk5c_13", Pt = {
  pointer: zX,
  list: MX,
  listItem: UX,
  listItemAlignRight: BX
};
var ws = (e) => e.type === "checkbox", Di = (e) => e instanceof Date, Rt = (e) => e == null;
const yF = (e) => typeof e == "object";
var rt = (e) => !Rt(e) && !Array.isArray(e) && yF(e) && !Di(e), gF = (e) => rt(e) && e.target ? ws(e.target) ? e.target.checked : e.target.value : e, qX = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, kF = (e, n) => e.has(qX(n)), HX = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return rt(n) && n.hasOwnProperty("isPrototypeOf");
}, _y = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xt(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(_y && (e instanceof Blob || i)) && (t || rt(e)))
    if (n = t ? [] : {}, !t && !HX(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = xt(e[a]));
  else
    return e;
  return n;
}
var ec = (e) => Array.isArray(e) ? e.filter(Boolean) : [], et = (e) => e === void 0, Ke = (e, n, t) => {
  if (!n || !rt(e))
    return t;
  const i = ec(n.split(/[,[\].]+?/)).reduce((a, o) => Rt(a) ? a : a[o], e);
  return et(i) || i === e ? et(e[n]) ? t : e[n] : i;
}, Xt = (e) => typeof e == "boolean", xy = (e) => /^\w*$/.test(e), bF = (e) => ec(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Hn = (e, n, t) => {
  let i = -1;
  const a = xy(n) ? [n] : bF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let c = t;
    if (i !== s) {
      const m = e[l];
      c = rt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = c, e = e[l];
  }
};
const su = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, _r = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Xr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, KX = we.createContext(null), Sy = () => we.useContext(KX);
var _F = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== _r.all && (n._proxyFormState[s] = !i || _r.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function WX(e) {
  const n = Sy(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = we.useState(t._formState), c = we.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = we.useRef(a);
  return m.current = a, we.useEffect(() => t._subscribe({
    name: m.current,
    formState: c.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...t._formState,
        ...d
      });
    }
  }), [t, i, o]), we.useEffect(() => {
    c.current.isValid && t._setValid(!0);
  }, [t]), we.useMemo(() => _F(s, t, c.current, !1), [s, t]);
}
var zr = (e) => typeof e == "string", xF = (e, n, t, i, a) => zr(e) ? (i && n.watch.add(e), Ke(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ke(t, o))) : (i && (n.watchAll = !0), t);
function SF(e) {
  const n = Sy(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = we.useRef(i), c = we.useRef(a);
  l.current = i, we.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (p) => !o && d(xF(l.current, t._names, p.values || t._formValues, !1, c.current))
  }), [t, o, s]);
  const [m, d] = we.useState(t._getWatch(i, a));
  return we.useEffect(() => t._removeUnmounted()), m;
}
function GX(e) {
  const n = Sy(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = kF(a._names.array, t), l = SF({
    control: a,
    name: t,
    defaultValue: Ke(a._formValues, t, Ke(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), c = WX({
    control: a,
    name: t,
    exact: !0
  }), m = we.useRef(e), d = we.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...Xt(e.disabled) ? { disabled: e.disabled } : {}
  })), p = we.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ke(c.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ke(c.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ke(c.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ke(c.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Ke(c.errors, t)
    }
  }), [c, t]), v = we.useCallback((j) => d.current.onChange({
    target: {
      value: gF(j),
      name: t
    },
    type: su.CHANGE
  }), [t]), y = we.useCallback(() => d.current.onBlur({
    target: {
      value: Ke(a._formValues, t),
      name: t
    },
    type: su.BLUR
  }), [t, a._formValues]), S = we.useCallback((j) => {
    const x = Ke(a._fields, t);
    x && j && (x._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (h) => j.setCustomValidity(h),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, t]), b = we.useMemo(() => ({
    name: t,
    value: l,
    ...Xt(i) || c.disabled ? { disabled: c.disabled || i } : {},
    onChange: v,
    onBlur: y,
    ref: S
  }), [t, i, c.disabled, v, y, S, l]);
  return we.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...Xt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const x = (h, P) => {
      const N = Ke(a._fields, h);
      N && N._f && (N._f.mount = P);
    };
    if (x(t, !0), j) {
      const h = xt(Ke(a._options.defaultValues, t));
      Hn(a._defaultValues, t, h), et(Ke(a._formValues, t)) && Hn(a._formValues, t, h);
    }
    return !s && a.register(t), () => {
      (s ? j && !a._state.action : j) ? a.unregister(t) : x(t, !1);
    };
  }, [t, a, s, o]), we.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), we.useMemo(() => ({
    field: b,
    formState: c,
    fieldState: p
  }), [b, c, p]);
}
const lN = (e) => e.render(GX(e));
var YX = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, Mo = (e) => Array.isArray(e) ? e : [e], uN = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const t of e)
        t.next && t.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((t) => t !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Ov = (e) => Rt(e) || !yF(e);
function pi(e, n) {
  if (Ov(e) || Ov(n))
    return e === n;
  if (Di(e) && Di(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Di(o) && Di(s) || rt(o) && rt(s) || Array.isArray(o) && Array.isArray(s) ? !pi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Et = (e) => rt(e) && !Object.keys(e).length, Ny = (e) => e.type === "file", xr = (e) => typeof e == "function", lu = (e) => {
  if (!_y)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, NF = (e) => e.type === "select-multiple", wy = (e) => e.type === "radio", JX = (e) => wy(e) || ws(e), Sp = (e) => lu(e) && e.isConnected;
function QX(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = et(e) ? i++ : e[n[i++]];
  return e;
}
function XX(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !et(e[n]))
      return !1;
  return !0;
}
function ft(e, n) {
  const t = Array.isArray(n) ? n : xy(n) ? [n] : bF(n), i = t.length === 1 ? e : QX(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (rt(i) && Et(i) || Array.isArray(i) && XX(i)) && ft(e, t.slice(0, -1)), e;
}
var wF = (e) => {
  for (const n in e)
    if (xr(e[n]))
      return !0;
  return !1;
};
function uu(e, n = {}) {
  const t = Array.isArray(e);
  if (rt(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || rt(e[i]) && !wF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, uu(e[i], n[i])) : Rt(e[i]) || (n[i] = !0);
  return n;
}
function jF(e, n, t) {
  const i = Array.isArray(e);
  if (rt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || rt(e[a]) && !wF(e[a]) ? et(n) || Ov(t[a]) ? t[a] = Array.isArray(e[a]) ? uu(e[a], []) : { ...uu(e[a]) } : jF(e[a], Rt(n) ? {} : n[a], t[a]) : t[a] = !pi(e[a], n[a]);
  return t;
}
var jo = (e, n) => jF(e, n, uu(n));
const cN = {
  value: !1,
  isValid: !1
}, dN = { value: !0, isValid: !0 };
var CF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !et(e[0].attributes.value) ? et(e[0].value) || e[0].value === "" ? dN : { value: e[0].value, isValid: !0 } : dN
    ) : cN;
  }
  return cN;
}, FF = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => et(e) ? e : n ? e === "" ? NaN : e && +e : t && zr(e) ? new Date(e) : i ? i(e) : e;
const mN = {
  isValid: !1,
  value: null
};
var IF = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, mN) : mN;
function fN(e) {
  const n = e.ref;
  return Ny(n) ? n.files : wy(n) ? IF(e.refs).value : NF(n) ? [...n.selectedOptions].map(({ value: t }) => t) : ws(n) ? CF(e.refs).value : FF(et(n.value) ? e.ref.value : n.value, e);
}
var ZX = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Ke(n, o);
    s && Hn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, cu = (e) => e instanceof RegExp, Co = (e) => et(e) ? e : cu(e) ? e.source : rt(e) ? cu(e.value) ? e.value.source : e.value : e, pN = (e) => ({
  isOnSubmit: !e || e === _r.onSubmit,
  isOnBlur: e === _r.onBlur,
  isOnChange: e === _r.onChange,
  isOnAll: e === _r.all,
  isOnTouch: e === _r.onTouched
});
const vN = "AsyncFunction";
var eZ = (e) => !!e && !!e.validate && !!(xr(e.validate) && e.validate.constructor.name === vN || rt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === vN)), nZ = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), hN = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Uo = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Ke(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Uo(l, n))
          break;
      } else if (rt(l) && Uo(l, n))
        break;
    }
  }
};
function yN(e, n, t) {
  const i = Ke(e, t);
  if (i || xy(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ke(n, o), l = Ke(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var tZ = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return Et(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || _r.all));
}, rZ = (e, n, t) => !e || !n || e === n || Mo(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), iZ = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, aZ = (e, n) => !ec(Ke(e, n)).length && ft(e, n), oZ = (e, n, t) => {
  const i = Mo(Ke(e, t));
  return Hn(i, "root", n[t]), Hn(e, t, i), e;
}, Pl = (e) => zr(e);
function gN(e, n, t = "validate") {
  if (Pl(e) || Array.isArray(e) && e.every(Pl) || Xt(e) && !e)
    return {
      type: t,
      message: Pl(e) ? e : "",
      ref: n
    };
}
var oa = (e) => rt(e) && !cu(e) ? e : {
  value: e,
  message: ""
}, kN = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: c, maxLength: m, minLength: d, min: p, max: v, pattern: y, validate: S, name: b, valueAsNumber: j, mount: x } = e._f, h = Ke(t, b);
  if (!x || n.has(b))
    return {};
  const P = l ? l[0] : s, N = (K) => {
    a && P.reportValidity && (P.setCustomValidity(Xt(K) ? "" : K || ""), P.reportValidity());
  }, $ = {}, O = wy(s), B = ws(s), Z = O || B, Y = (j || Ny(s)) && et(s.value) && et(h) || lu(s) && s.value === "" || h === "" || Array.isArray(h) && !h.length, ee = YX.bind(null, b, i, $), J = (K, V, Q, ne = Xr.maxLength, ce = Xr.minLength) => {
    const ae = K ? V : Q;
    $[b] = {
      type: K ? ne : ce,
      message: ae,
      ref: s,
      ...ee(K ? ne : ce, ae)
    };
  };
  if (o ? !Array.isArray(h) || !h.length : c && (!Z && (Y || Rt(h)) || Xt(h) && !h || B && !CF(l).isValid || O && !IF(l).isValid)) {
    const { value: K, message: V } = Pl(c) ? { value: !!c, message: c } : oa(c);
    if (K && ($[b] = {
      type: Xr.required,
      message: V,
      ref: P,
      ...ee(Xr.required, V)
    }, !i))
      return N(V), $;
  }
  if (!Y && (!Rt(p) || !Rt(v))) {
    let K, V;
    const Q = oa(v), ne = oa(p);
    if (!Rt(h) && !isNaN(h)) {
      const ce = s.valueAsNumber || h && +h;
      Rt(Q.value) || (K = ce > Q.value), Rt(ne.value) || (V = ce < ne.value);
    } else {
      const ce = s.valueAsDate || new Date(h), ae = (G) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + G), ve = s.type == "time", je = s.type == "week";
      zr(Q.value) && h && (K = ve ? ae(h) > ae(Q.value) : je ? h > Q.value : ce > new Date(Q.value)), zr(ne.value) && h && (V = ve ? ae(h) < ae(ne.value) : je ? h < ne.value : ce < new Date(ne.value));
    }
    if ((K || V) && (J(!!K, Q.message, ne.message, Xr.max, Xr.min), !i))
      return N($[b].message), $;
  }
  if ((m || d) && !Y && (zr(h) || o && Array.isArray(h))) {
    const K = oa(m), V = oa(d), Q = !Rt(K.value) && h.length > +K.value, ne = !Rt(V.value) && h.length < +V.value;
    if ((Q || ne) && (J(Q, K.message, V.message), !i))
      return N($[b].message), $;
  }
  if (y && !Y && zr(h)) {
    const { value: K, message: V } = oa(y);
    if (cu(K) && !h.match(K) && ($[b] = {
      type: Xr.pattern,
      message: V,
      ref: s,
      ...ee(Xr.pattern, V)
    }, !i))
      return N(V), $;
  }
  if (S) {
    if (xr(S)) {
      const K = await S(h, t), V = gN(K, P);
      if (V && ($[b] = {
        ...V,
        ...ee(Xr.validate, V.message)
      }, !i))
        return N(V.message), $;
    } else if (rt(S)) {
      let K = {};
      for (const V in S) {
        if (!Et(K) && !i)
          break;
        const Q = gN(await S[V](h, t), P, V);
        Q && (K = {
          ...Q,
          ...ee(V, Q.message)
        }, N(Q.message), i && ($[b] = K));
      }
      if (!Et(K) && ($[b] = {
        ref: P,
        ...K
      }, !i))
        return $;
    }
  }
  return N(!0), $;
};
const sZ = {
  mode: _r.onSubmit,
  reValidateMode: _r.onChange,
  shouldFocusError: !0
};
function lZ(e = {}) {
  let n = {
    ...sZ,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: xr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = rt(n.defaultValues) || rt(n.values) ? xt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : xt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let p = {
    ...d
  };
  const v = {
    array: uN(),
    state: uN()
  }, y = pN(n.mode), S = pN(n.reValidateMode), b = n.criteriaMode === _r.all, j = (C) => (k) => {
    clearTimeout(m), m = setTimeout(C, k);
  }, x = async (C) => {
    if (!n.disabled && (d.isValid || p.isValid || C)) {
      const k = n.resolver ? Et((await Y()).errors) : await J(i, !0);
      k !== t.isValid && v.state.next({
        isValid: k
      });
    }
  }, h = (C, k) => {
    !n.disabled && (d.isValidating || d.validatingFields || p.isValidating || p.validatingFields) && ((C || Array.from(l.mount)).forEach((F) => {
      F && (k ? Hn(t.validatingFields, F, k) : ft(t.validatingFields, F));
    }), v.state.next({
      validatingFields: t.validatingFields,
      isValidating: !Et(t.validatingFields)
    }));
  }, P = (C, k = [], F, W, X = !0, T = !0) => {
    if (W && F && !n.disabled) {
      if (s.action = !0, T && Array.isArray(Ke(i, C))) {
        const U = F(Ke(i, C), W.argA, W.argB);
        X && Hn(i, C, U);
      }
      if (T && Array.isArray(Ke(t.errors, C))) {
        const U = F(Ke(t.errors, C), W.argA, W.argB);
        X && Hn(t.errors, C, U), aZ(t.errors, C);
      }
      if ((d.touchedFields || p.touchedFields) && T && Array.isArray(Ke(t.touchedFields, C))) {
        const U = F(Ke(t.touchedFields, C), W.argA, W.argB);
        X && Hn(t.touchedFields, C, U);
      }
      (d.dirtyFields || p.dirtyFields) && (t.dirtyFields = jo(a, o)), v.state.next({
        name: C,
        isDirty: V(C, k),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Hn(o, C, k);
  }, N = (C, k) => {
    Hn(t.errors, C, k), v.state.next({
      errors: t.errors
    });
  }, $ = (C) => {
    t.errors = C, v.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, O = (C, k, F, W) => {
    const X = Ke(i, C);
    if (X) {
      const T = Ke(o, C, et(F) ? Ke(a, C) : F);
      et(T) || W && W.defaultChecked || k ? Hn(o, C, k ? T : fN(X._f)) : ce(C, T), s.mount && x();
    }
  }, B = (C, k, F, W, X) => {
    let T = !1, U = !1;
    const te = {
      name: C
    };
    if (!n.disabled) {
      if (!F || W) {
        (d.isDirty || p.isDirty) && (U = t.isDirty, t.isDirty = te.isDirty = V(), T = U !== te.isDirty);
        const pe = pi(Ke(a, C), k);
        U = !!Ke(t.dirtyFields, C), pe ? ft(t.dirtyFields, C) : Hn(t.dirtyFields, C, !0), te.dirtyFields = t.dirtyFields, T = T || (d.dirtyFields || p.dirtyFields) && U !== !pe;
      }
      if (F) {
        const pe = Ke(t.touchedFields, C);
        pe || (Hn(t.touchedFields, C, F), te.touchedFields = t.touchedFields, T = T || (d.touchedFields || p.touchedFields) && pe !== F);
      }
      T && X && v.state.next(te);
    }
    return T ? te : {};
  }, Z = (C, k, F, W) => {
    const X = Ke(t.errors, C), T = (d.isValid || p.isValid) && Xt(k) && t.isValid !== k;
    if (n.delayError && F ? (c = j(() => N(C, F)), c(n.delayError)) : (clearTimeout(m), c = null, F ? Hn(t.errors, C, F) : ft(t.errors, C)), (F ? !pi(X, F) : X) || !Et(W) || T) {
      const U = {
        ...W,
        ...T && Xt(k) ? { isValid: k } : {},
        errors: t.errors,
        name: C
      };
      t = {
        ...t,
        ...U
      }, v.state.next(U);
    }
  }, Y = async (C) => {
    h(C, !0);
    const k = await n.resolver(o, n.context, ZX(C || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return h(C), k;
  }, ee = async (C) => {
    const { errors: k } = await Y(C);
    if (C)
      for (const F of C) {
        const W = Ke(k, F);
        W ? Hn(t.errors, F, W) : ft(t.errors, F);
      }
    else
      t.errors = k;
    return k;
  }, J = async (C, k, F = {
    valid: !0
  }) => {
    for (const W in C) {
      const X = C[W];
      if (X) {
        const { _f: T, ...U } = X;
        if (T) {
          const te = l.array.has(T.name), pe = X._f && eZ(X._f);
          pe && d.validatingFields && h([W], !0);
          const Se = await kN(X, l.disabled, o, b, n.shouldUseNativeValidation && !k, te);
          if (pe && d.validatingFields && h([W]), Se[T.name] && (F.valid = !1, k))
            break;
          !k && (Ke(Se, T.name) ? te ? oZ(t.errors, Se, T.name) : Hn(t.errors, T.name, Se[T.name]) : ft(t.errors, T.name));
        }
        !Et(U) && await J(U, k, F);
      }
    }
    return F.valid;
  }, K = () => {
    for (const C of l.unMount) {
      const k = Ke(i, C);
      k && (k._f.refs ? k._f.refs.every((F) => !Sp(F)) : !Sp(k._f.ref)) && Oe(C);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, V = (C, k) => !n.disabled && (C && k && Hn(o, C, k), !pi(he(), a)), Q = (C, k, F) => xF(C, l, {
    ...s.mount ? o : et(k) ? a : zr(C) ? { [C]: k } : k
  }, F, k), ne = (C) => ec(Ke(s.mount ? o : a, C, n.shouldUnregister ? Ke(a, C, []) : [])), ce = (C, k, F = {}) => {
    const W = Ke(i, C);
    let X = k;
    if (W) {
      const T = W._f;
      T && (!T.disabled && Hn(o, C, FF(k, T)), X = lu(T.ref) && Rt(k) ? "" : k, NF(T.ref) ? [...T.ref.options].forEach((U) => U.selected = X.includes(U.value)) : T.refs ? ws(T.ref) ? T.refs.length > 1 ? T.refs.forEach((U) => (!U.defaultChecked || !U.disabled) && (U.checked = Array.isArray(X) ? !!X.find((te) => te === U.value) : X === U.value)) : T.refs[0] && (T.refs[0].checked = !!X) : T.refs.forEach((U) => U.checked = U.value === X) : Ny(T.ref) ? T.ref.value = "" : (T.ref.value = X, T.ref.type || v.state.next({
        name: C,
        values: xt(o)
      })));
    }
    (F.shouldDirty || F.shouldTouch) && B(C, X, F.shouldTouch, F.shouldDirty, !0), F.shouldValidate && le(C);
  }, ae = (C, k, F) => {
    for (const W in k) {
      const X = k[W], T = `${C}.${W}`, U = Ke(i, T);
      (l.array.has(C) || rt(X) || U && !U._f) && !Di(X) ? ae(T, X, F) : ce(T, X, F);
    }
  }, ve = (C, k, F = {}) => {
    const W = Ke(i, C), X = l.array.has(C), T = xt(k);
    Hn(o, C, T), X ? (v.array.next({
      name: C,
      values: xt(o)
    }), (d.isDirty || d.dirtyFields || p.isDirty || p.dirtyFields) && F.shouldDirty && v.state.next({
      name: C,
      dirtyFields: jo(a, o),
      isDirty: V(C, T)
    })) : W && !W._f && !Rt(T) ? ae(C, T, F) : ce(C, T, F), hN(C, l) && v.state.next({ ...t }), v.state.next({
      name: s.mount ? C : void 0,
      values: xt(o)
    });
  }, je = async (C) => {
    s.mount = !0;
    const k = C.target;
    let F = k.name, W = !0;
    const X = Ke(i, F), T = (U) => {
      W = Number.isNaN(U) || Di(U) && isNaN(U.getTime()) || pi(U, Ke(o, F, U));
    };
    if (X) {
      let U, te;
      const pe = k.type ? fN(X._f) : gF(C), Se = C.type === su.BLUR || C.type === su.FOCUS_OUT, Ze = !nZ(X._f) && !n.resolver && !Ke(t.errors, F) && !X._f.deps || iZ(Se, Ke(t.touchedFields, F), t.isSubmitted, S, y), un = hN(F, l, Se);
      Hn(o, F, pe), Se ? (X._f.onBlur && X._f.onBlur(C), c && c(0)) : X._f.onChange && X._f.onChange(C);
      const en = B(F, pe, Se), tn = !Et(en) || un;
      if (!Se && v.state.next({
        name: F,
        type: C.type,
        values: xt(o)
      }), Ze)
        return (d.isValid || p.isValid) && (n.mode === "onBlur" ? Se && x() : Se || x()), tn && v.state.next({ name: F, ...un ? {} : en });
      if (!Se && un && v.state.next({ ...t }), n.resolver) {
        const { errors: mn } = await Y([F]);
        if (T(pe), W) {
          const cn = yN(t.errors, i, F), vn = yN(mn, i, cn.name || F);
          U = vn.error, F = vn.name, te = Et(mn);
        }
      } else
        h([F], !0), U = (await kN(X, l.disabled, o, b, n.shouldUseNativeValidation))[F], h([F]), T(pe), W && (U ? te = !1 : (d.isValid || p.isValid) && (te = await J(i, !0)));
      W && (X._f.deps && le(X._f.deps), Z(F, te, U, en));
    }
  }, G = (C, k) => {
    if (Ke(t.errors, k) && C.focus)
      return C.focus(), 1;
  }, le = async (C, k = {}) => {
    let F, W;
    const X = Mo(C);
    if (n.resolver) {
      const T = await ee(et(C) ? C : X);
      F = Et(T), W = C ? !X.some((U) => Ke(T, U)) : F;
    } else C ? (W = (await Promise.all(X.map(async (T) => {
      const U = Ke(i, T);
      return await J(U && U._f ? { [T]: U } : U);
    }))).every(Boolean), !(!W && !t.isValid) && x()) : W = F = await J(i);
    return v.state.next({
      ...!zr(C) || (d.isValid || p.isValid) && F !== t.isValid ? {} : { name: C },
      ...n.resolver || !C ? { isValid: F } : {},
      errors: t.errors
    }), k.shouldFocus && !W && Uo(i, G, C ? X : l.mount), W;
  }, he = (C) => {
    const k = {
      ...s.mount ? o : a
    };
    return et(C) ? k : zr(C) ? Ke(k, C) : C.map((F) => Ke(k, F));
  }, M = (C, k) => ({
    invalid: !!Ke((k || t).errors, C),
    isDirty: !!Ke((k || t).dirtyFields, C),
    error: Ke((k || t).errors, C),
    isValidating: !!Ke(t.validatingFields, C),
    isTouched: !!Ke((k || t).touchedFields, C)
  }), Ae = (C) => {
    C && Mo(C).forEach((k) => ft(t.errors, k)), v.state.next({
      errors: C ? t.errors : {}
    });
  }, Ve = (C, k, F) => {
    const W = (Ke(i, C, { _f: {} })._f || {}).ref, X = Ke(t.errors, C) || {}, { ref: T, message: U, type: te, ...pe } = X;
    Hn(t.errors, C, {
      ...pe,
      ...k,
      ref: W
    }), v.state.next({
      name: C,
      errors: t.errors,
      isValid: !1
    }), F && F.shouldFocus && W && W.focus && W.focus();
  }, Te = (C, k) => xr(C) ? v.state.subscribe({
    next: (F) => C(Q(void 0, k), F)
  }) : Q(C, k, !0), ze = (C) => v.state.subscribe({
    next: (k) => {
      rZ(C.name, k.name, C.exact) && tZ(k, C.formState || d, Ie, C.reRenderRoot) && C.callback({
        values: { ...o },
        ...t,
        ...k
      });
    }
  }).unsubscribe, ge = (C) => (s.mount = !0, p = {
    ...p,
    ...C.formState
  }, ze({
    ...C,
    formState: p
  })), Oe = (C, k = {}) => {
    for (const F of C ? Mo(C) : l.mount)
      l.mount.delete(F), l.array.delete(F), k.keepValue || (ft(i, F), ft(o, F)), !k.keepError && ft(t.errors, F), !k.keepDirty && ft(t.dirtyFields, F), !k.keepTouched && ft(t.touchedFields, F), !k.keepIsValidating && ft(t.validatingFields, F), !n.shouldUnregister && !k.keepDefaultValue && ft(a, F);
    v.state.next({
      values: xt(o)
    }), v.state.next({
      ...t,
      ...k.keepDirty ? { isDirty: V() } : {}
    }), !k.keepIsValid && x();
  }, $e = ({ disabled: C, name: k }) => {
    (Xt(C) && s.mount || C || l.disabled.has(k)) && (C ? l.disabled.add(k) : l.disabled.delete(k));
  }, Ye = (C, k = {}) => {
    let F = Ke(i, C);
    const W = Xt(k.disabled) || Xt(n.disabled);
    return Hn(i, C, {
      ...F || {},
      _f: {
        ...F && F._f ? F._f : { ref: { name: C } },
        name: C,
        mount: !0,
        ...k
      }
    }), l.mount.add(C), F ? $e({
      disabled: Xt(k.disabled) ? k.disabled : n.disabled,
      name: C
    }) : O(C, !0, k.value), {
      ...W ? { disabled: k.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!k.required,
        min: Co(k.min),
        max: Co(k.max),
        minLength: Co(k.minLength),
        maxLength: Co(k.maxLength),
        pattern: Co(k.pattern)
      } : {},
      name: C,
      onChange: je,
      onBlur: je,
      ref: (X) => {
        if (X) {
          Ye(C, k), F = Ke(i, C);
          const T = et(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, U = JX(T), te = F._f.refs || [];
          if (U ? te.find((pe) => pe === T) : T === F._f.ref)
            return;
          Hn(i, C, {
            _f: {
              ...F._f,
              ...U ? {
                refs: [
                  ...te.filter(Sp),
                  T,
                  ...Array.isArray(Ke(a, C)) ? [{}] : []
                ],
                ref: { type: T.type, name: C }
              } : { ref: T }
            }
          }), O(C, !1, void 0, T);
        } else
          F = Ke(i, C, {}), F._f && (F._f.mount = !1), (n.shouldUnregister || k.shouldUnregister) && !(kF(l.array, C) && s.action) && l.unMount.add(C);
      }
    };
  }, xe = () => n.shouldFocusError && Uo(i, G, l.mount), Ue = (C) => {
    Xt(C) && (v.state.next({ disabled: C }), Uo(i, (k, F) => {
      const W = Ke(i, F);
      W && (k.disabled = W._f.disabled || C, Array.isArray(W._f.refs) && W._f.refs.forEach((X) => {
        X.disabled = W._f.disabled || C;
      }));
    }, 0, !1));
  }, Be = (C, k) => async (F) => {
    let W;
    F && (F.preventDefault && F.preventDefault(), F.persist && F.persist());
    let X = xt(o);
    if (v.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: T, values: U } = await Y();
      t.errors = T, X = U;
    } else
      await J(i);
    if (l.disabled.size)
      for (const T of l.disabled)
        Hn(X, T, void 0);
    if (ft(t.errors, "root"), Et(t.errors)) {
      v.state.next({
        errors: {}
      });
      try {
        await C(X, F);
      } catch (T) {
        W = T;
      }
    } else
      k && await k({ ...t.errors }, F), xe(), setTimeout(xe);
    if (v.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Et(t.errors) && !W,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), W)
      throw W;
  }, re = (C, k = {}) => {
    Ke(i, C) && (et(k.defaultValue) ? ve(C, xt(Ke(a, C))) : (ve(C, k.defaultValue), Hn(a, C, xt(k.defaultValue))), k.keepTouched || ft(t.touchedFields, C), k.keepDirty || (ft(t.dirtyFields, C), t.isDirty = k.defaultValue ? V(C, xt(Ke(a, C))) : V()), k.keepError || (ft(t.errors, C), d.isValid && x()), v.state.next({ ...t }));
  }, be = (C, k = {}) => {
    const F = C ? xt(C) : a, W = xt(F), X = Et(C), T = X ? a : W;
    if (k.keepDefaultValues || (a = F), !k.keepValues) {
      if (k.keepDirtyValues) {
        const U = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(jo(a, o))
        ]);
        for (const te of Array.from(U))
          Ke(t.dirtyFields, te) ? Hn(T, te, Ke(o, te)) : ve(te, Ke(T, te));
      } else {
        if (_y && et(C))
          for (const U of l.mount) {
            const te = Ke(i, U);
            if (te && te._f) {
              const pe = Array.isArray(te._f.refs) ? te._f.refs[0] : te._f.ref;
              if (lu(pe)) {
                const Se = pe.closest("form");
                if (Se) {
                  Se.reset();
                  break;
                }
              }
            }
          }
        for (const U of l.mount)
          ve(U, Ke(T, U));
      }
      o = xt(T), v.array.next({
        values: { ...T }
      }), v.state.next({
        values: { ...T }
      });
    }
    l = {
      mount: k.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!k.keepIsValid || !!k.keepDirtyValues, s.watch = !!n.shouldUnregister, v.state.next({
      submitCount: k.keepSubmitCount ? t.submitCount : 0,
      isDirty: X ? !1 : k.keepDirty ? t.isDirty : !!(k.keepDefaultValues && !pi(C, a)),
      isSubmitted: k.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: X ? {} : k.keepDirtyValues ? k.keepDefaultValues && o ? jo(a, o) : t.dirtyFields : k.keepDefaultValues && C ? jo(a, C) : k.keepDirty ? t.dirtyFields : {},
      touchedFields: k.keepTouched ? t.touchedFields : {},
      errors: k.keepErrors ? t.errors : {},
      isSubmitSuccessful: k.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ne = (C, k) => be(xr(C) ? C(o) : C, k), Pe = (C, k = {}) => {
    const F = Ke(i, C), W = F && F._f;
    if (W) {
      const X = W.refs ? W.refs[0] : W.ref;
      X.focus && (X.focus(), k.shouldSelect && xr(X.select) && X.select());
    }
  }, Ie = (C) => {
    t = {
      ...t,
      ...C
    };
  }, on = {
    control: {
      register: Ye,
      unregister: Oe,
      getFieldState: M,
      handleSubmit: Be,
      setError: Ve,
      _subscribe: ze,
      _runSchema: Y,
      _getWatch: Q,
      _getDirty: V,
      _setValid: x,
      _setFieldArray: P,
      _setDisabledField: $e,
      _setErrors: $,
      _getFieldArray: ne,
      _reset: be,
      _resetDefaultValues: () => xr(n.defaultValues) && n.defaultValues().then((C) => {
        Ne(C, n.resetOptions), v.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: K,
      _disableForm: Ue,
      _subjects: v,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(C) {
        s = C;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(C) {
        l = C;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(C) {
        n = {
          ...n,
          ...C
        };
      }
    },
    subscribe: ge,
    trigger: le,
    register: Ye,
    handleSubmit: Be,
    watch: Te,
    setValue: ve,
    getValues: he,
    reset: Ne,
    resetField: re,
    clearErrors: Ae,
    unregister: Oe,
    setError: Ve,
    setFocus: Pe,
    getFieldState: M
  };
  return {
    ...on,
    formControl: on
  };
}
function uZ(e = {}) {
  const n = we.useRef(void 0), t = we.useRef(void 0), [i, a] = we.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: xr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: xr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : lZ(e),
    formState: i
  }, e.formControl && e.defaultValues && !xr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, we.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), we.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), we.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), we.useEffect(() => {
    e.values && !pi(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), we.useEffect(() => {
    e.errors && !Et(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), we.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), we.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = _F(i, o), n.current;
}
const cZ = "_modalBody_1clhs_1", dZ = {
  modalBody: cZ
}, mZ = ({
  isOpen: e,
  onClose: n,
  pointsAccount: t,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = pn(), { track: l } = bn(), c = t == null ? void 0 : t.id, m = (t == null ? void 0 : t.balance) ?? 0, d = {
    balance: (m == null ? void 0 : m.toString()) ?? "0",
    description: "",
    transactionType: null
  }, { control: p, setValue: v, reset: y } = uZ({
    defaultValues: d,
    mode: "onChange"
  }), S = SF({ control: p }), b = parseInt((S == null ? void 0 : S.balance) ?? "0", 10), j = m === b, x = j ? "Change the value to update the points" : "", h = b < 0, P = h ? "Points can not be negative" : "", N = S.description === "", $ = N ? "Description can not be empty" : "";
  Ge(() => {
    b > m ? v(
      "transactionType",
      Tv.Addition
    ) : b < m && v(
      "transactionType",
      Tv.Deduction
    );
  }, [m, b, v]);
  const [O, { loading: B, error: Z, reset: Y }] = o(OX, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ee = () => {
    if (c) {
      const K = fX();
      O({
        variables: {
          input: {
            accountId: c,
            transactionId: K,
            amount: Math.abs(b - m),
            transactionType: S.transactionType,
            description: S.description,
            source: hF.UpdateBalance
          }
        }
      }).then(async (V) => {
        V != null && V.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), J());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, J = () => {
    y(d), Y(), n();
  };
  return /* @__PURE__ */ H.jsxs(
    Ht,
    {
      isOpen: e,
      onClose: J,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ H.jsx(Kt, { title: "Update points balance", onClose: J }),
        /* @__PURE__ */ H.jsxs(Wt, { className: dZ.modalBody, children: [
          /* @__PURE__ */ H.jsxs(Ir, { children: [
            /* @__PURE__ */ H.jsx(ln, { span: 6, children: /* @__PURE__ */ H.jsx(
              lN,
              {
                name: "balance",
                control: p,
                render: ({ field: K }) => /* @__PURE__ */ H.jsx(
                  ur,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: x || P
                    },
                    input: {
                      ...K,
                      value: K.value.toString(),
                      onChange: (V) => K.onChange(V)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ H.jsx(ln, { span: 6, children: /* @__PURE__ */ H.jsx(
              lN,
              {
                name: "description",
                control: p,
                render: ({ field: K }) => /* @__PURE__ */ H.jsx(
                  ur,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: K,
                    meta: {
                      warning: $
                    }
                  }
                )
              }
            ) })
          ] }),
          Z && /* @__PURE__ */ H.jsx(Fn, { error: Z })
        ] }),
        /* @__PURE__ */ H.jsx(
          rr,
          {
            confirmName: "Save",
            confirmOnClick: () => ee(),
            confirmProps: {
              isLoading: B,
              disabled: j || h || N,
              loadingIndicator: /* @__PURE__ */ H.jsx(fn, { size: 16 })
            },
            cancelOnClick: J
          }
        )
      ]
    }
  );
}, fZ = "_wrapper_1ge6c_1", pZ = "_block_1ge6c_12", bN = {
  wrapper: fZ,
  block: pZ
}, vZ = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: t } = pn(), { isCopied: i, copy: a } = Dl(), { isCopied: o, copy: s } = Dl(), { isCopied: l, copy: c } = Dl(), [m, d] = me(!1), [p, v] = me(), [y, S] = me(!1), {
    loading: b,
    data: j,
    refetch: x
  } = t(EX, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Ge(() => {
    var ne;
    if (j) {
      const ce = (ne = j == null ? void 0 : j.Voyado) == null ? void 0 : ne.PointAccountV_GetPointAccounts;
      ce && (ce == null ? void 0 : ce.length) > 0 && v(ce[0]);
    }
  }, [j]);
  const h = !!(p != null && p.id), P = (p == null ? void 0 : p.balance) ?? 0;
  if (!e)
    return null;
  const {
    firstName: N,
    lastName: $,
    street: O,
    zipCode: B,
    city: Z,
    country: Y,
    isRegistrationCompleted: ee,
    email: J,
    mobilePhone: K
  } = e, V = 14, Q = `${N || ""} ${$ || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ H.jsxs(_, { flexDirection: "column", className: bN.wrapper, children: [
    /* @__PURE__ */ H.jsxs(
      _,
      {
        justifyContent: "space-between",
        className: bN.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ H.jsx(q.Heading, { variant: "heading-2", children: Q }),
          b && /* @__PURE__ */ H.jsx(fn, { size: 12 }),
          h && !b && /* @__PURE__ */ H.jsxs(_, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ H.jsxs(Jn, { size: "small", variant: "warning", children: [
              P,
              " points"
            ] }),
            /* @__PURE__ */ H.jsx(nn, { content: "Update points balance", children: /* @__PURE__ */ H.jsx(
              ye,
              {
                name: "pen",
                size: 12,
                onClick: () => d(!0),
                className: Pt.pointer
              }
            ) }),
            y && /* @__PURE__ */ H.jsx(nn, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ H.jsx(
              ye,
              {
                name: "info",
                size: 12,
                className: Pt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (O || Z || B || Y || K || J) && /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "column", children: [
      K && /* @__PURE__ */ H.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ H.jsxs(_, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ H.jsx(ye, { size: V, name: "phone" }),
          /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: K })
        ] }),
        /* @__PURE__ */ H.jsx(
          ye,
          {
            size: V,
            name: o ? "done" : "copy",
            onClick: () => s(K),
            className: Pt.pointer
          }
        )
      ] }),
      J && /* @__PURE__ */ H.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ H.jsxs(_, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ H.jsx(ye, { size: V, name: "mail" }),
          /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: J })
        ] }),
        /* @__PURE__ */ H.jsx(
          ye,
          {
            size: V,
            name: i ? "done" : "copy",
            onClick: () => a(J),
            className: Pt.pointer
          }
        )
      ] }),
      (O || Z || B || Y) && /* @__PURE__ */ H.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ H.jsxs(_, { gap: "200", children: [
          /* @__PURE__ */ H.jsx(ye, { size: V, name: "home" }),
          /* @__PURE__ */ H.jsxs(q.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ H.jsx(Wn, { children: O }),
            /* @__PURE__ */ H.jsxs(Wn, { children: [
              B,
              " ",
              Z
            ] }),
            /* @__PURE__ */ H.jsx(Wn, { children: Y })
          ] })
        ] }),
        /* @__PURE__ */ H.jsx(
          ye,
          {
            size: V,
            name: l ? "done" : "copy",
            onClick: () => c(`${O}, ${B} ${Z}, ${Y}`),
            className: Pt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ H.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ H.jsxs(_, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ H.jsx(ye, { size: V, name: "sign-in" }),
          /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ H.jsx(
          ye,
          {
            name: ee ? "check-circle-filled" : "close-circle-filled",
            color: ee ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    h && /* @__PURE__ */ H.jsx(
      mZ,
      {
        isOpen: m,
        pointsAccount: p,
        onClose: () => d(!1),
        setHasPointsBeenUpdated: S,
        refetchPointsQuery: x
      }
    )
  ] });
}, hZ = "_list_yud4a_7", yZ = "_listItem_yud4a_11", gZ = "_listItemTooltip_yud4a_15", kZ = "_listItemTimestamp_yud4a_18", vl = {
  list: hZ,
  listItem: yZ,
  listItemTooltip: gZ,
  listItemTimestamp: kZ
}, bZ = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ H.jsx(q.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ H.jsx(Je, { className: vl.list, children: e.map((n, t) => /* @__PURE__ */ H.jsx(Je.Text, { variant: "dense", className: vl.listItem, children: /* @__PURE__ */ H.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ H.jsx(nn, { content: n == null ? void 0 : n.comment, children: /* @__PURE__ */ H.jsxs(
      _,
      {
        gap: "200",
        alignItems: "center",
        className: ct({
          [vl.listItemTooltip]: n == null ? void 0 : n.comment
        }),
        children: [
          /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ H.jsx(q.Paragraph, { className: vl.listItemTimestamp, children: An(n.date).format(vt) }),
          (n == null ? void 0 : n.comment) && /* @__PURE__ */ H.jsx(ye, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ H.jsx(
      ye,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, t)) })
] }), _Z = "_tagHover_kzbzk_1", xZ = "_channelUnsubscribed_kzbzk_6", _N = {
  tagHover: _Z,
  channelUnsubscribed: xZ
}, Np = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: t,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = bn(), { useMutation: l } = pn(), [c, m] = me(!1), [d, { loading: p }] = l(TX), v = async ({
    newPreference: S,
    isSubscribed: b,
    channelType: j
  }) => {
    var x, h;
    m(!0);
    const P = await d({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...S
          }
        }
      }
    });
    (h = (x = P == null ? void 0 : P.data) == null ? void 0 : x.Voyado.ContactsV_ContactPatch) != null && h.id ? b ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : b ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, y = c || p;
  return /* @__PURE__ */ H.jsx(nn, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ H.jsx(
    Dn,
    {
      className: _N.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ H.jsxs(
        _,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ct({
            [_N.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), v({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            y ? /* @__PURE__ */ H.jsx(fn, { size: 16 }) : /* @__PURE__ */ H.jsx(ye, { size: 16, name: t }),
            n
          ]
        }
      )
    }
  ) });
}, SZ = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: t
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ H.jsx(_, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ H.jsx(q.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ H.jsxs(_, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ H.jsx(
        Np,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      ),
      /* @__PURE__ */ H.jsx(
        Np,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      ),
      /* @__PURE__ */ H.jsx(
        Np,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      )
    ] })
  ] }) });
}, NZ = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: t,
    showPreferences: i,
    showAudiences: a,
    showConsents: o
  } = n, { isLoading: s, error: l, refetch: c, attributes: m, preferences: d, consents: p } = RX({ contactId: e }), v = At(
    () => p == null ? void 0 : p.filter(
      (y) => y !== null
    ),
    [p]
  );
  return l ? Zo({
    errors: l.graphQLErrors
  }) ? /* @__PURE__ */ H.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ H.jsx(q.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ H.jsx(Fn, { error: l }) : !t && !i && !a && !o ? null : s ? /* @__PURE__ */ H.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ H.jsx(fn, {}) }) : /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
    t && /* @__PURE__ */ H.jsx(
      vZ,
      {
        contactAttributes: m,
        contactId: e
      }
    ),
    i && /* @__PURE__ */ H.jsx(
      SZ,
      {
        refetchContact: c,
        contactPreferences: d,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ H.jsx(bZ, { contactConsents: v })
  ] });
}, Rv = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, wZ = "_list_zu4s7_1", jZ = "_listItem_zu4s7_4", CZ = "_listSum_zu4s7_7", hl = {
  list: wZ,
  listItem: jZ,
  listSum: CZ
}, FZ = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: t
}) => /* @__PURE__ */ H.jsxs(Je, { className: hl.list, children: [
  e == null ? void 0 : e.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ H.jsx(Je.Text, { variant: "dense", className: hl.listItem, children: /* @__PURE__ */ H.jsx(nn, { content: s, children: /* @__PURE__ */ H.jsxs(_, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ H.jsxs(_, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ H.jsx(_, { flex: "auto", children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: a == null ? void 0 : a.name }) }),
    o && n && /* @__PURE__ */ H.jsx(_, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: Rv(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ H.jsx(
    Je.Text,
    {
      variant: "dense",
      className: ct(hl.listItem, hl.listSum),
      children: /* @__PURE__ */ H.jsxs(_, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: Rv(t, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), IZ = "_transaction_1kr8d_1", $Z = "_transactionIsOpen_1kr8d_9", EZ = "_transactionHeader_1kr8d_12", TZ = "_transactionHeaderSubLine_1kr8d_15", OZ = "_transactionHeaderAlignItemRight_1kr8d_19", sa = {
  transaction: IZ,
  transactionIsOpen: $Z,
  transactionHeader: EZ,
  transactionHeaderSubLine: TZ,
  transactionHeaderAlignItemRight: OZ
}, RZ = ({
  transaction: e,
  openByDefault: n
}) => {
  const [t, i] = me(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: c,
    lineItems: m,
    localCurrency: d,
    localNetPriceSum: p
  } = e, v = d ?? "", y = p ?? 0, S = m != null && m.length ? m : [];
  return /* @__PURE__ */ H.jsxs(
    _,
    {
      className: ct(sa.transaction, {
        [sa.transactionIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ H.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: sa.transactionHeader,
            onClick: () => i(!t),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ H.jsxs(_, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ H.jsxs(_, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ H.jsx(Jn, { size: "small", variant: "info", children: An(o).format(vt) }),
                  /* @__PURE__ */ H.jsxs(
                    q.Heading,
                    {
                      variant: "heading-4",
                      className: sa.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ H.jsxs(
                  _,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: sa.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ H.jsx(q.Heading, { variant: "heading-4", children: Rv(y, v) }),
                      /* @__PURE__ */ H.jsxs(
                        q.Heading,
                        {
                          variant: "heading-4",
                          className: sa.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ H.jsx(_, { flexDirection: "column", children: /* @__PURE__ */ H.jsx(
                qr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        t && /* @__PURE__ */ H.jsxs(
          _,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ H.jsx(zv, {}),
              /* @__PURE__ */ H.jsxs(_, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ H.jsx(q.Heading, { variant: "heading-2", children: s }),
                c && /* @__PURE__ */ H.jsx(Dn, { children: /* @__PURE__ */ H.jsx(_, { alignItems: "center", children: c }) }),
                /* @__PURE__ */ H.jsx(
                  FZ,
                  {
                    lineItems: S,
                    localCurrency: v,
                    localNetPriceSum: y
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, DZ = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: t,
    transactions: i
  } = LX({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return t ? /* @__PURE__ */ H.jsx(Fn, { error: t }) : /* @__PURE__ */ H.jsxs(
    _,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ H.jsx(q.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ H.jsx(Jn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ H.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ H.jsx(fn, {}) }) : /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
          s === 0 && /* @__PURE__ */ H.jsx(_, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && (a == null ? void 0 : a.map((l, c) => /* @__PURE__ */ H.jsx(
            RZ,
            {
              transaction: l,
              openByDefault: c === 0
            },
            c
          )))
        ] })
      ]
    }
  );
}, PZ = "_message_unsvt_48", AZ = "_messageIsOpen_unsvt_56", LZ = "_messageHeader_unsvt_60", VZ = "_messageText_unsvt_64", zZ = "_buttonLink_unsvt_86", Fo = {
  message: PZ,
  messageIsOpen: AZ,
  messageHeader: LZ,
  messageText: VZ,
  buttonLink: zZ
}, wp = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, jp = (e, n) => n && e in wp && n in wp[e] ? wp[e][n] : null, MZ = ({
  message: e,
  openByDefault: n
}) => {
  const [t, i] = me(n), { track: a } = bn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: c,
    isTransactional: m,
    status: d,
    messageLink: p,
    messageText: v
  } = e, y = l ? jp("type", l) : null, S = c ? jp("source", c) : null, b = d ? jp("status", d) : null, j = l == null ? void 0 : l.replace("Message", "");
  return /* @__PURE__ */ H.jsxs(
    _,
    {
      className: ct(Fo.message, {
        [Fo.messageIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ H.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Fo.messageHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ H.jsxs(_, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ H.jsxs(_, { gap: "200", alignItems: "center", children: [
                  y && /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
                    /* @__PURE__ */ H.jsx(ye, { name: y, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ H.jsx(Jn, { size: "small", variant: "info", children: An(s).format(vt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ H.jsx(
                qr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ H.jsxs(_, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ H.jsx(zv, {}),
          /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            b && /* @__PURE__ */ H.jsx(Dn, { children: /* @__PURE__ */ H.jsxs(_, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ H.jsx(ye, { name: b }),
              " ",
              d
            ] }) }),
            S && /* @__PURE__ */ H.jsx(Dn, { children: /* @__PURE__ */ H.jsxs(_, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ H.jsx(ye, { name: S }),
              " ",
              c
            ] }) }),
            m && /* @__PURE__ */ H.jsx(Dn, { children: /* @__PURE__ */ H.jsxs(_, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ H.jsx(ye, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ H.jsxs(_, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", className: Fo.messageText, children: v })
          ] }),
          p && /* @__PURE__ */ H.jsx(
            Ct,
            {
              slotEnd: /* @__PURE__ */ H.jsx(ye, { name: "external-link" }),
              variant: "tertiary",
              className: Fo.buttonLink,
              navigate: () => {
                var x;
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), (x = window.open(p, "_blank")) == null || x.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, UZ = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: t,
    lastMessages: i
  } = PX({ contactId: e });
  if (!e)
    return null;
  if (t)
    return /* @__PURE__ */ H.jsx(Fn, { error: t });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ H.jsx(q.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ H.jsx(Jn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ H.jsx(_, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ H.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ H.jsx(fn, {}) }) : /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
      l && (o == null ? void 0 : o.map((c, m) => /* @__PURE__ */ H.jsx(
        MZ,
        {
          message: c || void 0,
          openByDefault: m === 0
        },
        m
      ))),
      !l && /* @__PURE__ */ H.jsx(_, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, nc = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, xN = ({
  labelText: e,
  address: n,
  icon: t = "home"
}) => {
  const { isCopied: i, copy: a } = Dl(), o = [n == null ? void 0 : n.title, n == null ? void 0 : n.firstname, n == null ? void 0 : n.lastname].filter(Boolean).join(" "), s = ut(() => [
    o,
    n == null ? void 0 : n.streetAddress,
    n == null ? void 0 : n.streetAddress2,
    n == null ? void 0 : n.postalCode,
    n == null ? void 0 : n.region,
    n == null ? void 0 : n.city,
    n == null ? void 0 : n.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ H.jsxs(_, { justifyContent: "space-between", children: [
    /* @__PURE__ */ H.jsxs(_, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ H.jsx(ye, { size: l, name: t, color: "green.500" }),
      /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ H.jsxs(_, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: o }),
          (n == null ? void 0 : n.streetAddress) && /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: n.streetAddress }),
          (n == null ? void 0 : n.streetAddress2) && /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: n.streetAddress2 }),
          (n == null ? void 0 : n.postalCode) && /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: n == null ? void 0 : n.postalCode }),
          (n == null ? void 0 : n.region) && /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: n.region }),
          (n == null ? void 0 : n.city) && /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: n.city }),
          (n == null ? void 0 : n.country) && /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ H.jsx(nn, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ H.jsx(
      ye,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: Pt.pointer
      }
    ) })
  ] });
}, BZ = "_order_19t4p_1", qZ = "_orderIsOpen_19t4p_9", HZ = "_orderHeader_19t4p_12", KZ = "_orderIconColor_19t4p_15", Ar = {
  order: BZ,
  orderIsOpen: qZ,
  orderHeader: HZ,
  orderIconColor: KZ
}, WZ = "_delivery_1m9nb_1", GZ = "_deliveryCode_1m9nb_4", Cp = {
  delivery: WZ,
  deliveryCode: GZ
}, YZ = ({
  delivery: e
}) => {
  const { isCopied: n, copy: t } = ri();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ H.jsxs(_, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ H.jsx(
      ye,
      {
        size: l,
        name: "eye",
        className: Ar.orderIconColor
      }
    ),
    /* @__PURE__ */ H.jsxs(_, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ H.jsx(
        nn,
        {
          content: /* @__PURE__ */ H.jsxs(q.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            An(s).format(vt)
          ] }),
          children: /* @__PURE__ */ H.jsxs(_, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ H.jsx(
              q.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ H.jsxs(
                  _,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Cp.delivery,
                    children: [
                      /* @__PURE__ */ H.jsx(ye, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ H.jsx(
              q.Paragraph,
              {
                variant: "4",
                className: ct(Cp.delivery, Cp.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ H.jsx(nn, { content: "Copy tracking code", children: /* @__PURE__ */ H.jsx(
      ye,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => t(a.toString()),
        className: Pt.pointer
      }
    ) })
  ] });
}, JZ = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = (e == null ? void 0 : e.items) ?? [];
  return /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ H.jsxs(_, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ H.jsx(
        ye,
        {
          size: 14,
          name: "file-text",
          className: Ar.orderIconColor
        }
      ),
      /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ H.jsx(Je, { className: Pt.list, children: t == null ? void 0 : t.map((i, a) => {
      var o, s;
      return /* @__PURE__ */ H.jsx(Je.Item, { className: Pt.listItem, children: /* @__PURE__ */ H.jsxs(
        _,
        {
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          children: [
            /* @__PURE__ */ H.jsxs(_, { flexDirection: "column", gap: "100", children: [
              /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "5", children: i == null ? void 0 : i.type }),
              /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: i == null ? void 0 : i.description })
            ] }),
            /* @__PURE__ */ H.jsx(_, { flexDirection: "column", gap: "100", children: (s = (o = i == null ? void 0 : i.taxes) == null ? void 0 : o.items) == null ? void 0 : s.map((l, c) => /* @__PURE__ */ H.jsxs(
              _,
              {
                gap: "100",
                flexDirection: "column",
                className: Pt.listItemAlignRight,
                children: [
                  /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "5", children: `${l == null ? void 0 : l.description} ${l == null ? void 0 : l.percent}%` }),
                  /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: nc({ value: l == null ? void 0 : l.amount, currencyCode: n }) })
                ]
              },
              `tax-${c}`
            )) })
          ]
        }
      ) }, `fees-${a}`);
    }) })
  ] });
}, QZ = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = (e == null ? void 0 : e.items) ?? [];
  return /* @__PURE__ */ H.jsxs(_, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ H.jsxs(_, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ H.jsx(
        ye,
        {
          size: 14,
          name: "tag",
          className: Ar.orderIconColor
        }
      ),
      /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ H.jsx(Je, { className: Pt.list, children: t == null ? void 0 : t.map((i) => {
      var a, o, s, l, c;
      return /* @__PURE__ */ H.jsx(
        Je.Item,
        {
          className: Pt.listItem,
          contentLeft: /* @__PURE__ */ H.jsxs(_, { gap: "200", children: [
            /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: i == null ? void 0 : i.quantity }),
            /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: "×" })
          ] }),
          title: /* @__PURE__ */ H.jsx(
            nn,
            {
              content: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", color: "inherit", children: (a = i == null ? void 0 : i.article) == null ? void 0 : a.sku }),
              children: /* @__PURE__ */ H.jsxs(_, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: (o = i == null ? void 0 : i.article) == null ? void 0 : o.name }),
                /* @__PURE__ */ H.jsx(_, { children: /* @__PURE__ */ H.jsx(Jn, { size: "small", variant: "info", children: nc({
                  value: i == null ? void 0 : i.totalPrice,
                  currencyCode: n
                }) }) })
              ] })
            }
          ),
          contentRight: ((s = i == null ? void 0 : i.article) == null ? void 0 : s.imageUri) && /* @__PURE__ */ H.jsx(
            GN,
            {
              src: (l = i == null ? void 0 : i.article) == null ? void 0 : l.imageUri,
              alt: (c = i == null ? void 0 : i.article) == null ? void 0 : c.name,
              style: { height: "48px" }
            }
          )
        },
        `list-${i == null ? void 0 : i.id}`
      );
    }) })
  ] });
}, XZ = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = (e == null ? void 0 : e.items) ?? [];
  return /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ H.jsxs(_, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ H.jsx(
        ye,
        {
          size: 14,
          name: "credit-card",
          className: Ar.orderIconColor
        }
      ),
      /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ H.jsx(Je, { className: Pt.list, children: t == null ? void 0 : t.map((i, a) => /* @__PURE__ */ H.jsx(
      Je.Item,
      {
        className: Pt.listItem,
        children: /* @__PURE__ */ H.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ H.jsxs(_, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "5", children: i == null ? void 0 : i.description }),
                /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: i == null ? void 0 : i.method })
              ] }),
              /* @__PURE__ */ H.jsxs(
                _,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: Pt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "5", children: An(i == null ? void 0 : i.paidAt).format(vt) }),
                    /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: nc({ value: i == null ? void 0 : i.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, ZZ = ({
  order: e,
  openByDefault: n
}) => {
  const [t, i] = me(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: c,
    createdAt: m,
    lastChangedAt: d,
    lineItems: p,
    billingAddress: v,
    deliveryAddress: y,
    totalPrice: S
  } = e, b = 14;
  return /* @__PURE__ */ H.jsxs(
    _,
    {
      className: ct(Ar.order, {
        [Ar.orderIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ H.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ar.orderHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ H.jsxs(_, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ H.jsx(_, { alignItems: "center", children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: An(m).format(vt) }) }),
                /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ H.jsx(
                qr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ H.jsxs(_, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ H.jsxs(_, { gap: "250", children: [
            /* @__PURE__ */ H.jsx(
              ye,
              {
                size: b,
                name: "activity",
                className: Ar.orderIconColor
              }
            ),
            /* @__PURE__ */ H.jsxs(_, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ H.jsxs(_, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ H.jsx(nn, { content: "Internal status", children: /* @__PURE__ */ H.jsx(Jn, { size: "small", variant: "info", children: /* @__PURE__ */ H.jsx(H.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ H.jsx(nn, { content: "External status", children: /* @__PURE__ */ H.jsx(Jn, { size: "small", variant: "info", children: /* @__PURE__ */ H.jsx(H.Fragment, { children: s }) }) }),
                /* @__PURE__ */ H.jsx(nn, { content: "Last updated at", children: /* @__PURE__ */ H.jsx(q.Paragraph, { as: "span", variant: "5", children: An(d).format(vt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ H.jsxs(_, { gap: "250", children: [
            /* @__PURE__ */ H.jsx(
              ye,
              {
                size: b,
                name: "chart-bar",
                className: Ar.orderIconColor
              }
            ),
            /* @__PURE__ */ H.jsxs(_, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: nc({
                value: S,
                currencyCode: l
              }) })
            ] })
          ] }),
          c && /* @__PURE__ */ H.jsxs(_, { gap: "250", children: [
            /* @__PURE__ */ H.jsx(
              ye,
              {
                size: b,
                name: "channels",
                className: Ar.orderIconColor
              }
            ),
            /* @__PURE__ */ H.jsxs(_, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", children: /* @__PURE__ */ H.jsx(Jn, { size: "small", variant: "info", children: /* @__PURE__ */ H.jsx(H.Fragment, { children: c }) }) })
            ] })
          ] }),
          /* @__PURE__ */ H.jsx(xN, { labelText: "Billing address", address: v }),
          /* @__PURE__ */ H.jsx(
            xN,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: y
            }
          ),
          /* @__PURE__ */ H.jsx(YZ, { delivery: e.delivery }),
          /* @__PURE__ */ H.jsx(QZ, { lineItems: p, currencyCode: l }),
          /* @__PURE__ */ H.jsx(JZ, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ H.jsx(
            XZ,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, eee = ({
  error: e,
  itemCount: n,
  children: t
}) => e ? n === 0 || Zo({ errors: e.graphQLErrors }) ? /* @__PURE__ */ H.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ H.jsx(Fn, { error: e }) : /* @__PURE__ */ H.jsx(H.Fragment, { children: t }), nee = ({
  contactId: e
}) => {
  const { useQuery: n } = pn(), [t, i] = me([]), { track: a } = bn(), {
    loading: o,
    error: s,
    data: l
  } = n($X, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Ge(() => {
    if (l != null && l.Voyado) {
      const c = l == null ? void 0 : l.Voyado.Orders_GetAllByContact;
      if (!o && c != null && c.items) {
        i(c.items);
        const { totalCount: m } = c;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l == null ? void 0 : l.Voyado]), e ? /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ H.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ H.jsx(q.Heading, { variant: "heading-3", children: "Orders" }),
      t.length > 0 && /* @__PURE__ */ H.jsx(Jn, { size: "small", variant: "success", children: t.length })
    ] }),
    o ? /* @__PURE__ */ H.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ H.jsx(fn, {}) }) : /* @__PURE__ */ H.jsx(eee, { error: s, itemCount: t.length, children: t.map((c, m) => /* @__PURE__ */ H.jsx(
      ZZ,
      {
        order: c,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, tee = ({
  conversationContext: e,
  settings: n
}) => {
  var t, i;
  const { isLoading: a, contactId: o, hasMultipleContacts: s, error: l } = VX({
    conversationContext: e
  }), c = !((t = e == null ? void 0 : e.customer) != null && t.email) && !((i = e == null ? void 0 : e.customer) != null && i.phone_number), m = !!o, {
    showCustomerAttributes: d,
    showPreferences: p,
    showAudiences: v,
    showConsents: y,
    showLastMessages: S,
    showCustomerTransactions: b,
    showOrders: j
  } = n;
  return c ? /* @__PURE__ */ H.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : s ? /* @__PURE__ */ H.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : l ? Zo({
    errors: l.graphQLErrors
  }) ? /* @__PURE__ */ H.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ H.jsx(Fn, { error: l }) : !d && !p && !v && !y && !S && !b ? /* @__PURE__ */ H.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : a ? /* @__PURE__ */ H.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ H.jsx(fn, {}) }) : /* @__PURE__ */ H.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ H.jsx(NZ, { contactId: o, settings: n }),
        S && /* @__PURE__ */ H.jsx(UZ, { contactId: o }),
        b && /* @__PURE__ */ H.jsx(DZ, { contactId: o }),
        j && /* @__PURE__ */ H.jsx(nee, { contactId: o }),
        !m && /* @__PURE__ */ H.jsx(_, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ H.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, ree = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_nr4rl_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_nr4rl_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_nr4rl_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_nr4rl_63:last-child{border-bottom:none}._channelHeadline_yeqqp_1{padding:var(--dixa-size-spacer-200);border-bottom:var(--dixa-size-border-200) solid var(--dixa-color-neutral-200)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Fp = { exports: {} }, Io = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SN;
function iee() {
  if (SN) return Io;
  SN = 1;
  var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var d, p = {}, v = null, y = null;
    m !== void 0 && (v = "" + m), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (d in c) i.call(c, d) && !o.hasOwnProperty(d) && (p[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) p[d] === void 0 && (p[d] = c[d]);
    return { $$typeof: n, type: l, key: v, ref: y, props: p, _owner: a.current };
  }
  return Io.Fragment = t, Io.jsx = s, Io.jsxs = s, Io;
}
var yl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NN;
function aee() {
  return NN || (NN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = we, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var u = S && r[S] || r[b];
      return typeof u == "function" ? u : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(r) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), g = 1; g < u; g++)
          f[g - 1] = arguments[g];
        P("error", r, f);
      }
    }
    function P(r, u, f) {
      {
        var g = x.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (u += "%s", f = f.concat([R]));
        var A = f.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + u), Function.prototype.apply.call(console[r], console, A);
      }
    }
    var N = !1, $ = !1, O = !1, B = !1, Z = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || B || r === y || N || $ || O || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === p || r.$$typeof === s || r.$$typeof === l || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Y || r.getModuleId !== void 0));
    }
    function J(r, u, f) {
      var g = r.displayName;
      if (g)
        return g;
      var R = u.displayName || u.name || "";
      return R !== "" ? f + "(" + R + ")" : f;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function V(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var u = r;
            return K(u) + ".Consumer";
          case s:
            var f = r;
            return K(f._context) + ".Provider";
          case c:
            return J(r, r.render, "ForwardRef");
          case p:
            var g = r.displayName || null;
            return g !== null ? g : V(r.type) || "Memo";
          case v: {
            var R = r, A = R._payload, I = R._init;
            try {
              return V(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, ne = 0, ce, ae, ve, je, G, le, he;
    function M() {
    }
    M.__reactDisabledLog = !0;
    function Ae() {
      {
        if (ne === 0) {
          ce = console.log, ae = console.info, ve = console.warn, je = console.error, G = console.group, le = console.groupCollapsed, he = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: M,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Ve() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, r, {
              value: ce
            }),
            info: Q({}, r, {
              value: ae
            }),
            warn: Q({}, r, {
              value: ve
            }),
            error: Q({}, r, {
              value: je
            }),
            group: Q({}, r, {
              value: G
            }),
            groupCollapsed: Q({}, r, {
              value: le
            }),
            groupEnd: Q({}, r, {
              value: he
            })
          });
        }
        ne < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Te = x.ReactCurrentDispatcher, ze;
    function ge(r, u, f) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + r;
      }
    }
    var Oe = !1, $e;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new Ye();
    }
    function xe(r, u) {
      if (!r || Oe)
        return "";
      {
        var f = $e.get(r);
        if (f !== void 0)
          return f;
      }
      var g;
      Oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Te.current, Te.current = null, Ae();
      try {
        if (u) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ie) {
              g = ie;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ie) {
              g = ie;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            g = ie;
          }
          r();
        }
      } catch (ie) {
        if (ie && g && typeof ie.stack == "string") {
          for (var w = ie.stack.split(`
`), E = g.stack.split(`
`), L = w.length - 1, z = E.length - 1; L >= 1 && z >= 0 && w[L] !== E[z]; )
            z--;
          for (; L >= 1 && z >= 0; L--, z--)
            if (w[L] !== E[z]) {
              if (L !== 1 || z !== 1)
                do
                  if (L--, z--, z < 0 || w[L] !== E[z]) {
                    var se = `
` + w[L].replace(" at new ", " at ");
                    return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), typeof r == "function" && $e.set(r, se), se;
                  }
                while (L >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Te.current = A, Ve(), Error.prepareStackTrace = R;
      }
      var Ee = r ? r.displayName || r.name : "", Ce = Ee ? ge(Ee) : "";
      return typeof r == "function" && $e.set(r, Ce), Ce;
    }
    function Ue(r, u, f) {
      return xe(r, !1);
    }
    function Be(r) {
      var u = r.prototype;
      return !!(u && u.isReactComponent);
    }
    function re(r, u, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return xe(r, Be(r));
      if (typeof r == "string")
        return ge(r);
      switch (r) {
        case m:
          return ge("Suspense");
        case d:
          return ge("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return Ue(r.render);
          case p:
            return re(r.type, u, f);
          case v: {
            var g = r, R = g._payload, A = g._init;
            try {
              return re(A(R), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, Ne = {}, Pe = x.ReactDebugCurrentFrame;
    function Ie(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        Pe.setExtraStackFrame(f);
      } else
        Pe.setExtraStackFrame(null);
    }
    function on(r, u, f, g, R) {
      {
        var A = Function.call.bind(be);
        for (var I in r)
          if (A(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var E = Error((g || "React class") + ": " + f + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = r[I](u, I, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              w = L;
            }
            w && !(w instanceof Error) && (Ie(R), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, I, typeof w), Ie(null)), w instanceof Error && !(w.message in Ne) && (Ne[w.message] = !0, Ie(R), h("Failed %s type: %s", f, w.message), Ie(null));
          }
      }
    }
    var C = Array.isArray;
    function k(r) {
      return C(r);
    }
    function F(r) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function W(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function T(r) {
      if (W(r))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", F(r)), X(r);
    }
    var U = x.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Se;
    function Ze(r) {
      if (be.call(r, "ref")) {
        var u = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (be.call(r, "key")) {
        var u = Object.getOwnPropertyDescriptor(r, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function en(r, u) {
      typeof r.ref == "string" && U.current;
    }
    function tn(r, u) {
      {
        var f = function() {
          pe || (pe = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function mn(r, u) {
      {
        var f = function() {
          Se || (Se = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var cn = function(r, u, f, g, R, A, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: u,
        ref: f,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, u, f, g, R) {
      {
        var A, I = {}, w = null, E = null;
        f !== void 0 && (T(f), w = "" + f), un(u) && (T(u.key), w = "" + u.key), Ze(u) && (E = u.ref, en(u));
        for (A in u)
          be.call(u, A) && !te.hasOwnProperty(A) && (I[A] = u[A]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (A in L)
            I[A] === void 0 && (I[A] = L[A]);
        }
        if (w || E) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && tn(I, z), E && mn(I, z);
        }
        return cn(r, w, E, R, g, U.current, I);
      }
    }
    var Qe = x.ReactCurrentOwner, hn = x.ReactDebugCurrentFrame;
    function Le(r) {
      if (r) {
        var u = r._owner, f = re(r.type, r._source, u ? u.type : null);
        hn.setExtraStackFrame(f);
      } else
        hn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function rn(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function Nn() {
      {
        if (Qe.current) {
          var r = V(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Bn(r) {
      return "";
    }
    var an = {};
    function On(r) {
      {
        var u = Nn();
        if (!u) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function wn(r, u) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = On(u);
        if (an[f])
          return;
        an[f] = !0;
        var g = "";
        r && r._owner && r._owner !== Qe.current && (g = " It was passed a child from " + V(r._owner.type) + "."), Le(r), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, g), Le(null);
      }
    }
    function _n(r, u) {
      {
        if (typeof r != "object")
          return;
        if (k(r))
          for (var f = 0; f < r.length; f++) {
            var g = r[f];
            rn(g) && wn(g, u);
          }
        else if (rn(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var A = R.call(r), I; !(I = A.next()).done; )
              rn(I.value) && wn(I.value, u);
        }
      }
    }
    function Ln(r) {
      {
        var u = r.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === p))
          f = u.propTypes;
        else
          return;
        if (f) {
          var g = V(u);
          on(f, r.props, "prop", g, r);
        } else if (u.PropTypes !== void 0 && !sn) {
          sn = !0;
          var R = V(u);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zn(r) {
      {
        for (var u = Object.keys(r.props), f = 0; f < u.length; f++) {
          var g = u[f];
          if (g !== "children" && g !== "key") {
            Le(r), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Le(null);
            break;
          }
        }
        r.ref !== null && (Le(r), h("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var xn = {};
    function jn(r, u, f, g, R, A) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Bn();
          E ? w += E : w += Nn();
          var L;
          r === null ? L = "null" : k(r) ? L = "array" : r !== void 0 && r.$$typeof === n ? (L = "<" + (V(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, w);
        }
        var z = vn(r, u, f, R, A);
        if (z == null)
          return z;
        if (I) {
          var se = u.children;
          if (se !== void 0)
            if (g)
              if (k(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  _n(se[Ee], r);
                Object.freeze && Object.freeze(se);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(se, r);
        }
        if (be.call(u, "key")) {
          var Ce = V(r), ie = Object.keys(u).filter(function(Sn) {
            return Sn !== "key";
          }), Xe = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[Ce + Xe]) {
            var $n = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Ce, $n, Ce), xn[Ce + Xe] = !0;
          }
        }
        return r === i ? zn(z) : Ln(z), z;
      }
    }
    function En(r, u, f) {
      return jn(r, u, f, !0);
    }
    function Pn(r, u, f) {
      return jn(r, u, f, !1);
    }
    var Mn = Pn, Un = En;
    yl.Fragment = i, yl.jsx = Mn, yl.jsxs = Un;
  }()), yl;
}
var wN;
function oee() {
  return wN || (wN = 1, process.env.NODE_ENV === "production" ? Fp.exports = iee() : Fp.exports = aee()), Fp.exports;
}
var de = oee();
const see = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "account_status" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "accepts_sms_marketing" } }, { kind: "Field", name: { kind: "Name", value: "accepts_email_marketing" } }, { kind: "Field", name: { kind: "Name", value: "channels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "suppressions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "province_code" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }] } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "response_messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "keyword" } }, { kind: "Field", name: { kind: "Name", value: "flowId" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }, { kind: "Field", name: { kind: "Name", value: "converted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_promotional_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_delivered" } }, { kind: "Field", name: { kind: "Name", value: "last_opened" } }, { kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_spam" } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, lee = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              account_status\n              default_language\n              dafault_currency\n              accepts_sms_marketing\n              accepts_email_marketing\n              channels {\n                sms {\n                  marketing {\n                    consent\n                    timestamp\n                  }\n                }\n                email {\n                  marketing {\n                    consent\n                    timestamp\n                    suppressions {\n                      timestamp\n                      timestamp\n                    }\n                  }\n                }\n              }\n              tags\n              address {\n                address1\n                address2\n                city\n                company\n                state\n                zip\n                province_code\n                country_code\n                phone_number\n              }\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_sms {\n                last_engaged\n                last_converted\n                last_sent\n                response_messages {\n                  id\n                  keyword\n                  flowId\n                  timestamp\n                }\n                campaigns {\n                  converted\n                  id\n                  clicked\n                }\n                flows {\n                  id\n                  opened\n                  clicked\n                  converted\n                }\n              }\n              yotpo_email {\n                last_sent\n                last_promotional_sent\n                last_delivered\n                last_opened\n                last_engaged\n                last_converted\n                last_spam\n                campaigns {\n                  opened\n                  id\n                  clicked\n                }\n                flows {\n                  converted\n                  id\n                }\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": see
};
function uee(e) {
  return lee[e] ?? {};
}
const cee = uee(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              account_status
              default_language
              dafault_currency
              accepts_sms_marketing
              accepts_email_marketing
              channels {
                sms {
                  marketing {
                    consent
                    timestamp
                  }
                }
                email {
                  marketing {
                    consent
                    timestamp
                    suppressions {
                      timestamp
                      timestamp
                    }
                  }
                }
              }
              tags
              address {
                address1
                address2
                city
                company
                state
                zip
                province_code
                country_code
                phone_number
              }
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_sms {
                last_engaged
                last_converted
                last_sent
                response_messages {
                  id
                  keyword
                  flowId
                  timestamp
                }
                campaigns {
                  converted
                  id
                  clicked
                }
                flows {
                  id
                  opened
                  clicked
                  converted
                }
              }
              yotpo_email {
                last_sent
                last_promotional_sent
                last_delivered
                last_opened
                last_engaged
                last_converted
                last_spam
                campaigns {
                  opened
                  id
                  clicked
                }
                flows {
                  converted
                  id
                }
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), dee = "_copyIcon_nr4rl_48", mee = "_list_nr4rl_53", fee = "_listItem_nr4rl_63", Ur = {
  copyIcon: dee,
  list: mee,
  listItem: fee
}, Cn = ({
  description: e,
  content: n,
  tooltip: t
}) => {
  if (n == null)
    return null;
  const i = iI(n);
  return /* @__PURE__ */ de.jsx(Je.Text, { variant: "dense", className: Ur.listItem, children: /* @__PURE__ */ de.jsx(nn, { content: t, children: /* @__PURE__ */ de.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", children: e }),
    i ? n : HN(n)
  ] }) }) });
}, jN = ({
  channel: e
}) => {
  var n, t, i, a;
  const o = (c) => Vv(c.replace("_", " "));
  if (!(e != null && e.marketing))
    return null;
  const { marketing: s } = e, l = "suppressions" in s && !!s.suppressions;
  return /* @__PURE__ */ de.jsxs(de.Fragment, { children: [
    /* @__PURE__ */ de.jsx(Je.Text, { variant: "dense", className: Ur.listItem, children: /* @__PURE__ */ de.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", children: "Consent" }),
      /* @__PURE__ */ de.jsxs(_, { gap: "100", alignItems: "center", children: [
        (s == null ? void 0 : s.timestamp) && /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "5", color: "secondary", children: An(s == null ? void 0 : s.timestamp).format(vt) }),
        (s == null ? void 0 : s.consent) && /* @__PURE__ */ de.jsx(Jn, { variant: "primary", size: "small", children: o(s == null ? void 0 : s.consent) })
      ] })
    ] }) }),
    l && /* @__PURE__ */ de.jsx(Je.Text, { variant: "dense", className: Ur.listItem, children: /* @__PURE__ */ de.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", children: "Suppressions" }),
      /* @__PURE__ */ de.jsxs(_, { gap: "100", alignItems: "center", children: [
        ((n = s.suppressions) == null ? void 0 : n.timestamp) && /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "5", color: "secondary", children: An((t = s.suppressions) == null ? void 0 : t.timestamp).format(
          vt
        ) }),
        ((i = s.suppressions) == null ? void 0 : i.suppression_reason) && /* @__PURE__ */ de.jsx(Jn, { variant: "warning", size: "small", children: (a = s.suppressions) == null ? void 0 : a.suppression_reason })
      ] })
    ] }) })
  ] });
}, pee = "_channelHeadline_yeqqp_1", CN = {
  channelHeadline: pee
}, vee = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { channels: n } = e, { yotpo_email: t, yotpo_sms: i } = e;
  return /* @__PURE__ */ de.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ de.jsx(q.Heading, { variant: "heading-3", children: "Channels" }),
    /* @__PURE__ */ de.jsxs(_, { flexDirection: "column", children: [
      /* @__PURE__ */ de.jsxs(_, { gap: "100", className: CN.channelHeadline, children: [
        /* @__PURE__ */ de.jsx(ye, { name: "mail" }),
        /* @__PURE__ */ de.jsx(q.Heading, { variant: "heading-4", children: "EMAIL" })
      ] }),
      /* @__PURE__ */ de.jsxs(Je, { className: Ur.list, children: [
        /* @__PURE__ */ de.jsx(jN, { channel: n == null ? void 0 : n.email }),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the customer's last email was sent.",
            content: t == null ? void 0 : t.last_sent
          }
        ),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last promotional sent",
            tooltip: "The timestamp for when the customer's last promotional email was sent.",
            content: t == null ? void 0 : t.last_promotional_sent
          }
        ),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last delivered",
            tooltip: "The timestamp for when the customer's last email was delivered.",
            content: t == null ? void 0 : t.last_delivered
          }
        ),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last opened",
            tooltip: "The timestamp for when the customer's last email was opened.",
            content: t == null ? void 0 : t.last_opened
          }
        ),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via email.",
            content: t == null ? void 0 : t.last_engaged
          }
        ),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via email.",
            content: t == null ? void 0 : t.last_converted
          }
        ),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last spam",
            tooltip: "The timestamp for when the customer's last email was marked as spam.",
            content: t == null ? void 0 : t.last_spam
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ de.jsxs(_, { flexDirection: "column", children: [
      /* @__PURE__ */ de.jsxs(_, { gap: "100", className: CN.channelHeadline, children: [
        /* @__PURE__ */ de.jsx(ye, { name: "sms" }),
        /* @__PURE__ */ de.jsx(q.Heading, { variant: "heading-4", children: "SMS" })
      ] }),
      /* @__PURE__ */ de.jsxs(Je, { className: Ur.list, children: [
        /* @__PURE__ */ de.jsx(jN, { channel: n == null ? void 0 : n.sms }),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via SMS.",
            content: i == null ? void 0 : i.last_engaged
          }
        ),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the last SMS was sent to the customer.",
            content: i == null ? void 0 : i.last_sent
          }
        ),
        /* @__PURE__ */ de.jsx(
          Cn,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via SMS.",
            content: i == null ? void 0 : i.last_converted
          }
        )
      ] })
    ] })
  ] });
}, hee = "_wrapper_1xucg_1", yee = "_externalLink_1xucg_7", Ip = {
  wrapper: hee,
  externalLink: yee
}, gee = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: t } = ri(), { isCopied: i, copy: a } = ri(), { isCopied: o, copy: s } = ri();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: c,
    address: m,
    email: d,
    phone_number: p,
    account_created_at: v,
    account_status: y,
    accepts_sms_marketing: S,
    accepts_email_marketing: b
  } = e, j = 14, x = `${l || ""} ${c || ""}`.trim() || "A customer has no name", {
    address1: h,
    address2: P,
    city: N,
    company: $,
    state: O,
    zip: B,
    province_code: Z,
    country_code: Y
  } = m || {}, ee = [
    h,
    P,
    [B, N].filter(Boolean).join(", "),
    [Y, O, Z].filter(Boolean).join(", "),
    $
  ].filter(Boolean);
  return /* @__PURE__ */ de.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ de.jsxs(_, { className: Ip.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ de.jsx(
      _,
      {
        justifyContent: "space-between",
        className: Ip.block,
        alignItems: "center",
        children: /* @__PURE__ */ de.jsx(q.Heading, { variant: "heading-2", children: x })
      }
    ),
    v && /* @__PURE__ */ de.jsxs(_, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", children: An(v).format(vt) })
    ] }),
    d && /* @__PURE__ */ de.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(ye, { size: j, name: "mail" }),
        /* @__PURE__ */ de.jsx("span", { className: Ip.externalLink, children: d })
      ] }),
      /* @__PURE__ */ de.jsx(nn, { content: "Copy email", children: /* @__PURE__ */ de.jsx(_, { alignItems: "center", children: /* @__PURE__ */ de.jsx(
        ye,
        {
          size: j,
          name: n ? "done" : "copy",
          onClick: () => t(d),
          className: Ur.copyIcon
        }
      ) }) })
    ] }),
    p && /* @__PURE__ */ de.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(ye, { size: j, name: "phone" }),
        /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", children: p })
      ] }),
      /* @__PURE__ */ de.jsx(nn, { content: "Copy phone number", children: /* @__PURE__ */ de.jsx(_, { alignItems: "center", children: /* @__PURE__ */ de.jsx(
        ye,
        {
          size: j,
          name: i ? "done" : "copy",
          onClick: () => a(p),
          className: Ur.copyIcon
        }
      ) }) })
    ] }),
    (h || N || $ || O || B || Y) && /* @__PURE__ */ de.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(_, { gap: "200", children: [
        /* @__PURE__ */ de.jsx(ye, { size: j, name: "home" }),
        /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", color: "secondary", children: ee.map((J) => /* @__PURE__ */ de.jsx(Wn, { children: J }, J)) })
      ] }),
      /* @__PURE__ */ de.jsx(nn, { content: "Copy address", children: /* @__PURE__ */ de.jsx(_, { alignItems: "center", children: /* @__PURE__ */ de.jsx(
        ye,
        {
          size: j,
          name: o ? "done" : "copy",
          onClick: () => s(ee.join(", ")),
          className: Ur.copyIcon
        }
      ) }) })
    ] }),
    /* @__PURE__ */ de.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(ye, { size: j, name: "sms" }),
        /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", children: "Accepts sms marketing" })
      ] }),
      /* @__PURE__ */ de.jsx(
        ye,
        {
          name: S ? "check-circle-filled" : "close-circle-filled",
          color: S ? "green.500" : "red.500"
        }
      )
    ] }),
    /* @__PURE__ */ de.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(ye, { size: j, name: "paper-plane" }),
        /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", children: "Accepts email marketing" })
      ] }),
      /* @__PURE__ */ de.jsx(
        ye,
        {
          name: b ? "check-circle-filled" : "close-circle-filled",
          color: b ? "green.500" : "red.500"
        }
      )
    ] }),
    y && /* @__PURE__ */ de.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ de.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ de.jsx(ye, { size: j, name: "yotpo", color: "rgb(0, 66, 228)" }),
        /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", children: "Account status" })
      ] }),
      /* @__PURE__ */ de.jsx(Dn, { children: Vv(y) })
    ] })
  ] }) });
}, kee = ({
  loyalty: e
}) => /* @__PURE__ */ de.jsxs(_, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ de.jsx(q.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ de.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ de.jsxs(Je, { className: Ur.list, children: [
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ de.jsx(
      Cn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), bee = ({ tags: e }) => {
  const n = e == null ? void 0 : e.split(","), t = n && n.length > 0;
  return /* @__PURE__ */ de.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ de.jsx(q.Heading, { variant: "heading-3", children: "Tags" }),
    !t && /* @__PURE__ */ de.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "No tags available" }) }),
    t && /* @__PURE__ */ de.jsx(_, { gap: "200", flexWrap: "wrap", children: n.map((i, a) => /* @__PURE__ */ de.jsx(Dn, { children: i }, a)) })
  ] });
}, _ee = ({
  userGeneratedContent: e
}) => {
  var n;
  return /* @__PURE__ */ de.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ de.jsx(q.Heading, { variant: "heading-3", children: "User generated content" }),
    !e && /* @__PURE__ */ de.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
    e && /* @__PURE__ */ de.jsxs(Je, { className: Ur.list, children: [
      /* @__PURE__ */ de.jsx(
        Cn,
        {
          description: "Total reviews",
          tooltip: "The total number of reviews submitted by the customer.",
          content: e.total_reviews
        }
      ),
      /* @__PURE__ */ de.jsx(
        Cn,
        {
          description: "Average product rating",
          tooltip: "The average product rating given by the customer.",
          content: e.avg_product_rating
        }
      ),
      /* @__PURE__ */ de.jsx(
        Cn,
        {
          description: "Average site rating",
          tooltip: "The average rating of the site/store given by the customer.",
          content: e.avg_site_rating
        }
      ),
      /* @__PURE__ */ de.jsx(
        Cn,
        {
          description: "Total average rating",
          tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
          content: e.total_avg_rating
        }
      ),
      /* @__PURE__ */ de.jsx(
        Cn,
        {
          description: "Total average sentiment score",
          tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
          content: e.sentiment_avg_site
        }
      ),
      /* @__PURE__ */ de.jsx(
        Cn,
        {
          description: "Last star rating",
          tooltip: "The star rating of the customer's last review.",
          content: e.last_star_rating
        }
      ),
      /* @__PURE__ */ de.jsx(
        Cn,
        {
          description: "Last review date",
          tooltip: "The timestamp for when the customer last submitted a review.",
          content: An(e.last_review_date).format(
            vt
          )
        }
      ),
      /* @__PURE__ */ de.jsx(
        Cn,
        {
          description: "Last sentiment",
          tooltip: "The sentiment score of the customer's last review.",
          content: e.last_sentiment
        }
      ),
      /* @__PURE__ */ de.jsx(
        Cn,
        {
          description: "Topics",
          tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
          content: /* @__PURE__ */ de.jsx(
            _,
            {
              gap: "100",
              width: "80%",
              flexWrap: "wrap",
              justifyContent: "flex-end",
              children: (n = e.top_topics) == null ? void 0 : n.map((t, i) => /* @__PURE__ */ de.jsx(Jn, { variant: "info", size: "small", children: /* @__PURE__ */ de.jsx(de.Fragment, { children: t }) }, i))
            }
          )
        }
      )
    ] })
  ] });
}, xee = ({
  conversationContext: e,
  settings: n
}) => {
  var t, i;
  const { useQuery: a } = pn(), { track: o } = bn(), [s, l] = me(), [c, m] = me(!1), d = (t = e == null ? void 0 : e.customer) == null ? void 0 : t.email, p = (i = e == null ? void 0 : e.customer) == null ? void 0 : i.phone_number, v = !d && !p, y = n == null ? void 0 : n.yotpoStoreId, S = (n == null ? void 0 : n.showCustomerDetails) ?? !1, b = (n == null ? void 0 : n.showTags) ?? !1, j = (n == null ? void 0 : n.showChannels) ?? !1, x = (n == null ? void 0 : n.showUserGeneratedContent) ?? !1, h = (n == null ? void 0 : n.displayLoyalty) ?? !1, P = (n == null ? void 0 : n.displayEmailData) ?? !1, N = (n == null ? void 0 : n.displaySmsData) ?? !1, $ = (n == null ? void 0 : n.displaySubscriptions) ?? !1, O = !S && !b && !j && !x && !h && !P && !N && !$, {
    loading: B,
    error: Z,
    data: Y
  } = a(cee, {
    skip: !d || !y,
    variables: {
      ...d && { email: d },
      ...!d && p && { phone_number: p },
      storeId: y
    }
  });
  return Ge(() => {
    var ee, J;
    const K = (ee = Y == null ? void 0 : Y.Yotpo) == null ? void 0 : ee.getCustomers;
    K != null && K.customers && (((J = K == null ? void 0 : K.customers) == null ? void 0 : J.length) > 0 ? (l(K == null ? void 0 : K.customers[0]), m(!1), o("yotpo:customer:received")) : m(!0));
  }, [Y == null ? void 0 : Y.Yotpo, B]), v ? /* @__PURE__ */ de.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : c ? /* @__PURE__ */ de.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) }) : O ? /* @__PURE__ */ de.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-features",
      children: /* @__PURE__ */ de.jsx(q.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
    }
  ) : Z ? Pv({ errors: Z.graphQLErrors }) ? /* @__PURE__ */ de.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      variant: "4",
      "data-testid": "widget-downstream-api-forbidden-error",
      children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
    }
  ) : Av({ errors: Z.graphQLErrors }) ? /* @__PURE__ */ de.jsx(
    q.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      variant: "4",
      "data-testid": "widget-downstream-api-authorization-error",
      children: "The integration could not authorize against Yotpo. Please contact your administrator."
    }
  ) : /* @__PURE__ */ de.jsx(Fn, { error: Z }) : B ? /* @__PURE__ */ de.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ de.jsx(fn, {}) }) : /* @__PURE__ */ de.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        S && /* @__PURE__ */ de.jsx(gee, { customerDetails: s }),
        b && /* @__PURE__ */ de.jsx(bee, { tags: s == null ? void 0 : s.tags }),
        j && /* @__PURE__ */ de.jsx(vee, { customerDetails: s }),
        x && /* @__PURE__ */ de.jsx(
          _ee,
          {
            userGeneratedContent: s == null ? void 0 : s.yotpo_ugc
          }
        ),
        h && /* @__PURE__ */ de.jsx(kee, { loyalty: s == null ? void 0 : s.yotpo_loyalty })
      ]
    }
  );
};
var js = (e) => e.type === "checkbox", Pi = (e) => e instanceof Date, Dt = (e) => e == null;
const $F = (e) => typeof e == "object";
var it = (e) => !Dt(e) && !Array.isArray(e) && $F(e) && !Pi(e), EF = (e) => it(e) && e.target ? js(e.target) ? e.target.checked : e.target.value : e, See = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, TF = (e, n) => e.has(See(n)), Nee = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return it(n) && n.hasOwnProperty("isPrototypeOf");
}, jy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function St(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(jy && (e instanceof Blob || i)) && (t || it(e)))
    if (n = t ? [] : {}, !t && !Nee(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = St(e[a]));
  else
    return e;
  return n;
}
var tc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], nt = (e) => e === void 0, We = (e, n, t) => {
  if (!n || !it(e))
    return t;
  const i = tc(n.split(/[,[\].]+?/)).reduce((a, o) => Dt(a) ? a : a[o], e);
  return nt(i) || i === e ? nt(e[n]) ? t : e[n] : i;
}, Zt = (e) => typeof e == "boolean", Cy = (e) => /^\w*$/.test(e), OF = (e) => tc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Kn = (e, n, t) => {
  let i = -1;
  const a = Cy(n) ? [n] : OF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let c = t;
    if (i !== s) {
      const m = e[l];
      c = it(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = c, e = e[l];
  }
};
const du = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Sr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Zr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, wee = we.createContext(null), Fy = () => we.useContext(wee);
var RF = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Sr.all && (n._proxyFormState[s] = !i || Sr.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function jee(e) {
  const n = Fy(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = we.useState(t._formState), c = we.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = we.useRef(a);
  return m.current = a, we.useEffect(() => t._subscribe({
    name: m.current,
    formState: c.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...t._formState,
        ...d
      });
    }
  }), [t, i, o]), we.useEffect(() => {
    c.current.isValid && t._setValid(!0);
  }, [t]), we.useMemo(() => RF(s, t, c.current, !1), [s, t]);
}
var Mr = (e) => typeof e == "string", DF = (e, n, t, i, a) => Mr(e) ? (i && n.watch.add(e), We(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), We(t, o))) : (i && (n.watchAll = !0), t);
function PF(e) {
  const n = Fy(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = we.useRef(i), c = we.useRef(a);
  l.current = i, we.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (p) => !o && d(DF(l.current, t._names, p.values || t._formValues, !1, c.current))
  }), [t, o, s]);
  const [m, d] = we.useState(t._getWatch(i, a));
  return we.useEffect(() => t._removeUnmounted()), m;
}
function Cee(e) {
  const n = Fy(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = TF(a._names.array, t), l = PF({
    control: a,
    name: t,
    defaultValue: We(a._formValues, t, We(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), c = jee({
    control: a,
    name: t,
    exact: !0
  }), m = we.useRef(e), d = we.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...Zt(e.disabled) ? { disabled: e.disabled } : {}
  })), p = we.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!We(c.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!We(c.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!We(c.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!We(c.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => We(c.errors, t)
    }
  }), [c, t]), v = we.useCallback((j) => d.current.onChange({
    target: {
      value: EF(j),
      name: t
    },
    type: du.CHANGE
  }), [t]), y = we.useCallback(() => d.current.onBlur({
    target: {
      value: We(a._formValues, t),
      name: t
    },
    type: du.BLUR
  }), [t, a._formValues]), S = we.useCallback((j) => {
    const x = We(a._fields, t);
    x && j && (x._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (h) => j.setCustomValidity(h),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, t]), b = we.useMemo(() => ({
    name: t,
    value: l,
    ...Zt(i) || c.disabled ? { disabled: c.disabled || i } : {},
    onChange: v,
    onBlur: y,
    ref: S
  }), [t, i, c.disabled, v, y, S, l]);
  return we.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...Zt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const x = (h, P) => {
      const N = We(a._fields, h);
      N && N._f && (N._f.mount = P);
    };
    if (x(t, !0), j) {
      const h = St(We(a._options.defaultValues, t));
      Kn(a._defaultValues, t, h), nt(We(a._formValues, t)) && Kn(a._formValues, t, h);
    }
    return !s && a.register(t), () => {
      (s ? j && !a._state.action : j) ? a.unregister(t) : x(t, !1);
    };
  }, [t, a, s, o]), we.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), we.useMemo(() => ({
    field: b,
    formState: c,
    fieldState: p
  }), [b, c, p]);
}
const FN = (e) => e.render(Cee(e));
var Fee = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, Bo = (e) => Array.isArray(e) ? e : [e], IN = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const t of e)
        t.next && t.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((t) => t !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Dv = (e) => Dt(e) || !$F(e);
function vi(e, n) {
  if (Dv(e) || Dv(n))
    return e === n;
  if (Pi(e) && Pi(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Pi(o) && Pi(s) || it(o) && it(s) || Array.isArray(o) && Array.isArray(s) ? !vi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Tt = (e) => it(e) && !Object.keys(e).length, Iy = (e) => e.type === "file", Nr = (e) => typeof e == "function", mu = (e) => {
  if (!jy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, AF = (e) => e.type === "select-multiple", $y = (e) => e.type === "radio", Iee = (e) => $y(e) || js(e), $p = (e) => mu(e) && e.isConnected;
function $ee(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = nt(e) ? i++ : e[n[i++]];
  return e;
}
function Eee(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !nt(e[n]))
      return !1;
  return !0;
}
function pt(e, n) {
  const t = Array.isArray(n) ? n : Cy(n) ? [n] : OF(n), i = t.length === 1 ? e : $ee(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (it(i) && Tt(i) || Array.isArray(i) && Eee(i)) && pt(e, t.slice(0, -1)), e;
}
var LF = (e) => {
  for (const n in e)
    if (Nr(e[n]))
      return !0;
  return !1;
};
function fu(e, n = {}) {
  const t = Array.isArray(e);
  if (it(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || it(e[i]) && !LF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, fu(e[i], n[i])) : Dt(e[i]) || (n[i] = !0);
  return n;
}
function VF(e, n, t) {
  const i = Array.isArray(e);
  if (it(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || it(e[a]) && !LF(e[a]) ? nt(n) || Dv(t[a]) ? t[a] = Array.isArray(e[a]) ? fu(e[a], []) : { ...fu(e[a]) } : VF(e[a], Dt(n) ? {} : n[a], t[a]) : t[a] = !vi(e[a], n[a]);
  return t;
}
var $o = (e, n) => VF(e, n, fu(n));
const $N = {
  value: !1,
  isValid: !1
}, EN = { value: !0, isValid: !0 };
var zF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !nt(e[0].attributes.value) ? nt(e[0].value) || e[0].value === "" ? EN : { value: e[0].value, isValid: !0 } : EN
    ) : $N;
  }
  return $N;
}, MF = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => nt(e) ? e : n ? e === "" ? NaN : e && +e : t && Mr(e) ? new Date(e) : i ? i(e) : e;
const TN = {
  isValid: !1,
  value: null
};
var UF = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, TN) : TN;
function ON(e) {
  const n = e.ref;
  return Iy(n) ? n.files : $y(n) ? UF(e.refs).value : AF(n) ? [...n.selectedOptions].map(({ value: t }) => t) : js(n) ? zF(e.refs).value : MF(nt(n.value) ? e.ref.value : n.value, e);
}
var Tee = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = We(n, o);
    s && Kn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, pu = (e) => e instanceof RegExp, Eo = (e) => nt(e) ? e : pu(e) ? e.source : it(e) ? pu(e.value) ? e.value.source : e.value : e, RN = (e) => ({
  isOnSubmit: !e || e === Sr.onSubmit,
  isOnBlur: e === Sr.onBlur,
  isOnChange: e === Sr.onChange,
  isOnAll: e === Sr.all,
  isOnTouch: e === Sr.onTouched
});
const DN = "AsyncFunction";
var Oee = (e) => !!e && !!e.validate && !!(Nr(e.validate) && e.validate.constructor.name === DN || it(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === DN)), Ree = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), PN = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const qo = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = We(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (qo(l, n))
          break;
      } else if (it(l) && qo(l, n))
        break;
    }
  }
};
function AN(e, n, t) {
  const i = We(e, t);
  if (i || Cy(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = We(n, o), l = We(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var Dee = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return Tt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Sr.all));
}, Pee = (e, n, t) => !e || !n || e === n || Bo(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), Aee = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, Lee = (e, n) => !tc(We(e, n)).length && pt(e, n), Vee = (e, n, t) => {
  const i = Bo(We(e, t));
  return Kn(i, "root", n[t]), Kn(e, t, i), e;
}, Al = (e) => Mr(e);
function LN(e, n, t = "validate") {
  if (Al(e) || Array.isArray(e) && e.every(Al) || Zt(e) && !e)
    return {
      type: t,
      message: Al(e) ? e : "",
      ref: n
    };
}
var la = (e) => it(e) && !pu(e) ? e : {
  value: e,
  message: ""
}, VN = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: c, maxLength: m, minLength: d, min: p, max: v, pattern: y, validate: S, name: b, valueAsNumber: j, mount: x } = e._f, h = We(t, b);
  if (!x || n.has(b))
    return {};
  const P = l ? l[0] : s, N = (K) => {
    a && P.reportValidity && (P.setCustomValidity(Zt(K) ? "" : K || ""), P.reportValidity());
  }, $ = {}, O = $y(s), B = js(s), Z = O || B, Y = (j || Iy(s)) && nt(s.value) && nt(h) || mu(s) && s.value === "" || h === "" || Array.isArray(h) && !h.length, ee = Fee.bind(null, b, i, $), J = (K, V, Q, ne = Zr.maxLength, ce = Zr.minLength) => {
    const ae = K ? V : Q;
    $[b] = {
      type: K ? ne : ce,
      message: ae,
      ref: s,
      ...ee(K ? ne : ce, ae)
    };
  };
  if (o ? !Array.isArray(h) || !h.length : c && (!Z && (Y || Dt(h)) || Zt(h) && !h || B && !zF(l).isValid || O && !UF(l).isValid)) {
    const { value: K, message: V } = Al(c) ? { value: !!c, message: c } : la(c);
    if (K && ($[b] = {
      type: Zr.required,
      message: V,
      ref: P,
      ...ee(Zr.required, V)
    }, !i))
      return N(V), $;
  }
  if (!Y && (!Dt(p) || !Dt(v))) {
    let K, V;
    const Q = la(v), ne = la(p);
    if (!Dt(h) && !isNaN(h)) {
      const ce = s.valueAsNumber || h && +h;
      Dt(Q.value) || (K = ce > Q.value), Dt(ne.value) || (V = ce < ne.value);
    } else {
      const ce = s.valueAsDate || new Date(h), ae = (G) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + G), ve = s.type == "time", je = s.type == "week";
      Mr(Q.value) && h && (K = ve ? ae(h) > ae(Q.value) : je ? h > Q.value : ce > new Date(Q.value)), Mr(ne.value) && h && (V = ve ? ae(h) < ae(ne.value) : je ? h < ne.value : ce < new Date(ne.value));
    }
    if ((K || V) && (J(!!K, Q.message, ne.message, Zr.max, Zr.min), !i))
      return N($[b].message), $;
  }
  if ((m || d) && !Y && (Mr(h) || o && Array.isArray(h))) {
    const K = la(m), V = la(d), Q = !Dt(K.value) && h.length > +K.value, ne = !Dt(V.value) && h.length < +V.value;
    if ((Q || ne) && (J(Q, K.message, V.message), !i))
      return N($[b].message), $;
  }
  if (y && !Y && Mr(h)) {
    const { value: K, message: V } = la(y);
    if (pu(K) && !h.match(K) && ($[b] = {
      type: Zr.pattern,
      message: V,
      ref: s,
      ...ee(Zr.pattern, V)
    }, !i))
      return N(V), $;
  }
  if (S) {
    if (Nr(S)) {
      const K = await S(h, t), V = LN(K, P);
      if (V && ($[b] = {
        ...V,
        ...ee(Zr.validate, V.message)
      }, !i))
        return N(V.message), $;
    } else if (it(S)) {
      let K = {};
      for (const V in S) {
        if (!Tt(K) && !i)
          break;
        const Q = LN(await S[V](h, t), P, V);
        Q && (K = {
          ...Q,
          ...ee(V, Q.message)
        }, N(Q.message), i && ($[b] = K));
      }
      if (!Tt(K) && ($[b] = {
        ref: P,
        ...K
      }, !i))
        return $;
    }
  }
  return N(!0), $;
};
const zee = {
  mode: Sr.onSubmit,
  reValidateMode: Sr.onChange,
  shouldFocusError: !0
};
function Mee(e = {}) {
  let n = {
    ...zee,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Nr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = it(n.defaultValues) || it(n.values) ? St(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : St(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let p = {
    ...d
  };
  const v = {
    array: IN(),
    state: IN()
  }, y = RN(n.mode), S = RN(n.reValidateMode), b = n.criteriaMode === Sr.all, j = (C) => (k) => {
    clearTimeout(m), m = setTimeout(C, k);
  }, x = async (C) => {
    if (!n.disabled && (d.isValid || p.isValid || C)) {
      const k = n.resolver ? Tt((await Y()).errors) : await J(i, !0);
      k !== t.isValid && v.state.next({
        isValid: k
      });
    }
  }, h = (C, k) => {
    !n.disabled && (d.isValidating || d.validatingFields || p.isValidating || p.validatingFields) && ((C || Array.from(l.mount)).forEach((F) => {
      F && (k ? Kn(t.validatingFields, F, k) : pt(t.validatingFields, F));
    }), v.state.next({
      validatingFields: t.validatingFields,
      isValidating: !Tt(t.validatingFields)
    }));
  }, P = (C, k = [], F, W, X = !0, T = !0) => {
    if (W && F && !n.disabled) {
      if (s.action = !0, T && Array.isArray(We(i, C))) {
        const U = F(We(i, C), W.argA, W.argB);
        X && Kn(i, C, U);
      }
      if (T && Array.isArray(We(t.errors, C))) {
        const U = F(We(t.errors, C), W.argA, W.argB);
        X && Kn(t.errors, C, U), Lee(t.errors, C);
      }
      if ((d.touchedFields || p.touchedFields) && T && Array.isArray(We(t.touchedFields, C))) {
        const U = F(We(t.touchedFields, C), W.argA, W.argB);
        X && Kn(t.touchedFields, C, U);
      }
      (d.dirtyFields || p.dirtyFields) && (t.dirtyFields = $o(a, o)), v.state.next({
        name: C,
        isDirty: V(C, k),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Kn(o, C, k);
  }, N = (C, k) => {
    Kn(t.errors, C, k), v.state.next({
      errors: t.errors
    });
  }, $ = (C) => {
    t.errors = C, v.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, O = (C, k, F, W) => {
    const X = We(i, C);
    if (X) {
      const T = We(o, C, nt(F) ? We(a, C) : F);
      nt(T) || W && W.defaultChecked || k ? Kn(o, C, k ? T : ON(X._f)) : ce(C, T), s.mount && x();
    }
  }, B = (C, k, F, W, X) => {
    let T = !1, U = !1;
    const te = {
      name: C
    };
    if (!n.disabled) {
      if (!F || W) {
        (d.isDirty || p.isDirty) && (U = t.isDirty, t.isDirty = te.isDirty = V(), T = U !== te.isDirty);
        const pe = vi(We(a, C), k);
        U = !!We(t.dirtyFields, C), pe ? pt(t.dirtyFields, C) : Kn(t.dirtyFields, C, !0), te.dirtyFields = t.dirtyFields, T = T || (d.dirtyFields || p.dirtyFields) && U !== !pe;
      }
      if (F) {
        const pe = We(t.touchedFields, C);
        pe || (Kn(t.touchedFields, C, F), te.touchedFields = t.touchedFields, T = T || (d.touchedFields || p.touchedFields) && pe !== F);
      }
      T && X && v.state.next(te);
    }
    return T ? te : {};
  }, Z = (C, k, F, W) => {
    const X = We(t.errors, C), T = (d.isValid || p.isValid) && Zt(k) && t.isValid !== k;
    if (n.delayError && F ? (c = j(() => N(C, F)), c(n.delayError)) : (clearTimeout(m), c = null, F ? Kn(t.errors, C, F) : pt(t.errors, C)), (F ? !vi(X, F) : X) || !Tt(W) || T) {
      const U = {
        ...W,
        ...T && Zt(k) ? { isValid: k } : {},
        errors: t.errors,
        name: C
      };
      t = {
        ...t,
        ...U
      }, v.state.next(U);
    }
  }, Y = async (C) => {
    h(C, !0);
    const k = await n.resolver(o, n.context, Tee(C || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return h(C), k;
  }, ee = async (C) => {
    const { errors: k } = await Y(C);
    if (C)
      for (const F of C) {
        const W = We(k, F);
        W ? Kn(t.errors, F, W) : pt(t.errors, F);
      }
    else
      t.errors = k;
    return k;
  }, J = async (C, k, F = {
    valid: !0
  }) => {
    for (const W in C) {
      const X = C[W];
      if (X) {
        const { _f: T, ...U } = X;
        if (T) {
          const te = l.array.has(T.name), pe = X._f && Oee(X._f);
          pe && d.validatingFields && h([W], !0);
          const Se = await VN(X, l.disabled, o, b, n.shouldUseNativeValidation && !k, te);
          if (pe && d.validatingFields && h([W]), Se[T.name] && (F.valid = !1, k))
            break;
          !k && (We(Se, T.name) ? te ? Vee(t.errors, Se, T.name) : Kn(t.errors, T.name, Se[T.name]) : pt(t.errors, T.name));
        }
        !Tt(U) && await J(U, k, F);
      }
    }
    return F.valid;
  }, K = () => {
    for (const C of l.unMount) {
      const k = We(i, C);
      k && (k._f.refs ? k._f.refs.every((F) => !$p(F)) : !$p(k._f.ref)) && Oe(C);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, V = (C, k) => !n.disabled && (C && k && Kn(o, C, k), !vi(he(), a)), Q = (C, k, F) => DF(C, l, {
    ...s.mount ? o : nt(k) ? a : Mr(C) ? { [C]: k } : k
  }, F, k), ne = (C) => tc(We(s.mount ? o : a, C, n.shouldUnregister ? We(a, C, []) : [])), ce = (C, k, F = {}) => {
    const W = We(i, C);
    let X = k;
    if (W) {
      const T = W._f;
      T && (!T.disabled && Kn(o, C, MF(k, T)), X = mu(T.ref) && Dt(k) ? "" : k, AF(T.ref) ? [...T.ref.options].forEach((U) => U.selected = X.includes(U.value)) : T.refs ? js(T.ref) ? T.refs.length > 1 ? T.refs.forEach((U) => (!U.defaultChecked || !U.disabled) && (U.checked = Array.isArray(X) ? !!X.find((te) => te === U.value) : X === U.value)) : T.refs[0] && (T.refs[0].checked = !!X) : T.refs.forEach((U) => U.checked = U.value === X) : Iy(T.ref) ? T.ref.value = "" : (T.ref.value = X, T.ref.type || v.state.next({
        name: C,
        values: St(o)
      })));
    }
    (F.shouldDirty || F.shouldTouch) && B(C, X, F.shouldTouch, F.shouldDirty, !0), F.shouldValidate && le(C);
  }, ae = (C, k, F) => {
    for (const W in k) {
      const X = k[W], T = `${C}.${W}`, U = We(i, T);
      (l.array.has(C) || it(X) || U && !U._f) && !Pi(X) ? ae(T, X, F) : ce(T, X, F);
    }
  }, ve = (C, k, F = {}) => {
    const W = We(i, C), X = l.array.has(C), T = St(k);
    Kn(o, C, T), X ? (v.array.next({
      name: C,
      values: St(o)
    }), (d.isDirty || d.dirtyFields || p.isDirty || p.dirtyFields) && F.shouldDirty && v.state.next({
      name: C,
      dirtyFields: $o(a, o),
      isDirty: V(C, T)
    })) : W && !W._f && !Dt(T) ? ae(C, T, F) : ce(C, T, F), PN(C, l) && v.state.next({ ...t }), v.state.next({
      name: s.mount ? C : void 0,
      values: St(o)
    });
  }, je = async (C) => {
    s.mount = !0;
    const k = C.target;
    let F = k.name, W = !0;
    const X = We(i, F), T = (U) => {
      W = Number.isNaN(U) || Pi(U) && isNaN(U.getTime()) || vi(U, We(o, F, U));
    };
    if (X) {
      let U, te;
      const pe = k.type ? ON(X._f) : EF(C), Se = C.type === du.BLUR || C.type === du.FOCUS_OUT, Ze = !Ree(X._f) && !n.resolver && !We(t.errors, F) && !X._f.deps || Aee(Se, We(t.touchedFields, F), t.isSubmitted, S, y), un = PN(F, l, Se);
      Kn(o, F, pe), Se ? (X._f.onBlur && X._f.onBlur(C), c && c(0)) : X._f.onChange && X._f.onChange(C);
      const en = B(F, pe, Se), tn = !Tt(en) || un;
      if (!Se && v.state.next({
        name: F,
        type: C.type,
        values: St(o)
      }), Ze)
        return (d.isValid || p.isValid) && (n.mode === "onBlur" ? Se && x() : Se || x()), tn && v.state.next({ name: F, ...un ? {} : en });
      if (!Se && un && v.state.next({ ...t }), n.resolver) {
        const { errors: mn } = await Y([F]);
        if (T(pe), W) {
          const cn = AN(t.errors, i, F), vn = AN(mn, i, cn.name || F);
          U = vn.error, F = vn.name, te = Tt(mn);
        }
      } else
        h([F], !0), U = (await VN(X, l.disabled, o, b, n.shouldUseNativeValidation))[F], h([F]), T(pe), W && (U ? te = !1 : (d.isValid || p.isValid) && (te = await J(i, !0)));
      W && (X._f.deps && le(X._f.deps), Z(F, te, U, en));
    }
  }, G = (C, k) => {
    if (We(t.errors, k) && C.focus)
      return C.focus(), 1;
  }, le = async (C, k = {}) => {
    let F, W;
    const X = Bo(C);
    if (n.resolver) {
      const T = await ee(nt(C) ? C : X);
      F = Tt(T), W = C ? !X.some((U) => We(T, U)) : F;
    } else C ? (W = (await Promise.all(X.map(async (T) => {
      const U = We(i, T);
      return await J(U && U._f ? { [T]: U } : U);
    }))).every(Boolean), !(!W && !t.isValid) && x()) : W = F = await J(i);
    return v.state.next({
      ...!Mr(C) || (d.isValid || p.isValid) && F !== t.isValid ? {} : { name: C },
      ...n.resolver || !C ? { isValid: F } : {},
      errors: t.errors
    }), k.shouldFocus && !W && qo(i, G, C ? X : l.mount), W;
  }, he = (C) => {
    const k = {
      ...s.mount ? o : a
    };
    return nt(C) ? k : Mr(C) ? We(k, C) : C.map((F) => We(k, F));
  }, M = (C, k) => ({
    invalid: !!We((k || t).errors, C),
    isDirty: !!We((k || t).dirtyFields, C),
    error: We((k || t).errors, C),
    isValidating: !!We(t.validatingFields, C),
    isTouched: !!We((k || t).touchedFields, C)
  }), Ae = (C) => {
    C && Bo(C).forEach((k) => pt(t.errors, k)), v.state.next({
      errors: C ? t.errors : {}
    });
  }, Ve = (C, k, F) => {
    const W = (We(i, C, { _f: {} })._f || {}).ref, X = We(t.errors, C) || {}, { ref: T, message: U, type: te, ...pe } = X;
    Kn(t.errors, C, {
      ...pe,
      ...k,
      ref: W
    }), v.state.next({
      name: C,
      errors: t.errors,
      isValid: !1
    }), F && F.shouldFocus && W && W.focus && W.focus();
  }, Te = (C, k) => Nr(C) ? v.state.subscribe({
    next: (F) => C(Q(void 0, k), F)
  }) : Q(C, k, !0), ze = (C) => v.state.subscribe({
    next: (k) => {
      Pee(C.name, k.name, C.exact) && Dee(k, C.formState || d, Ie, C.reRenderRoot) && C.callback({
        values: { ...o },
        ...t,
        ...k
      });
    }
  }).unsubscribe, ge = (C) => (s.mount = !0, p = {
    ...p,
    ...C.formState
  }, ze({
    ...C,
    formState: p
  })), Oe = (C, k = {}) => {
    for (const F of C ? Bo(C) : l.mount)
      l.mount.delete(F), l.array.delete(F), k.keepValue || (pt(i, F), pt(o, F)), !k.keepError && pt(t.errors, F), !k.keepDirty && pt(t.dirtyFields, F), !k.keepTouched && pt(t.touchedFields, F), !k.keepIsValidating && pt(t.validatingFields, F), !n.shouldUnregister && !k.keepDefaultValue && pt(a, F);
    v.state.next({
      values: St(o)
    }), v.state.next({
      ...t,
      ...k.keepDirty ? { isDirty: V() } : {}
    }), !k.keepIsValid && x();
  }, $e = ({ disabled: C, name: k }) => {
    (Zt(C) && s.mount || C || l.disabled.has(k)) && (C ? l.disabled.add(k) : l.disabled.delete(k));
  }, Ye = (C, k = {}) => {
    let F = We(i, C);
    const W = Zt(k.disabled) || Zt(n.disabled);
    return Kn(i, C, {
      ...F || {},
      _f: {
        ...F && F._f ? F._f : { ref: { name: C } },
        name: C,
        mount: !0,
        ...k
      }
    }), l.mount.add(C), F ? $e({
      disabled: Zt(k.disabled) ? k.disabled : n.disabled,
      name: C
    }) : O(C, !0, k.value), {
      ...W ? { disabled: k.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!k.required,
        min: Eo(k.min),
        max: Eo(k.max),
        minLength: Eo(k.minLength),
        maxLength: Eo(k.maxLength),
        pattern: Eo(k.pattern)
      } : {},
      name: C,
      onChange: je,
      onBlur: je,
      ref: (X) => {
        if (X) {
          Ye(C, k), F = We(i, C);
          const T = nt(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, U = Iee(T), te = F._f.refs || [];
          if (U ? te.find((pe) => pe === T) : T === F._f.ref)
            return;
          Kn(i, C, {
            _f: {
              ...F._f,
              ...U ? {
                refs: [
                  ...te.filter($p),
                  T,
                  ...Array.isArray(We(a, C)) ? [{}] : []
                ],
                ref: { type: T.type, name: C }
              } : { ref: T }
            }
          }), O(C, !1, void 0, T);
        } else
          F = We(i, C, {}), F._f && (F._f.mount = !1), (n.shouldUnregister || k.shouldUnregister) && !(TF(l.array, C) && s.action) && l.unMount.add(C);
      }
    };
  }, xe = () => n.shouldFocusError && qo(i, G, l.mount), Ue = (C) => {
    Zt(C) && (v.state.next({ disabled: C }), qo(i, (k, F) => {
      const W = We(i, F);
      W && (k.disabled = W._f.disabled || C, Array.isArray(W._f.refs) && W._f.refs.forEach((X) => {
        X.disabled = W._f.disabled || C;
      }));
    }, 0, !1));
  }, Be = (C, k) => async (F) => {
    let W;
    F && (F.preventDefault && F.preventDefault(), F.persist && F.persist());
    let X = St(o);
    if (v.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: T, values: U } = await Y();
      t.errors = T, X = U;
    } else
      await J(i);
    if (l.disabled.size)
      for (const T of l.disabled)
        Kn(X, T, void 0);
    if (pt(t.errors, "root"), Tt(t.errors)) {
      v.state.next({
        errors: {}
      });
      try {
        await C(X, F);
      } catch (T) {
        W = T;
      }
    } else
      k && await k({ ...t.errors }, F), xe(), setTimeout(xe);
    if (v.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Tt(t.errors) && !W,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), W)
      throw W;
  }, re = (C, k = {}) => {
    We(i, C) && (nt(k.defaultValue) ? ve(C, St(We(a, C))) : (ve(C, k.defaultValue), Kn(a, C, St(k.defaultValue))), k.keepTouched || pt(t.touchedFields, C), k.keepDirty || (pt(t.dirtyFields, C), t.isDirty = k.defaultValue ? V(C, St(We(a, C))) : V()), k.keepError || (pt(t.errors, C), d.isValid && x()), v.state.next({ ...t }));
  }, be = (C, k = {}) => {
    const F = C ? St(C) : a, W = St(F), X = Tt(C), T = X ? a : W;
    if (k.keepDefaultValues || (a = F), !k.keepValues) {
      if (k.keepDirtyValues) {
        const U = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys($o(a, o))
        ]);
        for (const te of Array.from(U))
          We(t.dirtyFields, te) ? Kn(T, te, We(o, te)) : ve(te, We(T, te));
      } else {
        if (jy && nt(C))
          for (const U of l.mount) {
            const te = We(i, U);
            if (te && te._f) {
              const pe = Array.isArray(te._f.refs) ? te._f.refs[0] : te._f.ref;
              if (mu(pe)) {
                const Se = pe.closest("form");
                if (Se) {
                  Se.reset();
                  break;
                }
              }
            }
          }
        for (const U of l.mount)
          ve(U, We(T, U));
      }
      o = St(T), v.array.next({
        values: { ...T }
      }), v.state.next({
        values: { ...T }
      });
    }
    l = {
      mount: k.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!k.keepIsValid || !!k.keepDirtyValues, s.watch = !!n.shouldUnregister, v.state.next({
      submitCount: k.keepSubmitCount ? t.submitCount : 0,
      isDirty: X ? !1 : k.keepDirty ? t.isDirty : !!(k.keepDefaultValues && !vi(C, a)),
      isSubmitted: k.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: X ? {} : k.keepDirtyValues ? k.keepDefaultValues && o ? $o(a, o) : t.dirtyFields : k.keepDefaultValues && C ? $o(a, C) : k.keepDirty ? t.dirtyFields : {},
      touchedFields: k.keepTouched ? t.touchedFields : {},
      errors: k.keepErrors ? t.errors : {},
      isSubmitSuccessful: k.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ne = (C, k) => be(Nr(C) ? C(o) : C, k), Pe = (C, k = {}) => {
    const F = We(i, C), W = F && F._f;
    if (W) {
      const X = W.refs ? W.refs[0] : W.ref;
      X.focus && (X.focus(), k.shouldSelect && Nr(X.select) && X.select());
    }
  }, Ie = (C) => {
    t = {
      ...t,
      ...C
    };
  }, on = {
    control: {
      register: Ye,
      unregister: Oe,
      getFieldState: M,
      handleSubmit: Be,
      setError: Ve,
      _subscribe: ze,
      _runSchema: Y,
      _getWatch: Q,
      _getDirty: V,
      _setValid: x,
      _setFieldArray: P,
      _setDisabledField: $e,
      _setErrors: $,
      _getFieldArray: ne,
      _reset: be,
      _resetDefaultValues: () => Nr(n.defaultValues) && n.defaultValues().then((C) => {
        Ne(C, n.resetOptions), v.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: K,
      _disableForm: Ue,
      _subjects: v,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(C) {
        s = C;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(C) {
        l = C;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(C) {
        n = {
          ...n,
          ...C
        };
      }
    },
    subscribe: ge,
    trigger: le,
    register: Ye,
    handleSubmit: Be,
    watch: Te,
    setValue: ve,
    getValues: he,
    reset: Ne,
    resetField: re,
    clearErrors: Ae,
    unregister: Oe,
    setError: Ve,
    setFocus: Pe,
    getFieldState: M
  };
  return {
    ...on,
    formControl: on
  };
}
function Uee(e = {}) {
  const n = we.useRef(void 0), t = we.useRef(void 0), [i, a] = we.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Nr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Nr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Mee(e),
    formState: i
  }, e.formControl && e.defaultValues && !Nr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, we.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), we.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), we.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), we.useEffect(() => {
    e.values && !vi(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), we.useEffect(() => {
    e.errors && !Tt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), we.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), we.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = RF(i, o), n.current;
}
const Bee = "_settingsWrapper_1ycvy_1", qee = "_settingsWrapperHeader_1ycvy_6", Hee = "_settingsWrapperContent_1ycvy_10", Kee = "_settingsWrapperContentCode_1ycvy_18", Wee = "_settingsWrapperContentCURL_1ycvy_26", To = {
  settingsWrapper: Bee,
  settingsWrapperHeader: qee,
  settingsWrapperContent: Hee,
  settingsWrapperContentCode: Kee,
  settingsWrapperContentCURL: Wee
}, Gee = ({
  handleChangeText: e
}) => {
  const [n, t] = me(!1), { isCopied: i, copy: a } = ri(), { control: o } = Uee({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = PF({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", c = ut(() => {
    const m = s.storeId, d = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${d ? ` \\
  --data '{"secret":"${d}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ de.jsx(de.Fragment, { children: /* @__PURE__ */ de.jsx(ln, { span: 6, children: /* @__PURE__ */ de.jsxs(_, { flexDirection: "column", className: To.settingsWrapper, children: [
    /* @__PURE__ */ de.jsxs(
      _,
      {
        gap: "200",
        alignItems: "center",
        className: To.settingsWrapperHeader,
        onClick: () => t(!n),
        children: [
          /* @__PURE__ */ de.jsx(q.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ de.jsx(ye, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ de.jsxs(
      _,
      {
        flexDirection: "column",
        className: To.settingsWrapperContent,
        children: [
          /* @__PURE__ */ de.jsx(_, { margin: "0 0 400", children: /* @__PURE__ */ de.jsx(
            hu,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ de.jsxs("ol", { children: [
                /* @__PURE__ */ de.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ de.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ de.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ de.jsx("span", { className: To.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ de.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ de.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ de.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ de.jsx(
            FN,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ de.jsx(
                ur,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (d) => {
                      m.onChange(d), e({
                        target: {
                          name: "yotpoStoreId",
                          value: (d == null ? void 0 : d.target.value) ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ de.jsx(
            FN,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ de.jsx(
                ur,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ de.jsxs(de.Fragment, { children: [
            /* @__PURE__ */ de.jsx(Vn, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ de.jsx(
              _,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: To.settingsWrapperContentCURL,
                children: c()
              }
            ) }),
            /* @__PURE__ */ de.jsx(_, { alignContent: "start", children: /* @__PURE__ */ de.jsx(
              nn,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ de.jsx(
                  Qn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(c()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, Yee = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: Gee
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showChannels",
    label: "Show email and sms channels",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], BF = () => ({
  SHOPIFY: {
    widget: lX,
    icon: "shopify",
    iconColors: {
      contentColor: "rgb(148, 190, 69)",
      backgroundColor: "rgba(148, 190, 69, 0.1)"
    },
    settingsConfiguration: [
      {
        key: "apiAccessToken",
        label: "API Access Token",
        placeholder: "API access token from Shopify",
        required: !0,
        secret: !0,
        type: "input"
      },
      {
        key: "apiHostName",
        label: "API host name",
        placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
        required: !0,
        secret: !1,
        type: "input",
        prefix: "https://",
        customValidation: (n) => qN(n)
      },
      ...US ? [...US] : []
    ]
  },
  JIRA: {
    widget: oq,
    icon: "jira",
    iconColors: {
      contentColor: "rgb(38, 132, 255)",
      backgroundColor: "rgba(38, 132, 255, 0.075)"
    },
    settingsConfiguration: [
      ...Vb ? [...Vb] : []
    ]
  },
  GITHUB: {
    widget: LB,
    icon: "github",
    iconColors: {
      contentColor: "rgb(87, 96, 106)",
      backgroundColor: "rgba(221, 244, 255, 0.75)"
    },
    settingsConfiguration: [...VB]
  },
  MIUROS: {
    widget: h8,
    icon: "miuros",
    iconColors: {
      contentColor: "rgb(246, 135, 179)",
      backgroundColor: "rgba(246, 135, 179, 0.15)"
    },
    settingsConfiguration: [...y8]
  },
  KLAVIYO: {
    widget: b6,
    icon: "klaviyo",
    iconColors: {
      contentColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0.075)"
    },
    settingsConfiguration: [..._6]
  },
  LINEAR: {
    widget: YW,
    icon: "linear",
    iconColors: {
      contentColor: "rgb(94, 106, 210)",
      backgroundColor: "rgba(94, 106, 210, 0.15)"
    },
    settingsConfiguration: [...JW]
  },
  VOYADO: {
    widget: tee,
    icon: "voyado",
    iconColors: {
      contentColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0.075)"
    },
    settingsConfiguration: [...ree]
  },
  LOYALTYLION: {
    widget: CG,
    icon: "loyaltylion",
    iconColors: {
      contentColor: "rgb(36, 31, 79)",
      backgroundColor: "rgba(36, 31, 79, 0.075)"
    },
    settingsConfiguration: [...FG]
  },
  RECHARGE: {
    widget: U8,
    icon: "recharge",
    iconColors: {
      contentColor: "rgb(57, 1, 241)",
      backgroundColor: "rgba(57, 1, 241, 0.075)"
    },
    settingsConfiguration: [...B8]
  },
  BRAZE: {
    widget: WU,
    icon: "braze",
    iconColors: {
      contentColor: "rgb(48, 2, 102)",
      backgroundColor: "rgba(48, 2, 102, 0.075)"
    },
    settingsConfiguration: [...GU]
  },
  YOTPO: {
    widget: xee,
    icon: "yotpo",
    iconColors: {
      contentColor: "rgb(0, 66, 228)",
      backgroundColor: "rgba(0, 66, 228, 0.075)"
    },
    settingsConfiguration: [...Yee]
  }
}), Jee = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, Qee = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, qF = ({
  key: e,
  configuration: n,
  settingType: t,
  settingDefault: i
}) => {
  const a = n == null ? void 0 : n.find(
    (l) => l.key === e
  ), o = Qee(a == null ? void 0 : a.value, t), s = i !== void 0 ? i : Jee(
    t
  );
  return o !== void 0 ? o : s;
}, Xee = (e) => {
  const n = BF();
  return e.map(
    ({ id: t, type: i, name: a, settings: o, misconfigured: s }) => {
      var p;
      const c = n[i], { settingsConfiguration: m } = c, d = (p = m == null ? void 0 : m.filter(({ secret: v }) => !v)) == null ? void 0 : p.map(
        ({
          key: v,
          type: y,
          defaultValue: S
        }) => ({
          key: v,
          value: qF({
            key: v,
            configuration: o,
            settingType: y,
            settingDefault: S
          })
        })
      );
      return {
        id: t,
        type: i,
        name: a,
        settings: d,
        misconfigured: s,
        icon: c.icon,
        iconColors: c.iconColors,
        widget: c.widget
      };
    }
  );
}, Gne = ({
  configuration: e,
  conversationContext: n,
  showNotification: t,
  onToggleFn: i,
  isOpenFn: a,
  isMinimized: o
}) => {
  const { track: s } = bn(), { isLoading: l, widgets: c } = kU(
    e.baseUrl
  ), [m, d] = me([]);
  Ge(() => {
    if (c != null && c.length && !l) {
      const h = c.filter((P) => e.featureFlags[P.type]).filter((P) => P.enabled);
      d(
        // Mapping the widget from the backend (`widgets`) to our
        // `widgetDefinitions` configuration
        Xee(h)
      );
    }
  }, [l]);
  const p = {
    headline: "",
    text: "",
    onConfirm: () => x(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [v, y] = me(p), [S, b] = me(!1), j = (h) => {
    b(!0), y(h);
  }, x = () => {
    b(!1), y(p);
  };
  return /* @__PURE__ */ qe.jsxs(qe.Fragment, { children: [
    m.sort((h, P) => h.name.localeCompare(P.name)).map(
      ({
        id: h,
        name: P,
        type: N,
        widget: $,
        settings: O,
        misconfigured: B,
        icon: Z,
        iconColors: Y
      }) => {
        const ee = `partner-integration-${h}`, J = `partner-integration-${N}`, K = /* @__PURE__ */ qe.jsx(Mv, { icon: Z, color: Y }), V = O == null ? void 0 : O.reduce(
          (Q, ne) => (Q[ne.key] = ne.value, Q),
          {}
        );
        return o ? /* @__PURE__ */ qe.jsx("div", { className: "icon-holder", children: K }, `partner-icon-${h}`) : /* @__PURE__ */ qe.jsxs(
          lr,
          {
            onToggle: () => {
              s(
                a(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: h,
                  widgetType: N.toLowerCase()
                }
              ), i(ee);
            },
            isOpen: a(ee),
            className: J,
            children: [
              /* @__PURE__ */ qe.jsx(lr.Header, { avatar: K, children: P }),
              /* @__PURE__ */ qe.jsx(lr.Content, { children: B ? /* @__PURE__ */ qe.jsx(Fn, { isMisconfigured: !0 }) : /* @__PURE__ */ qe.jsx(
                YN.Provider,
                {
                  value: {
                    onError: (Q, ne) => console.warn(
                      `Something went wrong with a partner widget of type '${N}' and id '${h}'`,
                      Q,
                      ne
                    )
                  },
                  children: /* @__PURE__ */ qe.jsx(
                    $1,
                    {
                      integrationId: h,
                      type: N,
                      configuration: e,
                      showNotification: t,
                      showModal: j,
                      children: aI($, {
                        conversationContext: n,
                        settings: V
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ qe.jsx(
      E1,
      {
        isOpen: S,
        setIsOpen: b,
        headline: v.headline,
        text: v.text,
        confirmLabel: v.confirmLabel,
        confirmVariant: v.confirmVariant,
        cancelLabel: v.cancelLabel,
        cancelVariant: v.cancelVariant,
        onConfirm: v.onConfirm ? () => {
          try {
            v.onConfirm && v.onConfirm();
          } finally {
            b(!1), y(p);
          }
        } : void 0,
        onCancel: v.onCancel ? () => {
          try {
            v.onCancel && v.onCancel();
          } finally {
            b(!1), y(p);
          }
        } : void 0,
        children: v.children
      }
    )
  ] });
}, Zee = "FULL_ACCESS", ene = "2", nne = ({
  type: e,
  baseUrl: n
}) => {
  const t = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return (l == null ? void 0 : l.access_token) || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((c) => c.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: t,
        scopes: [Zee],
        version: ene
      })
    }).then((l) => l.json())
  };
}, tne = "dixaApiToken", Ey = "dixaApiTokenId", HF = "dixaApiTokenName", zN = (e) => [Ey, HF].every(
  (t) => e.find((i) => (i == null ? void 0 : i.key) === t)
);
function rne({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const t = ine(e), i = (o, s) => o == null ? void 0 : o.find((l) => (l == null ? void 0 : l.key) === s);
  return n.map((o) => {
    const s = o && i(t, o.key);
    return i(n, o == null ? void 0 : o.key) && s ? s : o;
  });
}
const ine = (e) => [
  {
    key: tne,
    value: e.value,
    secret: !0
  },
  {
    key: Ey,
    value: e.id,
    secret: !1
  },
  {
    key: HF,
    value: e.name,
    secret: !1
  }
], ane = es`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        settings {
          key
          value
        }
      }
    }
  }
`, one = es`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        settings {
          key
          value
        }
      }
    }
  }
`, sne = es`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        settings {
          key
          value
        }
      }
    }
  }
`, lne = es`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, une = "_wrapper_1lmim_1", cne = "_wrapperBox_1lmim_4", dne = "_wrapperBoxErrorBorder_1lmim_9", Ep = {
  wrapper: une,
  wrapperBox: cne,
  wrapperBoxErrorBorder: dne
}, mne = ({
  required: e,
  readOnly: n,
  isSecret: t,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: c,
  handleChangeText: m
}) => {
  const d = o == null ? void 0 : o.find(
    (P) => P.type === "basicAuthInput"
  ), p = d == null ? void 0 : d.additionalProperties, { username: v, password: y } = p, S = `Insert your ${v.label.toLowerCase()}`, b = `Insert your ${y.label.toLowerCase()}`, [j, x] = me({
    username: "",
    password: ""
  }), h = ut(
    (P) => {
      m({
        target: {
          name: s,
          value: P
        }
      });
    },
    [s, m]
  );
  return Ge(() => {
    h(
      j.username !== "" && j.password !== "" ? window.btoa(`${j.username}:${j.password}`) : ""
    );
  }, [j]), /* @__PURE__ */ qe.jsx(
    Vn,
    {
      required: e,
      label: a,
      meta: l,
      className: Ep.wrapper,
      children: /* @__PURE__ */ qe.jsxs(
        _,
        {
          gap: "300",
          flexDirection: "column",
          className: ct(Ep.wrapperBox, {
            [Ep.wrapperBoxErrorBorder]: !!(l != null && l.error)
          }),
          children: [
            /* @__PURE__ */ qe.jsx(
              ur,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: j.username,
                  onChange: (P) => x({
                    username: (P == null ? void 0 : P.target.value) ?? "",
                    password: j.password
                  })
                },
                ...t && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => c(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ qe.jsx(
              ur,
              {
                noAlert: !0,
                required: e,
                label: y.label,
                readOnly: n,
                placeholder: b,
                input: {
                  name: s,
                  value: j.password,
                  onChange: (P) => x({
                    username: j.username,
                    password: (P == null ? void 0 : P.target.value) ?? ""
                  })
                },
                ...t && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => c(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function fne({
  isSecret: e,
  widgetSettingsKey: n,
  label: t,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: c,
  handleEditSecret: m,
  getValueByKey: d,
  isEditingField: p,
  errors: v,
  type: y,
  isCreationMode: S,
  prefix: b,
  integrationId: j,
  integrationType: x,
  configuration: h,
  settings: P,
  otherProps: N
}) {
  var B, Z;
  const $ = y === "custom" && (N == null ? void 0 : N.component), O = (B = d(n)) == null ? void 0 : B.value;
  return $ ? /* @__PURE__ */ qe.jsx(
    $,
    {
      configuration: h,
      integrationId: j,
      integrationType: x,
      label: t,
      settings: P,
      getValueByKey: d,
      widgetSettingsKey: n,
      handleChangeSelect: c,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ qe.jsxs(qe.Fragment, { children: [
    /* @__PURE__ */ qe.jsx(ln, { span: 3, children: /* @__PURE__ */ qe.jsx(
      pne,
      {
        widgetSettingsKey: n,
        label: t,
        isEditingField: p,
        handleEditSecret: m,
        isCreationMode: S,
        children: y === "input" ? /* @__PURE__ */ qe.jsx(
          ur,
          {
            required: i,
            readOnly: a,
            label: t,
            placeholder: o,
            input: {
              name: n,
              value: O,
              onChange: s
            },
            meta: { error: v[n] },
            prefix: b,
            ...e && !S && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : y === "basicAuthInput" ? /* @__PURE__ */ qe.jsx(
          mne,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: S,
            label: t,
            widgetSettingsKey: n,
            settings: P,
            meta: { error: v[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : y === "switch" ? /* @__PURE__ */ qe.jsx(Vn, { label: t, children: /* @__PURE__ */ qe.jsx(
          JN,
          {
            input: {
              name: n,
              value: "",
              checked: O,
              onChange: l
            }
          }
        ) }) : y === "select" ? /* @__PURE__ */ qe.jsx(Vn, { label: t, children: /* @__PURE__ */ qe.jsx(
          ni,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (Y) => c(n, Y),
            getItemTitleByValue: (Y) => Y ? /* @__PURE__ */ qe.jsx(q.Paragraph, { children: Y.label }) : /* @__PURE__ */ qe.jsx(qe.Fragment, {}),
            value: O ? [
              {
                label: (Z = ((N == null ? void 0 : N.selectItems) || []).find(
                  (Y) => Y.value === O
                )) == null ? void 0 : Z.label,
                value: O
              }
            ] : [],
            equalityFn: (Y, ee) => Y.value === ee.value,
            children: ((N == null ? void 0 : N.selectItems) || []).map((Y) => /* @__PURE__ */ qe.jsx(Bt.Item, { value: Y, children: Y.label }, Y.value))
          }
        ) }) : /* @__PURE__ */ qe.jsx(qe.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ qe.jsx(ln, { span: 3 })
  ] });
}
function pne({
  widgetSettingsKey: e,
  label: n,
  isEditingField: t,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return t || o ? a : /* @__PURE__ */ qe.jsx(Vn, { label: n, children: /* @__PURE__ */ qe.jsxs(
    Qn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Ho = "partner-integrations-widget-name-form-field", MN = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: t = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: c
  }) => ({
    key: i,
    value: qF({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: t ? !0 : !o,
    type: s,
    ...c && { customValidation: c }
  })
), vne = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [t, i] = me(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = me({}), s = (N) => i(N), l = (N) => !N || N === "", c = (N) => {
    const { [N]: $, ...O } = a;
    o(O);
  }, m = (N) => ({
    ...N,
    settings: N.settings.filter(({ isEditing: $ }) => $).map(({ key: $, value: O, secret: B }) => ({
      key: $,
      value: O,
      secret: B
    }))
  }), d = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, p = (N) => {
    if (!N)
      return;
    const {
      target: { name: $, value: O }
    } = N;
    a[$] && !l(O) && c($), i({
      ...t,
      settings: t.settings.map(
        (B) => B.key === $ ? { ...B, value: O } : B
      )
    });
  }, v = (N) => {
    if (!N)
      return;
    const {
      target: { name: $, checked: O }
    } = N;
    i({
      ...t,
      settings: t.settings.map(
        (B) => B.key === $ ? { ...B, value: O } : B
      )
    });
  }, y = (N, $) => {
    if (!$)
      return;
    const { selectedValues: O } = $, B = O == null ? void 0 : O[0];
    if (B) {
      const Z = t.settings.map(
        (Y) => Y.key === N ? { ...Y, value: B == null ? void 0 : B.value } : Y
      );
      i({
        ...t,
        settings: Z
      });
    } else {
      const Z = t.settings.filter(
        (Y) => Y.key !== N
      );
      i({
        ...t,
        settings: Z
      });
    }
  }, S = (N) => {
    i({
      ...t,
      enabled: N
    });
  }, b = (N) => {
    if (!N)
      return;
    const {
      target: { value: $ }
    } = N;
    a[Ho] && !l($) && c(Ho), i({
      ...t,
      name: $
    });
  }, j = (N, $) => {
    const { settings: O } = t, B = O.map((Z) => Z.key === $ ? {
      ...Z,
      isEditing: N,
      ...!N && { value: "" }
    } : Z);
    a[$] && !N && c($), i({
      ...t,
      settings: B
    });
  }, x = (N) => t.settings.find(
    ($) => $.key === N
  ), h = async (N) => {
    N.preventDefault(), P() && n(m(t));
  }, P = () => {
    var B;
    const N = {}, { name: $, settings: O } = t;
    return l($) && (N[Ho] = d.input), O.forEach(
      ({ key: Z, value: Y, required: ee, isEditing: J, type: K, customValidation: V }) => {
        if (ee && J)
          if (V) {
            const Q = V(Y);
            typeof Q == "string" && (N[Z] = Q);
          } else
            typeof Y == "string" && l(Y) && (N[Z] = d[K]);
      }
    ), o(N), !((B = Object.keys(N)) != null && B.length);
  };
  return {
    formData: t,
    errors: a,
    handleIsEnabled: S,
    handleChangeText: p,
    handleChangeBoolean: v,
    handleChangeSelect: y,
    handleEditSecret: j,
    handleChangeName: b,
    handleSubmit: h,
    getSettingValueByKey: x,
    initializeFormData: s,
    validate: P
  };
}, hne = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], UN = "The configuration of the integration is not correct. Please check the settings.", yne = ({
  integrationId: e,
  type: n,
  handleRedirect: t,
  showNotification: i,
  configuration: a
}) => {
  const { track: o } = bn(), { deleteDixaApiToken: s, createDixaApiToken: l } = nne({
    type: n,
    baseUrl: a.baseUrl
  }), m = xI().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), d = !e && !!n && !!m, p = hne.includes(n), [v, y] = me(), [S, b] = me(!1), [j, x] = me(!1), [h, P] = me(!1), [N, $] = me(null), Z = BF()[n].settingsConfiguration, Y = Z.filter(({ type: ge }) => ge !== "hidden").filter(({ hideOnCreate: ge }) => d ? !ge : !0), {
    error: ee,
    loading: J,
    data: K,
    refetch: V
  } = kI(ane, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (ge) => {
      Object.keys(ge).length === 0 ? P(!0) : P(!1);
    }
  }), [Q, { error: ne }] = Oy(
    d ? sne : one,
    {
      onError: (ge) => {
        y(ge), b(!1), i({
          title: "Something went wrong",
          text: `The ${d ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (ge) => {
        var Oe, $e, Ye;
        if (b(!1), Object.keys(ge).length !== 0) {
          if (d && t(($e = (Oe = ge == null ? void 0 : ge.Management) == null ? void 0 : Oe.createWidgetConfiguration) == null ? void 0 : $e.id), !d) {
            const xe = (Ye = ge == null ? void 0 : ge.Management) == null ? void 0 : Ye.updateWidgetConfiguration;
            xe.misconfigured ? $(
              (xe == null ? void 0 : xe.misconfigurationCause) ?? UN
            ) : $(null);
          }
          i({
            title: `${d ? "Creating" : "Updating"} was successful`,
            text: `${d ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${d ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [ce] = Oy(lne, {
    onError: (ge) => {
      y(ge), b(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      b(!1), t(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: ae,
    handleIsEnabled: ve,
    errors: je,
    handleChangeText: G,
    handleChangeBoolean: le,
    handleChangeSelect: he,
    handleEditSecret: M,
    handleChangeName: Ae,
    handleSubmit: Ve,
    getSettingValueByKey: Te,
    initializeFormData: ze
  } = vne({
    onSubmit: async (ge) => {
      d ? o("settings:create:submitted", { widgetType: n }) : e && o("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), b(!0);
      const Oe = ge.settings.map(
        (Ue) => typeof Ue.value == "boolean" ? { ...Ue, value: Ue.value.toString() } : Ue
      ), $e = zN(Oe) && d;
      let Ye = [];
      if ($e) {
        const Ue = await l().catch(
          (Be) => {
            b(!1), console.warn("API-Token (creation) error resonse", Be), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        Ue != null && Ue.data && (Ye = rne({
          token: Ue.data,
          settings: Oe
        }));
      }
      const xe = {
        ...ge,
        settings: [
          ...Ye.length > 0 ? Ye : Oe
        ]
      };
      ($e && Ye.length > 1 || !$e && Ye.length === 0) && (Q({
        variables: {
          ...!d && { id: e },
          ...d && { type: n },
          ...xe
        }
      }), Oe.forEach(
        (Ue) => Ue.secret && M(!1, Ue.key)
      ));
    },
    ...d && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: MN({
          settingsFromBackend: [],
          settingsConfiguration: Z,
          creating: !0
        })
      }
    }
  });
  return Ge(() => {
    var Oe;
    const ge = (Oe = K == null ? void 0 : K.Management) == null ? void 0 : Oe.widgetConfigurations[0];
    if (ge) {
      const $e = MN({
        settingsFromBackend: ge.settings,
        settingsConfiguration: Z
      });
      ze({
        enabled: !!ge.enabled,
        name: ge.name,
        settings: $e
      }), ge.misconfigured ? $(
        (ge == null ? void 0 : ge.misconfigurationCause) ?? UN
      ) : $(null);
    }
  }, [K]), ee || ne || v ? /* @__PURE__ */ qe.jsx(
    Fn,
    {
      error: ee || v,
      retry: ee ? V : void 0
    }
  ) : S || J ? /* @__PURE__ */ qe.jsx(fn, { "data-testid": "widget-settings-loading" }) : h ? /* @__PURE__ */ qe.jsxs(q.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ qe.jsx(Dn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ qe.jsxs("form", { children: [
    N && /* @__PURE__ */ qe.jsx(_, { margin: "0 0 400", children: /* @__PURE__ */ qe.jsx(
      hu,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ qe.jsxs(_, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ qe.jsx(q.Paragraph, { children: N }),
          /* @__PURE__ */ qe.jsxs(_, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ qe.jsx(q.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ qe.jsx(q.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ qe.jsxs(
      Ir,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          /* @__PURE__ */ qe.jsx(ln, { children: /* @__PURE__ */ qe.jsx(Vn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ qe.jsx(
            JN,
            {
              input: {
                name: "enabled",
                checked: ae.enabled,
                value: "dummy",
                onChange: (ge) => ve(ge.target.checked)
              }
            }
          ) }) }),
          /* @__PURE__ */ qe.jsx(ln, { span: 3, children: /* @__PURE__ */ qe.jsx(
            ur,
            {
              required: !0,
              label: "Widget name",
              placeholder: "Insert the name of the widget",
              input: {
                name: Ho,
                value: ae.name,
                onChange: Ae
              },
              meta: {
                error: je[Ho]
              }
            }
          ) }),
          /* @__PURE__ */ qe.jsx(ln, { span: 3 }),
          Y == null ? void 0 : Y.map(
            ({
              key: ge,
              secret: Oe,
              label: $e,
              placeholder: Ye = "",
              required: xe = !1,
              type: Ue,
              prefix: Be,
              readOnly: re,
              ...be
            }) => {
              const { settings: Ne } = ae, Pe = Ne.find(
                (Ie) => Ie.key === ge
              );
              return /* @__PURE__ */ qe.jsx(oI, { children: /* @__PURE__ */ qe.jsx(
                fne,
                {
                  widgetSettingsKey: ge,
                  isEditingField: !!(Pe != null && Pe.isEditing),
                  handleEditSecret: M,
                  handleChangeText: G,
                  handleChangeBoolean: le,
                  handleChangeSelect: he,
                  getValueByKey: Te,
                  isSecret: Oe,
                  label: $e,
                  placeholder: Ye,
                  required: xe,
                  errors: je,
                  type: Ue,
                  isCreationMode: d,
                  prefix: Be,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: re,
                  settings: Z,
                  otherProps: be
                }
              ) }, ge);
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ qe.jsxs(_, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ qe.jsx(Qn, { onClick: Ve, children: "Submit" }),
      !d && /* @__PURE__ */ qe.jsx(
        Qn,
        {
          style: { marginLeft: 20 },
          icon: "trash",
          variant: "secondary",
          onClick: () => {
            e && o("settings:view:delete:requested", {
              widgetId: e,
              widgetType: n
            }), x(!0);
          },
          children: "Delete"
        }
      )
    ] }),
    /* @__PURE__ */ qe.jsx(
      E1,
      {
        isOpen: j,
        setIsOpen: x,
        confirmVariant: p ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && o("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          var ge;
          if (e && o("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), zN(ae.settings)) {
            const Oe = (ge = ae.settings.find(
              ({ key: $e }) => $e === Ey
            )) == null ? void 0 : ge.value;
            Oe && s(Oe).catch(($e) => {
              console.warn("API-Token (deletion) error response", $e), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          ce({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ qe.jsx(_, { children: p ? /* @__PURE__ */ qe.jsxs(_, { gap: "400", children: [
          /* @__PURE__ */ qe.jsx(
            ye,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ qe.jsxs(_, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ qe.jsxs(q.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ qe.jsxs(q.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ qe.jsxs(q.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              ae.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ qe.jsxs(qe.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          ae.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, Yne = ({
  configuration: e,
  integrationId: n,
  type: t,
  handleRedirect: i,
  showNotification: a
}) => /* @__PURE__ */ qe.jsx(
  YN.Provider,
  {
    value: {
      onError: (o, s) => console.warn(
        `Something went wrong with the partner widget settings of type ${t} and id ${n}`,
        o,
        s
      )
    },
    children: /* @__PURE__ */ qe.jsx(
      $1,
      {
        integrationId: n,
        type: t,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ qe.jsx(
          yne,
          {
            configuration: e,
            integrationId: n,
            type: t,
            handleRedirect: i,
            showNotification: a
          }
        )
      }
    )
  }
);
var gl = { exports: {} }, BN;
function gne() {
  if (BN) return gl.exports;
  BN = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function($, O, B) {
    return Function.prototype.apply.call($, O, B);
  }, t;
  e && typeof e.ownKeys == "function" ? t = e.ownKeys : Object.getOwnPropertySymbols ? t = function($) {
    return Object.getOwnPropertyNames($).concat(Object.getOwnPropertySymbols($));
  } : t = function($) {
    return Object.getOwnPropertyNames($);
  };
  function i(N) {
    console && console.warn && console.warn(N);
  }
  var a = Number.isNaN || function($) {
    return $ !== $;
  };
  function o() {
    o.init.call(this);
  }
  gl.exports = o, gl.exports.once = x, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(N) {
    if (typeof N != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof N);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(N) {
      if (typeof N != "number" || N < 0 || a(N))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + N + ".");
      s = N;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function($) {
    if (typeof $ != "number" || $ < 0 || a($))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + $ + ".");
    return this._maxListeners = $, this;
  };
  function c(N) {
    return N._maxListeners === void 0 ? o.defaultMaxListeners : N._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return c(this);
  }, o.prototype.emit = function($) {
    for (var O = [], B = 1; B < arguments.length; B++) O.push(arguments[B]);
    var Z = $ === "error", Y = this._events;
    if (Y !== void 0)
      Z = Z && Y.error === void 0;
    else if (!Z)
      return !1;
    if (Z) {
      var ee;
      if (O.length > 0 && (ee = O[0]), ee instanceof Error)
        throw ee;
      var J = new Error("Unhandled error." + (ee ? " (" + ee.message + ")" : ""));
      throw J.context = ee, J;
    }
    var K = Y[$];
    if (K === void 0)
      return !1;
    if (typeof K == "function")
      n(K, this, O);
    else
      for (var V = K.length, Q = S(K, V), B = 0; B < V; ++B)
        n(Q[B], this, O);
    return !0;
  };
  function m(N, $, O, B) {
    var Z, Y, ee;
    if (l(O), Y = N._events, Y === void 0 ? (Y = N._events = /* @__PURE__ */ Object.create(null), N._eventsCount = 0) : (Y.newListener !== void 0 && (N.emit(
      "newListener",
      $,
      O.listener ? O.listener : O
    ), Y = N._events), ee = Y[$]), ee === void 0)
      ee = Y[$] = O, ++N._eventsCount;
    else if (typeof ee == "function" ? ee = Y[$] = B ? [O, ee] : [ee, O] : B ? ee.unshift(O) : ee.push(O), Z = c(N), Z > 0 && ee.length > Z && !ee.warned) {
      ee.warned = !0;
      var J = new Error("Possible EventEmitter memory leak detected. " + ee.length + " " + String($) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      J.name = "MaxListenersExceededWarning", J.emitter = N, J.type = $, J.count = ee.length, i(J);
    }
    return N;
  }
  o.prototype.addListener = function($, O) {
    return m(this, $, O, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function($, O) {
    return m(this, $, O, !0);
  };
  function d() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function p(N, $, O) {
    var B = { fired: !1, wrapFn: void 0, target: N, type: $, listener: O }, Z = d.bind(B);
    return Z.listener = O, B.wrapFn = Z, Z;
  }
  o.prototype.once = function($, O) {
    return l(O), this.on($, p(this, $, O)), this;
  }, o.prototype.prependOnceListener = function($, O) {
    return l(O), this.prependListener($, p(this, $, O)), this;
  }, o.prototype.removeListener = function($, O) {
    var B, Z, Y, ee, J;
    if (l(O), Z = this._events, Z === void 0)
      return this;
    if (B = Z[$], B === void 0)
      return this;
    if (B === O || B.listener === O)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Z[$], Z.removeListener && this.emit("removeListener", $, B.listener || O));
    else if (typeof B != "function") {
      for (Y = -1, ee = B.length - 1; ee >= 0; ee--)
        if (B[ee] === O || B[ee].listener === O) {
          J = B[ee].listener, Y = ee;
          break;
        }
      if (Y < 0)
        return this;
      Y === 0 ? B.shift() : b(B, Y), B.length === 1 && (Z[$] = B[0]), Z.removeListener !== void 0 && this.emit("removeListener", $, J || O);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function($) {
    var O, B, Z;
    if (B = this._events, B === void 0)
      return this;
    if (B.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : B[$] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete B[$]), this;
    if (arguments.length === 0) {
      var Y = Object.keys(B), ee;
      for (Z = 0; Z < Y.length; ++Z)
        ee = Y[Z], ee !== "removeListener" && this.removeAllListeners(ee);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (O = B[$], typeof O == "function")
      this.removeListener($, O);
    else if (O !== void 0)
      for (Z = O.length - 1; Z >= 0; Z--)
        this.removeListener($, O[Z]);
    return this;
  };
  function v(N, $, O) {
    var B = N._events;
    if (B === void 0)
      return [];
    var Z = B[$];
    return Z === void 0 ? [] : typeof Z == "function" ? O ? [Z.listener || Z] : [Z] : O ? j(Z) : S(Z, Z.length);
  }
  o.prototype.listeners = function($) {
    return v(this, $, !0);
  }, o.prototype.rawListeners = function($) {
    return v(this, $, !1);
  }, o.listenerCount = function(N, $) {
    return typeof N.listenerCount == "function" ? N.listenerCount($) : y.call(N, $);
  }, o.prototype.listenerCount = y;
  function y(N) {
    var $ = this._events;
    if ($ !== void 0) {
      var O = $[N];
      if (typeof O == "function")
        return 1;
      if (O !== void 0)
        return O.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? t(this._events) : [];
  };
  function S(N, $) {
    for (var O = new Array($), B = 0; B < $; ++B)
      O[B] = N[B];
    return O;
  }
  function b(N, $) {
    for (; $ + 1 < N.length; $++)
      N[$] = N[$ + 1];
    N.pop();
  }
  function j(N) {
    for (var $ = new Array(N.length), O = 0; O < $.length; ++O)
      $[O] = N[O].listener || N[O];
    return $;
  }
  function x(N, $) {
    return new Promise(function(O, B) {
      function Z(ee) {
        N.removeListener($, Y), B(ee);
      }
      function Y() {
        typeof N.removeListener == "function" && N.removeListener("error", Z), O([].slice.call(arguments));
      }
      P(N, $, Y, { once: !0 }), $ !== "error" && h(N, Z, { once: !0 });
    });
  }
  function h(N, $, O) {
    typeof N.on == "function" && P(N, "error", $, O);
  }
  function P(N, $, O, B) {
    if (typeof N.on == "function")
      B.once ? N.once($, O) : N.on($, O);
    else if (typeof N.addEventListener == "function")
      N.addEventListener($, function Z(Y) {
        B.once && N.removeEventListener($, Z), O(Y);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof N);
  }
  return gl.exports;
}
var kne = gne();
function Jne() {
  const e = new kne.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  yU as GraphQLClientProvider,
  E1 as IntegrationModal,
  Gne as PartnerIntegrations,
  Yne as PartnerIntegrationsSettings,
  sne as createWidgetConfigurationMutation,
  lne as deleteWidgetConfigurationMutation,
  ane as getWidgetConfigurationByIdQuery,
  BF as getWidgetDefinitions,
  Jne as initializePartnerEventEmitter,
  one as updateWidgetConfigurationMutation,
  kU as usePartnerIntegrationWidgetConfigurations
};
